"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});
var commonjsGlobal = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

function unwrapExports(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}

function createCommonjsModule(e, t) {
  return e(t = {
    exports: {}
  }, t.exports), t.exports;
}

function getCjsExportFromNamespace(e) {
  return e && e.default || e;
}

var _extends_1 = createCommonjsModule(function (e) {
  function t() {
    return e.exports = t = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];

        for (var n in r) {
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
      }

      return e;
    }, t.apply(this, arguments);
  }

  e.exports = t;
});

function _objectWithoutPropertiesLoose(e, t) {
  if (null == e) return {};
  var r,
      n,
      o = {},
      a = Object.keys(e);

  for (n = 0; n < a.length; n++) {
    r = a[n], 0 <= t.indexOf(r) || (o[r] = e[r]);
  }

  return o;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var r,
      n,
      o = objectWithoutPropertiesLoose(e, t);

  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);

    for (n = 0; n < a.length; n++) {
      r = a[n], 0 <= t.indexOf(r) || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
    }
  }

  return o;
}

var objectWithoutProperties = _objectWithoutProperties,
    getOwnPropertySymbols = Object.getOwnPropertySymbols,
    hasOwnProperty = Object.prototype.hasOwnProperty,
    propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(e) {
  if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(e);
}

function shouldUseNative() {
  try {
    if (!Object.assign) return !1;
    var e = new String("abc");
    if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

    for (var t = {}, r = 0; r < 10; r++) {
      t["_" + String.fromCharCode(r)] = r;
    }

    if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
      return t[e];
    }).join("")) return !1;
    var n = {};
    return "abcdefghijklmnopqrst".split("").forEach(function (e) {
      n[e] = e;
    }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, n)).join("");
  } catch (e) {
    return !1;
  }
}

var objectAssign = shouldUseNative() ? Object.assign : function (e, t) {
  for (var r, n, o = toObject(e), a = 1; a < arguments.length; a++) {
    for (var i in r = Object(arguments[a])) {
      hasOwnProperty.call(r, i) && (o[i] = r[i]);
    }

    if (getOwnPropertySymbols) {
      n = getOwnPropertySymbols(r);

      for (var s = 0; s < n.length; s++) {
        propIsEnumerable.call(r, n[s]) && (o[n[s]] = r[n[s]]);
      }
    }
  }

  return o;
},
    n = "function" == typeof Symbol && Symbol.for,
    p = n ? Symbol.for("react.element") : 60103,
    q = n ? Symbol.for("react.portal") : 60106,
    r = n ? Symbol.for("react.fragment") : 60107,
    t = n ? Symbol.for("react.strict_mode") : 60108,
    u = n ? Symbol.for("react.profiler") : 60114,
    v = n ? Symbol.for("react.provider") : 60109,
    w = n ? Symbol.for("react.context") : 60110,
    x = n ? Symbol.for("react.concurrent_mode") : 60111,
    y = n ? Symbol.for("react.forward_ref") : 60112,
    z = n ? Symbol.for("react.suspense") : 60113,
    aa = n ? Symbol.for("react.memo") : 60115,
    ba = n ? Symbol.for("react.lazy") : 60116,
    A = "function" == typeof Symbol && Symbol.iterator;

function ca(e, t, r, n, o, a, i, s) {
  if (!e) {
    if ((e = void 0) === t) e = Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
      var c = [r, n, o, a, i, s],
          u = 0;
      (e = Error(t.replace(/%s/g, function () {
        return c[u++];
      }))).name = "Invariant Violation";
    }
    throw e.framesToPop = 1, e;
  }
}

function B(e) {
  for (var t = arguments.length - 1, r = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, n = 0; n < t; n++) {
    r += "&args[]=" + encodeURIComponent(arguments[n + 1]);
  }

  ca(!1, "Minified React error #" + e + "; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ", r);
}

var C = {
  isMounted: function isMounted() {
    return !1;
  },
  enqueueForceUpdate: function enqueueForceUpdate() {},
  enqueueReplaceState: function enqueueReplaceState() {},
  enqueueSetState: function enqueueSetState() {}
},
    D = {};

function E(e, t, r) {
  this.props = e, this.context = t, this.refs = D, this.updater = r || C;
}

function F() {}

function G(e, t, r) {
  this.props = e, this.context = t, this.refs = D, this.updater = r || C;
}

E.prototype.isReactComponent = {}, E.prototype.setState = function (e, t) {
  "object" != typeof e && "function" != typeof e && null != e && B("85"), this.updater.enqueueSetState(this, e, t, "setState");
}, E.prototype.forceUpdate = function (e) {
  this.updater.enqueueForceUpdate(this, e, "forceUpdate");
}, F.prototype = E.prototype;
var H = G.prototype = new F();
H.constructor = G, objectAssign(H, E.prototype), H.isPureReactComponent = !0;
var I = {
  current: null
},
    J = {
  current: null
},
    K = Object.prototype.hasOwnProperty,
    L = {
  key: !0,
  ref: !0,
  __self: !0,
  __source: !0
};

function M(e, t, r) {
  var n = void 0,
      o = {},
      a = null,
      i = null;
  if (null != t) for (n in void 0 !== t.ref && (i = t.ref), void 0 !== t.key && (a = "" + t.key), t) {
    K.call(t, n) && !L.hasOwnProperty(n) && (o[n] = t[n]);
  }
  var s = arguments.length - 2;
  if (1 === s) o.children = r;else if (1 < s) {
    for (var c = Array(s), u = 0; u < s; u++) {
      c[u] = arguments[u + 2];
    }

    o.children = c;
  }
  if (e && e.defaultProps) for (n in s = e.defaultProps) {
    void 0 === o[n] && (o[n] = s[n]);
  }
  return {
    $$typeof: p,
    type: e,
    key: a,
    ref: i,
    props: o,
    _owner: J.current
  };
}

function da(e, t) {
  return {
    $$typeof: p,
    type: e.type,
    key: t,
    ref: e.ref,
    props: e.props,
    _owner: e._owner
  };
}

function N(e) {
  return "object" == typeof e && null !== e && e.$$typeof === p;
}

function escape(e) {
  var t = {
    "=": "=0",
    ":": "=2"
  };
  return "$" + ("" + e).replace(/[=:]/g, function (e) {
    return t[e];
  });
}

var O = /\/+/g,
    P = [];

function Q(e, t, r, n) {
  if (P.length) {
    var o = P.pop();
    return o.result = e, o.keyPrefix = t, o.func = r, o.context = n, o.count = 0, o;
  }

  return {
    result: e,
    keyPrefix: t,
    func: r,
    context: n,
    count: 0
  };
}

function R(e) {
  e.result = null, e.keyPrefix = null, e.func = null, e.context = null, e.count = 0, P.length < 10 && P.push(e);
}

function S(e, t, r, n) {
  var o = typeof e;
  "undefined" !== o && "boolean" !== o || (e = null);
  var a = !1;
  if (null === e) a = !0;else switch (o) {
    case "string":
    case "number":
      a = !0;
      break;

    case "object":
      switch (e.$$typeof) {
        case p:
        case q:
          a = !0;
      }

  }
  if (a) return r(n, e, "" === t ? "." + T(e, 0) : t), 1;
  if (a = 0, t = "" === t ? "." : t + ":", Array.isArray(e)) for (var i = 0; i < e.length; i++) {
    var s = t + T(o = e[i], i);
    a += S(o, s, r, n);
  } else if ("function" == typeof (s = null === e || "object" != typeof e ? null : "function" == typeof (s = A && e[A] || e["@@iterator"]) ? s : null)) for (e = s.call(e), i = 0; !(o = e.next()).done;) {
    a += S(o = o.value, s = t + T(o, i++), r, n);
  } else "object" === o && B("31", "[object Object]" === (r = "" + e) ? "object with keys {" + Object.keys(e).join(", ") + "}" : r, "");
  return a;
}

function U(e, t, r) {
  return null == e ? 0 : S(e, "", t, r);
}

function T(e, t) {
  return "object" == typeof e && null !== e && null != e.key ? escape(e.key) : t.toString(36);
}

function ea(e, t) {
  e.func.call(e.context, t, e.count++);
}

function fa(e, t, r) {
  var n = e.result,
      o = e.keyPrefix;
  e = e.func.call(e.context, t, e.count++), Array.isArray(e) ? V(e, n, r, function (e) {
    return e;
  }) : null != e && (N(e) && (e = da(e, o + (!e.key || t && t.key === e.key ? "" : ("" + e.key).replace(O, "$&/") + "/") + r)), n.push(e));
}

function V(e, t, r, n, o) {
  var a = "";
  null != r && (a = ("" + r).replace(O, "$&/") + "/"), U(e, fa, t = Q(t, a, n, o)), R(t);
}

function W() {
  var e = I.current;
  return null === e && B("307"), e;
}

var X = {
  Children: {
    map: function map(e, t, r) {
      if (null == e) return e;
      var n = [];
      return V(e, n, null, t, r), n;
    },
    forEach: function forEach(e, t, r) {
      if (null == e) return e;
      U(e, ea, t = Q(null, null, t, r)), R(t);
    },
    count: function count(e) {
      return U(e, function () {
        return null;
      }, null);
    },
    toArray: function toArray(e) {
      var t = [];
      return V(e, t, null, function (e) {
        return e;
      }), t;
    },
    only: function only(e) {
      return N(e) || B("143"), e;
    }
  },
  createRef: function createRef() {
    return {
      current: null
    };
  },
  Component: E,
  PureComponent: G,
  createContext: function createContext(e, t) {
    return void 0 === t && (t = null), (e = {
      $$typeof: w,
      _calculateChangedBits: t,
      _currentValue: e,
      _currentValue2: e,
      _threadCount: 0,
      Provider: null,
      Consumer: null
    }).Provider = {
      $$typeof: v,
      _context: e
    }, e.Consumer = e;
  },
  forwardRef: function forwardRef(e) {
    return {
      $$typeof: y,
      render: e
    };
  },
  lazy: function lazy(e) {
    return {
      $$typeof: ba,
      _ctor: e,
      _status: -1,
      _result: null
    };
  },
  memo: function memo(e, t) {
    return {
      $$typeof: aa,
      type: e,
      compare: void 0 === t ? null : t
    };
  },
  useCallback: function useCallback(e, t) {
    return W().useCallback(e, t);
  },
  useContext: function useContext(e, t) {
    return W().useContext(e, t);
  },
  useEffect: function useEffect(e, t) {
    return W().useEffect(e, t);
  },
  useImperativeHandle: function useImperativeHandle(e, t, r) {
    return W().useImperativeHandle(e, t, r);
  },
  useDebugValue: function useDebugValue() {},
  useLayoutEffect: function useLayoutEffect(e, t) {
    return W().useLayoutEffect(e, t);
  },
  useMemo: function useMemo(e, t) {
    return W().useMemo(e, t);
  },
  useReducer: function useReducer(e, t, r) {
    return W().useReducer(e, t, r);
  },
  useRef: function useRef(e) {
    return W().useRef(e);
  },
  useState: function useState(e) {
    return W().useState(e);
  },
  Fragment: r,
  StrictMode: t,
  Suspense: z,
  createElement: M,
  cloneElement: function cloneElement(e, t, r) {
    null == e && B("267", e);
    var n = void 0,
        o = objectAssign({}, e.props),
        a = e.key,
        i = e.ref,
        s = e._owner;

    if (null != t) {
      void 0 !== t.ref && (i = t.ref, s = J.current), void 0 !== t.key && (a = "" + t.key);
      var c = void 0;

      for (n in e.type && e.type.defaultProps && (c = e.type.defaultProps), t) {
        K.call(t, n) && !L.hasOwnProperty(n) && (o[n] = void 0 === t[n] && void 0 !== c ? c[n] : t[n]);
      }
    }

    if (1 === (n = arguments.length - 2)) o.children = r;else if (1 < n) {
      c = Array(n);

      for (var u = 0; u < n; u++) {
        c[u] = arguments[u + 2];
      }

      o.children = c;
    }
    return {
      $$typeof: p,
      type: e.type,
      key: a,
      ref: i,
      props: o,
      _owner: s
    };
  },
  createFactory: function createFactory(e) {
    var t = M.bind(null, e);
    return t.type = e, t;
  },
  isValidElement: N,
  version: "16.8.3",
  unstable_ConcurrentMode: x,
  unstable_Profiler: u,
  __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: {
    ReactCurrentDispatcher: I,
    ReactCurrentOwner: J,
    assign: objectAssign
  }
},
    Y = {
  default: X
},
    Z = Y && X || Y,
    react_production_min = Z.default || Z,
    ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",
    ReactPropTypesSecret_1 = ReactPropTypesSecret,
    printWarning = function printWarning() {};

if ("production" !== process.env.NODE_ENV) {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1,
      loggedTypeFailures = {},
      has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function printWarning(e) {
    var t = "Warning: " + e;
    "undefined" != typeof console && console.error(t);

    try {
      throw new Error(t);
    } catch (e) {}
  };
}

function checkPropTypes(e, t, r, n, o) {
  if ("production" !== process.env.NODE_ENV) for (var a in e) {
    if (has(e, a)) {
      var i;

      try {
        if ("function" != typeof e[a]) {
          var s = Error((n || "React class") + ": " + r + " type `" + a + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[a] + "`.");
          throw s.name = "Invariant Violation", s;
        }

        i = e[a](t, a, n, r, null, ReactPropTypesSecret$1);
      } catch (e) {
        i = e;
      }

      if (!i || i instanceof Error || printWarning((n || "React class") + ": type specification of " + r + " `" + a + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof i + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), i instanceof Error && !(i.message in loggedTypeFailures)) {
        loggedTypeFailures[i.message] = !0;
        var c = o ? o() : "";
        printWarning("Failed " + r + " type: " + i.message + (null != c ? c : ""));
      }
    }
  }
}

checkPropTypes.resetWarningCache = function () {
  "production" !== process.env.NODE_ENV && (loggedTypeFailures = {});
};

var checkPropTypes_1 = checkPropTypes,
    react_development = createCommonjsModule(function (Pe) {
  "production" !== process.env.NODE_ENV && function () {
    var h = objectAssign,
        o = checkPropTypes_1,
        e = "function" == typeof Symbol && Symbol.for,
        b = e ? Symbol.for("react.element") : 60103,
        v = e ? Symbol.for("react.portal") : 60106,
        u = e ? Symbol.for("react.fragment") : 60107,
        s = e ? Symbol.for("react.strict_mode") : 60108,
        c = e ? Symbol.for("react.profiler") : 60114,
        l = e ? Symbol.for("react.provider") : 60109,
        f = e ? Symbol.for("react.context") : 60110,
        p = e ? Symbol.for("react.concurrent_mode") : 60111,
        d = e ? Symbol.for("react.forward_ref") : 60112,
        y = e ? Symbol.for("react.suspense") : 60113,
        m = e ? Symbol.for("react.memo") : 60115,
        g = e ? Symbol.for("react.lazy") : 60116,
        r = "function" == typeof Symbol && Symbol.iterator,
        n = "@@iterator";

    function _(e) {
      if (null === e || "object" != typeof e) return null;
      var t = r && e[r] || e[n];
      return "function" == typeof t ? t : null;
    }

    var w = function w() {};

    function $(e, t, r, n, o, a, i, s) {
      if (w(t), !e) {
        var c = void 0;
        if (void 0 === t) c = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
          var u = [r, n, o, a, i, s],
              l = 0;
          (c = new Error(t.replace(/%s/g, function () {
            return u[l++];
          }))).name = "Invariant Violation";
        }
        throw c.framesToPop = 1, c;
      }
    }

    w = function w(e) {
      if (void 0 === e) throw new Error("invariant requires an error message argument");
    };

    var a = function a(e, t) {
      if (void 0 === t) throw new Error("`lowPriorityWarning(condition, format, ...args)` requires a warning message argument");

      if (!e) {
        for (var r = arguments.length, n = Array(2 < r ? r - 2 : 0), o = 2; o < r; o++) {
          n[o - 2] = arguments[o];
        }

        (function (e) {
          for (var t = arguments.length, r = Array(1 < t ? t - 1 : 0), n = 1; n < t; n++) {
            r[n - 1] = arguments[n];
          }

          var o = 0,
              a = "Warning: " + e.replace(/%s/g, function () {
            return r[o++];
          });
          "undefined" != typeof console && console.warn(a);

          try {
            throw new Error(a);
          } catch (e) {}
        }).apply(void 0, [t].concat(n));
      }
    },
        S = function S(e, t) {
      for (var r = arguments.length, n = Array(2 < r ? r - 2 : 0), o = 2; o < r; o++) {
        n[o - 2] = arguments[o];
      }

      if (void 0 === t) throw new Error("`warningWithoutStack(condition, format, ...args)` requires a warning message argument");
      if (8 < n.length) throw new Error("warningWithoutStack() currently supports at most 8 arguments.");

      if (!e) {
        if ("undefined" != typeof console) {
          var a = n.map(function (e) {
            return "" + e;
          });
          a.unshift("Warning: " + t), Function.prototype.apply.call(console.error, console, a);
        }

        try {
          var i = 0,
              s = "Warning: " + t.replace(/%s/g, function () {
            return n[i++];
          });
          throw new Error(s);
        } catch (e) {}
      }
    },
        i = {};

    function T(e, t) {
      var r = e.constructor,
          n = r && (r.displayName || r.name) || "ReactClass",
          o = n + "." + t;
      i[o] || (S(!1, "Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", t, n), i[o] = !0);
    }

    var P = {
      isMounted: function isMounted(e) {
        return !1;
      },
      enqueueForceUpdate: function enqueueForceUpdate(e, t, r) {
        T(e, "forceUpdate");
      },
      enqueueReplaceState: function enqueueReplaceState(e, t, r, n) {
        T(e, "replaceState");
      },
      enqueueSetState: function enqueueSetState(e, t, r, n) {
        T(e, "setState");
      }
    },
        x = {};

    function E(e, t, r) {
      this.props = e, this.context = t, this.refs = x, this.updater = r || P;
    }

    Object.freeze(x), E.prototype.isReactComponent = {}, E.prototype.setState = function (e, t) {
      "object" != typeof e && "function" != typeof e && null != e && $(!1, "setState(...): takes an object of state variables to update or a function which returns an object of state variables."), this.updater.enqueueSetState(this, e, t, "setState");
    }, E.prototype.forceUpdate = function (e) {
      this.updater.enqueueForceUpdate(this, e, "forceUpdate");
    };

    var t = {
      isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],
      replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]
    },
        C = function C(e, t) {
      Object.defineProperty(E.prototype, e, {
        get: function get() {
          a(!1, "%s(...) is deprecated in plain JavaScript React classes. %s", t[0], t[1]);
        }
      });
    };

    for (var O in t) {
      t.hasOwnProperty(O) && C(O, t[O]);
    }

    function A() {}

    function R(e, t, r) {
      this.props = e, this.context = t, this.refs = x, this.updater = r || P;
    }

    A.prototype = E.prototype;
    var N = R.prototype = new A();
    N.constructor = R, h(N, E.prototype), N.isPureReactComponent = !0;
    var j = {
      current: null
    },
        I = {
      current: null
    },
        k = /^(.*)[\\\/]/,
        F = 1;

    function M(e) {
      if (null == e) return null;
      if ("number" == typeof e.tag && S(!1, "Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), "function" == typeof e) return e.displayName || e.name || null;
      if ("string" == typeof e) return e;

      switch (e) {
        case p:
          return "ConcurrentMode";

        case u:
          return "Fragment";

        case v:
          return "Portal";

        case c:
          return "Profiler";

        case s:
          return "StrictMode";

        case y:
          return "Suspense";
      }

      if ("object" == typeof e) switch (e.$$typeof) {
        case f:
          return "Context.Consumer";

        case l:
          return "Context.Provider";

        case d:
          return o = (n = e).render, a = "ForwardRef", i = o.displayName || o.name || "", n.displayName || ("" !== i ? a + "(" + i + ")" : a);

        case m:
          return M(e.type);

        case g:
          var t = (r = e)._status === F ? r._result : null;
          if (t) return M(t);
      }
      var r, n, o, a, i;
      return null;
    }

    var D = {},
        L = null;

    function U(e) {
      L = e;
    }

    D.getCurrentStack = null, D.getStackAddendum = function () {
      var e = "";

      if (L) {
        var t = M(L.type),
            r = L._owner;

        e += function (e, t, r) {
          var n = "";

          if (t) {
            var o = t.fileName,
                a = o.replace(k, "");

            if (/^index\./.test(a)) {
              var i = o.match(k);

              if (i) {
                var s = i[1];
                s && (a = s.replace(k, "") + "/" + a);
              }
            }

            n = " (at " + a + ":" + t.lineNumber + ")";
          } else r && (n = " (created by " + r + ")");

          return "\n    in " + (e || "Unknown") + n;
        }(t, L._source, r && M(r.type));
      }

      var n = D.getCurrentStack;
      return n && (e += n() || ""), e;
    };
    var W = {
      ReactCurrentDispatcher: j,
      ReactCurrentOwner: I,
      assign: h
    };
    h(W, {
      ReactDebugCurrentFrame: D,
      ReactComponentTreeHook: {}
    });

    var V = function V(e, t) {
      if (!e) {
        for (var r = W.ReactDebugCurrentFrame.getStackAddendum(), n = arguments.length, o = Array(2 < n ? n - 2 : 0), a = 2; a < n; a++) {
          o[a - 2] = arguments[a];
        }

        S.apply(void 0, [!1, t + "%s"].concat(o, [r]));
      }
    },
        q = Object.prototype.hasOwnProperty,
        B = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    },
        H = void 0,
        G = void 0;

    function z(e) {
      if (q.call(e, "ref")) {
        var t = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (t && t.isReactWarning) return !1;
      }

      return void 0 !== e.ref;
    }

    function Y(e) {
      if (q.call(e, "key")) {
        var t = Object.getOwnPropertyDescriptor(e, "key").get;
        if (t && t.isReactWarning) return !1;
      }

      return void 0 !== e.key;
    }

    var K = function K(e, t, r, n, o, a, i) {
      var s = {
        $$typeof: b,
        type: e,
        key: t,
        ref: r,
        props: i,
        _owner: a,
        _store: {}
      };
      return Object.defineProperty(s._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(s, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: n
      }), Object.defineProperty(s, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: o
      }), Object.freeze && (Object.freeze(s.props), Object.freeze(s)), s;
    };

    function X(e, t, r) {
      var n = void 0,
          o = {},
          a = null,
          i = null,
          s = null,
          c = null;
      if (null != t) for (n in z(t) && (i = t.ref), Y(t) && (a = "" + t.key), s = void 0 === t.__self ? null : t.__self, c = void 0 === t.__source ? null : t.__source, t) {
        q.call(t, n) && !B.hasOwnProperty(n) && (o[n] = t[n]);
      }
      var u,
          l,
          f,
          p,
          d,
          h,
          y = arguments.length - 2;
      if (1 === y) o.children = r;else if (1 < y) {
        for (var m = Array(y), b = 0; b < y; b++) {
          m[b] = arguments[b + 2];
        }

        Object.freeze && Object.freeze(m), o.children = m;
      }

      if (e && e.defaultProps) {
        var v = e.defaultProps;

        for (n in v) {
          void 0 === o[n] && (o[n] = v[n]);
        }
      }

      if (a || i) {
        var g = "function" == typeof e ? e.displayName || e.name || "Unknown" : e;
        a && (p = o, d = g, (h = function h() {
          H || S(!(H = !0), "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://fb.me/react-special-props)", d);
        }).isReactWarning = !0, Object.defineProperty(p, "key", {
          get: h,
          configurable: !0
        })), i && (u = o, l = g, (f = function f() {
          G || S(!(G = !0), "%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://fb.me/react-special-props)", l);
        }).isReactWarning = !0, Object.defineProperty(u, "ref", {
          get: f,
          configurable: !0
        }));
      }

      return K(e, a, i, s, c, I.current, o);
    }

    function J(e) {
      return "object" == typeof e && null !== e && e.$$typeof === b;
    }

    var Z = ".",
        Q = ":";
    var ee = !1,
        te = /\/+/g;

    function re(e) {
      return ("" + e).replace(te, "$&/");
    }

    var ne = 10,
        oe = [];

    function ae(e, t, r, n) {
      if (oe.length) {
        var o = oe.pop();
        return o.result = e, o.keyPrefix = t, o.func = r, o.context = n, o.count = 0, o;
      }

      return {
        result: e,
        keyPrefix: t,
        func: r,
        context: n,
        count: 0
      };
    }

    function ie(e) {
      e.result = null, e.keyPrefix = null, e.func = null, e.context = null, e.count = 0, oe.length < ne && oe.push(e);
    }

    function se(e, t, r) {
      return null == e ? 0 : function e(t, r, n, o) {
        var a = typeof t;
        "undefined" !== a && "boolean" !== a || (t = null);
        var i = !1;
        if (null === t) i = !0;else switch (a) {
          case "string":
          case "number":
            i = !0;
            break;

          case "object":
            switch (t.$$typeof) {
              case b:
              case v:
                i = !0;
            }

        }
        if (i) return n(o, t, "" === r ? Z + ce(t, 0) : r), 1;
        var s = void 0,
            c = 0,
            u = "" === r ? Z : r + Q;
        if (Array.isArray(t)) for (var l = 0; l < t.length; l++) {
          c += e(s = t[l], u + ce(s, l), n, o);
        } else {
          var f = _(t);

          if ("function" == typeof f) {
            f === t.entries && (ee || V(!1, "Using Maps as children is unsupported and will likely yield unexpected results. Convert it to a sequence/iterable of keyed ReactElements instead."), ee = !0);

            for (var p = f.call(t), d = void 0, h = 0; !(d = p.next()).done;) {
              c += e(s = d.value, u + ce(s, h++), n, o);
            }
          } else if ("object" === a) {
            var y;
            y = " If you meant to render a collection of children, use an array instead." + D.getStackAddendum();
            var m = "" + t;
            $(!1, "Objects are not valid as a React child (found: %s).%s", "[object Object]" === m ? "object with keys {" + Object.keys(t).join(", ") + "}" : m, y);
          }
        }
        return c;
      }(e, "", t, r);
    }

    function ce(e, t) {
      return "object" == typeof e && null !== e && null != e.key ? (r = e.key, n = {
        "=": "=0",
        ":": "=2"
      }, "$" + ("" + r).replace(/[=:]/g, function (e) {
        return n[e];
      })) : t.toString(36);
      var r, n;
    }

    function ue(e, t, r) {
      var n = e.func,
          o = e.context;
      n.call(o, t, e.count++);
    }

    function le(e, t, r) {
      var n,
          o,
          a = e.result,
          i = e.keyPrefix,
          s = e.func,
          c = e.context,
          u = s.call(c, t, e.count++);
      Array.isArray(u) ? fe(u, a, r, function (e) {
        return e;
      }) : null != u && (J(u) && (o = i + (!(n = u).key || t && t.key === u.key ? "" : re(u.key) + "/") + r, u = K(n.type, o, n.ref, n._self, n._source, n._owner, n.props)), a.push(u));
    }

    function fe(e, t, r, n, o) {
      var a = "";
      null != r && (a = re(r) + "/");
      var i = ae(t, a, n, o);
      se(e, le, i), ie(i);
    }

    function pe(e) {
      return "string" == typeof e || "function" == typeof e || e === u || e === p || e === c || e === s || e === y || "object" == typeof e && null !== e && (e.$$typeof === g || e.$$typeof === m || e.$$typeof === l || e.$$typeof === f || e.$$typeof === d);
    }

    function de() {
      var e = j.current;
      return null === e && $(!1, "Hooks can only be called inside the body of a function component. (https://fb.me/react-invalid-hook-call)"), e;
    }

    var he = void 0;

    function ye() {
      if (I.current) {
        var e = M(I.current.type);
        if (e) return "\n\nCheck the render method of `" + e + "`.";
      }

      return "";
    }

    he = !1;
    var me = {};

    function be(e, t) {
      if (e._store && !e._store.validated && null == e.key) {
        e._store.validated = !0;

        var r = function (e) {
          var t = ye();

          if (!t) {
            var r = "string" == typeof e ? e : e.displayName || e.name;
            r && (t = "\n\nCheck the top-level render call using <" + r + ">.");
          }

          return t;
        }(t);

        if (!me[r]) {
          me[r] = !0;
          var n = "";
          e && e._owner && e._owner !== I.current && (n = " It was passed a child from " + M(e._owner.type) + "."), U(e), V(!1, 'Each child in a list should have a unique "key" prop.%s%s See https://fb.me/react-warning-keys for more information.', r, n), U(null);
        }
      }
    }

    function ve(e, t) {
      if ("object" == typeof e) if (Array.isArray(e)) for (var r = 0; r < e.length; r++) {
        var n = e[r];
        J(n) && be(n, t);
      } else if (J(e)) e._store && (e._store.validated = !0);else if (e) {
        var o = _(e);

        if ("function" == typeof o && o !== e.entries) for (var a = o.call(e), i = void 0; !(i = a.next()).done;) {
          J(i.value) && be(i.value, t);
        }
      }
    }

    function ge(e) {
      var t = e.type;

      if (null != t && "string" != typeof t) {
        var r = M(t),
            n = void 0;
        if ("function" == typeof t) n = t.propTypes;else {
          if ("object" != typeof t || t.$$typeof !== d && t.$$typeof !== m) return;
          n = t.propTypes;
        }
        n ? (U(e), o(n, e.props, "prop", r, D.getStackAddendum), U(null)) : void 0 === t.PropTypes || he || S(!(he = !0), "Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", r || "Unknown"), "function" == typeof t.getDefaultProps && (t.getDefaultProps.isReactClassApproved || S(!1, "getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead."));
      }
    }

    function _e(e, t, r) {
      var n = pe(e);

      if (!n) {
        var o = "";
        (void 0 === e || "object" == typeof e && null !== e && 0 === Object.keys(e).length) && (o += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");

        var a = function (e) {
          if (null == e || void 0 === e.__source) return "";
          var t = e.__source;
          return "\n\nCheck your code at " + t.fileName.replace(/^.*[\\\/]/, "") + ":" + t.lineNumber + ".";
        }(t);

        o += a || ye();
        var i = void 0;
        null === e ? i = "null" : Array.isArray(e) ? i = "array" : void 0 !== e && e.$$typeof === b ? (i = "<" + (M(e.type) || "Unknown") + " />", o = " Did you accidentally export a JSX literal instead of a component?") : i = typeof e, V(!1, "React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", i, o);
      }

      var s = X.apply(this, arguments);
      if (null == s) return s;
      if (n) for (var c = 2; c < arguments.length; c++) {
        ve(arguments[c], e);
      }
      return e === u ? function (e) {
        U(e);

        for (var t = Object.keys(e.props), r = 0; r < t.length; r++) {
          var n = t[r];

          if ("children" !== n && "key" !== n) {
            V(!1, "Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", n);
            break;
          }
        }

        null !== e.ref && V(!1, "Invalid attribute `ref` supplied to `React.Fragment`."), U(null);
      }(s) : ge(s), s;
    }

    var we = {
      Children: {
        map: function map(e, t, r) {
          if (null == e) return e;
          var n = [];
          return fe(e, n, null, t, r), n;
        },
        forEach: function forEach(e, t, r) {
          if (null == e) return e;
          var n = ae(null, null, t, r);
          se(e, ue, n), ie(n);
        },
        count: function count(e) {
          return se(e, function () {
            return null;
          }, null);
        },
        toArray: function toArray(e) {
          var t = [];
          return fe(e, t, null, function (e) {
            return e;
          }), t;
        },
        only: function only(e) {
          return J(e) || $(!1, "React.Children.only expected to receive a single React element child."), e;
        }
      },
      createRef: function createRef() {
        var e = {
          current: null
        };
        return Object.seal(e), e;
      },
      Component: E,
      PureComponent: R,
      createContext: function createContext(e, t) {
        void 0 === t ? t = null : null !== t && "function" != typeof t && S(!1, "createContext: Expected the optional second argument to be a function. Instead received: %s", t);
        var r = {
          $$typeof: f,
          _calculateChangedBits: t,
          _currentValue: e,
          _currentValue2: e,
          _threadCount: 0,
          Provider: null,
          Consumer: null
        },
            n = (r.Provider = {
          $$typeof: l,
          _context: r
        }, !1),
            o = !1,
            a = {
          $$typeof: f,
          _context: r,
          _calculateChangedBits: r._calculateChangedBits
        };
        return Object.defineProperties(a, {
          Provider: {
            get: function get() {
              return o || V(!(o = !0), "Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?"), r.Provider;
            },
            set: function set(e) {
              r.Provider = e;
            }
          },
          _currentValue: {
            get: function get() {
              return r._currentValue;
            },
            set: function set(e) {
              r._currentValue = e;
            }
          },
          _currentValue2: {
            get: function get() {
              return r._currentValue2;
            },
            set: function set(e) {
              r._currentValue2 = e;
            }
          },
          _threadCount: {
            get: function get() {
              return r._threadCount;
            },
            set: function set(e) {
              r._threadCount = e;
            }
          },
          Consumer: {
            get: function get() {
              return n || V(!(n = !0), "Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"), r.Consumer;
            }
          }
        }), r.Consumer = a, r._currentRenderer = null, r._currentRenderer2 = null, r;
      },
      forwardRef: function forwardRef(e) {
        return null != e && e.$$typeof === m ? S(!1, "forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : "function" != typeof e ? S(!1, "forwardRef requires a render function but was given %s.", null === e ? "null" : typeof e) : 0 !== e.length && 2 !== e.length && S(!1, "forwardRef render functions accept exactly two parameters: props and ref. %s", 1 === e.length ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined."), null != e && (null != e.defaultProps || null != e.propTypes) && S(!1, "forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?"), {
          $$typeof: d,
          render: e
        };
      },
      lazy: function lazy(e) {
        var t = {
          $$typeof: g,
          _ctor: e,
          _status: -1,
          _result: null
        },
            r = void 0,
            n = void 0;
        return Object.defineProperties(t, {
          defaultProps: {
            configurable: !0,
            get: function get() {
              return r;
            },
            set: function set(e) {
              V(!1, "React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), r = e, Object.defineProperty(t, "defaultProps", {
                enumerable: !0
              });
            }
          },
          propTypes: {
            configurable: !0,
            get: function get() {
              return n;
            },
            set: function set(e) {
              V(!1, "React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), n = e, Object.defineProperty(t, "propTypes", {
                enumerable: !0
              });
            }
          }
        }), t;
      },
      memo: function memo(e, t) {
        return pe(e) || S(!1, "memo: The first argument must be a component. Instead received: %s", null === e ? "null" : typeof e), {
          $$typeof: m,
          type: e,
          compare: void 0 === t ? null : t
        };
      },
      useCallback: function useCallback(e, t) {
        return de().useCallback(e, t);
      },
      useContext: function useContext(e, t) {
        var r = de();

        if (void 0 !== t && V(!1, "useContext() second argument is reserved for future use in React. Passing it is not supported. You passed: %s.%s", t, "number" == typeof t && Array.isArray(arguments[2]) ? "\n\nDid you call array.map(useContext)? Calling Hooks inside a loop is not supported. Learn more at https://fb.me/rules-of-hooks" : ""), void 0 !== e._context) {
          var n = e._context;
          n.Consumer === e ? V(!1, "Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?") : n.Provider === e && V(!1, "Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
        }

        return r.useContext(e, t);
      },
      useEffect: function useEffect(e, t) {
        return de().useEffect(e, t);
      },
      useImperativeHandle: function useImperativeHandle(e, t, r) {
        return de().useImperativeHandle(e, t, r);
      },
      useDebugValue: function useDebugValue(e, t) {
        return de().useDebugValue(e, t);
      },
      useLayoutEffect: function useLayoutEffect(e, t) {
        return de().useLayoutEffect(e, t);
      },
      useMemo: function useMemo(e, t) {
        return de().useMemo(e, t);
      },
      useReducer: function useReducer(e, t, r) {
        return de().useReducer(e, t, r);
      },
      useRef: function useRef(e) {
        return de().useRef(e);
      },
      useState: function useState(e) {
        return de().useState(e);
      },
      Fragment: u,
      StrictMode: s,
      Suspense: y,
      createElement: _e,
      cloneElement: function cloneElement(e, t, r) {
        for (var n = function (e, t, r) {
          null == e && $(!1, "React.cloneElement(...): The argument must be a React element, but you passed %s.", e);
          var n = void 0,
              o = h({}, e.props),
              a = e.key,
              i = e.ref,
              s = e._self,
              c = e._source,
              u = e._owner;

          if (null != t) {
            z(t) && (i = t.ref, u = I.current), Y(t) && (a = "" + t.key);
            var l = void 0;

            for (n in e.type && e.type.defaultProps && (l = e.type.defaultProps), t) {
              q.call(t, n) && !B.hasOwnProperty(n) && (void 0 === t[n] && void 0 !== l ? o[n] = l[n] : o[n] = t[n]);
            }
          }

          var f = arguments.length - 2;
          if (1 === f) o.children = r;else if (1 < f) {
            for (var p = Array(f), d = 0; d < f; d++) {
              p[d] = arguments[d + 2];
            }

            o.children = p;
          }
          return K(e.type, a, i, s, c, u, o);
        }.apply(this, arguments), o = 2; o < arguments.length; o++) {
          ve(arguments[o], n.type);
        }

        return ge(n), n;
      },
      createFactory: function createFactory(e) {
        var t = _e.bind(null, e);

        return t.type = e, Object.defineProperty(t, "type", {
          enumerable: !1,
          get: function get() {
            return a(!1, "Factory.type is deprecated. Access the class directly before passing it to createFactory."), Object.defineProperty(this, "type", {
              value: e
            }), e;
          }
        }), t;
      },
      isValidElement: J,
      version: "16.8.3",
      unstable_ConcurrentMode: p,
      unstable_Profiler: c,
      __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: W
    },
        $e = Object.freeze({
      default: we
    }),
        Se = $e && we || $e,
        Te = Se.default || Se;
    Pe.exports = Te;
  }();
}),
    react = createCommonjsModule(function (e) {
  "production" === process.env.NODE_ENV ? e.exports = react_production_min : e.exports = react_development;
}),
    react_1 = react.Component,
    react_2 = react.PureComponent,
    react_3 = react.Fragment,
    react_4 = react.Children,
    react_5 = react.createElement,
    react_6 = react.createFactory,
    s = {
  root: "styles-module_root__1DcTU",
  content: "styles-module_content__1DbKZ",
  contentActive: "styles-module_contentActive__1Cac7"
};

function _defineProperty(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}

var defineProperty = _defineProperty,
    classnames = createCommonjsModule(function (e) {
  !function () {
    var i = {}.hasOwnProperty;

    function s() {
      for (var e = [], t = 0; t < arguments.length; t++) {
        var r = arguments[t];

        if (r) {
          var n = typeof r;
          if ("string" === n || "number" === n) e.push(r);else if (Array.isArray(r) && r.length) {
            var o = s.apply(null, r);
            o && e.push(o);
          } else if ("object" === n) for (var a in r) {
            i.call(r, a) && r[a] && e.push(a);
          }
        }
      }

      return e.join(" ");
    }

    e.exports ? (s.default = s, e.exports = s) : window.classNames = s;
  }();
}),
    reactIs_production_min = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = "function" == typeof Symbol && Symbol.for,
      n = r ? Symbol.for("react.element") : 60103,
      o = r ? Symbol.for("react.portal") : 60106,
      a = r ? Symbol.for("react.fragment") : 60107,
      i = r ? Symbol.for("react.strict_mode") : 60108,
      s = r ? Symbol.for("react.profiler") : 60114,
      c = r ? Symbol.for("react.provider") : 60109,
      u = r ? Symbol.for("react.context") : 60110,
      l = r ? Symbol.for("react.async_mode") : 60111,
      f = r ? Symbol.for("react.concurrent_mode") : 60111,
      p = r ? Symbol.for("react.forward_ref") : 60112,
      d = r ? Symbol.for("react.suspense") : 60113,
      h = r ? Symbol.for("react.memo") : 60115,
      y = r ? Symbol.for("react.lazy") : 60116;

  function m(e) {
    if ("object" == typeof e && null !== e) {
      var t = e.$$typeof;

      switch (t) {
        case n:
          switch (e = e.type) {
            case l:
            case f:
            case a:
            case s:
            case i:
            case d:
              return e;

            default:
              switch (e = e && e.$$typeof) {
                case u:
                case p:
                case c:
                  return e;

                default:
                  return t;
              }

          }

        case y:
        case h:
        case o:
          return t;
      }
    }
  }

  function b(e) {
    return m(e) === f;
  }

  t.typeOf = m, t.AsyncMode = l, t.ConcurrentMode = f, t.ContextConsumer = u, t.ContextProvider = c, t.Element = n, t.ForwardRef = p, t.Fragment = a, t.Lazy = y, t.Memo = h, t.Portal = o, t.Profiler = s, t.StrictMode = i, t.Suspense = d, t.isValidElementType = function (e) {
    return "string" == typeof e || "function" == typeof e || e === a || e === f || e === s || e === i || e === d || "object" == typeof e && null !== e && (e.$$typeof === y || e.$$typeof === h || e.$$typeof === c || e.$$typeof === u || e.$$typeof === p);
  }, t.isAsyncMode = function (e) {
    return b(e) || m(e) === l;
  }, t.isConcurrentMode = b, t.isContextConsumer = function (e) {
    return m(e) === u;
  }, t.isContextProvider = function (e) {
    return m(e) === c;
  }, t.isElement = function (e) {
    return "object" == typeof e && null !== e && e.$$typeof === n;
  }, t.isForwardRef = function (e) {
    return m(e) === p;
  }, t.isFragment = function (e) {
    return m(e) === a;
  }, t.isLazy = function (e) {
    return m(e) === y;
  }, t.isMemo = function (e) {
    return m(e) === h;
  }, t.isPortal = function (e) {
    return m(e) === o;
  }, t.isProfiler = function (e) {
    return m(e) === s;
  }, t.isStrictMode = function (e) {
    return m(e) === i;
  }, t.isSuspense = function (e) {
    return m(e) === d;
  };
});
unwrapExports(reactIs_production_min);
var reactIs_production_min_1 = reactIs_production_min.typeOf,
    reactIs_production_min_2 = reactIs_production_min.AsyncMode,
    reactIs_production_min_3 = reactIs_production_min.ConcurrentMode,
    reactIs_production_min_4 = reactIs_production_min.ContextConsumer,
    reactIs_production_min_5 = reactIs_production_min.ContextProvider,
    reactIs_production_min_6 = reactIs_production_min.Element,
    reactIs_production_min_7 = reactIs_production_min.ForwardRef,
    reactIs_production_min_8 = reactIs_production_min.Fragment,
    reactIs_production_min_9 = reactIs_production_min.Lazy,
    reactIs_production_min_10 = reactIs_production_min.Memo,
    reactIs_production_min_11 = reactIs_production_min.Portal,
    reactIs_production_min_12 = reactIs_production_min.Profiler,
    reactIs_production_min_13 = reactIs_production_min.StrictMode,
    reactIs_production_min_14 = reactIs_production_min.Suspense,
    reactIs_production_min_15 = reactIs_production_min.isValidElementType,
    reactIs_production_min_16 = reactIs_production_min.isAsyncMode,
    reactIs_production_min_17 = reactIs_production_min.isConcurrentMode,
    reactIs_production_min_18 = reactIs_production_min.isContextConsumer,
    reactIs_production_min_19 = reactIs_production_min.isContextProvider,
    reactIs_production_min_20 = reactIs_production_min.isElement,
    reactIs_production_min_21 = reactIs_production_min.isForwardRef,
    reactIs_production_min_22 = reactIs_production_min.isFragment,
    reactIs_production_min_23 = reactIs_production_min.isLazy,
    reactIs_production_min_24 = reactIs_production_min.isMemo,
    reactIs_production_min_25 = reactIs_production_min.isPortal,
    reactIs_production_min_26 = reactIs_production_min.isProfiler,
    reactIs_production_min_27 = reactIs_production_min.isStrictMode,
    reactIs_production_min_28 = reactIs_production_min.isSuspense,
    reactIs_development = createCommonjsModule(function (e, R) {
  "production" !== process.env.NODE_ENV && function () {
    Object.defineProperty(R, "__esModule", {
      value: !0
    });
    var e = "function" == typeof Symbol && Symbol.for,
        o = e ? Symbol.for("react.element") : 60103,
        a = e ? Symbol.for("react.portal") : 60106,
        i = e ? Symbol.for("react.fragment") : 60107,
        s = e ? Symbol.for("react.strict_mode") : 60108,
        c = e ? Symbol.for("react.profiler") : 60114,
        u = e ? Symbol.for("react.provider") : 60109,
        l = e ? Symbol.for("react.context") : 60110,
        f = e ? Symbol.for("react.async_mode") : 60111,
        p = e ? Symbol.for("react.concurrent_mode") : 60111,
        d = e ? Symbol.for("react.forward_ref") : 60112,
        h = e ? Symbol.for("react.suspense") : 60113,
        y = e ? Symbol.for("react.memo") : 60115,
        m = e ? Symbol.for("react.lazy") : 60116;

    var t = function t(e, _t) {
      if (void 0 === _t) throw new Error("`lowPriorityWarning(condition, format, ...args)` requires a warning message argument");

      if (!e) {
        for (var r = arguments.length, n = Array(2 < r ? r - 2 : 0), o = 2; o < r; o++) {
          n[o - 2] = arguments[o];
        }

        (function (e) {
          for (var t = arguments.length, r = Array(1 < t ? t - 1 : 0), n = 1; n < t; n++) {
            r[n - 1] = arguments[n];
          }

          var o = 0,
              a = "Warning: " + e.replace(/%s/g, function () {
            return r[o++];
          });
          "undefined" != typeof console && console.warn(a);

          try {
            throw new Error(a);
          } catch (e) {}
        }).apply(void 0, [_t].concat(n));
      }
    };

    function r(e) {
      if ("object" == typeof e && null !== e) {
        var t = e.$$typeof;

        switch (t) {
          case o:
            var r = e.type;

            switch (r) {
              case f:
              case p:
              case i:
              case c:
              case s:
              case h:
                return r;

              default:
                var n = r && r.$$typeof;

                switch (n) {
                  case l:
                  case d:
                  case u:
                    return n;

                  default:
                    return t;
                }

            }

          case m:
          case y:
          case a:
            return t;
        }
      }
    }

    var n = f,
        b = p,
        v = l,
        g = u,
        _ = o,
        w = d,
        $ = i,
        S = m,
        T = y,
        P = a,
        x = c,
        E = s,
        C = h,
        O = !1;

    function A(e) {
      return r(e) === p;
    }

    R.typeOf = r, R.AsyncMode = n, R.ConcurrentMode = b, R.ContextConsumer = v, R.ContextProvider = g, R.Element = _, R.ForwardRef = w, R.Fragment = $, R.Lazy = S, R.Memo = T, R.Portal = P, R.Profiler = x, R.StrictMode = E, R.Suspense = C, R.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === i || e === p || e === c || e === s || e === h || "object" == typeof e && null !== e && (e.$$typeof === m || e.$$typeof === y || e.$$typeof === u || e.$$typeof === l || e.$$typeof === d);
    }, R.isAsyncMode = function (e) {
      return O || t(!(O = !0), "The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API."), A(e) || r(e) === f;
    }, R.isConcurrentMode = A, R.isContextConsumer = function (e) {
      return r(e) === l;
    }, R.isContextProvider = function (e) {
      return r(e) === u;
    }, R.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === o;
    }, R.isForwardRef = function (e) {
      return r(e) === d;
    }, R.isFragment = function (e) {
      return r(e) === i;
    }, R.isLazy = function (e) {
      return r(e) === m;
    }, R.isMemo = function (e) {
      return r(e) === y;
    }, R.isPortal = function (e) {
      return r(e) === a;
    }, R.isProfiler = function (e) {
      return r(e) === c;
    }, R.isStrictMode = function (e) {
      return r(e) === s;
    }, R.isSuspense = function (e) {
      return r(e) === h;
    };
  }();
});
unwrapExports(reactIs_development);

var reactIs_development_1 = reactIs_development.typeOf,
    reactIs_development_2 = reactIs_development.AsyncMode,
    reactIs_development_3 = reactIs_development.ConcurrentMode,
    reactIs_development_4 = reactIs_development.ContextConsumer,
    reactIs_development_5 = reactIs_development.ContextProvider,
    reactIs_development_6 = reactIs_development.Element,
    reactIs_development_7 = reactIs_development.ForwardRef,
    reactIs_development_8 = reactIs_development.Fragment,
    reactIs_development_9 = reactIs_development.Lazy,
    reactIs_development_10 = reactIs_development.Memo,
    reactIs_development_11 = reactIs_development.Portal,
    reactIs_development_12 = reactIs_development.Profiler,
    reactIs_development_13 = reactIs_development.StrictMode,
    reactIs_development_14 = reactIs_development.Suspense,
    reactIs_development_15 = reactIs_development.isValidElementType,
    reactIs_development_16 = reactIs_development.isAsyncMode,
    reactIs_development_17 = reactIs_development.isConcurrentMode,
    reactIs_development_18 = reactIs_development.isContextConsumer,
    reactIs_development_19 = reactIs_development.isContextProvider,
    reactIs_development_20 = reactIs_development.isElement,
    reactIs_development_21 = reactIs_development.isForwardRef,
    reactIs_development_22 = reactIs_development.isFragment,
    reactIs_development_23 = reactIs_development.isLazy,
    reactIs_development_24 = reactIs_development.isMemo,
    reactIs_development_25 = reactIs_development.isPortal,
    reactIs_development_26 = reactIs_development.isProfiler,
    reactIs_development_27 = reactIs_development.isStrictMode,
    reactIs_development_28 = reactIs_development.isSuspense,
    reactIs = createCommonjsModule(function (e) {
  "production" === process.env.NODE_ENV ? e.exports = reactIs_production_min : e.exports = reactIs_development;
}),
    reactIs_1 = reactIs.isValidElementType,
    has$1 = Function.call.bind(Object.prototype.hasOwnProperty),
    printWarning$1 = function printWarning$1() {};

function emptyFunctionThatReturnsNull() {
  return null;
}

"production" !== process.env.NODE_ENV && (printWarning$1 = function printWarning$1(e) {
  var t = "Warning: " + e;
  "undefined" != typeof console && console.error(t);

  try {
    throw new Error(t);
  } catch (e) {}
});

var factoryWithTypeCheckers = function factoryWithTypeCheckers(s, p) {
  var a = "function" == typeof Symbol && Symbol.iterator,
      i = "@@iterator";
  var d = "<<anonymous>>",
      e = {
    array: t("array"),
    bool: t("boolean"),
    func: t("function"),
    number: t("number"),
    object: t("object"),
    string: t("string"),
    symbol: t("symbol"),
    any: r(emptyFunctionThatReturnsNull),
    arrayOf: function arrayOf(u) {
      return r(function (e, t, r, n, o) {
        if ("function" != typeof u) return new h("Property `" + o + "` of component `" + r + "` has invalid PropType notation inside arrayOf.");
        var a = e[t];

        if (!Array.isArray(a)) {
          var i = y(a);
          return new h("Invalid " + n + " `" + o + "` of type `" + i + "` supplied to `" + r + "`, expected an array.");
        }

        for (var s = 0; s < a.length; s++) {
          var c = u(a, s, r, n, o + "[" + s + "]", ReactPropTypesSecret_1);
          if (c instanceof Error) return c;
        }

        return null;
      });
    },
    element: r(function (e, t, r, n, o) {
      var a = e[t];
      if (s(a)) return null;
      var i = y(a);
      return new h("Invalid " + n + " `" + o + "` of type `" + i + "` supplied to `" + r + "`, expected a single ReactElement.");
    }),
    elementType: r(function (e, t, r, n, o) {
      var a = e[t];
      if (reactIs.isValidElementType(a)) return null;
      var i = y(a);
      return new h("Invalid " + n + " `" + o + "` of type `" + i + "` supplied to `" + r + "`, expected a single ReactElement type.");
    }),
    instanceOf: function instanceOf(c) {
      return r(function (e, t, r, n, o) {
        if (e[t] instanceof c) return null;
        var a = c.name || d,
            i = (s = e[t], s.constructor && s.constructor.name ? s.constructor.name : d);
        var s;
        return new h("Invalid " + n + " `" + o + "` of type `" + i + "` supplied to `" + r + "`, expected instance of `" + a + "`.");
      });
    },
    node: r(function (e, t, r, n, o) {
      return c(e[t]) ? null : new h("Invalid " + n + " `" + o + "` supplied to `" + r + "`, expected a ReactNode.");
    }),
    objectOf: function objectOf(u) {
      return r(function (e, t, r, n, o) {
        if ("function" != typeof u) return new h("Property `" + o + "` of component `" + r + "` has invalid PropType notation inside objectOf.");
        var a = e[t],
            i = y(a);
        if ("object" !== i) return new h("Invalid " + n + " `" + o + "` of type `" + i + "` supplied to `" + r + "`, expected an object.");

        for (var s in a) {
          if (has$1(a, s)) {
            var c = u(a, s, r, n, o + "." + s, ReactPropTypesSecret_1);
            if (c instanceof Error) return c;
          }
        }

        return null;
      });
    },
    oneOf: function oneOf(c) {
      if (!Array.isArray(c)) return "production" !== process.env.NODE_ENV && (1 < arguments.length ? printWarning$1("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).") : printWarning$1("Invalid argument supplied to oneOf, expected an array.")), emptyFunctionThatReturnsNull;
      return r(function (e, t, r, n, o) {
        for (var a = e[t], i = 0; i < c.length; i++) {
          if (u(a, c[i])) return null;
        }

        var s = JSON.stringify(c, function (e, t) {
          var r = l(t);
          return "symbol" === r ? String(t) : t;
        });
        return new h("Invalid " + n + " `" + o + "` of value `" + String(a) + "` supplied to `" + r + "`, expected one of " + s + ".");
      });
    },
    oneOfType: function oneOfType(s) {
      if (!Array.isArray(s)) return "production" !== process.env.NODE_ENV && printWarning$1("Invalid argument supplied to oneOfType, expected an instance of array."), emptyFunctionThatReturnsNull;

      for (var e = 0; e < s.length; e++) {
        var t = s[e];
        if ("function" != typeof t) return printWarning$1("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + n(t) + " at index " + e + "."), emptyFunctionThatReturnsNull;
      }

      return r(function (e, t, r, n, o) {
        for (var a = 0; a < s.length; a++) {
          var i = s[a];
          if (null == i(e, t, r, n, o, ReactPropTypesSecret_1)) return null;
        }

        return new h("Invalid " + n + " `" + o + "` supplied to `" + r + "`.");
      });
    },
    shape: function shape(l) {
      return r(function (e, t, r, n, o) {
        var a = e[t],
            i = y(a);
        if ("object" !== i) return new h("Invalid " + n + " `" + o + "` of type `" + i + "` supplied to `" + r + "`, expected `object`.");

        for (var s in l) {
          var c = l[s];

          if (c) {
            var u = c(a, s, r, n, o + "." + s, ReactPropTypesSecret_1);
            if (u) return u;
          }
        }

        return null;
      });
    },
    exact: function exact(f) {
      return r(function (e, t, r, n, o) {
        var a = e[t],
            i = y(a);
        if ("object" !== i) return new h("Invalid " + n + " `" + o + "` of type `" + i + "` supplied to `" + r + "`, expected `object`.");
        var s = objectAssign({}, e[t], f);

        for (var c in s) {
          var u = f[c];
          if (!u) return new h("Invalid " + n + " `" + o + "` key `" + c + "` supplied to `" + r + "`.\nBad object: " + JSON.stringify(e[t], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(f), null, "  "));
          var l = u(a, c, r, n, o + "." + c, ReactPropTypesSecret_1);
          if (l) return l;
        }

        return null;
      });
    }
  };

  function u(e, t) {
    return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
  }

  function h(e) {
    this.message = e, this.stack = "";
  }

  function r(u) {
    if ("production" !== process.env.NODE_ENV) var l = {},
        f = 0;

    function e(e, t, r, n, o, a, i) {
      if (n = n || d, a = a || r, i !== ReactPropTypesSecret_1) {
        if (p) {
          var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
          throw s.name = "Invariant Violation", s;
        }

        if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
          var c = n + ":" + r;
          !l[c] && f < 3 && (printWarning$1("You are manually calling a React.PropTypes validation function for the `" + a + "` prop on `" + n + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), l[c] = !0, f++);
        }
      }

      return null == t[r] ? e ? null === t[r] ? new h("The " + o + " `" + a + "` is marked as required in `" + n + "`, but its value is `null`.") : new h("The " + o + " `" + a + "` is marked as required in `" + n + "`, but its value is `undefined`.") : null : u(t, r, n, o, a);
    }

    var t = e.bind(null, !1);
    return t.isRequired = e.bind(null, !0), t;
  }

  function t(s) {
    return r(function (e, t, r, n, o, a) {
      var i = e[t];
      return y(i) === s ? null : new h("Invalid " + n + " `" + o + "` of type `" + l(i) + "` supplied to `" + r + "`, expected `" + s + "`.");
    });
  }

  function c(e) {
    switch (typeof e) {
      case "number":
      case "string":
      case "undefined":
        return !0;

      case "boolean":
        return !e;

      case "object":
        if (Array.isArray(e)) return e.every(c);
        if (null === e || s(e)) return !0;

        var t = function (e) {
          var t = e && (a && e[a] || e[i]);
          if ("function" == typeof t) return t;
        }(e);

        if (!t) return !1;
        var r,
            n = t.call(e);

        if (t !== e.entries) {
          for (; !(r = n.next()).done;) {
            if (!c(r.value)) return !1;
          }
        } else for (; !(r = n.next()).done;) {
          var o = r.value;
          if (o && !c(o[1])) return !1;
        }

        return !0;

      default:
        return !1;
    }
  }

  function y(e) {
    var t,
        r = typeof e;
    return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : (t = e, "symbol" === r || t && ("Symbol" === t["@@toStringTag"] || "function" == typeof Symbol && t instanceof Symbol) ? "symbol" : r);
  }

  function l(e) {
    if (null == e) return "" + e;
    var t = y(e);

    if ("object" === t) {
      if (e instanceof Date) return "date";
      if (e instanceof RegExp) return "regexp";
    }

    return t;
  }

  function n(e) {
    var t = l(e);

    switch (t) {
      case "array":
      case "object":
        return "an " + t;

      case "boolean":
      case "date":
      case "regexp":
        return "a " + t;

      default:
        return t;
    }
  }

  return h.prototype = Error.prototype, e.checkPropTypes = checkPropTypes_1, e.resetWarningCache = checkPropTypes_1.resetWarningCache, e.PropTypes = e;
};

function emptyFunction() {}

function emptyFunctionWithReset() {}

emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function factoryWithThrowingShims() {
  function e(e, t, r, n, o, a) {
    if (a !== ReactPropTypesSecret_1) {
      var i = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      throw i.name = "Invariant Violation", i;
    }
  }

  function t() {
    return e;
  }

  var r = {
    array: e.isRequired = e,
    bool: e,
    func: e,
    number: e,
    object: e,
    string: e,
    symbol: e,
    any: e,
    arrayOf: t,
    element: e,
    elementType: e,
    instanceOf: t,
    node: e,
    objectOf: t,
    oneOf: t,
    oneOfType: t,
    shape: t,
    exact: t,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  return r.PropTypes = r;
},
    propTypes = createCommonjsModule(function (e) {
  if ("production" !== process.env.NODE_ENV) {
    var t = reactIs;
    e.exports = factoryWithTypeCheckers(t.isElement, !0);
  } else e.exports = factoryWithThrowingShims();
}),
    ComponentType = propTypes.oneOfType([propTypes.string, propTypes.func]),
    s$1 = {
  root: "styles-module_root__13efy",
  down: "styles-module_down__mOClV",
  up: "styles-module_up__1iqX3",
  right: "styles-module_right__te_9f",
  left: "styles-module_left__3u9Iv"
},
    Arrow = function Arrow(e) {
  var t = e.className,
      r = e.direction;
  return react.createElement("i", {
    className: classnames(s$1.root, s$1[r], t)
  });
};

Arrow.defaultProps = {
  className: null
};

var s$2 = {
  header: "styles-module_header__2xwSU",
  headerActive: "styles-module_headerActive__1VLld",
  arrow: "styles-module_arrow__PDFR3",
  arrowActive: "styles-module_arrowActive__2BGdD"
},
    AccordionHeader = function AccordionHeader(e) {
  var t = e.active,
      r = e.children,
      n = e.component,
      o = objectWithoutProperties(e, ["active", "children", "component"]);
  return react.createElement(n, _extends_1({
    className: classnames(s$2.header, defineProperty({}, s$2.headerActive, t))
  }, o), r, react.createElement(Arrow, {
    className: classnames(s$2.arrow, defineProperty({}, s$2.arrowActive, t)),
    direction: t ? "up" : "down"
  }));
};

AccordionHeader.defaultProps = {
  active: !1,
  component: "div"
};

var s$3 = {
  root: "styles-module_root__1e5X8"
},
    AccordionItem = function AccordionItem(e) {
  var t = e.children,
      r = objectWithoutProperties(e, ["children"]);
  return react.createElement("div", _extends_1({
    className: s$3.root
  }, r), t);
},
    Accordion = function Accordion(e) {
  var t = e.children,
      r = objectWithoutProperties(e, ["children"]);
  return react.createElement("div", _extends_1({
    className: s.root
  }, r), t);
};

function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

var classCallCheck = _classCallCheck;

function _defineProperties(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}

function _createClass(e, t, r) {
  return t && _defineProperties(e.prototype, t), r && _defineProperties(e, r), e;
}

var createClass = _createClass,
    _typeof_1 = createCommonjsModule(function (t) {
  function r(e) {
    return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function n(e) {
    return "function" == typeof Symbol && "symbol" === r(Symbol.iterator) ? t.exports = n = function n(e) {
      return r(e);
    } : t.exports = n = function n(e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : r(e);
    }, n(e);
  }

  t.exports = n;
});

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

var assertThisInitialized = _assertThisInitialized;

function _possibleConstructorReturn(e, t) {
  return !t || "object" !== _typeof_1(t) && "function" != typeof t ? assertThisInitialized(e) : t;
}

var possibleConstructorReturn = _possibleConstructorReturn,
    getPrototypeOf = createCommonjsModule(function (t) {
  function r(e) {
    return t.exports = r = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    }, r(e);
  }

  t.exports = r;
}),
    setPrototypeOf = createCommonjsModule(function (r) {
  function n(e, t) {
    return r.exports = n = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    }, n(e, t);
  }

  r.exports = n;
});

function _inherits(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && setPrototypeOf(e, t);
}

var keysShim,
    inherits = _inherits,
    toStr = Object.prototype.toString,
    isArguments = function isArguments(e) {
  var t = toStr.call(e),
      r = "[object Arguments]" === t;
  return r || (r = "[object Array]" !== t && null !== e && "object" == typeof e && "number" == typeof e.length && 0 <= e.length && "[object Function]" === toStr.call(e.callee)), r;
};

if (!Object.keys) {
  var has$2 = Object.prototype.hasOwnProperty,
      toStr$1 = Object.prototype.toString,
      isArgs = isArguments,
      isEnumerable = Object.prototype.propertyIsEnumerable,
      hasDontEnumBug = !isEnumerable.call({
    toString: null
  }, "toString"),
      hasProtoEnumBug = isEnumerable.call(function () {}, "prototype"),
      dontEnums = ["toString", "toLocaleString", "valueOf", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "constructor"],
      equalsConstructorPrototype = function equalsConstructorPrototype(e) {
    var t = e.constructor;
    return t && t.prototype === e;
  },
      excludedKeys = {
    $applicationCache: !0,
    $console: !0,
    $external: !0,
    $frame: !0,
    $frameElement: !0,
    $frames: !0,
    $innerHeight: !0,
    $innerWidth: !0,
    $outerHeight: !0,
    $outerWidth: !0,
    $pageXOffset: !0,
    $pageYOffset: !0,
    $parent: !0,
    $scrollLeft: !0,
    $scrollTop: !0,
    $scrollX: !0,
    $scrollY: !0,
    $self: !0,
    $webkitIndexedDB: !0,
    $webkitStorageInfo: !0,
    $window: !0
  },
      hasAutomationEqualityBug = function () {
    if ("undefined" == typeof window) return !1;

    for (var e in window) {
      try {
        if (!excludedKeys["$" + e] && has$2.call(window, e) && null !== window[e] && "object" == typeof window[e]) try {
          equalsConstructorPrototype(window[e]);
        } catch (e) {
          return !0;
        }
      } catch (e) {
        return !0;
      }
    }

    return !1;
  }(),
      equalsConstructorPrototypeIfNotBuggy = function equalsConstructorPrototypeIfNotBuggy(e) {
    if ("undefined" == typeof window || !hasAutomationEqualityBug) return equalsConstructorPrototype(e);

    try {
      return equalsConstructorPrototype(e);
    } catch (e) {
      return !1;
    }
  };

  keysShim = function keysShim(e) {
    var t = null !== e && "object" == typeof e,
        r = "[object Function]" === toStr$1.call(e),
        n = isArgs(e),
        o = t && "[object String]" === toStr$1.call(e),
        a = [];
    if (!t && !r && !n) throw new TypeError("Object.keys called on a non-object");
    var i = hasProtoEnumBug && r;
    if (o && 0 < e.length && !has$2.call(e, 0)) for (var s = 0; s < e.length; ++s) {
      a.push(String(s));
    }
    if (n && 0 < e.length) for (var c = 0; c < e.length; ++c) {
      a.push(String(c));
    } else for (var u in e) {
      i && "prototype" === u || !has$2.call(e, u) || a.push(String(u));
    }
    if (hasDontEnumBug) for (var l = equalsConstructorPrototypeIfNotBuggy(e), f = 0; f < dontEnums.length; ++f) {
      l && "constructor" === dontEnums[f] || !has$2.call(e, dontEnums[f]) || a.push(dontEnums[f]);
    }
    return a;
  };
}

var implementation = keysShim,
    slice = Array.prototype.slice,
    origKeys = Object.keys,
    keysShim$1 = origKeys ? function (e) {
  return origKeys(e);
} : implementation,
    originalKeys = Object.keys;

keysShim$1.shim = function () {
  Object.keys ? function () {
    var e = Object.keys(arguments);
    return e && e.length === arguments.length;
  }(1, 2) || (Object.keys = function (e) {
    return isArguments(e) ? originalKeys(slice.call(e)) : originalKeys(e);
  }) : Object.keys = keysShim$1;
  return Object.keys || keysShim$1;
};

var objectKeys = keysShim$1,
    hasSymbols = "function" == typeof Symbol && "symbol" == typeof Symbol("foo"),
    toStr$2 = Object.prototype.toString,
    concat = Array.prototype.concat,
    origDefineProperty = Object.defineProperty,
    isFunction = function isFunction(e) {
  return "function" == typeof e && "[object Function]" === toStr$2.call(e);
},
    arePropertyDescriptorsSupported = function arePropertyDescriptorsSupported() {
  var e = {};

  try {
    for (var t in origDefineProperty(e, "x", {
      enumerable: !1,
      value: e
    }), e) {
      return !1;
    }

    return e.x === e;
  } catch (e) {
    return !1;
  }
},
    supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported(),
    defineProperty$1 = function defineProperty$1(e, t, r, n) {
  (!(t in e) || isFunction(n) && n()) && (supportsDescriptors ? origDefineProperty(e, t, {
    configurable: !0,
    enumerable: !1,
    value: r,
    writable: !0
  }) : e[t] = r);
},
    defineProperties = function defineProperties(e, t) {
  var r = 2 < arguments.length ? arguments[2] : {},
      n = objectKeys(t);
  hasSymbols && (n = concat.call(n, Object.getOwnPropertySymbols(t)));

  for (var o = 0; o < n.length; o += 1) {
    defineProperty$1(e, n[o], t[n[o]], r[n[o]]);
  }
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

var undefined$1,
    defineProperties_1 = defineProperties,
    ERROR_MESSAGE = "Function.prototype.bind called on incompatible ",
    slice$1 = Array.prototype.slice,
    toStr$3 = Object.prototype.toString,
    funcType = "[object Function]",
    implementation$1 = function implementation$1(t) {
  var r = this;
  if ("function" != typeof r || toStr$3.call(r) !== funcType) throw new TypeError(ERROR_MESSAGE + r);

  for (var n, o = slice$1.call(arguments, 1), e = Math.max(0, r.length - o.length), a = [], i = 0; i < e; i++) {
    a.push("$" + i);
  }

  if (n = Function("binder", "return function (" + a.join(",") + "){ return binder.apply(this,arguments); }")(function () {
    if (this instanceof n) {
      var e = r.apply(this, o.concat(slice$1.call(arguments)));
      return Object(e) === e ? e : this;
    }

    return r.apply(t, o.concat(slice$1.call(arguments)));
  }), r.prototype) {
    var s = function s() {};

    s.prototype = r.prototype, n.prototype = new s(), s.prototype = null;
  }

  return n;
},
    functionBind = Function.prototype.bind || implementation$1,
    src = functionBind.call(Function.call, Object.prototype.hasOwnProperty),
    isPrimitive = function isPrimitive(e) {
  return null === e || "function" != typeof e && "object" != typeof e;
},
    fnToStr = Function.prototype.toString,
    constructorRegex = /^\s*class\b/,
    isES6ClassFn = function isES6ClassFn(e) {
  try {
    var t = fnToStr.call(e);
    return constructorRegex.test(t);
  } catch (e) {
    return !1;
  }
},
    tryFunctionObject = function tryFunctionObject(e) {
  try {
    return !isES6ClassFn(e) && (fnToStr.call(e), !0);
  } catch (e) {
    return !1;
  }
},
    toStr$4 = Object.prototype.toString,
    fnClass = "[object Function]",
    genClass = "[object GeneratorFunction]",
    hasToStringTag = "function" == typeof Symbol && "symbol" == typeof Symbol.toStringTag,
    isCallable = function isCallable(e) {
  if (!e) return !1;
  if ("function" != typeof e && "object" != typeof e) return !1;
  if ("function" == typeof e && !e.prototype) return !0;
  if (hasToStringTag) return tryFunctionObject(e);
  if (isES6ClassFn(e)) return !1;
  var t = toStr$4.call(e);
  return t === fnClass || t === genClass;
},
    getDay = Date.prototype.getDay,
    tryDateObject = function tryDateObject(e) {
  try {
    return getDay.call(e), !0;
  } catch (e) {
    return !1;
  }
},
    toStr$5 = Object.prototype.toString,
    dateClass = "[object Date]",
    hasToStringTag$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.toStringTag,
    isDateObject = function isDateObject(e) {
  return "object" == typeof e && null !== e && (hasToStringTag$1 ? tryDateObject(e) : toStr$5.call(e) === dateClass);
},
    shams = function shams() {
  if ("function" != typeof Symbol || "function" != typeof Object.getOwnPropertySymbols) return !1;
  if ("symbol" == typeof Symbol.iterator) return !0;
  var e = {},
      t = Symbol("test"),
      r = Object(t);
  if ("string" == typeof t) return !1;
  if ("[object Symbol]" !== Object.prototype.toString.call(t)) return !1;
  if ("[object Symbol]" !== Object.prototype.toString.call(r)) return !1;

  for (t in e[t] = 42, e) {
    return !1;
  }

  if ("function" == typeof Object.keys && 0 !== Object.keys(e).length) return !1;
  if ("function" == typeof Object.getOwnPropertyNames && 0 !== Object.getOwnPropertyNames(e).length) return !1;
  var n = Object.getOwnPropertySymbols(e);
  if (1 !== n.length || n[0] !== t) return !1;
  if (!Object.prototype.propertyIsEnumerable.call(e, t)) return !1;

  if ("function" == typeof Object.getOwnPropertyDescriptor) {
    var o = Object.getOwnPropertyDescriptor(e, t);
    if (42 !== o.value || !0 !== o.enumerable) return !1;
  }

  return !0;
},
    origSymbol = commonjsGlobal.Symbol,
    hasSymbols$1 = function hasSymbols$1() {
  return "function" == typeof origSymbol && "function" == typeof Symbol && "symbol" == typeof origSymbol("foo") && "symbol" == typeof Symbol("bar") && shams();
},
    isSymbol = createCommonjsModule(function (e) {
  var r = Object.prototype.toString;

  if (hasSymbols$1()) {
    var n = Symbol.prototype.toString,
        o = /^Symbol\(.*\)$/;

    e.exports = function (e) {
      if ("symbol" == typeof e) return !0;
      if ("[object Symbol]" !== r.call(e)) return !1;

      try {
        return "symbol" == typeof (t = e).valueOf() && o.test(n.call(t));
      } catch (e) {
        return !1;
      }

      var t;
    };
  } else e.exports = function (e) {
    return !1;
  };
}),
    hasSymbols$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator,
    ordinaryToPrimitive = function ordinaryToPrimitive(e, t) {
  if (null == e) throw new TypeError("Cannot call method on " + e);
  if ("string" != typeof t || "number" !== t && "string" !== t) throw new TypeError('hint must be "string" or "number"');
  var r,
      n,
      o,
      a = "string" === t ? ["toString", "valueOf"] : ["valueOf", "toString"];

  for (o = 0; o < a.length; ++o) {
    if (r = e[a[o]], isCallable(r) && (n = r.call(e), isPrimitive(n))) return n;
  }

  throw new TypeError("No default value");
},
    GetMethod = function GetMethod(e, t) {
  var r = e[t];

  if (null != r) {
    if (!isCallable(r)) throw new TypeError(r + " returned for property " + t + " of object " + e + " is not a function");
    return r;
  }
},
    es2015 = function es2015(e) {
  if (isPrimitive(e)) return e;
  var t,
      r = "default";
  if (1 < arguments.length && (arguments[1] === String ? r = "string" : arguments[1] === Number && (r = "number")), hasSymbols$2 && (Symbol.toPrimitive ? t = GetMethod(e, Symbol.toPrimitive) : isSymbol(e) && (t = Symbol.prototype.valueOf)), void 0 === t) return "default" === r && (isDateObject(e) || isSymbol(e)) && (r = "string"), ordinaryToPrimitive(e, "default" === r ? "number" : r);
  var n = t.call(e, r);
  if (isPrimitive(n)) return n;
  throw new TypeError("unable to convert exotic object to primitive");
},
    es6 = es2015,
    ThrowTypeError = Object.getOwnPropertyDescriptor ? function () {
  return Object.getOwnPropertyDescriptor(arguments, "callee").get;
}() : function () {
  throw new TypeError();
},
    hasSymbols$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator,
    getProto = Object.getPrototypeOf || function (e) {
  return e.__proto__;
},
    generatorFunction = undefined$1,
    asyncFunction = undefined$1,
    asyncGenFunction = undefined$1,
    TypedArray = "undefined" == typeof Uint8Array ? undefined$1 : getProto(Uint8Array),
    INTRINSICS = {
  "$ %Array%": Array,
  "$ %ArrayBuffer%": "undefined" == typeof ArrayBuffer ? undefined$1 : ArrayBuffer,
  "$ %ArrayBufferPrototype%": "undefined" == typeof ArrayBuffer ? undefined$1 : ArrayBuffer.prototype,
  "$ %ArrayIteratorPrototype%": hasSymbols$3 ? getProto([][Symbol.iterator]()) : undefined$1,
  "$ %ArrayPrototype%": Array.prototype,
  "$ %ArrayProto_entries%": Array.prototype.entries,
  "$ %ArrayProto_forEach%": Array.prototype.forEach,
  "$ %ArrayProto_keys%": Array.prototype.keys,
  "$ %ArrayProto_values%": Array.prototype.values,
  "$ %AsyncFromSyncIteratorPrototype%": undefined$1,
  "$ %AsyncFunction%": asyncFunction,
  "$ %AsyncFunctionPrototype%": undefined$1,
  "$ %AsyncGenerator%": undefined$1,
  "$ %AsyncGeneratorFunction%": asyncGenFunction,
  "$ %AsyncGeneratorPrototype%": undefined$1,
  "$ %AsyncIteratorPrototype%": undefined$1,
  "$ %Atomics%": "undefined" == typeof Atomics ? undefined$1 : Atomics,
  "$ %Boolean%": Boolean,
  "$ %BooleanPrototype%": Boolean.prototype,
  "$ %DataView%": "undefined" == typeof DataView ? undefined$1 : DataView,
  "$ %DataViewPrototype%": "undefined" == typeof DataView ? undefined$1 : DataView.prototype,
  "$ %Date%": Date,
  "$ %DatePrototype%": Date.prototype,
  "$ %decodeURI%": decodeURI,
  "$ %decodeURIComponent%": decodeURIComponent,
  "$ %encodeURI%": encodeURI,
  "$ %encodeURIComponent%": encodeURIComponent,
  "$ %Error%": Error,
  "$ %ErrorPrototype%": Error.prototype,
  "$ %eval%": eval,
  "$ %EvalError%": EvalError,
  "$ %EvalErrorPrototype%": EvalError.prototype,
  "$ %Float32Array%": "undefined" == typeof Float32Array ? undefined$1 : Float32Array,
  "$ %Float32ArrayPrototype%": "undefined" == typeof Float32Array ? undefined$1 : Float32Array.prototype,
  "$ %Float64Array%": "undefined" == typeof Float64Array ? undefined$1 : Float64Array,
  "$ %Float64ArrayPrototype%": "undefined" == typeof Float64Array ? undefined$1 : Float64Array.prototype,
  "$ %Function%": Function,
  "$ %FunctionPrototype%": Function.prototype,
  "$ %Generator%": undefined$1,
  "$ %GeneratorFunction%": generatorFunction,
  "$ %GeneratorPrototype%": undefined$1,
  "$ %Int8Array%": "undefined" == typeof Int8Array ? undefined$1 : Int8Array,
  "$ %Int8ArrayPrototype%": "undefined" == typeof Int8Array ? undefined$1 : Int8Array.prototype,
  "$ %Int16Array%": "undefined" == typeof Int16Array ? undefined$1 : Int16Array,
  "$ %Int16ArrayPrototype%": "undefined" == typeof Int16Array ? undefined$1 : Int8Array.prototype,
  "$ %Int32Array%": "undefined" == typeof Int32Array ? undefined$1 : Int32Array,
  "$ %Int32ArrayPrototype%": "undefined" == typeof Int32Array ? undefined$1 : Int32Array.prototype,
  "$ %isFinite%": isFinite,
  "$ %isNaN%": isNaN,
  "$ %IteratorPrototype%": hasSymbols$3 ? getProto(getProto([][Symbol.iterator]())) : undefined$1,
  "$ %JSON%": JSON,
  "$ %JSONParse%": JSON.parse,
  "$ %Map%": "undefined" == typeof Map ? undefined$1 : Map,
  "$ %MapIteratorPrototype%": "undefined" != typeof Map && hasSymbols$3 ? getProto(new Map()[Symbol.iterator]()) : undefined$1,
  "$ %MapPrototype%": "undefined" == typeof Map ? undefined$1 : Map.prototype,
  "$ %Math%": Math,
  "$ %Number%": Number,
  "$ %NumberPrototype%": Number.prototype,
  "$ %Object%": Object,
  "$ %ObjectPrototype%": Object.prototype,
  "$ %ObjProto_toString%": Object.prototype.toString,
  "$ %ObjProto_valueOf%": Object.prototype.valueOf,
  "$ %parseFloat%": parseFloat,
  "$ %parseInt%": parseInt,
  "$ %Promise%": "undefined" == typeof Promise ? undefined$1 : Promise,
  "$ %PromisePrototype%": "undefined" == typeof Promise ? undefined$1 : Promise.prototype,
  "$ %PromiseProto_then%": "undefined" == typeof Promise ? undefined$1 : Promise.prototype.then,
  "$ %Promise_all%": "undefined" == typeof Promise ? undefined$1 : Promise.all,
  "$ %Promise_reject%": "undefined" == typeof Promise ? undefined$1 : Promise.reject,
  "$ %Promise_resolve%": "undefined" == typeof Promise ? undefined$1 : Promise.resolve,
  "$ %Proxy%": "undefined" == typeof Proxy ? undefined$1 : Proxy,
  "$ %RangeError%": RangeError,
  "$ %RangeErrorPrototype%": RangeError.prototype,
  "$ %ReferenceError%": ReferenceError,
  "$ %ReferenceErrorPrototype%": ReferenceError.prototype,
  "$ %Reflect%": "undefined" == typeof Reflect ? undefined$1 : Reflect,
  "$ %RegExp%": RegExp,
  "$ %RegExpPrototype%": RegExp.prototype,
  "$ %Set%": "undefined" == typeof Set ? undefined$1 : Set,
  "$ %SetIteratorPrototype%": "undefined" != typeof Set && hasSymbols$3 ? getProto(new Set()[Symbol.iterator]()) : undefined$1,
  "$ %SetPrototype%": "undefined" == typeof Set ? undefined$1 : Set.prototype,
  "$ %SharedArrayBuffer%": "undefined" == typeof SharedArrayBuffer ? undefined$1 : SharedArrayBuffer,
  "$ %SharedArrayBufferPrototype%": "undefined" == typeof SharedArrayBuffer ? undefined$1 : SharedArrayBuffer.prototype,
  "$ %String%": String,
  "$ %StringIteratorPrototype%": hasSymbols$3 ? getProto(""[Symbol.iterator]()) : undefined$1,
  "$ %StringPrototype%": String.prototype,
  "$ %Symbol%": hasSymbols$3 ? Symbol : undefined$1,
  "$ %SymbolPrototype%": hasSymbols$3 ? Symbol.prototype : undefined$1,
  "$ %SyntaxError%": SyntaxError,
  "$ %SyntaxErrorPrototype%": SyntaxError.prototype,
  "$ %ThrowTypeError%": ThrowTypeError,
  "$ %TypedArray%": TypedArray,
  "$ %TypedArrayPrototype%": TypedArray ? TypedArray.prototype : undefined$1,
  "$ %TypeError%": TypeError,
  "$ %TypeErrorPrototype%": TypeError.prototype,
  "$ %Uint8Array%": "undefined" == typeof Uint8Array ? undefined$1 : Uint8Array,
  "$ %Uint8ArrayPrototype%": "undefined" == typeof Uint8Array ? undefined$1 : Uint8Array.prototype,
  "$ %Uint8ClampedArray%": "undefined" == typeof Uint8ClampedArray ? undefined$1 : Uint8ClampedArray,
  "$ %Uint8ClampedArrayPrototype%": "undefined" == typeof Uint8ClampedArray ? undefined$1 : Uint8ClampedArray.prototype,
  "$ %Uint16Array%": "undefined" == typeof Uint16Array ? undefined$1 : Uint16Array,
  "$ %Uint16ArrayPrototype%": "undefined" == typeof Uint16Array ? undefined$1 : Uint16Array.prototype,
  "$ %Uint32Array%": "undefined" == typeof Uint32Array ? undefined$1 : Uint32Array,
  "$ %Uint32ArrayPrototype%": "undefined" == typeof Uint32Array ? undefined$1 : Uint32Array.prototype,
  "$ %URIError%": URIError,
  "$ %URIErrorPrototype%": URIError.prototype,
  "$ %WeakMap%": "undefined" == typeof WeakMap ? undefined$1 : WeakMap,
  "$ %WeakMapPrototype%": "undefined" == typeof WeakMap ? undefined$1 : WeakMap.prototype,
  "$ %WeakSet%": "undefined" == typeof WeakSet ? undefined$1 : WeakSet,
  "$ %WeakSetPrototype%": "undefined" == typeof WeakSet ? undefined$1 : WeakSet.prototype
},
    GetIntrinsic = function GetIntrinsic(e, t) {
  if (1 < arguments.length && "boolean" != typeof t) throw new TypeError('"allowMissing" argument must be a boolean');
  var r = "$ " + e;
  if (!(r in INTRINSICS)) throw new SyntaxError("intrinsic " + e + " does not exist!");
  if (void 0 === INTRINSICS[r] && !t) throw new TypeError("intrinsic " + e + " exists, but is not available. Please file an issue!");
  return INTRINSICS[r];
},
    $TypeError = GetIntrinsic("%TypeError%"),
    $SyntaxError = GetIntrinsic("%SyntaxError%"),
    predicates = {
  "Property Descriptor": function PropertyDescriptor(e, t) {
    if ("Object" !== e.Type(t)) return !1;
    var r = {
      "[[Configurable]]": !0,
      "[[Enumerable]]": !0,
      "[[Get]]": !0,
      "[[Set]]": !0,
      "[[Value]]": !0,
      "[[Writable]]": !0
    };

    for (var n in t) {
      if (src(t, n) && !r[n]) return !1;
    }

    var o = src(t, "[[Value]]"),
        a = src(t, "[[Get]]") || src(t, "[[Set]]");
    if (o && a) throw new $TypeError("Property Descriptors may not be both accessor and data descriptors");
    return !0;
  }
},
    assertRecord = function assertRecord(e, t, r, n) {
  var o = predicates[t];
  if ("function" != typeof o) throw new $SyntaxError("unknown record type: " + t);
  if (!o(e, n)) throw new $TypeError(r + " must be a " + t);
  console.log(o(e, n), n);
},
    _isNaN = Number.isNaN || function (e) {
  return e != e;
},
    $isNaN = Number.isNaN || function (e) {
  return e != e;
},
    _isFinite = Number.isFinite || function (e) {
  return "number" == typeof e && !$isNaN(e) && e !== 1 / 0 && e !== -1 / 0;
},
    has$3 = functionBind.call(Function.call, Object.prototype.hasOwnProperty),
    $assign = Object.assign,
    assign = function assign(e, t) {
  if ($assign) return $assign(e, t);

  for (var r in t) {
    has$3(t, r) && (e[r] = t[r]);
  }

  return e;
},
    sign = function sign(e) {
  return 0 <= e ? 1 : -1;
},
    mod = function mod(e, t) {
  var r = e % t;
  return Math.floor(0 <= r ? r : r + t);
},
    isPrimitive$1 = function isPrimitive$1(e) {
  return null === e || "function" != typeof e && "object" != typeof e;
},
    toStr$6 = Object.prototype.toString,
    ES5internalSlots = {
  "[[DefaultValue]]": function DefaultValue(e) {
    var t;
    if ((t = 1 < arguments.length ? arguments[1] : "[object Date]" === toStr$6.call(e) ? String : Number) !== String && t !== Number) throw new TypeError("invalid [[DefaultValue]] hint supplied");
    var r,
        n,
        o = t === String ? ["toString", "valueOf"] : ["valueOf", "toString"];

    for (n = 0; n < o.length; ++n) {
      if (isCallable(e[o[n]]) && (r = e[o[n]](), isPrimitive(r))) return r;
    }

    throw new TypeError("No default value");
  }
},
    es5 = function es5(e) {
  return isPrimitive(e) ? e : 1 < arguments.length ? ES5internalSlots["[[DefaultValue]]"](e, arguments[1]) : ES5internalSlots["[[DefaultValue]]"](e);
},
    $Object = GetIntrinsic("%Object%"),
    $TypeError$1 = GetIntrinsic("%TypeError%"),
    $String = GetIntrinsic("%String%"),
    ES5 = {
  ToPrimitive: es5,
  ToBoolean: function ToBoolean(e) {
    return !!e;
  },
  ToNumber: function ToNumber(e) {
    return +e;
  },
  ToInteger: function ToInteger(e) {
    var t = this.ToNumber(e);
    return _isNaN(t) ? 0 : 0 !== t && _isFinite(t) ? sign(t) * Math.floor(Math.abs(t)) : t;
  },
  ToInt32: function ToInt32(e) {
    return this.ToNumber(e) >> 0;
  },
  ToUint32: function ToUint32(e) {
    return this.ToNumber(e) >>> 0;
  },
  ToUint16: function ToUint16(e) {
    var t = this.ToNumber(e);
    if (_isNaN(t) || 0 === t || !_isFinite(t)) return 0;
    var r = sign(t) * Math.floor(Math.abs(t));
    return mod(r, 65536);
  },
  ToString: function ToString(e) {
    return $String(e);
  },
  ToObject: function ToObject(e) {
    return this.CheckObjectCoercible(e), $Object(e);
  },
  CheckObjectCoercible: function CheckObjectCoercible(e, t) {
    if (null == e) throw new $TypeError$1(t || "Cannot call method on " + e);
    return e;
  },
  IsCallable: isCallable,
  SameValue: function SameValue(e, t) {
    return e === t ? 0 !== e || 1 / e == 1 / t : _isNaN(e) && _isNaN(t);
  },
  Type: function Type(e) {
    return null === e ? "Null" : void 0 === e ? "Undefined" : "function" == typeof e || "object" == typeof e ? "Object" : "number" == typeof e ? "Number" : "boolean" == typeof e ? "Boolean" : "string" == typeof e ? "String" : void 0;
  },
  IsPropertyDescriptor: function IsPropertyDescriptor(e) {
    if ("Object" !== this.Type(e)) return !1;
    var t = {
      "[[Configurable]]": !0,
      "[[Enumerable]]": !0,
      "[[Get]]": !0,
      "[[Set]]": !0,
      "[[Value]]": !0,
      "[[Writable]]": !0
    };

    for (var r in e) {
      if (src(e, r) && !t[r]) return !1;
    }

    var n = src(e, "[[Value]]"),
        o = src(e, "[[Get]]") || src(e, "[[Set]]");
    if (n && o) throw new $TypeError$1("Property Descriptors may not be both accessor and data descriptors");
    return !0;
  },
  IsAccessorDescriptor: function IsAccessorDescriptor(e) {
    return void 0 !== e && (assertRecord(this, "Property Descriptor", "Desc", e), !(!src(e, "[[Get]]") && !src(e, "[[Set]]")));
  },
  IsDataDescriptor: function IsDataDescriptor(e) {
    return void 0 !== e && (assertRecord(this, "Property Descriptor", "Desc", e), !(!src(e, "[[Value]]") && !src(e, "[[Writable]]")));
  },
  IsGenericDescriptor: function IsGenericDescriptor(e) {
    return void 0 !== e && (assertRecord(this, "Property Descriptor", "Desc", e), !this.IsAccessorDescriptor(e) && !this.IsDataDescriptor(e));
  },
  FromPropertyDescriptor: function FromPropertyDescriptor(e) {
    if (void 0 === e) return e;
    if (assertRecord(this, "Property Descriptor", "Desc", e), this.IsDataDescriptor(e)) return {
      value: e["[[Value]]"],
      writable: !!e["[[Writable]]"],
      enumerable: !!e["[[Enumerable]]"],
      configurable: !!e["[[Configurable]]"]
    };
    if (this.IsAccessorDescriptor(e)) return {
      get: e["[[Get]]"],
      set: e["[[Set]]"],
      enumerable: !!e["[[Enumerable]]"],
      configurable: !!e["[[Configurable]]"]
    };
    throw new $TypeError$1("FromPropertyDescriptor must be called with a fully populated Property Descriptor");
  },
  ToPropertyDescriptor: function ToPropertyDescriptor(e) {
    if ("Object" !== this.Type(e)) throw new $TypeError$1("ToPropertyDescriptor requires an object");
    var t = {};

    if (src(e, "enumerable") && (t["[[Enumerable]]"] = this.ToBoolean(e.enumerable)), src(e, "configurable") && (t["[[Configurable]]"] = this.ToBoolean(e.configurable)), src(e, "value") && (t["[[Value]]"] = e.value), src(e, "writable") && (t["[[Writable]]"] = this.ToBoolean(e.writable)), src(e, "get")) {
      var r = e.get;
      if (void 0 !== r && !this.IsCallable(r)) throw new TypeError("getter must be a function");
      t["[[Get]]"] = r;
    }

    if (src(e, "set")) {
      var n = e.set;
      if (void 0 !== n && !this.IsCallable(n)) throw new $TypeError$1("setter must be a function");
      t["[[Set]]"] = n;
    }

    if ((src(t, "[[Get]]") || src(t, "[[Set]]")) && (src(t, "[[Value]]") || src(t, "[[Writable]]"))) throw new $TypeError$1("Invalid property descriptor. Cannot both specify accessors and a value or writable attribute");
    return t;
  }
},
    es5$1 = ES5,
    regexExec = RegExp.prototype.exec,
    gOPD = Object.getOwnPropertyDescriptor,
    tryRegexExecCall = function tryRegexExecCall(e) {
  try {
    var t = e.lastIndex;
    return e.lastIndex = 0, regexExec.call(e), !0;
  } catch (e) {
    return !1;
  } finally {
    e.lastIndex = t;
  }
},
    toStr$7 = Object.prototype.toString,
    regexClass = "[object RegExp]",
    hasToStringTag$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.toStringTag,
    isRegex = function isRegex(e) {
  if (!e || "object" != typeof e) return !1;
  if (!hasToStringTag$2) return toStr$7.call(e) === regexClass;
  var t = gOPD(e, "lastIndex");
  return !(!t || !src(t, "value")) && tryRegexExecCall(e);
},
    $TypeError$2 = GetIntrinsic("%TypeError%"),
    $SyntaxError$1 = GetIntrinsic("%SyntaxError%"),
    $Array = GetIntrinsic("%Array%"),
    $String$1 = GetIntrinsic("%String%"),
    $Object$1 = GetIntrinsic("%Object%"),
    $Number = GetIntrinsic("%Number%"),
    $Symbol = GetIntrinsic("%Symbol%", !0),
    $RegExp = GetIntrinsic("%RegExp%"),
    hasSymbols$4 = !!$Symbol,
    MAX_SAFE_INTEGER = $Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1,
    parseInteger = parseInt,
    arraySlice = functionBind.call(Function.call, $Array.prototype.slice),
    strSlice = functionBind.call(Function.call, $String$1.prototype.slice),
    isBinary = functionBind.call(Function.call, $RegExp.prototype.test, /^0b[01]+$/i),
    isOctal = functionBind.call(Function.call, $RegExp.prototype.test, /^0o[0-7]+$/i),
    regexExec$1 = functionBind.call(Function.call, $RegExp.prototype.exec),
    nonWS = ["", "​", "￾"].join(""),
    nonWSregex = new $RegExp("[" + nonWS + "]", "g"),
    hasNonWS = functionBind.call(Function.call, $RegExp.prototype.test, nonWSregex),
    invalidHexLiteral = /^[-+]0x[0-9a-f]+$/i,
    isInvalidHexLiteral = functionBind.call(Function.call, $RegExp.prototype.test, invalidHexLiteral),
    $charCodeAt = functionBind.call(Function.call, $String$1.prototype.charCodeAt),
    toStr$8 = functionBind.call(Function.call, Object.prototype.toString),
    $NumberValueOf = functionBind.call(Function.call, GetIntrinsic("%NumberPrototype%").valueOf),
    $BooleanValueOf = functionBind.call(Function.call, GetIntrinsic("%BooleanPrototype%").valueOf),
    $StringValueOf = functionBind.call(Function.call, GetIntrinsic("%StringPrototype%").valueOf),
    $DateValueOf = functionBind.call(Function.call, GetIntrinsic("%DatePrototype%").valueOf),
    $floor = Math.floor,
    $abs = Math.abs,
    $ObjectCreate = Object.create,
    $gOPD = $Object$1.getOwnPropertyDescriptor,
    $isExtensible = $Object$1.isExtensible,
    $defineProperty = $Object$1.defineProperty,
    ws = ["\t\n\v\f\r   ᠎    ", "\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028", "\u2029\uFEFF"].join(""),
    trimRegex = new RegExp("(^[" + ws + "]+)|([" + ws + "]+$)", "g"),
    replace = functionBind.call(Function.call, $String$1.prototype.replace),
    trim = function trim(e) {
  return replace(e, trimRegex, "");
},
    ES6 = assign(assign({}, es5$1), {
  Call: function Call(e, t) {
    var r = 2 < arguments.length ? arguments[2] : [];
    if (!this.IsCallable(e)) throw new $TypeError$2(e + " is not a function");
    return e.apply(t, r);
  },
  ToPrimitive: es6,
  ToNumber: function ToNumber(e) {
    var t = isPrimitive$1(e) ? e : es6(e, $Number);
    if ("symbol" == typeof t) throw new $TypeError$2("Cannot convert a Symbol value to a number");

    if ("string" == typeof t) {
      if (isBinary(t)) return this.ToNumber(parseInteger(strSlice(t, 2), 2));
      if (isOctal(t)) return this.ToNumber(parseInteger(strSlice(t, 2), 8));
      if (hasNonWS(t) || isInvalidHexLiteral(t)) return NaN;
      var r = trim(t);
      if (r !== t) return this.ToNumber(r);
    }

    return $Number(t);
  },
  ToInt16: function ToInt16(e) {
    var t = this.ToUint16(e);
    return 32768 <= t ? t - 65536 : t;
  },
  ToInt8: function ToInt8(e) {
    var t = this.ToUint8(e);
    return 128 <= t ? t - 256 : t;
  },
  ToUint8: function ToUint8(e) {
    var t = this.ToNumber(e);
    if (_isNaN(t) || 0 === t || !_isFinite(t)) return 0;
    var r = sign(t) * $floor($abs(t));
    return mod(r, 256);
  },
  ToUint8Clamp: function ToUint8Clamp(e) {
    var t = this.ToNumber(e);
    if (_isNaN(t) || t <= 0) return 0;
    if (255 <= t) return 255;
    var r = $floor(e);
    return r + .5 < t ? r + 1 : t < r + .5 ? r : r % 2 != 0 ? r + 1 : r;
  },
  ToString: function ToString(e) {
    if ("symbol" == typeof e) throw new $TypeError$2("Cannot convert a Symbol value to a string");
    return $String$1(e);
  },
  ToObject: function ToObject(e) {
    return this.RequireObjectCoercible(e), $Object$1(e);
  },
  ToPropertyKey: function ToPropertyKey(e) {
    var t = this.ToPrimitive(e, $String$1);
    return "symbol" == typeof t ? t : this.ToString(t);
  },
  ToLength: function ToLength(e) {
    var t = this.ToInteger(e);
    return t <= 0 ? 0 : MAX_SAFE_INTEGER < t ? MAX_SAFE_INTEGER : t;
  },
  CanonicalNumericIndexString: function CanonicalNumericIndexString(e) {
    if ("[object String]" !== toStr$8(e)) throw new $TypeError$2("must be a string");
    if ("-0" === e) return -0;
    var t = this.ToNumber(e);
    return this.SameValue(this.ToString(t), e) ? t : void 0;
  },
  RequireObjectCoercible: es5$1.CheckObjectCoercible,
  IsArray: $Array.isArray || function (e) {
    return "[object Array]" === toStr$8(e);
  },
  IsConstructor: function IsConstructor(e) {
    return "function" == typeof e && !!e.prototype;
  },
  IsExtensible: Object.preventExtensions ? function (e) {
    return !isPrimitive$1(e) && $isExtensible(e);
  } : function (e) {
    return !0;
  },
  IsInteger: function IsInteger(e) {
    if ("number" != typeof e || _isNaN(e) || !_isFinite(e)) return !1;
    var t = $abs(e);
    return $floor(t) === t;
  },
  IsPropertyKey: function IsPropertyKey(e) {
    return "string" == typeof e || "symbol" == typeof e;
  },
  IsRegExp: function IsRegExp(e) {
    if (!e || "object" != typeof e) return !1;

    if (hasSymbols$4) {
      var t = e[$Symbol.match];
      if (void 0 !== t) return es5$1.ToBoolean(t);
    }

    return isRegex(e);
  },
  SameValueZero: function SameValueZero(e, t) {
    return e === t || _isNaN(e) && _isNaN(t);
  },
  GetV: function GetV(e, t) {
    if (!this.IsPropertyKey(t)) throw new $TypeError$2("Assertion failed: IsPropertyKey(P) is not true");
    return this.ToObject(e)[t];
  },
  GetMethod: function GetMethod(e, t) {
    if (!this.IsPropertyKey(t)) throw new $TypeError$2("Assertion failed: IsPropertyKey(P) is not true");
    var r = this.GetV(e, t);

    if (null != r) {
      if (!this.IsCallable(r)) throw new $TypeError$2(t + "is not a function");
      return r;
    }
  },
  Get: function Get(e, t) {
    if ("Object" !== this.Type(e)) throw new $TypeError$2("Assertion failed: Type(O) is not Object");
    if (!this.IsPropertyKey(t)) throw new $TypeError$2("Assertion failed: IsPropertyKey(P) is not true");
    return e[t];
  },
  Type: function Type(e) {
    return "symbol" == typeof e ? "Symbol" : es5$1.Type(e);
  },
  SpeciesConstructor: function SpeciesConstructor(e, t) {
    if ("Object" !== this.Type(e)) throw new $TypeError$2("Assertion failed: Type(O) is not Object");
    var r = e.constructor;
    if (void 0 === r) return t;
    if ("Object" !== this.Type(r)) throw new $TypeError$2("O.constructor is not an Object");
    var n = hasSymbols$4 && $Symbol.species ? r[$Symbol.species] : void 0;
    if (null == n) return t;
    if (this.IsConstructor(n)) return n;
    throw new $TypeError$2("no constructor found");
  },
  CompletePropertyDescriptor: function CompletePropertyDescriptor(e) {
    return assertRecord(this, "Property Descriptor", "Desc", e), this.IsGenericDescriptor(e) || this.IsDataDescriptor(e) ? (src(e, "[[Value]]") || (e["[[Value]]"] = void 0), src(e, "[[Writable]]") || (e["[[Writable]]"] = !1)) : (src(e, "[[Get]]") || (e["[[Get]]"] = void 0), src(e, "[[Set]]") || (e["[[Set]]"] = void 0)), src(e, "[[Enumerable]]") || (e["[[Enumerable]]"] = !1), src(e, "[[Configurable]]") || (e["[[Configurable]]"] = !1), e;
  },
  Set: function Set(e, t, r, n) {
    if ("Object" !== this.Type(e)) throw new $TypeError$2("O must be an Object");
    if (!this.IsPropertyKey(t)) throw new $TypeError$2("P must be a Property Key");
    if ("Boolean" !== this.Type(n)) throw new $TypeError$2("Throw must be a Boolean");
    if (n) return e[t] = r, !0;

    try {
      e[t] = r;
    } catch (e) {
      return !1;
    }
  },
  HasOwnProperty: function HasOwnProperty(e, t) {
    if ("Object" !== this.Type(e)) throw new $TypeError$2("O must be an Object");
    if (!this.IsPropertyKey(t)) throw new $TypeError$2("P must be a Property Key");
    return src(e, t);
  },
  HasProperty: function HasProperty(e, t) {
    if ("Object" !== this.Type(e)) throw new $TypeError$2("O must be an Object");
    if (!this.IsPropertyKey(t)) throw new $TypeError$2("P must be a Property Key");
    return t in e;
  },
  IsConcatSpreadable: function IsConcatSpreadable(e) {
    if ("Object" !== this.Type(e)) return !1;

    if (hasSymbols$4 && "symbol" == typeof $Symbol.isConcatSpreadable) {
      var t = this.Get(e, Symbol.isConcatSpreadable);
      if (void 0 !== t) return this.ToBoolean(t);
    }

    return this.IsArray(e);
  },
  Invoke: function Invoke(e, t) {
    if (!this.IsPropertyKey(t)) throw new $TypeError$2("P must be a Property Key");
    var r = arraySlice(arguments, 2),
        n = this.GetV(e, t);
    return this.Call(n, e, r);
  },
  GetIterator: function GetIterator(e, t) {
    if (!hasSymbols$4) throw new SyntaxError("ES.GetIterator depends on native iterator support.");
    var r = t;
    arguments.length < 2 && (r = this.GetMethod(e, $Symbol.iterator));
    var n = this.Call(r, e);
    if ("Object" !== this.Type(n)) throw new $TypeError$2("iterator must return an object");
    return n;
  },
  IteratorNext: function IteratorNext(e, t) {
    var r = this.Invoke(e, "next", arguments.length < 2 ? [] : [t]);
    if ("Object" !== this.Type(r)) throw new $TypeError$2("iterator next must return an object");
    return r;
  },
  IteratorComplete: function IteratorComplete(e) {
    if ("Object" !== this.Type(e)) throw new $TypeError$2("Assertion failed: Type(iterResult) is not Object");
    return this.ToBoolean(this.Get(e, "done"));
  },
  IteratorValue: function IteratorValue(e) {
    if ("Object" !== this.Type(e)) throw new $TypeError$2("Assertion failed: Type(iterResult) is not Object");
    return this.Get(e, "value");
  },
  IteratorStep: function IteratorStep(e) {
    var t = this.IteratorNext(e);
    return !0 !== this.IteratorComplete(t) && t;
  },
  IteratorClose: function IteratorClose(e, t) {
    if ("Object" !== this.Type(e)) throw new $TypeError$2("Assertion failed: Type(iterator) is not Object");
    if (!this.IsCallable(t)) throw new $TypeError$2("Assertion failed: completion is not a thunk for a Completion Record");
    var r,
        n = t,
        o = this.GetMethod(e, "return");
    if (void 0 === o) return n();

    try {
      var a = this.Call(o, e, []);
    } catch (e) {
      throw r = n(), n = null, e;
    }

    if (r = n(), n = null, "Object" !== this.Type(a)) throw new $TypeError$2("iterator .return must return an object");
    return r;
  },
  CreateIterResultObject: function CreateIterResultObject(e, t) {
    if ("Boolean" !== this.Type(t)) throw new $TypeError$2("Assertion failed: Type(done) is not Boolean");
    return {
      value: e,
      done: t
    };
  },
  RegExpExec: function RegExpExec(e, t) {
    if ("Object" !== this.Type(e)) throw new $TypeError$2("R must be an Object");
    if ("String" !== this.Type(t)) throw new $TypeError$2("S must be a String");
    var r = this.Get(e, "exec");

    if (this.IsCallable(r)) {
      var n = this.Call(r, e, [t]);
      if (null === n || "Object" === this.Type(n)) return n;
      throw new $TypeError$2('"exec" method must return `null` or an Object');
    }

    return regexExec$1(e, t);
  },
  ArraySpeciesCreate: function ArraySpeciesCreate(e, t) {
    if (!this.IsInteger(t) || t < 0) throw new $TypeError$2("Assertion failed: length must be an integer >= 0");
    var r,
        n = 0 === t ? 0 : t;
    if (this.IsArray(e) && (r = this.Get(e, "constructor"), "Object" === this.Type(r) && hasSymbols$4 && $Symbol.species && null === (r = this.Get(r, $Symbol.species)) && (r = void 0)), void 0 === r) return $Array(n);
    if (!this.IsConstructor(r)) throw new $TypeError$2("C must be a constructor");
    return new r(n);
  },
  CreateDataProperty: function CreateDataProperty(e, t, r) {
    if ("Object" !== this.Type(e)) throw new $TypeError$2("Assertion failed: Type(O) is not Object");
    if (!this.IsPropertyKey(t)) throw new $TypeError$2("Assertion failed: IsPropertyKey(P) is not true");
    var n = $gOPD(e, t),
        o = n || "function" != typeof $isExtensible || $isExtensible(e);
    return !(!(!n || n.writable && n.configurable) || !o) && ($defineProperty(e, t, {
      configurable: !0,
      enumerable: !0,
      value: r,
      writable: !0
    }), !0);
  },
  CreateDataPropertyOrThrow: function CreateDataPropertyOrThrow(e, t, r) {
    if ("Object" !== this.Type(e)) throw new $TypeError$2("Assertion failed: Type(O) is not Object");
    if (!this.IsPropertyKey(t)) throw new $TypeError$2("Assertion failed: IsPropertyKey(P) is not true");
    var n = this.CreateDataProperty(e, t, r);
    if (!n) throw new $TypeError$2("unable to create data property");
    return n;
  },
  ObjectCreate: function ObjectCreate(e, t) {
    if (null !== e && "Object" !== this.Type(e)) throw new $TypeError$2("Assertion failed: proto must be null or an object");
    if (0 < (arguments.length < 2 ? [] : t).length) throw new $SyntaxError$1("es-abstract does not yet support internal slots");
    if (null === e && !$ObjectCreate) throw new $SyntaxError$1("native Object.create support is required to create null objects");
    return $ObjectCreate(e);
  },
  AdvanceStringIndex: function AdvanceStringIndex(e, t, r) {
    if ("String" !== this.Type(e)) throw new $TypeError$2("S must be a String");
    if (!this.IsInteger(t) || t < 0 || MAX_SAFE_INTEGER < t) throw new $TypeError$2("Assertion failed: length must be an integer >= 0 and <= 2**53");
    if ("Boolean" !== this.Type(r)) throw new $TypeError$2("Assertion failed: unicode must be a Boolean");
    if (!r) return t + 1;
    if (e.length <= t + 1) return t + 1;
    var n = $charCodeAt(e, t);
    if (n < 55296 || 56319 < n) return t + 1;
    var o = $charCodeAt(e, t + 1);
    return o < 56320 || 57343 < o ? t + 1 : t + 2;
  },
  CreateMethodProperty: function CreateMethodProperty(e, t, r) {
    if ("Object" !== this.Type(e)) throw new $TypeError$2("Assertion failed: Type(O) is not Object");
    if (!this.IsPropertyKey(t)) throw new $TypeError$2("Assertion failed: IsPropertyKey(P) is not true");
    return !!$defineProperty(e, t, {
      configurable: !0,
      enumerable: !1,
      value: r,
      writable: !0
    });
  },
  DefinePropertyOrThrow: function DefinePropertyOrThrow(e, t, r) {
    if ("Object" !== this.Type(e)) throw new $TypeError$2("Assertion failed: Type(O) is not Object");
    if (!this.IsPropertyKey(t)) throw new $TypeError$2("Assertion failed: IsPropertyKey(P) is not true");
    return !!$defineProperty(e, t, r);
  },
  DeletePropertyOrThrow: function DeletePropertyOrThrow(e, t) {
    if ("Object" !== this.Type(e)) throw new $TypeError$2("Assertion failed: Type(O) is not Object");
    if (!this.IsPropertyKey(t)) throw new $TypeError$2("Assertion failed: IsPropertyKey(P) is not true");
    var r = delete e[t];
    if (!r) throw new TypeError("Attempt to delete property failed.");
    return r;
  },
  EnumerableOwnNames: function EnumerableOwnNames(e) {
    if ("Object" !== this.Type(e)) throw new $TypeError$2("Assertion failed: Type(O) is not Object");
    return objectKeys(e);
  },
  thisNumberValue: function thisNumberValue(e) {
    return "Number" === this.Type(e) ? e : $NumberValueOf(e);
  },
  thisBooleanValue: function thisBooleanValue(e) {
    return "Boolean" === this.Type(e) ? e : $BooleanValueOf(e);
  },
  thisStringValue: function thisStringValue(e) {
    return "String" === this.Type(e) ? e : $StringValueOf(e);
  },
  thisTimeValue: function thisTimeValue(e) {
    return $DateValueOf(e);
  }
});

delete ES6.CheckObjectCoercible;

var es2015$1 = ES6,
    ES2016 = assign(assign({}, es2015$1), {
  SameValueNonNumber: function SameValueNonNumber(e, t) {
    if ("number" == typeof e || typeof e != typeof t) throw new TypeError("SameValueNonNumber requires two non-number values of the same type.");
    return this.SameValue(e, t);
  }
}),
    es2016 = ES2016,
    forEach = function forEach(e, t) {
  for (var r = 0; r < e.length; r += 1) {
    t(e[r], r, e);
  }
},
    $TypeError$3 = GetIntrinsic("%TypeError%"),
    $isEnumerable = functionBind.call(Function.call, GetIntrinsic("%ObjectPrototype%").propertyIsEnumerable),
    $pushApply = functionBind.call(Function.apply, GetIntrinsic("%ArrayPrototype%").push),
    ES2017 = assign(assign({}, es2016), {
  ToIndex: function ToIndex(e) {
    if (void 0 === e) return 0;
    var t = this.ToInteger(e);
    if (t < 0) throw new RangeError("index must be >= 0");
    var r = this.ToLength(t);
    if (!this.SameValueZero(t, r)) throw new RangeError("index must be >= 0 and < 2 ** 53 - 1");
    return r;
  },
  EnumerableOwnProperties: function EnumerableOwnProperties(t, r) {
    var e = es2016.EnumerableOwnNames(t);
    if ("key" === r) return e;
    if ("value" !== r && "key+value" !== r) throw new $TypeError$3('Assertion failed: "kind" is not "key", "value", or "key+value": ' + r);
    var n = [];
    return forEach(e, function (e) {
      $isEnumerable(t, e) && $pushApply(n, ["value" === r ? t[e] : [e, t[e]]]);
    }), n;
  }
});

delete ES2017.EnumerableOwnNames;

var es2017 = ES2017,
    MAX_SAFE_INTEGER$1 = Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1,
    FlattenIntoArray = function e(t, r, n, o, a) {
  for (var i = o, s = 0; s < n;) {
    var c = es2017.ToString(s);

    if (es2017.HasProperty(r, c)) {
      var u = es2017.Get(r, c),
          l = !1;

      if (0 < a && (l = es2017.IsArray(u)), l) {
        i = e(t, u, es2017.ToLength(es2017.Get(u, "length")), i, a - 1);
      } else {
        if (MAX_SAFE_INTEGER$1 <= i) throw new TypeError("index too large");
        es2017.CreateDataPropertyOrThrow(t, es2017.ToString(i), u), i += 1;
      }
    }

    s += 1;
  }

  return i;
},
    implementation$2 = function implementation$2() {
  var e = es2017.ToObject(this),
      t = es2017.ToLength(es2017.Get(e, "length")),
      r = 1;
  0 < arguments.length && void 0 !== arguments[0] && (r = es2017.ToInteger(arguments[0]));
  var n = es2017.ArraySpeciesCreate(e, 0);
  return FlattenIntoArray(n, e, t, 0, r), n;
},
    polyfill = function polyfill() {
  return Array.prototype.flat || implementation$2;
},
    shim = function shim() {
  var e = polyfill();
  return defineProperties_1(Array.prototype, {
    flat: e
  }, {
    flat: function flat() {
      return Array.prototype.flat !== e;
    }
  }), e;
},
    polyfill$1 = polyfill(),
    boundFlat = functionBind.call(Function.call, polyfill$1);

defineProperties_1(boundFlat, {
  getPolyfill: polyfill,
  implementation: implementation$2,
  shim: shim
});
var array_prototype_flat = boundFlat,
    globalKey = "__ global cache key __";
"function" == typeof Symbol && isSymbol(Symbol("foo")) && "function" == typeof Symbol.for && (globalKey = Symbol.for(globalKey));

var trueThunk = function trueThunk() {
  return !0;
},
    ensureCache = function ensureCache() {
  if (!commonjsGlobal[globalKey]) {
    var e = {};
    e[globalKey] = {};
    var t = {};
    t[globalKey] = trueThunk, defineProperties_1(commonjsGlobal, e, t);
  }

  return commonjsGlobal[globalKey];
},
    cache = ensureCache(),
    isPrimitive$2 = function isPrimitive$2(e) {
  return null === e || "object" != typeof e && "function" != typeof e;
},
    getPrimitiveKey = function getPrimitiveKey(e) {
  return isSymbol(e) ? Symbol.prototype.valueOf.call(e) : typeof e + " | " + String(e);
},
    requirePrimitiveKey = function requirePrimitiveKey(e) {
  if (!isPrimitive$2(e)) throw new TypeError("key must not be an object");
},
    globalCache = {
  clear: function clear() {
    delete commonjsGlobal[globalKey], cache = ensureCache();
  },
  delete: function _delete(e) {
    return requirePrimitiveKey(e), delete cache[getPrimitiveKey(e)], !globalCache.has(e);
  },
  get: function get(e) {
    return requirePrimitiveKey(e), cache[getPrimitiveKey(e)];
  },
  has: function has(e) {
    return requirePrimitiveKey(e), getPrimitiveKey(e) in cache;
  },
  set: function set(e, t) {
    requirePrimitiveKey(e);
    var r = getPrimitiveKey(e),
        n = {};
    n[r] = t;
    var o = {};
    return o[r] = trueThunk, defineProperties_1(cache, n, o), globalCache.has(e);
  },
  setIfMissingThenGet: function setIfMissingThenGet(e, t) {
    if (globalCache.has(e)) return globalCache.get(e);
    var r = t();
    return globalCache.set(e, r), r;
  }
},
    globalCache_1 = globalCache,
    constants = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  t.GLOBAL_CACHE_KEY = "reactWithStylesInterfaceCSS", t.MAX_SPECIFICITY = 20;
});

unwrapExports(constants);
var constants_1 = constants.GLOBAL_CACHE_KEY,
    constants_2 = constants.MAX_SPECIFICITY,
    getClassName_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e, t) {
    return (0 < e.length ? String(e) + "__" : "") + String(t);
  };
});
unwrapExports(getClassName_1);
var separateStyles_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    for (var t = [], r = !1, n = {}, o = 0; o < e.length; o++) {
      var a = e[o];
      a && ("string" == typeof a ? t.push(a) : (Object.assign(n, a), r = !0));
    }

    return {
      classNames: t,
      hasInlineStyles: r,
      inlineStyles: n
    };
  };
});
unwrapExports(separateStyles_1);
var dist = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var s = r(array_prototype_flat),
      a = r(globalCache_1),
      i = r(getClassName_1),
      c = r(separateStyles_1);

  function r(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  t.default = {
    create: function create(e) {
      var r = {},
          t = Object.keys(e),
          n = (a.default.get(constants.GLOBAL_CACHE_KEY) || {}).namespace,
          o = void 0 === n ? "" : n;
      return t.forEach(function (e) {
        var t = (0, i.default)(o, e);
        r[e] = t;
      }), r;
    },
    resolve: function resolve(e) {
      var t = (0, s.default)(e, 1 / 0),
          r = (0, c.default)(t),
          n = r.classNames,
          o = r.hasInlineStyles,
          a = r.inlineStyles,
          i = {
        className: n.map(function (e, t) {
          return String(e) + " " + String(e) + "_" + String(t + 1);
        }).join(" ")
      };
      return o && (i.style = a), i;
    }
  };
});
unwrapExports(dist);
var reactWithStylesInterfaceCss = dist.default,
    ThemedStyleSheet = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var o = void 0,
      n = void 0;

  function r(e, t) {
    var r = t(e(n));
    return function () {
      return r;
    };
  }

  function a(e) {
    return r(e, o.createLTR || o.create);
  }

  function i() {
    "production" !== process.env.NODE_ENV && "undefined" != typeof performance && void 0 !== performance.mark && performance.mark("react-with-styles.resolve.start");

    for (var e = arguments.length, t = Array(e), r = 0; r < e; r++) {
      t[r] = arguments[r];
    }

    var n = o.resolve(t);
    return "production" !== process.env.NODE_ENV && "undefined" != typeof performance && void 0 !== performance.mark && (performance.mark("react-with-styles.resolve.end"), performance.measure("👩‍🎨 [resolve]", "react-with-styles.resolve.start", "react-with-styles.resolve.end")), n;
  }

  function s() {
    for (var e = arguments.length, t = Array(e), r = 0; r < e; r++) {
      t[r] = arguments[r];
    }

    return o.resolveLTR ? o.resolveLTR(t) : i(t);
  }

  t.default = {
    registerTheme: function registerTheme(e) {
      n = e;
    },
    registerInterface: function registerInterface(e) {
      o = e;
    },
    create: a,
    createLTR: a,
    createRTL: function createRTL(e) {
      return r(e, o.createRTL || o.create);
    },
    get: function get() {
      return n;
    },
    resolve: s,
    resolveLTR: s,
    resolveRTL: function resolveRTL() {
      for (var e = arguments.length, t = Array(e), r = 0; r < e; r++) {
        t[r] = arguments[r];
      }

      return o.resolveRTL ? o.resolveRTL(t) : i(t);
    },
    flush: function flush() {
      o.flush && o.flush();
    }
  };
});
unwrapExports(ThemedStyleSheet);
var DefaultTheme = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = {
    white: "#fff",
    gray: "#484848",
    grayLight: "#82888a",
    grayLighter: "#cacccd",
    grayLightest: "#f2f2f2",
    borderMedium: "#c4c4c4",
    border: "#dbdbdb",
    borderLight: "#e4e7e7",
    borderLighter: "#eceeee",
    borderBright: "#f4f5f5",
    primary: "#00a699",
    primaryShade_1: "#33dacd",
    primaryShade_2: "#66e2da",
    primaryShade_3: "#80e8e0",
    primaryShade_4: "#b2f1ec",
    primary_dark: "#008489",
    secondary: "#007a87",
    yellow: "#ffe8bc",
    yellow_dark: "#ffce71"
  },
      n = {
    reactDates: {
      zIndex: 0,
      border: {
        input: {
          border: 0,
          borderTop: 0,
          borderRight: 0,
          borderBottom: "2px solid transparent",
          borderLeft: 0,
          outlineFocused: 0,
          borderFocused: 0,
          borderTopFocused: 0,
          borderLeftFocused: 0,
          borderBottomFocused: "2px solid ".concat(r.primary_dark),
          borderRightFocused: 0,
          borderRadius: 0
        },
        pickerInput: {
          borderWidth: 1,
          borderStyle: "solid",
          borderRadius: 2
        }
      },
      color: {
        core: r,
        disabled: r.grayLightest,
        background: r.white,
        backgroundDark: "#f2f2f2",
        backgroundFocused: r.white,
        border: "rgb(219, 219, 219)",
        text: r.gray,
        textDisabled: r.border,
        textFocused: "#007a87",
        placeholderText: "#757575",
        outside: {
          backgroundColor: r.white,
          backgroundColor_active: r.white,
          backgroundColor_hover: r.white,
          color: r.gray,
          color_active: r.gray,
          color_hover: r.gray
        },
        highlighted: {
          backgroundColor: r.yellow,
          backgroundColor_active: r.yellow_dark,
          backgroundColor_hover: r.yellow_dark,
          color: r.gray,
          color_active: r.gray,
          color_hover: r.gray
        },
        minimumNights: {
          backgroundColor: r.white,
          backgroundColor_active: r.white,
          backgroundColor_hover: r.white,
          borderColor: r.borderLighter,
          color: r.grayLighter,
          color_active: r.grayLighter,
          color_hover: r.grayLighter
        },
        hoveredSpan: {
          backgroundColor: r.primaryShade_4,
          backgroundColor_active: r.primaryShade_3,
          backgroundColor_hover: r.primaryShade_4,
          borderColor: r.primaryShade_3,
          borderColor_active: r.primaryShade_3,
          borderColor_hover: r.primaryShade_3,
          color: r.secondary,
          color_active: r.secondary,
          color_hover: r.secondary
        },
        selectedSpan: {
          backgroundColor: r.primaryShade_2,
          backgroundColor_active: r.primaryShade_1,
          backgroundColor_hover: r.primaryShade_1,
          borderColor: r.primaryShade_1,
          borderColor_active: r.primary,
          borderColor_hover: r.primary,
          color: r.white,
          color_active: r.white,
          color_hover: r.white
        },
        selected: {
          backgroundColor: r.primary,
          backgroundColor_active: r.primary,
          backgroundColor_hover: r.primary,
          borderColor: r.primary,
          borderColor_active: r.primary,
          borderColor_hover: r.primary,
          color: r.white,
          color_active: r.white,
          color_hover: r.white
        },
        blocked_calendar: {
          backgroundColor: r.grayLighter,
          backgroundColor_active: r.grayLighter,
          backgroundColor_hover: r.grayLighter,
          borderColor: r.grayLighter,
          borderColor_active: r.grayLighter,
          borderColor_hover: r.grayLighter,
          color: r.grayLight,
          color_active: r.grayLight,
          color_hover: r.grayLight
        },
        blocked_out_of_range: {
          backgroundColor: r.white,
          backgroundColor_active: r.white,
          backgroundColor_hover: r.white,
          borderColor: r.borderLight,
          borderColor_active: r.borderLight,
          borderColor_hover: r.borderLight,
          color: r.grayLighter,
          color_active: r.grayLighter,
          color_hover: r.grayLighter
        }
      },
      spacing: {
        dayPickerHorizontalPadding: 9,
        captionPaddingTop: 22,
        captionPaddingBottom: 37,
        inputPadding: 0,
        displayTextPaddingVertical: void 0,
        displayTextPaddingTop: 11,
        displayTextPaddingBottom: 9,
        displayTextPaddingHorizontal: void 0,
        displayTextPaddingLeft: 11,
        displayTextPaddingRight: 11,
        displayTextPaddingVertical_small: void 0,
        displayTextPaddingTop_small: 7,
        displayTextPaddingBottom_small: 5,
        displayTextPaddingHorizontal_small: void 0,
        displayTextPaddingLeft_small: 7,
        displayTextPaddingRight_small: 7
      },
      sizing: {
        inputWidth: 130,
        inputWidth_small: 97,
        arrowWidth: 24
      },
      noScrollBarOnVerticalScrollable: !1,
      font: {
        size: 14,
        captionSize: 18,
        input: {
          size: 19,
          lineHeight: "24px",
          size_small: 15,
          lineHeight_small: "18px",
          letterSpacing_small: "0.2px",
          styleDisabled: "italic"
        }
      }
    }
  };
  t.default = n;
});
unwrapExports(DefaultTheme);
var registerInterfaceWithDefaultTheme_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    r.default.registerInterface(e), r.default.registerTheme(n.default);
  };
  var r = o(ThemedStyleSheet),
      n = o(DefaultTheme);

  function o(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
});
unwrapExports(registerInterfaceWithDefaultTheme_1);
var registerCSSInterfaceWithDefaultTheme_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function () {
    (0, n.default)(r.default);
  };
  var r = o(reactWithStylesInterfaceCss),
      n = o(registerInterfaceWithDefaultTheme_1);

  function o(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
});
unwrapExports(registerCSSInterfaceWithDefaultTheme_1);
var initialize = createCommonjsModule(function (e) {
  var t;
  (0, ((t = registerCSSInterfaceWithDefaultTheme_1) && t.__esModule ? t : {
    default: t
  }).default)();
});

function _isPlaceholder(e) {
  return null != e && "object" == typeof e && !0 === e["@@functional/placeholder"];
}

function _curry1(r) {
  return function e(t) {
    return 0 === arguments.length || _isPlaceholder(t) ? e : r.apply(this, arguments);
  };
}

function _curry2(n) {
  return function e(t, r) {
    switch (arguments.length) {
      case 0:
        return e;

      case 1:
        return _isPlaceholder(t) ? e : _curry1(function (e) {
          return n(t, e);
        });

      default:
        return _isPlaceholder(t) && _isPlaceholder(r) ? e : _isPlaceholder(t) ? _curry1(function (e) {
          return n(e, r);
        }) : _isPlaceholder(r) ? _curry1(function (e) {
          return n(t, e);
        }) : n(t, r);
    }
  };
}

function _concat(e, t) {
  var r;
  t = t || [];
  var n = (e = e || []).length,
      o = t.length,
      a = [];

  for (r = 0; r < n;) {
    a[a.length] = e[r], r += 1;
  }

  for (r = 0; r < o;) {
    a[a.length] = t[r], r += 1;
  }

  return a;
}

function _arity(e, l) {
  switch (e) {
    case 0:
      return function () {
        return l.apply(this, arguments);
      };

    case 1:
      return function (e) {
        return l.apply(this, arguments);
      };

    case 2:
      return function (e, t) {
        return l.apply(this, arguments);
      };

    case 3:
      return function (e, t, r) {
        return l.apply(this, arguments);
      };

    case 4:
      return function (e, t, r, n) {
        return l.apply(this, arguments);
      };

    case 5:
      return function (e, t, r, n, o) {
        return l.apply(this, arguments);
      };

    case 6:
      return function (e, t, r, n, o, a) {
        return l.apply(this, arguments);
      };

    case 7:
      return function (e, t, r, n, o, a, i) {
        return l.apply(this, arguments);
      };

    case 8:
      return function (e, t, r, n, o, a, i, s) {
        return l.apply(this, arguments);
      };

    case 9:
      return function (e, t, r, n, o, a, i, s, c) {
        return l.apply(this, arguments);
      };

    case 10:
      return function (e, t, r, n, o, a, i, s, c, u) {
        return l.apply(this, arguments);
      };

    default:
      throw new Error("First argument to _arity must be a non-negative integer no greater than ten");
  }
}

function _curryN(a, i, s) {
  return function () {
    for (var e = [], t = 0, r = a, n = 0; n < i.length || t < arguments.length;) {
      var o;
      n < i.length && (!_isPlaceholder(i[n]) || t >= arguments.length) ? o = i[n] : (o = arguments[t], t += 1), _isPlaceholder(e[n] = o) || (r -= 1), n += 1;
    }

    return r <= 0 ? s.apply(this, e) : _arity(r, _curryN(a, e, s));
  };
}

unwrapExports(initialize);

var curryN = _curry2(function (e, t) {
  return 1 === e ? _curry1(t) : _arity(e, _curryN(e, [], t));
}),
    addIndex = _curry1(function (o) {
  return curryN(o.length, function () {
    var t = 0,
        r = arguments[0],
        n = arguments[arguments.length - 1],
        e = Array.prototype.slice.call(arguments, 0);
    return e[0] = function () {
      var e = r.apply(this, _concat(arguments, [t, n]));
      return t += 1, e;
    }, o.apply(this, e);
  });
});

function _curry3(a) {
  return function e(r, n, o) {
    switch (arguments.length) {
      case 0:
        return e;

      case 1:
        return _isPlaceholder(r) ? e : _curry2(function (e, t) {
          return a(r, e, t);
        });

      case 2:
        return _isPlaceholder(r) && _isPlaceholder(n) ? e : _isPlaceholder(r) ? _curry2(function (e, t) {
          return a(e, n, t);
        }) : _isPlaceholder(n) ? _curry2(function (e, t) {
          return a(r, e, t);
        }) : _curry1(function (e) {
          return a(r, n, e);
        });

      default:
        return _isPlaceholder(r) && _isPlaceholder(n) && _isPlaceholder(o) ? e : _isPlaceholder(r) && _isPlaceholder(n) ? _curry2(function (e, t) {
          return a(e, t, o);
        }) : _isPlaceholder(r) && _isPlaceholder(o) ? _curry2(function (e, t) {
          return a(e, n, t);
        }) : _isPlaceholder(n) && _isPlaceholder(o) ? _curry2(function (e, t) {
          return a(r, e, t);
        }) : _isPlaceholder(r) ? _curry1(function (e) {
          return a(e, n, o);
        }) : _isPlaceholder(n) ? _curry1(function (e) {
          return a(r, e, o);
        }) : _isPlaceholder(o) ? _curry1(function (e) {
          return a(r, n, e);
        }) : a(r, n, o);
    }
  };
}

var _isArray = Array.isArray || function (e) {
  return null != e && 0 <= e.length && "[object Array]" === Object.prototype.toString.call(e);
};

function _isTransformer(e) {
  return null != e && "function" == typeof e["@@transducer/step"];
}

function _dispatchable(n, o, a) {
  return function () {
    if (0 === arguments.length) return a();
    var e = Array.prototype.slice.call(arguments, 0),
        t = e.pop();

    if (!_isArray(t)) {
      for (var r = 0; r < n.length;) {
        if ("function" == typeof t[n[r]]) return t[n[r]].apply(t, e);
        r += 1;
      }

      if (_isTransformer(t)) return o.apply(null, e)(t);
    }

    return a.apply(this, arguments);
  };
}

var _xfBase = {
  init: function init() {
    return this.xf["@@transducer/init"]();
  },
  result: function result(e) {
    return this.xf["@@transducer/result"](e);
  }
};

function _map(e, t) {
  for (var r = 0, n = t.length, o = Array(n); r < n;) {
    o[r] = e(t[r]), r += 1;
  }

  return o;
}

function _isString(e) {
  return "[object String]" === Object.prototype.toString.call(e);
}

var _isArrayLike = _curry1(function (e) {
  return !!_isArray(e) || !!e && "object" == typeof e && !_isString(e) && (1 === e.nodeType ? !!e.length : 0 === e.length || 0 < e.length && e.hasOwnProperty(0) && e.hasOwnProperty(e.length - 1));
}),
    XWrap = function () {
  function e(e) {
    this.f = e;
  }

  return e.prototype["@@transducer/init"] = function () {
    throw new Error("init not implemented on XWrap");
  }, e.prototype["@@transducer/result"] = function (e) {
    return e;
  }, e.prototype["@@transducer/step"] = function (e, t) {
    return this.f(e, t);
  }, e;
}();

function _xwrap(e) {
  return new XWrap(e);
}

var bind = _curry2(function (e, t) {
  return _arity(e.length, function () {
    return e.apply(t, arguments);
  });
});

function _arrayReduce(e, t, r) {
  for (var n = 0, o = r.length; n < o;) {
    if ((t = e["@@transducer/step"](t, r[n])) && t["@@transducer/reduced"]) {
      t = t["@@transducer/value"];
      break;
    }

    n += 1;
  }

  return e["@@transducer/result"](t);
}

function _iterableReduce(e, t, r) {
  for (var n = r.next(); !n.done;) {
    if ((t = e["@@transducer/step"](t, n.value)) && t["@@transducer/reduced"]) {
      t = t["@@transducer/value"];
      break;
    }

    n = r.next();
  }

  return e["@@transducer/result"](t);
}

function _methodReduce(e, t, r, n) {
  return e["@@transducer/result"](r[n](bind(e["@@transducer/step"], e), t));
}

var symIterator = "undefined" != typeof Symbol ? Symbol.iterator : "@@iterator";

function _reduce(e, t, r) {
  if ("function" == typeof e && (e = _xwrap(e)), _isArrayLike(r)) return _arrayReduce(e, t, r);
  if ("function" == typeof r["fantasy-land/reduce"]) return _methodReduce(e, t, r, "fantasy-land/reduce");
  if (null != r[symIterator]) return _iterableReduce(e, t, r[symIterator]());
  if ("function" == typeof r.next) return _iterableReduce(e, t, r);
  if ("function" == typeof r.reduce) return _methodReduce(e, t, r, "reduce");
  throw new TypeError("reduce: list must be array or iterable");
}

var XMap = function () {
  function e(e, t) {
    this.xf = t, this.f = e;
  }

  return e.prototype["@@transducer/init"] = _xfBase.init, e.prototype["@@transducer/result"] = _xfBase.result, e.prototype["@@transducer/step"] = function (e, t) {
    return this.xf["@@transducer/step"](e, this.f(t));
  }, e;
}(),
    _xmap = _curry2(function (e, t) {
  return new XMap(e, t);
});

function _has(e, t) {
  return Object.prototype.hasOwnProperty.call(t, e);
}

var toString = Object.prototype.toString,
    _isArguments = function () {
  return "[object Arguments]" === toString.call(arguments) ? function (e) {
    return "[object Arguments]" === toString.call(e);
  } : function (e) {
    return _has("callee", e);
  };
}(),
    hasEnumBug = !{
  toString: null
}.propertyIsEnumerable("toString"),
    nonEnumerableProps = ["constructor", "valueOf", "isPrototypeOf", "toString", "propertyIsEnumerable", "hasOwnProperty", "toLocaleString"],
    hasArgsEnumBug = function () {
  return arguments.propertyIsEnumerable("length");
}(),
    contains = function contains(e, t) {
  for (var r = 0; r < e.length;) {
    if (e[r] === t) return !0;
    r += 1;
  }

  return !1;
},
    keys = "function" != typeof Object.keys || hasArgsEnumBug ? _curry1(function (e) {
  if (Object(e) !== e) return [];

  var t,
      r,
      n = [],
      o = hasArgsEnumBug && _isArguments(e);

  for (t in e) {
    !_has(t, e) || o && "length" === t || (n[n.length] = t);
  }

  if (hasEnumBug) for (r = nonEnumerableProps.length - 1; 0 <= r;) {
    _has(t = nonEnumerableProps[r], e) && !contains(n, t) && (n[n.length] = t), r -= 1;
  }
  return n;
}) : _curry1(function (e) {
  return Object(e) !== e ? [] : Object.keys(e);
}),
    map = _curry2(_dispatchable(["fantasy-land/map", "map"], _xmap, function (r, n) {
  switch (Object.prototype.toString.call(n)) {
    case "[object Function]":
      return curryN(n.length, function () {
        return r.call(this, n.apply(this, arguments));
      });

    case "[object Object]":
      return _reduce(function (e, t) {
        return e[t] = r(n[t]), e;
      }, {}, keys(n));

    default:
      return _map(r, n);
  }
})),
    path = _curry2(function (e, t) {
  for (var r = t, n = 0; n < e.length;) {
    if (null == r) return;
    r = r[e[n]], n += 1;
  }

  return r;
}),
    prop = _curry2(function (e, t) {
  return path([e], t);
}),
    type = _curry1(function (e) {
  return null === e ? "Null" : void 0 === e ? "Undefined" : Object.prototype.toString.call(e).slice(8, -1);
});

function _arrayFromIterator(e) {
  for (var t, r = []; !(t = e.next()).done;) {
    r.push(t.value);
  }

  return r;
}

function _includesWith(e, t, r) {
  for (var n = 0, o = r.length; n < o;) {
    if (e(t, r[n])) return !0;
    n += 1;
  }

  return !1;
}

function _functionName(e) {
  var t = String(e).match(/^function (\w*)/);
  return null == t ? "" : t[1];
}

function _objectIs(e, t) {
  return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
}

var _objectIs$1 = "function" == typeof Object.is ? Object.is : _objectIs;

function _uniqContentEquals(e, t, r, n) {
  var o = _arrayFromIterator(e);

  function a(e, t) {
    return _equals(e, t, r.slice(), n.slice());
  }

  return !_includesWith(function (e, t) {
    return !_includesWith(a, t, e);
  }, _arrayFromIterator(t), o);
}

function _equals(e, t, r, n) {
  if (_objectIs$1(e, t)) return !0;
  var o = type(e);
  if (o !== type(t)) return !1;
  if (null == e || null == t) return !1;
  if ("function" == typeof e["fantasy-land/equals"] || "function" == typeof t["fantasy-land/equals"]) return "function" == typeof e["fantasy-land/equals"] && e["fantasy-land/equals"](t) && "function" == typeof t["fantasy-land/equals"] && t["fantasy-land/equals"](e);
  if ("function" == typeof e.equals || "function" == typeof t.equals) return "function" == typeof e.equals && e.equals(t) && "function" == typeof t.equals && t.equals(e);

  switch (o) {
    case "Arguments":
    case "Array":
    case "Object":
      if ("function" == typeof e.constructor && "Promise" === _functionName(e.constructor)) return e === t;
      break;

    case "Boolean":
    case "Number":
    case "String":
      if (typeof e != typeof t || !_objectIs$1(e.valueOf(), t.valueOf())) return !1;
      break;

    case "Date":
      if (!_objectIs$1(e.valueOf(), t.valueOf())) return !1;
      break;

    case "Error":
      return e.name === t.name && e.message === t.message;

    case "RegExp":
      if (e.source !== t.source || e.global !== t.global || e.ignoreCase !== t.ignoreCase || e.multiline !== t.multiline || e.sticky !== t.sticky || e.unicode !== t.unicode) return !1;
  }

  for (var a = r.length - 1; 0 <= a;) {
    if (r[a] === e) return n[a] === t;
    a -= 1;
  }

  switch (o) {
    case "Map":
      return e.size === t.size && _uniqContentEquals(e.entries(), t.entries(), r.concat([e]), n.concat([t]));

    case "Set":
      return e.size === t.size && _uniqContentEquals(e.values(), t.values(), r.concat([e]), n.concat([t]));

    case "Arguments":
    case "Array":
    case "Object":
    case "Boolean":
    case "Number":
    case "String":
    case "Date":
    case "Error":
    case "RegExp":
    case "Int8Array":
    case "Uint8Array":
    case "Uint8ClampedArray":
    case "Int16Array":
    case "Uint16Array":
    case "Int32Array":
    case "Uint32Array":
    case "Float32Array":
    case "Float64Array":
    case "ArrayBuffer":
      break;

    default:
      return !1;
  }

  var i = keys(e);
  if (i.length !== keys(t).length) return !1;
  var s = r.concat([e]),
      c = n.concat([t]);

  for (a = i.length - 1; 0 <= a;) {
    var u = i[a];
    if (!_has(u, t) || !_equals(t[u], e[u], s, c)) return !1;
    a -= 1;
  }

  return !0;
}

var equals = _curry2(function (e, t) {
  return _equals(e, t, [], []);
});

function _complement(e) {
  return function () {
    return !e.apply(this, arguments);
  };
}

function _filter(e, t) {
  for (var r = 0, n = t.length, o = []; r < n;) {
    e(t[r]) && (o[o.length] = t[r]), r += 1;
  }

  return o;
}

function _isObject(e) {
  return "[object Object]" === Object.prototype.toString.call(e);
}

var XFilter = function () {
  function e(e, t) {
    this.xf = t, this.f = e;
  }

  return e.prototype["@@transducer/init"] = _xfBase.init, e.prototype["@@transducer/result"] = _xfBase.result, e.prototype["@@transducer/step"] = function (e, t) {
    return this.f(t) ? this.xf["@@transducer/step"](e, t) : e;
  }, e;
}(),
    _xfilter = _curry2(function (e, t) {
  return new XFilter(e, t);
}),
    filter = _curry2(_dispatchable(["filter"], _xfilter, function (r, n) {
  return _isObject(n) ? _reduce(function (e, t) {
    return r(n[t]) && (e[t] = n[t]), e;
  }, {}, keys(n)) : _filter(r, n);
})),
    reject = _curry2(function (e, t) {
  return filter(_complement(e), t);
}),
    prepend = _curry2(function (e, t) {
  return _concat([e], t);
}),
    propEq = _curry3(function (e, t, r) {
  return equals(t, r[e]);
}),
    mapIndex = addIndex(map),
    tDefault = function tDefault(e) {
  return e;
},
    s$4 = {
  container: "styles-module_container__2-i__",
  dislikeBtn: "styles-module_dislikeBtn__t8Bgx",
  likeBtn: "styles-module_likeBtn__GJYp3"
},
    imageThumbsDown = "data:image/png;base64,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",
    imageThumbsDownActive = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAAH7+Yj7AAAAAXNSR0IArs4c6QAABG5JREFUWAnNWF+IVFUYP9+5d9eWav5sZmSUPkkQZiFhRNCjSU8KSkFU0IOaNrPMHdNeYojAXHeHmdklEnTF6I8iPUQURC/6IEWhFpTh0kMPaRRmM7OoZHfu53fuzLmeuffcnXPZIe55mPOd7/t93/c7/+8cxqhknfqPGaf+uZBFAfGTKdVQ1LJwKag1z+57L68q2tUJ39vXhUNEYkIEQX7aRLYuCZfZrJGxnARoyUujWmvzqAAp82yp9r1sLFbf7jmh1K5JntJZmzoMEmA/4vLS7JqbzL1Irb848jeb1cKcjCRrs14Dc3muXK9Ir9gamc09xJ2xAMXAGbIVSjtW1PZah+6b7D4AwLH2dPEVqdMOODC43qoW75QgUQepaal/Ig1hUB+QQn/pA2nQpYNaB6nzzsymDna6YBURkaHDOZSbU4VaxESKIKC6cHRAU53fZ9rWN0wdBuG6g4h4xyCgqZ3nKkeDfWvqtBiOewvtM4sBktr8SVl/6NDIr/P/7mfoPSQDIMA6hrhGtmVNDuda1Yn1sh2ug1lWDeOl+lMuwwhz3Ymg+gk5WNmqoQP4ltoWskkwgdMGbE1PPEvUmwIgyjILIl3vWqK/fV2m9VgDxJfpaqGZBxpG9gO5fGNb9uzfk7t+ibpHNUHABDvlDB9d9mLz3Z2/RcP1tt743tlH3P/cn3SAJDrLguf8MXRd79EkjnHYTge/6G097+M4UFK9dpaTBlHxfHXl6NAOBhGYX11of61mWKrMad0NlyEyeHCprFR/mhS8T1UsVR7qLAPAcZv23iXauw8kYbbxyZX2yW3bOjoffy9nnMYLgN5mFUBJtqptKY/x8bv+nHrpmmyH6+BwUA2Zcv155mFw80sbt0Yebx7cJU6g2KIfQ10wBs6gYCKLPmAoPw12q1ktVkNqbdMoIALbofXWKI0CtqeKxzW+WpU2INjWExJNs5boM0U7yzmn5ngIB2gXWTJwgvoPGnNxBZ8l/7PcHvvunwPbWwn8+6B9BBER6LP7HCJ7rA81zAbAPCD7me7Um92wdLXKQvmFSHvqkm3zE1cnC9/eNpIht6fxjNfxTglQKgqwiwHBTOXwOCxco9HDVakg1yMRLGoidzpt5ATHgCCRuydNIye5+ASz5cYeUtwvlWmquyOIWEgTKZVLjyD7SlWmSeZZpzGFDF9NEymVC71e4HZVkSaZzsAbNr0MfEBH92v/BzF6OzkNFszR20/vFullFX/URKF/bEzKDK7cuwpP+Yb83pm1nut9SEfNUP709NIqFXxWyhS2VCrgKUojMbhJTNDUAcg5jfO0ZteZ4Omj4fcRi2+4Mvn6ZRO8DhP/3hVCC3J0Xl6gq/zhkEnTpLmycGvrYPFTjTGRyphgvlx/m9bqQHI0anOt6eLQToXgqhvULfoEenoQhjbBkWGSE/mMCdIWmx9IcHT0nUGYpHZjgvm7M0Wx6OMSkO39uIeWOB8TfaJdLAIuf2Nmpet5O9BjGxFwNX0djyLw3e3pwkcmCZNibgExqUj5ssSuwgAAAABJRU5ErkJggg==",
    imageThumbsUp = "data:image/png;base64,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",
    imageThumbsUpActive = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAuCAYAAAEkS8ucAAAAAXNSR0IArs4c6QAABO5JREFUWAnVWVuIW0UYnv8k6xa2m2zq0tLLgtZCwVaFIigUvNA++VIt4qMUFXxQmyVJU8RLI4hY0iybjWtV9GH1QVDqi1TWB2kpPrQPlVpbX7yCW0UEu0m8lN2cGb85u5NMzi2TNEea85D5579888/MP/9cwpj2JQ/N3KaqliJkKWz+fSIzPSdpkj/yS2bKdcHEWqdCjBM0hFNx/bRB6TKLGNV0hqRrU5PNJhxZMlv+WBJtMEKIRyWzqao37utJm7k0lZ8vs4m5otP6bbVBz9am0rNS4qvcUmzvDyUz0+cxRrtamMGUZaooIXw74o9NwtfnsVy5wLk40jIigU4GAzvzL9rBArVloGAieQs9wOdEdvp3XUnRHuTx/HujTLD1SkEvPR3UJ0RXnEhsGvaNFl1Jpz1u6EKdhgt/Gisjii4YK1dLk3uMlaVLXSl7hm5D7vj6f/nSArLAkOrgrsRdQ6cLDzY8ykohqHTPg2exrxp25TIi9xF3g4lM+aSbJ+vGwGPZN+7DcvjEAxJjFQ8PjLgf082T3eei4WYzsuhYtZie9wjACB1jLKkfkQpv9TPsxOsq7juB6XLjMdaNOtEWUSUSYLLYfCTAV4vpz/oOLFeeHConKtZlZ253KrGYYDZ3Nt8G8TsREbNIjeOdxlSXq5UYGm66gaIRgl+Dxm5l5Wql5z5XfHfZ1VCMZSsPoxeyJztx+pjHvvmWG1DVuwLmzH5bGcoSY/a0XtfproCDtiIdUNHGwDsKH92kjExKY+Bf6r/WTQCVjhEwstu3GAaPxwipowrIXXYMt0R25mUm+CtuQ1lXMesnCwVOHa7cYS/bF/0Mg3hErIitNx8InMqVd2IRfhMEEMa3WGxfJPmYiBaMJi/MOz8ZFs7PkQCz0ZF9kQDXCk91cSLz63MILxKPZXt9B0YcfxgJMCJiJBLgYYtyEQCT/Ucx/V3fgZEfrkhQ+cWtRDJl1eubSNuheZwN8QafxN72xIqa8W9TPzAJ6VCpQ+WHuM3yuHvdr/N1GvnhnWop3dwDjYB1gG7oQkFYU7XyGdjs9tgRnZwY3bj/cuGxJY8shBGpw/LpAdPkvDT4+0A2xWh7tXjwB3+5l9v3Ba2auPmF45vDnZWaIsZs8byyMSkjc9i+tmTqyISJo0onEoed5xEhnlGNhJW4UpwLk7tlRndHt1FQfTz/5vblxtJZXF7HgnR0PjJAdfPaja8u6swOdKyD3EiMWKXpv1InbG7Ll7Q1JkbYvP5eQ8PbfnrtgOfhMMz+urOEvJBwwfEc0P7gFdaoIyP6koT4LUhPEP2Dq+0FFmOnFo8elDcp5+vZ4XWZ2QmbLZ/BbnzLKla0BdEHtVL6cUrmK3fjEvo6WltpGPOL3sEP50MpFA0Gok4IC2O5FTeGSBbsarv+BdGncdHgZ518qKvoPup8eOl4r3WhTRxxBYO1G6OE5D0oH9G7//+09jo4ZB3BIejw4DgsxF7Z14FxGHm7/yftXme7ox2xcwiHJwdphJt/rAxESMDJL9Qs3PgOWzS1WJp8aUAcJrt2LJ1VzjoxjL9ZX8SWa+vMG4VGZjjh9qXnw88DhVPxr+qX9uDf6P04buzFbr3VDX5ddaI5HHYOuDF6dtgN5K5vyL0/co1V78Eb+L2YwW2Qb8GxagtGDSUb1fVxpLqKQ8oCZKfR8TmksPO6XKf/A30TesjaxPgGAAAAAElFTkSuQmCC",
    ArticleLike = function (e) {
  function a() {
    var e, t;
    classCallCheck(this, a);

    for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) {
      n[o] = arguments[o];
    }

    return t = possibleConstructorReturn(this, (e = getPrototypeOf(a)).call.apply(e, [this].concat(n))), defineProperty(assertThisInitialized(t), "onPressLike", function () {
      var e = t.props;
      (0, e.onUpdate)({
        like: !e.like || null
      });
    }), defineProperty(assertThisInitialized(t), "onPressDislike", function () {
      var e = t.props;
      (0, e.onUpdate)({
        like: !1 === e.like && null
      });
    }), t;
  }

  return inherits(a, react_1), createClass(a, [{
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.className,
          r = e.like,
          n = (e.onUpdate, objectWithoutProperties(e, ["className", "like", "onUpdate"]));
      return react.createElement("div", _extends_1({
        className: classnames(s$4.container, t)
      }, n), react.createElement("div", {
        className: s$4.likeBtn
      }, react.createElement("div", {
        onClick: this.onPressLike
      }, react.createElement("img", {
        src: r ? imageThumbsUpActive : imageThumbsUp,
        alt: "like"
      }))), react.createElement("div", {
        className: s$4.dislikeBtn
      }, react.createElement("div", {
        onClick: this.onPressDislike
      }, react.createElement("img", {
        src: !1 === r ? imageThumbsDownActive : imageThumbsDown,
        alt: "dislike"
      }))));
    }
  }]), a;
}();

defineProperty(ArticleLike, "defaultProps", {
  like: null,
  className: null
});

var s$5 = {
  root: "styles-module_root__3PEDK",
  headerTitle: "styles-module_headerTitle__N8TMR",
  headerSubTitle: "styles-module_headerSubTitle__2VEh9",
  headInfo: "styles-module_headInfo__1Rjcm",
  footer: "styles-module_footer__15LpK",
  footerTitle: "styles-module_footerTitle__2ETsD",
  header: "styles-module_header__2komz",
  content: "styles-module_content__2Rv9M",
  contentBtn: "styles-module_contentBtn__3bHO4"
},
    Article = function (e) {
  function t() {
    return classCallCheck(this, t), possibleConstructorReturn(this, getPrototypeOf(t).apply(this, arguments));
  }

  return inherits(t, react_1), createClass(t, [{
    key: "getHeader",
    value: function value() {
      var e = this.props,
          t = e.title,
          r = e.imgUrl,
          n = e.subTitle,
          o = e.publishedBy,
          a = e.date,
          i = e.t;
      return react.createElement("div", {
        className: s$5.header
      }, react.createElement("header", {
        className: s$5.headerTitle
      }, t), r && react.createElement("img", {
        src: r,
        alt: r
      }), react.createElement("div", {
        className: s$5.headerSubTitle
      }, n), a && react.createElement("div", {
        className: s$5.headInfo
      }, a), o && react.createElement("div", {
        className: s$5.headInfo
      }, react.createElement("span", null, "".concat(i("Published by"), ": ")), o));
    }
  }, {
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.like,
          r = e.children,
          n = e.updateLike,
          o = e.t,
          a = e.className,
          i = e.pdfBtn,
          s = objectWithoutProperties(e, ["like", "children", "updateLike", "t", "className", "pdfBtn"]);
      return react.createElement("article", _extends_1({
        className: classnames(s$5.root, a)
      }, s), this.getHeader(), react.createElement("div", {
        className: s$5.content
      }, r, i && react.createElement("div", {
        className: s$5.contentBtn
      }, i)), react.createElement("footer", {
        className: s$5.footer
      }, react.createElement("div", {
        className: s$5.footerTitle
      }, o("Was this information helpful?")), react.createElement(ArticleLike, {
        onUpdate: n,
        like: t
      })));
    }
  }]), t;
}();

defineProperty(Article, "defaultProps", {
  subTitle: null,
  date: null,
  publishedBy: null,
  imgUrl: null,
  t: tDefault,
  className: null,
  pdfBtn: null
});

var s$6 = {
  root: "styles-module_root__26sGY",
  stretch: "styles-module_stretch__2YWdI",
  outlined: "styles-module_outlined__KKQdA",
  sm: "styles-module_sm__30-Kc",
  md: "styles-module_md__1TD1H",
  primary: "styles-module_primary__308_9",
  primaryOutlined: "styles-module_primaryOutlined__1QcNr",
  secondary: "styles-module_secondary__2ZzZ5",
  secondaryOutlined: "styles-module_secondaryOutlined__Ws15O",
  success: "styles-module_success__3mGRX",
  successOutlined: "styles-module_successOutlined__3FOdy",
  warning: "styles-module_warning__o5g-X",
  warningOutlined: "styles-module_warningOutlined__20FhO",
  danger: "styles-module_danger__27IBc",
  dangerOutlined: "styles-module_dangerOutlined__1h3bK",
  info: "styles-module_info__3SKbf",
  infoOutlined: "styles-module_infoOutlined__cXUqb",
  link: "styles-module_link__2K2v-",
  "link-secondary": "styles-module_link-secondary__TfbEY",
  content: "styles-module_content__1LcDH",
  icon: "styles-module_icon__3b5-O"
},
    Button = function Button(e) {
  var t,
      r = e.children,
      n = e.className,
      o = e.iconClassName,
      a = e.component,
      i = e.outlined,
      s = e.icon,
      c = e.size,
      u = e.stretch,
      l = e.variant,
      f = objectWithoutProperties(e, ["children", "className", "iconClassName", "component", "outlined", "icon", "size", "stretch", "variant"]);
  return react.createElement(a, _extends_1({
    className: classnames(s$6.root, n, s$6[c], (t = {}, defineProperty(t, s$6[l], !i), defineProperty(t, s$6.outlined, i), defineProperty(t, s$6["".concat(l, "Outlined")], i), defineProperty(t, s$6.stretch, u), t))
  }, f), react.createElement("div", {
    className: s$6.content
  }, s && react.createElement("div", {
    className: classnames(s$6.icon, o)
  }, s), r));
};

Button.defaultProps = {
  className: null,
  iconClassName: null,
  component: "button",
  icon: null,
  outlined: !1,
  size: "md",
  stretch: !1,
  variant: "secondary"
};

var s$7 = {
  buttonsContainer: "styles-module_buttonsContainer__K9MWq",
  wrapped: "styles-module_wrapped__25g4k",
  noSpaceTop: "styles-module_noSpaceTop__1T9Pd"
},
    ButtonsContainer = function ButtonsContainer(e) {
  var t,
      r = e.children,
      n = e.className,
      o = e.noSpaceTop,
      a = e.wrapped,
      i = objectWithoutProperties(e, ["children", "className", "noSpaceTop", "wrapped"]);
  return react.createElement("div", _extends_1({
    "data-test": "form.buttons.container",
    className: classnames(s$7.buttonsContainer, n, (t = {}, defineProperty(t, s$7.noSpaceTop, o), defineProperty(t, s$7.wrapped, a), t))
  }, i), r);
};

ButtonsContainer.defaultProps = {
  className: null,
  noSpaceTop: !1,
  wrapped: !1
};

var s$8 = {
  root: "styles-module_root__1Bu0G",
  spin: "styles-module_spin__10wJM",
  sm: "styles-module_sm__HG1Vg",
  md: "styles-module_md__2790q",
  default: "styles-module_default__3g_h6",
  primary: "styles-module_primary__3454K"
},
    Loading = function Loading(e) {
  var t = e.className,
      r = e.size,
      n = e.variant;
  return react.createElement("div", {
    className: classnames(s$8.root, s$8[n], s$8[r], t)
  });
};

Loading.defaultProps = {
  className: void 0,
  size: "md",
  variant: "default"
};

var s$9 = {
  button: "styles-module_button__S2IoI",
  spinner: "styles-module_spinner__3xh4v",
  loading: "styles-module_loading__vcoec",
  children: "styles-module_children__CGJhg"
},
    ButtonWithLoader = function ButtonWithLoader(e) {
  var t = e.className,
      r = e.childrenClassName,
      n = e.children,
      o = e.disabled,
      a = e.loading,
      i = objectWithoutProperties(e, ["className", "childrenClassName", "children", "disabled", "loading"]);
  return react.createElement(Button, _extends_1({
    className: classnames(s$9.button, t, defineProperty({}, s$9.loading, a)),
    disabled: o || a
  }, i), react.createElement("span", {
    className: classnames(s$9.children, r)
  }, n), a && react.createElement(Loading, {
    className: s$9.spinner,
    size: "sm"
  }));
};

ButtonWithLoader.defaultProps = {
  disabled: !1,
  loading: !1,
  className: null,
  childrenClassName: null
};

var s$a = {
  root: "styles-module_root__3Cp3E"
},
    CircledButton = function CircledButton(e) {
  var t = e.children,
      r = e.className,
      n = e.component,
      o = objectWithoutProperties(e, ["children", "className", "component"]);
  return react.createElement(n, _extends_1({
    className: classnames(s$a.root, r)
  }, o), t);
};

function _extends() {
  return (_extends = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }

    return e;
  }).apply(this, arguments);
}

CircledButton.defaultProps = {
  className: null,
  component: "button"
};

var _ref = react.createElement("path", {
  fill: "currentColor",
  d: "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
}),
    SvgCheckSolid = function SvgCheckSolid(e) {
  return react.createElement("svg", _extends({
    "aria-hidden": "true",
    "data-prefix": "fas",
    "data-icon": "check",
    className: "check-solid_svg__svg-inline--fa check-solid_svg__fa-check check-solid_svg__fa-w-16",
    viewBox: "0 0 512 512"
  }, e), _ref);
},
    s$b = {
  checkbox: "styles-module_checkbox__1YNdX",
  input: "styles-module_input__vYJiN",
  error: "styles-module_error__Zy0rP"
},
    _ref2 = react.createElement(SvgCheckSolid, null),
    Checkbox = function Checkbox(e) {
  var t = e.error,
      r = e.checked,
      n = objectWithoutProperties(e, ["error", "checked"]);
  return react.createElement("span", {
    className: classnames(s$b.checkbox, defineProperty({}, s$b.error, t))
  }, react.createElement("input", _extends_1({
    className: s$b.input,
    type: "checkbox",
    checked: r
  }, n)), react.createElement("span", {
    className: s$b.mark
  }, _ref2));
};

Checkbox.defaultProps = {
  checked: !1,
  error: !1
};

var flexboxgrid2 = Object.freeze({
  default: void 0
}),
    _flexboxgrid = getCjsExportFromNamespace(flexboxgrid2),
    classNames = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return n.default && n.default[e] ? n.default[e] : e;
  };
  var r,
      n = (r = _flexboxgrid) && r.__esModule ? r : {
    default: r
  };
});

unwrapExports(classNames);
var createProps_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (t, r, e) {
    var n = {};
    Object.keys(r).filter(function (e) {
      return "children" === e || !t[e];
    }).forEach(function (e) {
      return n[e] = r[e];
    });
    var o = e.filter(function (e) {
      return e;
    }).join(" ");
    return Object.assign({}, n, {
      className: o
    });
  };
});
unwrapExports(createProps_1);
var types = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.ViewportSizeType = t.ColumnSizeType = void 0;
  var r,
      n = (r = propTypes) && r.__esModule ? r : {
    default: r
  };
  t.ColumnSizeType = n.default.oneOfType([n.default.number, n.default.bool]), t.ViewportSizeType = n.default.oneOf(["xs", "sm", "md", "lg", "xl"]);
});
unwrapExports(types);
var types_1 = types.ViewportSizeType,
    types_2 = types.ColumnSizeType,
    Row_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.getRowProps = u, t.default = l;
  var a = i(classNames),
      r = i(react),
      n = i(propTypes),
      o = i(createProps_1);

  function i(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var s = ["start", "center", "end", "top", "middle", "bottom", "around", "between"],
      c = {
    reverse: n.default.bool,
    start: types.ViewportSizeType,
    center: types.ViewportSizeType,
    end: types.ViewportSizeType,
    top: types.ViewportSizeType,
    middle: types.ViewportSizeType,
    bottom: types.ViewportSizeType,
    around: types.ViewportSizeType,
    between: types.ViewportSizeType,
    className: n.default.string,
    tagName: n.default.string,
    children: n.default.node
  };

  function u(e) {
    return (0, o.default)(c, e, function (e) {
      for (var t = [e.className, (0, a.default)("row")], r = 0; r < s.length; ++r) {
        var n = s[r],
            o = e[n];
        o && t.push((0, a.default)(n + "-" + o));
      }

      return e.reverse && t.push((0, a.default)("reverse")), t;
    }(e));
  }

  function l(e) {
    return r.default.createElement(e.tagName || "div", u(e));
  }

  l.propTypes = c;
});
unwrapExports(Row_1);
var Row_2 = Row_1.getRowProps,
    Col_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.getColumnProps = l, t.default = f;
  var n = i(react),
      r = i(propTypes),
      o = i(createProps_1),
      a = i(classNames);

  function i(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var s = {
    xs: types.ColumnSizeType,
    sm: types.ColumnSizeType,
    md: types.ColumnSizeType,
    lg: types.ColumnSizeType,
    xl: types.ColumnSizeType,
    xsOffset: r.default.number,
    smOffset: r.default.number,
    mdOffset: r.default.number,
    lgOffset: r.default.number,
    xlOffset: r.default.number,
    first: types.ViewportSizeType,
    last: types.ViewportSizeType,
    className: r.default.string,
    tagName: r.default.string,
    children: r.default.node
  },
      c = {
    xs: "col-xs",
    sm: "col-sm",
    md: "col-md",
    lg: "col-lg",
    xl: "col-xl",
    xsOffset: "col-xs-offset",
    smOffset: "col-sm-offset",
    mdOffset: "col-md-offset",
    lgOffset: "col-lg-offset",
    xlOffset: "col-xl-offset"
  };

  function u(r) {
    var e = [];
    return r.className && e.push(r.className), r.first && e.push((0, a.default)("first-" + r.first)), r.last && e.push((0, a.default)("last-" + r.last)), Object.keys(r).filter(function (e) {
      return c[e];
    }).map(function (e) {
      return (0, a.default)("number" == typeof (t = r[e]) && isFinite(t) && Math.floor(t) === t ? c[e] + "-" + r[e] : c[e]);
      var t;
    }).concat(e);
  }

  function l(e) {
    return (0, o.default)(s, e, u(e));
  }

  function f(e) {
    var t = e.tagName,
        r = function (e, t) {
      var r = {};

      for (var n in e) {
        0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
      }

      return r;
    }(e, ["tagName"]);

    return n.default.createElement(t || "div", l(r));
  }

  f.propTypes = s;
});
unwrapExports(Col_1);
var Col_2 = Col_1.getColumnProps,
    Grid_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = c;
  var n = i(react),
      r = i(propTypes),
      o = i(createProps_1),
      a = i(classNames);

  function i(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var s = {
    fluid: r.default.bool,
    className: r.default.string,
    tagName: r.default.string,
    children: r.default.node
  };

  function c(e) {
    var t = (0, a.default)(e.fluid ? "container-fluid" : "container"),
        r = [e.className, t];
    return n.default.createElement(e.tagName || "div", (0, o.default)(s, e, r));
  }

  c.propTypes = s;
});
unwrapExports(Grid_1);
var lib = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.getColumnProps = t.Col = t.getRowProps = t.Row = t.Grid = void 0, Object.defineProperty(t, "getRowProps", {
    enumerable: !0,
    get: function get() {
      return Row_1.getRowProps;
    }
  }), Object.defineProperty(t, "getColumnProps", {
    enumerable: !0,
    get: function get() {
      return Col_1.getColumnProps;
    }
  });
  var r = a(Grid_1),
      n = a(Row_1),
      o = a(Col_1);

  function a(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  t.Grid = r.default, t.Row = n.default, t.Col = o.default;
});
unwrapExports(lib);

var lib_1 = lib.getColumnProps,
    lib_2 = lib.Col,
    lib_3 = lib.getRowProps,
    lib_4 = lib.Row,
    lib_5 = lib.Grid,
    s$c = {
  container: "styles-module_container__2me_P"
},
    Container = function Container(e) {
  var t = e.children,
      r = e.className,
      n = objectWithoutProperties(e, ["children", "className"]);
  return react.createElement(lib_5, _extends_1({
    className: classnames(s$c.container, r)
  }, n), t);
};

Container.defaultProps = {
  className: null
};

var s$d = {
  dataItem: "styles-module_dataItem__2o3Tb"
},
    DataItem = function DataItem(e) {
  var t = e.children,
      r = e.className,
      n = e.title,
      o = objectWithoutProperties(e, ["children", "className", "title"]);
  return react.createElement("div", _extends_1({
    className: classnames(s$d.dataItem, r)
  }, o), react.createElement("strong", null, n), t);
};

DataItem.defaultProps = {
  className: null
};

var s$e = {
  dot: "styles-module_dot__1ud5f"
},
    DotNotification = function DotNotification(e) {
  var t = e.className,
      r = objectWithoutProperties(e, ["className"]);
  return react.createElement("div", _extends_1({
    className: classnames(s$e.dot, t)
  }, r));
};

function ascending(e, t) {
  return e < t ? -1 : t < e ? 1 : t <= e ? 0 : NaN;
}

function bisector(a) {
  return 1 === a.length && (a = ascendingComparator(a)), {
    left: function left(e, t, r, n) {
      for (null == r && (r = 0), null == n && (n = e.length); r < n;) {
        var o = r + n >>> 1;
        a(e[o], t) < 0 ? r = o + 1 : n = o;
      }

      return r;
    },
    right: function right(e, t, r, n) {
      for (null == r && (r = 0), null == n && (n = e.length); r < n;) {
        var o = r + n >>> 1;
        0 < a(e[o], t) ? n = o : r = o + 1;
      }

      return r;
    }
  };
}

function ascendingComparator(r) {
  return function (e, t) {
    return ascending(r(e), t);
  };
}

DotNotification.defaultProps = {
  className: null
};
var ascendingBisect = bisector(ascending),
    bisectRight = ascendingBisect.right;

function extent(e, t) {
  var r,
      n,
      o,
      a = e.length,
      i = -1;

  if (null == t) {
    for (; ++i < a;) {
      if (null != (r = e[i]) && r <= r) for (n = o = r; ++i < a;) {
        null != (r = e[i]) && (r < n && (n = r), o < r && (o = r));
      }
    }
  } else for (; ++i < a;) {
    if (null != (r = t(e[i], i, e)) && r <= r) for (n = o = r; ++i < a;) {
      null != (r = t(e[i], i, e)) && (r < n && (n = r), o < r && (o = r));
    }
  }

  return [n, o];
}

var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

function ticks(e, t, r) {
  var n,
      o,
      a,
      i,
      s = -1;
  if (r = +r, (e = +e) === (t = +t) && 0 < r) return [e];
  if ((n = t < e) && (o = e, e = t, t = o), 0 === (i = tickIncrement(e, t, r)) || !isFinite(i)) return [];
  if (0 < i) for (e = Math.ceil(e / i), t = Math.floor(t / i), a = new Array(o = Math.ceil(t - e + 1)); ++s < o;) {
    a[s] = (e + s) * i;
  } else for (e = Math.floor(e * i), t = Math.ceil(t * i), a = new Array(o = Math.ceil(e - t + 1)); ++s < o;) {
    a[s] = (e - s) / i;
  }
  return n && a.reverse(), a;
}

function tickIncrement(e, t, r) {
  var n = (t - e) / Math.max(0, r),
      o = Math.floor(Math.log(n) / Math.LN10),
      a = n / Math.pow(10, o);
  return 0 <= o ? (e10 <= a ? 10 : e5 <= a ? 5 : e2 <= a ? 2 : 1) * Math.pow(10, o) : -Math.pow(10, -o) / (e10 <= a ? 10 : e5 <= a ? 5 : e2 <= a ? 2 : 1);
}

function tickStep(e, t, r) {
  var n = Math.abs(t - e) / Math.max(0, r),
      o = Math.pow(10, Math.floor(Math.log(n) / Math.LN10)),
      a = n / o;
  return e10 <= a ? o *= 10 : e5 <= a ? o *= 5 : e2 <= a && (o *= 2), t < e ? -o : o;
}

var noop = {
  value: function value() {}
};

function dispatch() {
  for (var e, t = 0, r = arguments.length, n = {}; t < r; ++t) {
    if (!(e = arguments[t] + "") || e in n) throw new Error("illegal type: " + e);
    n[e] = [];
  }

  return new Dispatch(n);
}

function Dispatch(e) {
  this._ = e;
}

function parseTypenames(e, n) {
  return e.trim().split(/^|\s+/).map(function (e) {
    var t = "",
        r = e.indexOf(".");
    if (0 <= r && (t = e.slice(r + 1), e = e.slice(0, r)), e && !n.hasOwnProperty(e)) throw new Error("unknown type: " + e);
    return {
      type: e,
      name: t
    };
  });
}

function get(e, t) {
  for (var r, n = 0, o = e.length; n < o; ++n) {
    if ((r = e[n]).name === t) return r.value;
  }
}

function set(e, t, r) {
  for (var n = 0, o = e.length; n < o; ++n) {
    if (e[n].name === t) {
      e[n] = noop, e = e.slice(0, n).concat(e.slice(n + 1));
      break;
    }
  }

  return null != r && e.push({
    name: t,
    value: r
  }), e;
}

Dispatch.prototype = dispatch.prototype = {
  constructor: Dispatch,
  on: function on(e, t) {
    var r,
        n = this._,
        o = parseTypenames(e + "", n),
        a = -1,
        i = o.length;

    if (!(arguments.length < 2)) {
      if (null != t && "function" != typeof t) throw new Error("invalid callback: " + t);

      for (; ++a < i;) {
        if (r = (e = o[a]).type) n[r] = set(n[r], e.name, t);else if (null == t) for (r in n) {
          n[r] = set(n[r], e.name, null);
        }
      }

      return this;
    }

    for (; ++a < i;) {
      if ((r = (e = o[a]).type) && (r = get(n[r], e.name))) return r;
    }
  },
  copy: function copy() {
    var e = {},
        t = this._;

    for (var r in t) {
      e[r] = t[r].slice();
    }

    return new Dispatch(e);
  },
  call: function call(e, t) {
    if (0 < (r = arguments.length - 2)) for (var r, n, o = new Array(r), a = 0; a < r; ++a) {
      o[a] = arguments[a + 2];
    }
    if (!this._.hasOwnProperty(e)) throw new Error("unknown type: " + e);

    for (a = 0, r = (n = this._[e]).length; a < r; ++a) {
      n[a].value.apply(t, o);
    }
  },
  apply: function apply(e, t, r) {
    if (!this._.hasOwnProperty(e)) throw new Error("unknown type: " + e);

    for (var n = this._[e], o = 0, a = n.length; o < a; ++o) {
      n[o].value.apply(t, r);
    }
  }
};
var xhtml = "http://www.w3.org/1999/xhtml",
    namespaces = {
  svg: "http://www.w3.org/2000/svg",
  xhtml: xhtml,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};

function namespace(e) {
  var t = e += "",
      r = t.indexOf(":");
  return 0 <= r && "xmlns" !== (t = e.slice(0, r)) && (e = e.slice(r + 1)), namespaces.hasOwnProperty(t) ? {
    space: namespaces[t],
    local: e
  } : e;
}

function creatorInherit(r) {
  return function () {
    var e = this.ownerDocument,
        t = this.namespaceURI;
    return t === xhtml && e.documentElement.namespaceURI === xhtml ? e.createElement(r) : e.createElementNS(t, r);
  };
}

function creatorFixed(e) {
  return function () {
    return this.ownerDocument.createElementNS(e.space, e.local);
  };
}

function creator(e) {
  var t = namespace(e);
  return (t.local ? creatorFixed : creatorInherit)(t);
}

function none() {}

function selector(e) {
  return null == e ? none : function () {
    return this.querySelector(e);
  };
}

function selection_select(e) {
  "function" != typeof e && (e = selector(e));

  for (var t = this._groups, r = t.length, n = new Array(r), o = 0; o < r; ++o) {
    for (var a, i, s = t[o], c = s.length, u = n[o] = new Array(c), l = 0; l < c; ++l) {
      (a = s[l]) && (i = e.call(a, a.__data__, l, s)) && ("__data__" in a && (i.__data__ = a.__data__), u[l] = i);
    }
  }

  return new Selection(n, this._parents);
}

function empty() {
  return [];
}

function selectorAll(e) {
  return null == e ? empty : function () {
    return this.querySelectorAll(e);
  };
}

function selection_selectAll(e) {
  "function" != typeof e && (e = selectorAll(e));

  for (var t = this._groups, r = t.length, n = [], o = [], a = 0; a < r; ++a) {
    for (var i, s = t[a], c = s.length, u = 0; u < c; ++u) {
      (i = s[u]) && (n.push(e.call(i, i.__data__, u, s)), o.push(i));
    }
  }

  return new Selection(n, o);
}

function matcher(e) {
  return function () {
    return this.matches(e);
  };
}

function selection_filter(e) {
  "function" != typeof e && (e = matcher(e));

  for (var t = this._groups, r = t.length, n = new Array(r), o = 0; o < r; ++o) {
    for (var a, i = t[o], s = i.length, c = n[o] = [], u = 0; u < s; ++u) {
      (a = i[u]) && e.call(a, a.__data__, u, i) && c.push(a);
    }
  }

  return new Selection(n, this._parents);
}

function sparse(e) {
  return new Array(e.length);
}

function selection_enter() {
  return new Selection(this._enter || this._groups.map(sparse), this._parents);
}

function EnterNode(e, t) {
  this.ownerDocument = e.ownerDocument, this.namespaceURI = e.namespaceURI, this._next = null, this._parent = e, this.__data__ = t;
}

function constant(e) {
  return function () {
    return e;
  };
}

EnterNode.prototype = {
  constructor: EnterNode,
  appendChild: function appendChild(e) {
    return this._parent.insertBefore(e, this._next);
  },
  insertBefore: function insertBefore(e, t) {
    return this._parent.insertBefore(e, t);
  },
  querySelector: function querySelector(e) {
    return this._parent.querySelector(e);
  },
  querySelectorAll: function querySelectorAll(e) {
    return this._parent.querySelectorAll(e);
  }
};
var keyPrefix = "$";

function bindIndex(e, t, r, n, o, a) {
  for (var i, s = 0, c = t.length, u = a.length; s < u; ++s) {
    (i = t[s]) ? (i.__data__ = a[s], n[s] = i) : r[s] = new EnterNode(e, a[s]);
  }

  for (; s < c; ++s) {
    (i = t[s]) && (o[s] = i);
  }
}

function bindKey(e, t, r, n, o, a, i) {
  var s,
      c,
      u,
      l = {},
      f = t.length,
      p = a.length,
      d = new Array(f);

  for (s = 0; s < f; ++s) {
    (c = t[s]) && (d[s] = u = keyPrefix + i.call(c, c.__data__, s, t), u in l ? o[s] = c : l[u] = c);
  }

  for (s = 0; s < p; ++s) {
    (c = l[u = keyPrefix + i.call(e, a[s], s, a)]) ? ((n[s] = c).__data__ = a[s], l[u] = null) : r[s] = new EnterNode(e, a[s]);
  }

  for (s = 0; s < f; ++s) {
    (c = t[s]) && l[d[s]] === c && (o[s] = c);
  }
}

function selection_data(e, t) {
  if (!e) return d = new Array(this.size()), u = -1, this.each(function (e) {
    d[++u] = e;
  }), d;
  var r = t ? bindKey : bindIndex,
      n = this._parents,
      o = this._groups;
  "function" != typeof e && (e = constant(e));

  for (var a = o.length, i = new Array(a), s = new Array(a), c = new Array(a), u = 0; u < a; ++u) {
    var l = n[u],
        f = o[u],
        p = f.length,
        d = e.call(l, l && l.__data__, u, n),
        h = d.length,
        y = s[u] = new Array(h),
        m = i[u] = new Array(h);
    r(l, f, y, m, c[u] = new Array(p), d, t);

    for (var b, v, g = 0, _ = 0; g < h; ++g) {
      if (b = y[g]) {
        for (_ <= g && (_ = g + 1); !(v = m[_]) && ++_ < h;) {
          ;
        }

        b._next = v || null;
      }
    }
  }

  return (i = new Selection(i, n))._enter = s, i._exit = c, i;
}

function selection_exit() {
  return new Selection(this._exit || this._groups.map(sparse), this._parents);
}

function selection_join(e, t, r) {
  var n = this.enter(),
      o = this,
      a = this.exit();
  return n = "function" == typeof e ? e(n) : n.append(e + ""), null != t && (o = t(o)), null == r ? a.remove() : r(a), n && o ? n.merge(o).order() : o;
}

function selection_merge(e) {
  for (var t = this._groups, r = e._groups, n = t.length, o = r.length, a = Math.min(n, o), i = new Array(n), s = 0; s < a; ++s) {
    for (var c, u = t[s], l = r[s], f = u.length, p = i[s] = new Array(f), d = 0; d < f; ++d) {
      (c = u[d] || l[d]) && (p[d] = c);
    }
  }

  for (; s < n; ++s) {
    i[s] = t[s];
  }

  return new Selection(i, this._parents);
}

function selection_order() {
  for (var e = this._groups, t = -1, r = e.length; ++t < r;) {
    for (var n, o = e[t], a = o.length - 1, i = o[a]; 0 <= --a;) {
      (n = o[a]) && (i && 4 ^ n.compareDocumentPosition(i) && i.parentNode.insertBefore(n, i), i = n);
    }
  }

  return this;
}

function selection_sort(r) {
  function e(e, t) {
    return e && t ? r(e.__data__, t.__data__) : !e - !t;
  }

  r || (r = ascending$1);

  for (var t = this._groups, n = t.length, o = new Array(n), a = 0; a < n; ++a) {
    for (var i, s = t[a], c = s.length, u = o[a] = new Array(c), l = 0; l < c; ++l) {
      (i = s[l]) && (u[l] = i);
    }

    u.sort(e);
  }

  return new Selection(o, this._parents).order();
}

function ascending$1(e, t) {
  return e < t ? -1 : t < e ? 1 : t <= e ? 0 : NaN;
}

function selection_call() {
  var e = arguments[0];
  return arguments[0] = this, e.apply(null, arguments), this;
}

function selection_nodes() {
  var e = new Array(this.size()),
      t = -1;
  return this.each(function () {
    e[++t] = this;
  }), e;
}

function selection_node() {
  for (var e = this._groups, t = 0, r = e.length; t < r; ++t) {
    for (var n = e[t], o = 0, a = n.length; o < a; ++o) {
      var i = n[o];
      if (i) return i;
    }
  }

  return null;
}

function selection_size() {
  var e = 0;
  return this.each(function () {
    ++e;
  }), e;
}

function selection_empty() {
  return !this.node();
}

function selection_each(e) {
  for (var t = this._groups, r = 0, n = t.length; r < n; ++r) {
    for (var o, a = t[r], i = 0, s = a.length; i < s; ++i) {
      (o = a[i]) && e.call(o, o.__data__, i, a);
    }
  }

  return this;
}

function attrRemove(e) {
  return function () {
    this.removeAttribute(e);
  };
}

function attrRemoveNS(e) {
  return function () {
    this.removeAttributeNS(e.space, e.local);
  };
}

function attrConstant(e, t) {
  return function () {
    this.setAttribute(e, t);
  };
}

function attrConstantNS(e, t) {
  return function () {
    this.setAttributeNS(e.space, e.local, t);
  };
}

function attrFunction(t, r) {
  return function () {
    var e = r.apply(this, arguments);
    null == e ? this.removeAttribute(t) : this.setAttribute(t, e);
  };
}

function attrFunctionNS(t, r) {
  return function () {
    var e = r.apply(this, arguments);
    null == e ? this.removeAttributeNS(t.space, t.local) : this.setAttributeNS(t.space, t.local, e);
  };
}

function selection_attr(e, t) {
  var r = namespace(e);

  if (arguments.length < 2) {
    var n = this.node();
    return r.local ? n.getAttributeNS(r.space, r.local) : n.getAttribute(r);
  }

  return this.each((null == t ? r.local ? attrRemoveNS : attrRemove : "function" == typeof t ? r.local ? attrFunctionNS : attrFunction : r.local ? attrConstantNS : attrConstant)(r, t));
}

function defaultView(e) {
  return e.ownerDocument && e.ownerDocument.defaultView || e.document && e || e.defaultView;
}

function styleRemove(e) {
  return function () {
    this.style.removeProperty(e);
  };
}

function styleConstant(e, t, r) {
  return function () {
    this.style.setProperty(e, t, r);
  };
}

function styleFunction(t, r, n) {
  return function () {
    var e = r.apply(this, arguments);
    null == e ? this.style.removeProperty(t) : this.style.setProperty(t, e, n);
  };
}

function selection_style(e, t, r) {
  return 1 < arguments.length ? this.each((null == t ? styleRemove : "function" == typeof t ? styleFunction : styleConstant)(e, t, null == r ? "" : r)) : styleValue(this.node(), e);
}

function styleValue(e, t) {
  return e.style.getPropertyValue(t) || defaultView(e).getComputedStyle(e, null).getPropertyValue(t);
}

function propertyRemove(e) {
  return function () {
    delete this[e];
  };
}

function propertyConstant(e, t) {
  return function () {
    this[e] = t;
  };
}

function propertyFunction(t, r) {
  return function () {
    var e = r.apply(this, arguments);
    null == e ? delete this[t] : this[t] = e;
  };
}

function selection_property(e, t) {
  return 1 < arguments.length ? this.each((null == t ? propertyRemove : "function" == typeof t ? propertyFunction : propertyConstant)(e, t)) : this.node()[e];
}

function classArray(e) {
  return e.trim().split(/^|\s+/);
}

function classList(e) {
  return e.classList || new ClassList(e);
}

function ClassList(e) {
  this._node = e, this._names = classArray(e.getAttribute("class") || "");
}

function classedAdd(e, t) {
  for (var r = classList(e), n = -1, o = t.length; ++n < o;) {
    r.add(t[n]);
  }
}

function classedRemove(e, t) {
  for (var r = classList(e), n = -1, o = t.length; ++n < o;) {
    r.remove(t[n]);
  }
}

function classedTrue(e) {
  return function () {
    classedAdd(this, e);
  };
}

function classedFalse(e) {
  return function () {
    classedRemove(this, e);
  };
}

function classedFunction(e, t) {
  return function () {
    (t.apply(this, arguments) ? classedAdd : classedRemove)(this, e);
  };
}

function selection_classed(e, t) {
  var r = classArray(e + "");

  if (arguments.length < 2) {
    for (var n = classList(this.node()), o = -1, a = r.length; ++o < a;) {
      if (!n.contains(r[o])) return !1;
    }

    return !0;
  }

  return this.each(("function" == typeof t ? classedFunction : t ? classedTrue : classedFalse)(r, t));
}

function textRemove() {
  this.textContent = "";
}

function textConstant(e) {
  return function () {
    this.textContent = e;
  };
}

function textFunction(t) {
  return function () {
    var e = t.apply(this, arguments);
    this.textContent = null == e ? "" : e;
  };
}

function selection_text(e) {
  return arguments.length ? this.each(null == e ? textRemove : ("function" == typeof e ? textFunction : textConstant)(e)) : this.node().textContent;
}

function htmlRemove() {
  this.innerHTML = "";
}

function htmlConstant(e) {
  return function () {
    this.innerHTML = e;
  };
}

function htmlFunction(t) {
  return function () {
    var e = t.apply(this, arguments);
    this.innerHTML = null == e ? "" : e;
  };
}

function selection_html(e) {
  return arguments.length ? this.each(null == e ? htmlRemove : ("function" == typeof e ? htmlFunction : htmlConstant)(e)) : this.node().innerHTML;
}

function raise() {
  this.nextSibling && this.parentNode.appendChild(this);
}

function selection_raise() {
  return this.each(raise);
}

function lower() {
  this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
}

function selection_lower() {
  return this.each(lower);
}

function selection_append(e) {
  var t = "function" == typeof e ? e : creator(e);
  return this.select(function () {
    return this.appendChild(t.apply(this, arguments));
  });
}

function constantNull() {
  return null;
}

function selection_insert(e, t) {
  var r = "function" == typeof e ? e : creator(e),
      n = null == t ? constantNull : "function" == typeof t ? t : selector(t);
  return this.select(function () {
    return this.insertBefore(r.apply(this, arguments), n.apply(this, arguments) || null);
  });
}

function remove() {
  var e = this.parentNode;
  e && e.removeChild(this);
}

function selection_remove() {
  return this.each(remove);
}

function selection_cloneShallow() {
  return this.parentNode.insertBefore(this.cloneNode(!1), this.nextSibling);
}

function selection_cloneDeep() {
  return this.parentNode.insertBefore(this.cloneNode(!0), this.nextSibling);
}

function selection_clone(e) {
  return this.select(e ? selection_cloneDeep : selection_cloneShallow);
}

function selection_datum(e) {
  return arguments.length ? this.property("__data__", e) : this.node().__data__;
}

ClassList.prototype = {
  add: function add(e) {
    this._names.indexOf(e) < 0 && (this._names.push(e), this._node.setAttribute("class", this._names.join(" ")));
  },
  remove: function remove(e) {
    var t = this._names.indexOf(e);

    0 <= t && (this._names.splice(t, 1), this._node.setAttribute("class", this._names.join(" ")));
  },
  contains: function contains(e) {
    return 0 <= this._names.indexOf(e);
  }
};
var filterEvents = {};

if ("undefined" != typeof document) {
  var element = document.documentElement;
  "onmouseenter" in element || (filterEvents = {
    mouseenter: "mouseover",
    mouseleave: "mouseout"
  });
}

function filterContextListener(r, e, t) {
  return r = contextListener(r, e, t), function (e) {
    var t = e.relatedTarget;
    t && (t === this || 8 & t.compareDocumentPosition(this)) || r.call(this, e);
  };
}

function contextListener(t, r, n) {
  return function (e) {
    try {
      t.call(this, this.__data__, r, n);
    } finally {}
  };
}

function parseTypenames$1(e) {
  return e.trim().split(/^|\s+/).map(function (e) {
    var t = "",
        r = e.indexOf(".");
    return 0 <= r && (t = e.slice(r + 1), e = e.slice(0, r)), {
      type: e,
      name: t
    };
  });
}

function onRemove(a) {
  return function () {
    var e = this.__on;

    if (e) {
      for (var t, r = 0, n = -1, o = e.length; r < o; ++r) {
        t = e[r], a.type && t.type !== a.type || t.name !== a.name ? e[++n] = t : this.removeEventListener(t.type, t.listener, t.capture);
      }

      ++n ? e.length = n : delete this.__on;
    }
  };
}

function onAdd(c, u, l) {
  var f = filterEvents.hasOwnProperty(c.type) ? filterContextListener : contextListener;
  return function (e, t, r) {
    var n,
        o = this.__on,
        a = f(u, t, r);
    if (o) for (var i = 0, s = o.length; i < s; ++i) {
      if ((n = o[i]).type === c.type && n.name === c.name) return this.removeEventListener(n.type, n.listener, n.capture), this.addEventListener(n.type, n.listener = a, n.capture = l), void (n.value = u);
    }
    this.addEventListener(c.type, a, l), n = {
      type: c.type,
      name: c.name,
      value: u,
      listener: a,
      capture: l
    }, o ? o.push(n) : this.__on = [n];
  };
}

function selection_on(e, t, r) {
  var n,
      o,
      a = parseTypenames$1(e + ""),
      i = a.length;

  if (!(arguments.length < 2)) {
    for (s = t ? onAdd : onRemove, null == r && (r = !1), n = 0; n < i; ++n) {
      this.each(s(a[n], t, r));
    }

    return this;
  }

  var s = this.node().__on;

  if (s) for (var c, u = 0, l = s.length; u < l; ++u) {
    for (n = 0, c = s[u]; n < i; ++n) {
      if ((o = a[n]).type === c.type && o.name === c.name) return c.value;
    }
  }
}

function dispatchEvent(e, t, r) {
  var n = defaultView(e),
      o = n.CustomEvent;
  "function" == typeof o ? o = new o(t, r) : (o = n.document.createEvent("Event"), r ? (o.initEvent(t, r.bubbles, r.cancelable), o.detail = r.detail) : o.initEvent(t, !1, !1)), e.dispatchEvent(o);
}

function dispatchConstant(e, t) {
  return function () {
    return dispatchEvent(this, e, t);
  };
}

function dispatchFunction(e, t) {
  return function () {
    return dispatchEvent(this, e, t.apply(this, arguments));
  };
}

function selection_dispatch(e, t) {
  return this.each(("function" == typeof t ? dispatchFunction : dispatchConstant)(e, t));
}

var root = [null];

function Selection(e, t) {
  this._groups = e, this._parents = t;
}

function selection() {
  return new Selection([[document.documentElement]], root);
}

function define(e, t, r) {
  e.prototype = t.prototype = r, r.constructor = e;
}

function extend(e, t) {
  var r = Object.create(e.prototype);

  for (var n in t) {
    r[n] = t[n];
  }

  return r;
}

function Color() {}

Selection.prototype = selection.prototype = {
  constructor: Selection,
  select: selection_select,
  selectAll: selection_selectAll,
  filter: selection_filter,
  data: selection_data,
  enter: selection_enter,
  exit: selection_exit,
  join: selection_join,
  merge: selection_merge,
  order: selection_order,
  sort: selection_sort,
  call: selection_call,
  nodes: selection_nodes,
  node: selection_node,
  size: selection_size,
  empty: selection_empty,
  each: selection_each,
  attr: selection_attr,
  style: selection_style,
  property: selection_property,
  classed: selection_classed,
  text: selection_text,
  html: selection_html,
  raise: selection_raise,
  lower: selection_lower,
  append: selection_append,
  insert: selection_insert,
  remove: selection_remove,
  clone: selection_clone,
  datum: selection_datum,
  on: selection_on,
  dispatch: selection_dispatch
};

var _darker = .7,
    _brighter = 1 / _darker,
    reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex3 = /^#([0-9a-f]{3})$/,
    reHex6 = /^#([0-9a-f]{6})$/,
    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$"),
    named = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};

function color(e) {
  var t;
  return e = (e + "").trim().toLowerCase(), (t = reHex3.exec(e)) ? new Rgb((t = parseInt(t[1], 16)) >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | 240 & t, (15 & t) << 4 | 15 & t, 1) : (t = reHex6.exec(e)) ? rgbn(parseInt(t[1], 16)) : (t = reRgbInteger.exec(e)) ? new Rgb(t[1], t[2], t[3], 1) : (t = reRgbPercent.exec(e)) ? new Rgb(255 * t[1] / 100, 255 * t[2] / 100, 255 * t[3] / 100, 1) : (t = reRgbaInteger.exec(e)) ? rgba(t[1], t[2], t[3], t[4]) : (t = reRgbaPercent.exec(e)) ? rgba(255 * t[1] / 100, 255 * t[2] / 100, 255 * t[3] / 100, t[4]) : (t = reHslPercent.exec(e)) ? hsla(t[1], t[2] / 100, t[3] / 100, 1) : (t = reHslaPercent.exec(e)) ? hsla(t[1], t[2] / 100, t[3] / 100, t[4]) : named.hasOwnProperty(e) ? rgbn(named[e]) : "transparent" === e ? new Rgb(NaN, NaN, NaN, 0) : null;
}

function rgbn(e) {
  return new Rgb(e >> 16 & 255, e >> 8 & 255, 255 & e, 1);
}

function rgba(e, t, r, n) {
  return n <= 0 && (e = t = r = NaN), new Rgb(e, t, r, n);
}

function rgbConvert(e) {
  return e instanceof Color || (e = color(e)), e ? new Rgb((e = e.rgb()).r, e.g, e.b, e.opacity) : new Rgb();
}

function rgb(e, t, r, n) {
  return 1 === arguments.length ? rgbConvert(e) : new Rgb(e, t, r, null == n ? 1 : n);
}

function Rgb(e, t, r, n) {
  this.r = +e, this.g = +t, this.b = +r, this.opacity = +n;
}

function _hex(e) {
  return ((e = Math.max(0, Math.min(255, Math.round(e) || 0))) < 16 ? "0" : "") + e.toString(16);
}

function hsla(e, t, r, n) {
  return n <= 0 ? e = t = r = NaN : r <= 0 || 1 <= r ? e = t = NaN : t <= 0 && (e = NaN), new Hsl(e, t, r, n);
}

function hslConvert(e) {
  if (e instanceof Hsl) return new Hsl(e.h, e.s, e.l, e.opacity);
  if (e instanceof Color || (e = color(e)), !e) return new Hsl();
  if (e instanceof Hsl) return e;
  var t = (e = e.rgb()).r / 255,
      r = e.g / 255,
      n = e.b / 255,
      o = Math.min(t, r, n),
      a = Math.max(t, r, n),
      i = NaN,
      s = a - o,
      c = (a + o) / 2;
  return s ? (i = t === a ? (r - n) / s + 6 * (r < n) : r === a ? (n - t) / s + 2 : (t - r) / s + 4, s /= c < .5 ? a + o : 2 - a - o, i *= 60) : s = 0 < c && c < 1 ? 0 : i, new Hsl(i, s, c, e.opacity);
}

function hsl(e, t, r, n) {
  return 1 === arguments.length ? hslConvert(e) : new Hsl(e, t, r, null == n ? 1 : n);
}

function Hsl(e, t, r, n) {
  this.h = +e, this.s = +t, this.l = +r, this.opacity = +n;
}

function hsl2rgb(e, t, r) {
  return 255 * (e < 60 ? t + (r - t) * e / 60 : e < 180 ? r : e < 240 ? t + (r - t) * (240 - e) / 60 : t);
}

define(Color, color, {
  displayable: function displayable() {
    return this.rgb().displayable();
  },
  hex: function hex() {
    return this.rgb().hex();
  },
  toString: function toString() {
    return this.rgb() + "";
  }
}), define(Rgb, rgb, extend(Color, {
  brighter: function brighter(e) {
    return e = null == e ? _brighter : Math.pow(_brighter, e), new Rgb(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker: function darker(e) {
    return e = null == e ? _darker : Math.pow(_darker, e), new Rgb(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb: function rgb() {
    return this;
  },
  displayable: function displayable() {
    return 0 <= this.r && this.r <= 255 && 0 <= this.g && this.g <= 255 && 0 <= this.b && this.b <= 255 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: function hex() {
    return "#" + _hex(this.r) + _hex(this.g) + _hex(this.b);
  },
  toString: function toString() {
    var e = this.opacity;
    return (1 === (e = isNaN(e) ? 1 : Math.max(0, Math.min(1, e))) ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (1 === e ? ")" : ", " + e + ")");
  }
})), define(Hsl, hsl, extend(Color, {
  brighter: function brighter(e) {
    return e = null == e ? _brighter : Math.pow(_brighter, e), new Hsl(this.h, this.s, this.l * e, this.opacity);
  },
  darker: function darker(e) {
    return e = null == e ? _darker : Math.pow(_darker, e), new Hsl(this.h, this.s, this.l * e, this.opacity);
  },
  rgb: function rgb() {
    var e = this.h % 360 + 360 * (this.h < 0),
        t = isNaN(e) || isNaN(this.s) ? 0 : this.s,
        r = this.l,
        n = r + (r < .5 ? r : 1 - r) * t,
        o = 2 * r - n;
    return new Rgb(hsl2rgb(240 <= e ? e - 240 : e + 120, o, n), hsl2rgb(e, o, n), hsl2rgb(e < 120 ? e + 240 : e - 120, o, n), this.opacity);
  },
  displayable: function displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  }
}));
var deg2rad = Math.PI / 180,
    rad2deg = 180 / Math.PI,
    K$1 = 18,
    Xn = .96422,
    Yn = 1,
    Zn = .82521,
    t0 = 4 / 29,
    t1 = 6 / 29,
    t2 = 3 * t1 * t1,
    t3 = t1 * t1 * t1;

function labConvert(e) {
  if (e instanceof Lab) return new Lab(e.l, e.a, e.b, e.opacity);

  if (e instanceof Hcl) {
    if (isNaN(e.h)) return new Lab(e.l, 0, 0, e.opacity);
    var t = e.h * deg2rad;
    return new Lab(e.l, Math.cos(t) * e.c, Math.sin(t) * e.c, e.opacity);
  }

  e instanceof Rgb || (e = rgbConvert(e));
  var r,
      n,
      o = rgb2lrgb(e.r),
      a = rgb2lrgb(e.g),
      i = rgb2lrgb(e.b),
      s = xyz2lab((.2225045 * o + .7168786 * a + .0606169 * i) / Yn);
  return o === a && a === i ? r = n = s : (r = xyz2lab((.4360747 * o + .3850649 * a + .1430804 * i) / Xn), n = xyz2lab((.0139322 * o + .0971045 * a + .7141733 * i) / Zn)), new Lab(116 * s - 16, 500 * (r - s), 200 * (s - n), e.opacity);
}

function lab(e, t, r, n) {
  return 1 === arguments.length ? labConvert(e) : new Lab(e, t, r, null == n ? 1 : n);
}

function Lab(e, t, r, n) {
  this.l = +e, this.a = +t, this.b = +r, this.opacity = +n;
}

function xyz2lab(e) {
  return t3 < e ? Math.pow(e, 1 / 3) : e / t2 + t0;
}

function lab2xyz(e) {
  return t1 < e ? e * e * e : t2 * (e - t0);
}

function lrgb2rgb(e) {
  return 255 * (e <= .0031308 ? 12.92 * e : 1.055 * Math.pow(e, 1 / 2.4) - .055);
}

function rgb2lrgb(e) {
  return (e /= 255) <= .04045 ? e / 12.92 : Math.pow((e + .055) / 1.055, 2.4);
}

function hclConvert(e) {
  if (e instanceof Hcl) return new Hcl(e.h, e.c, e.l, e.opacity);
  if (e instanceof Lab || (e = labConvert(e)), 0 === e.a && 0 === e.b) return new Hcl(NaN, 0, e.l, e.opacity);
  var t = Math.atan2(e.b, e.a) * rad2deg;
  return new Hcl(t < 0 ? t + 360 : t, Math.sqrt(e.a * e.a + e.b * e.b), e.l, e.opacity);
}

function hcl(e, t, r, n) {
  return 1 === arguments.length ? hclConvert(e) : new Hcl(e, t, r, null == n ? 1 : n);
}

function Hcl(e, t, r, n) {
  this.h = +e, this.c = +t, this.l = +r, this.opacity = +n;
}

define(Lab, lab, extend(Color, {
  brighter: function brighter(e) {
    return new Lab(this.l + K$1 * (null == e ? 1 : e), this.a, this.b, this.opacity);
  },
  darker: function darker(e) {
    return new Lab(this.l - K$1 * (null == e ? 1 : e), this.a, this.b, this.opacity);
  },
  rgb: function rgb() {
    var e = (this.l + 16) / 116,
        t = isNaN(this.a) ? e : e + this.a / 500,
        r = isNaN(this.b) ? e : e - this.b / 200;
    return new Rgb(lrgb2rgb(3.1338561 * (t = Xn * lab2xyz(t)) - 1.6168667 * (e = Yn * lab2xyz(e)) - .4906146 * (r = Zn * lab2xyz(r))), lrgb2rgb(-.9787684 * t + 1.9161415 * e + .033454 * r), lrgb2rgb(.0719453 * t - .2289914 * e + 1.4052427 * r), this.opacity);
  }
})), define(Hcl, hcl, extend(Color, {
  brighter: function brighter(e) {
    return new Hcl(this.h, this.c, this.l + K$1 * (null == e ? 1 : e), this.opacity);
  },
  darker: function darker(e) {
    return new Hcl(this.h, this.c, this.l - K$1 * (null == e ? 1 : e), this.opacity);
  },
  rgb: function rgb() {
    return labConvert(this).rgb();
  }
}));
var A$1 = -.14861,
    B$1 = 1.78277,
    C$1 = -.29227,
    D$1 = -.90649,
    E$1 = 1.97294,
    ED = E$1 * D$1,
    EB = E$1 * B$1,
    BC_DA = B$1 * C$1 - D$1 * A$1;

function cubehelixConvert(e) {
  if (e instanceof Cubehelix) return new Cubehelix(e.h, e.s, e.l, e.opacity);
  e instanceof Rgb || (e = rgbConvert(e));
  var t = e.r / 255,
      r = e.g / 255,
      n = e.b / 255,
      o = (BC_DA * n + ED * t - EB * r) / (BC_DA + ED - EB),
      a = n - o,
      i = (E$1 * (r - o) - C$1 * a) / D$1,
      s = Math.sqrt(i * i + a * a) / (E$1 * o * (1 - o)),
      c = s ? Math.atan2(i, a) * rad2deg - 120 : NaN;
  return new Cubehelix(c < 0 ? c + 360 : c, s, o, e.opacity);
}

function cubehelix(e, t, r, n) {
  return 1 === arguments.length ? cubehelixConvert(e) : new Cubehelix(e, t, r, null == n ? 1 : n);
}

function Cubehelix(e, t, r, n) {
  this.h = +e, this.s = +t, this.l = +r, this.opacity = +n;
}

function basis(e, t, r, n, o) {
  var a = e * e,
      i = a * e;
  return ((1 - 3 * e + 3 * a - i) * t + (4 - 6 * a + 3 * i) * r + (1 + 3 * e + 3 * a - 3 * i) * n + i * o) / 6;
}

function basis$1(i) {
  var s = i.length - 1;
  return function (e) {
    var t = e <= 0 ? e = 0 : 1 <= e ? s - (e = 1) : Math.floor(e * s),
        r = i[t],
        n = i[t + 1],
        o = 0 < t ? i[t - 1] : 2 * r - n,
        a = t < s - 1 ? i[t + 2] : 2 * n - r;
    return basis((e - t / s) * s, o, r, n, a);
  };
}

function constant$1(e) {
  return function () {
    return e;
  };
}

function linear(t, r) {
  return function (e) {
    return t + e * r;
  };
}

function exponential(t, r, n) {
  return t = Math.pow(t, n), r = Math.pow(r, n) - t, n = 1 / n, function (e) {
    return Math.pow(t + e * r, n);
  };
}

function hue(e, t) {
  var r = t - e;
  return r ? linear(e, 180 < r || r < -180 ? r - 360 * Math.round(r / 360) : r) : constant$1(isNaN(e) ? t : e);
}

function gamma(r) {
  return 1 == (r = +r) ? nogamma : function (e, t) {
    return t - e ? exponential(e, t, r) : constant$1(isNaN(e) ? t : e);
  };
}

function nogamma(e, t) {
  var r = t - e;
  return r ? linear(e, r) : constant$1(isNaN(e) ? t : e);
}

define(Cubehelix, cubehelix, extend(Color, {
  brighter: function brighter(e) {
    return e = null == e ? _brighter : Math.pow(_brighter, e), new Cubehelix(this.h, this.s, this.l * e, this.opacity);
  },
  darker: function darker(e) {
    return e = null == e ? _darker : Math.pow(_darker, e), new Cubehelix(this.h, this.s, this.l * e, this.opacity);
  },
  rgb: function rgb() {
    var e = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
        t = +this.l,
        r = isNaN(this.s) ? 0 : this.s * t * (1 - t),
        n = Math.cos(e),
        o = Math.sin(e);
    return new Rgb(255 * (t + r * (A$1 * n + B$1 * o)), 255 * (t + r * (C$1 * n + D$1 * o)), 255 * (t + r * (E$1 * n)), this.opacity);
  }
}));

var interpolateRgb = function e(t) {
  var i = gamma(t);

  function r(t, e) {
    var r = i((t = rgb(t)).r, (e = rgb(e)).r),
        n = i(t.g, e.g),
        o = i(t.b, e.b),
        a = nogamma(t.opacity, e.opacity);
    return function (e) {
      return t.r = r(e), t.g = n(e), t.b = o(e), t.opacity = a(e), t + "";
    };
  }

  return r.gamma = e, r;
}(1);

function rgbSpline(s) {
  return function (e) {
    var t,
        r,
        n = e.length,
        o = new Array(n),
        a = new Array(n),
        i = new Array(n);

    for (t = 0; t < n; ++t) {
      r = rgb(e[t]), o[t] = r.r || 0, a[t] = r.g || 0, i[t] = r.b || 0;
    }

    return o = s(o), a = s(a), i = s(i), r.opacity = 1, function (e) {
      return r.r = o(e), r.g = a(e), r.b = i(e), r + "";
    };
  };
}

var rgbBasis = rgbSpline(basis$1);

function array(e, t) {
  var r,
      n = t ? t.length : 0,
      o = e ? Math.min(n, e.length) : 0,
      a = new Array(o),
      i = new Array(n);

  for (r = 0; r < o; ++r) {
    a[r] = interpolateValue(e[r], t[r]);
  }

  for (; r < n; ++r) {
    i[r] = t[r];
  }

  return function (e) {
    for (r = 0; r < o; ++r) {
      i[r] = a[r](e);
    }

    return i;
  };
}

function date(t, r) {
  var n = new Date();
  return r -= t = +t, function (e) {
    return n.setTime(t + r * e), n;
  };
}

function interpolateNumber(t, r) {
  return r -= t = +t, function (e) {
    return t + r * e;
  };
}

function object(e, t) {
  var r,
      n = {},
      o = {};

  for (r in null !== e && "object" == typeof e || (e = {}), null !== t && "object" == typeof t || (t = {}), t) {
    r in e ? n[r] = interpolateValue(e[r], t[r]) : o[r] = t[r];
  }

  return function (e) {
    for (r in n) {
      o[r] = n[r](e);
    }

    return o;
  };
}

var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(e) {
  return function () {
    return e;
  };
}

function one(t) {
  return function (e) {
    return t(e) + "";
  };
}

function interpolateString(e, n) {
  var t,
      r,
      o,
      a = reA.lastIndex = reB.lastIndex = 0,
      i = -1,
      s = [],
      c = [];

  for (e += "", n += ""; (t = reA.exec(e)) && (r = reB.exec(n));) {
    (o = r.index) > a && (o = n.slice(a, o), s[i] ? s[i] += o : s[++i] = o), (t = t[0]) === (r = r[0]) ? s[i] ? s[i] += r : s[++i] = r : (s[++i] = null, c.push({
      i: i,
      x: interpolateNumber(t, r)
    })), a = reB.lastIndex;
  }

  return a < n.length && (o = n.slice(a), s[i] ? s[i] += o : s[++i] = o), s.length < 2 ? c[0] ? one(c[0].x) : zero(n) : (n = c.length, function (e) {
    for (var t, r = 0; r < n; ++r) {
      s[(t = c[r]).i] = t.x(e);
    }

    return s.join("");
  });
}

function interpolateValue(e, t) {
  var r,
      n = typeof t;
  return null == t || "boolean" === n ? constant$1(t) : ("number" === n ? interpolateNumber : "string" === n ? (r = color(t)) ? (t = r, interpolateRgb) : interpolateString : t instanceof color ? interpolateRgb : t instanceof Date ? date : Array.isArray(t) ? array : "function" != typeof t.valueOf && "function" != typeof t.toString || isNaN(t) ? object : interpolateNumber)(e, t);
}

function interpolateRound(t, r) {
  return r -= t = +t, function (e) {
    return Math.round(t + r * e);
  };
}

var cssNode,
    cssRoot,
    cssView,
    svgNode,
    degrees = 180 / Math.PI,
    identity = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

function decompose(e, t, r, n, o, a) {
  var i, s, c;
  return (i = Math.sqrt(e * e + t * t)) && (e /= i, t /= i), (c = e * r + t * n) && (r -= e * c, n -= t * c), (s = Math.sqrt(r * r + n * n)) && (r /= s, n /= s, c /= s), e * n < t * r && (e = -e, t = -t, c = -c, i = -i), {
    translateX: o,
    translateY: a,
    rotate: Math.atan2(t, e) * degrees,
    skewX: Math.atan(c) * degrees,
    scaleX: i,
    scaleY: s
  };
}

function parseCss(e) {
  return "none" === e ? identity : (cssNode || (cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView), cssNode.style.transform = e, e = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform"), cssRoot.removeChild(cssNode), decompose(+(e = e.slice(7, -1).split(","))[0], +e[1], +e[2], +e[3], +e[4], +e[5]));
}

function parseSvg(e) {
  return null == e ? identity : (svgNode || (svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g")), svgNode.setAttribute("transform", e), (e = svgNode.transform.baseVal.consolidate()) ? decompose((e = e.matrix).a, e.b, e.c, e.d, e.e, e.f) : identity);
}

function interpolateTransform(p, d, h, y) {
  function m(e) {
    return e.length ? e.pop() + " " : "";
  }

  return function (e, t) {
    var r,
        n,
        o,
        a,
        i,
        s,
        c,
        u,
        l = [],
        f = [];
    return e = p(e), t = p(t), function (e, t, r, n, o, a) {
      if (e !== r || t !== n) {
        var i = o.push("translate(", null, d, null, h);
        a.push({
          i: i - 4,
          x: interpolateNumber(e, r)
        }, {
          i: i - 2,
          x: interpolateNumber(t, n)
        });
      } else (r || n) && o.push("translate(" + r + d + n + h);
    }(e.translateX, e.translateY, t.translateX, t.translateY, l, f), r = e.rotate, n = t.rotate, o = l, a = f, r !== n ? (180 < r - n ? n += 360 : 180 < n - r && (r += 360), a.push({
      i: o.push(m(o) + "rotate(", null, y) - 2,
      x: interpolateNumber(r, n)
    })) : n && o.push(m(o) + "rotate(" + n + y), i = e.skewX, s = t.skewX, c = l, u = f, i !== s ? u.push({
      i: c.push(m(c) + "skewX(", null, y) - 2,
      x: interpolateNumber(i, s)
    }) : s && c.push(m(c) + "skewX(" + s + y), function (e, t, r, n, o, a) {
      if (e !== r || t !== n) {
        var i = o.push(m(o) + "scale(", null, ",", null, ")");
        a.push({
          i: i - 4,
          x: interpolateNumber(e, r)
        }, {
          i: i - 2,
          x: interpolateNumber(t, n)
        });
      } else 1 === r && 1 === n || o.push(m(o) + "scale(" + r + "," + n + ")");
    }(e.scaleX, e.scaleY, t.scaleX, t.scaleY, l, f), e = t = null, function (e) {
      for (var t, r = -1, n = f.length; ++r < n;) {
        l[(t = f[r]).i] = t.x(e);
      }

      return l.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)"),
    interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")"),
    rho = Math.SQRT2;

function cubehelix$1(s) {
  return function e(i) {
    function t(t, e) {
      var r = s((t = cubehelix(t)).h, (e = cubehelix(e)).h),
          n = nogamma(t.s, e.s),
          o = nogamma(t.l, e.l),
          a = nogamma(t.opacity, e.opacity);
      return function (e) {
        return t.h = r(e), t.s = n(e), t.l = o(Math.pow(e, i)), t.opacity = a(e), t + "";
      };
    }

    return i = +i, t.gamma = e, t;
  }(1);
}

cubehelix$1(hue);
var taskHead,
    taskTail,
    cubehelixLong = cubehelix$1(nogamma),
    frame = 0,
    timeout = 0,
    interval = 0,
    pokeDelay = 1e3,
    clockLast = 0,
    clockNow = 0,
    clockSkew = 0,
    clock = "object" == typeof performance && performance.now ? performance : Date,
    setFrame = "object" == typeof window && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function (e) {
  setTimeout(e, 17);
};

function now() {
  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}

function clearNow() {
  clockNow = 0;
}

function Timer() {
  this._call = this._time = this._next = null;
}

function timer(e, t, r) {
  var n = new Timer();
  return n.restart(e, t, r), n;
}

function timerFlush() {
  now(), ++frame;

  for (var e, t = taskHead; t;) {
    0 <= (e = clockNow - t._time) && t._call.call(null, e), t = t._next;
  }

  --frame;
}

function wake() {
  clockNow = (clockLast = clock.now()) + clockSkew, frame = timeout = 0;

  try {
    timerFlush();
  } finally {
    frame = 0, nap(), clockNow = 0;
  }
}

function poke() {
  var e = clock.now(),
      t = e - clockLast;
  pokeDelay < t && (clockSkew -= t, clockLast = e);
}

function nap() {
  for (var e, t, r = taskHead, n = 1 / 0; r;) {
    r = r._call ? (n > r._time && (n = r._time), (e = r)._next) : (t = r._next, r._next = null, e ? e._next = t : taskHead = t);
  }

  taskTail = e, sleep(n);
}

function sleep(e) {
  frame || (timeout && (timeout = clearTimeout(timeout)), 24 < e - clockNow ? (e < 1 / 0 && (timeout = setTimeout(wake, e - clock.now() - clockSkew)), interval && (interval = clearInterval(interval))) : (interval || (clockLast = clock.now(), interval = setInterval(poke, pokeDelay)), frame = 1, setFrame(wake)));
}

function timeout$1(t, r, e) {
  var n = new Timer();
  return r = null == r ? 0 : +r, n.restart(function (e) {
    n.stop(), t(e + r);
  }, r, e), n;
}

Timer.prototype = timer.prototype = {
  constructor: Timer,
  restart: function restart(e, t, r) {
    if ("function" != typeof e) throw new TypeError("callback is not a function");
    r = (null == r ? now() : +r) + (null == t ? 0 : +t), this._next || taskTail === this || (taskTail ? taskTail._next = this : taskHead = this, taskTail = this), this._call = e, this._time = r, sleep();
  },
  stop: function stop() {
    this._call && (this._call = null, this._time = 1 / 0, sleep());
  }
};
var emptyOn = dispatch("start", "end", "cancel", "interrupt"),
    emptyTween = [],
    CREATED = 0,
    SCHEDULED = 1,
    STARTING = 2,
    STARTED = 3,
    RUNNING = 4,
    ENDING = 5,
    ENDED = 6;

function schedule(e, t, r, n, o, a) {
  var i = e.__transition;

  if (i) {
    if (r in i) return;
  } else e.__transition = {};

  create(e, r, {
    name: t,
    index: n,
    group: o,
    on: emptyOn,
    tween: emptyTween,
    time: a.time,
    delay: a.delay,
    duration: a.duration,
    ease: a.ease,
    timer: null,
    state: CREATED
  });
}

function init(e, t) {
  var r = get$1(e, t);
  if (r.state > CREATED) throw new Error("too late; already scheduled");
  return r;
}

function set$1(e, t) {
  var r = get$1(e, t);
  if (r.state > STARTED) throw new Error("too late; already running");
  return r;
}

function get$1(e, t) {
  var r = e.__transition;
  if (!r || !(r = r[t])) throw new Error("transition not found");
  return r;
}

function create(a, i, s) {
  var c,
      u = a.__transition;

  function l(e) {
    var t, r, n, o;
    if (s.state !== SCHEDULED) return p();

    for (t in u) {
      if ((o = u[t]).name === s.name) {
        if (o.state === STARTED) return timeout$1(l);
        o.state === RUNNING ? (o.state = ENDED, o.timer.stop(), o.on.call("interrupt", a, a.__data__, o.index, o.group), delete u[t]) : +t < i && (o.state = ENDED, o.timer.stop(), o.on.call("cancel", a, a.__data__, o.index, o.group), delete u[t]);
      }
    }

    if (timeout$1(function () {
      s.state === STARTED && (s.state = RUNNING, s.timer.restart(f, s.delay, s.time), f(e));
    }), s.state = STARTING, s.on.call("start", a, a.__data__, s.index, s.group), s.state === STARTING) {
      for (s.state = STARTED, c = new Array(n = s.tween.length), t = 0, r = -1; t < n; ++t) {
        (o = s.tween[t].value.call(a, a.__data__, s.index, s.group)) && (c[++r] = o);
      }

      c.length = r + 1;
    }
  }

  function f(e) {
    for (var t = e < s.duration ? s.ease.call(null, e / s.duration) : (s.timer.restart(p), s.state = ENDING, 1), r = -1, n = c.length; ++r < n;) {
      c[r].call(a, t);
    }

    s.state === ENDING && (s.on.call("end", a, a.__data__, s.index, s.group), p());
  }

  function p() {
    for (var e in s.state = ENDED, s.timer.stop(), delete u[i], u) {
      return;
    }

    delete a.__transition;
  }

  (u[i] = s).timer = timer(function (e) {
    s.state = SCHEDULED, s.timer.restart(l, s.delay, s.time), s.delay <= e && l(e - s.delay);
  }, 0, s.time);
}

function interrupt(e, t) {
  var r,
      n,
      o,
      a = e.__transition,
      i = !0;

  if (a) {
    for (o in t = null == t ? null : t + "", a) {
      (r = a[o]).name === t ? (n = r.state > STARTING && r.state < ENDING, r.state = ENDED, r.timer.stop(), r.on.call(n ? "interrupt" : "cancel", e, e.__data__, r.index, r.group), delete a[o]) : i = !1;
    }

    i && delete e.__transition;
  }
}

function selection_interrupt(e) {
  return this.each(function () {
    interrupt(this, e);
  });
}

function tweenRemove(o, a) {
  var i, s;
  return function () {
    var e = set$1(this, o),
        t = e.tween;
    if (t !== i) for (var r = 0, n = (s = i = t).length; r < n; ++r) {
      if (s[r].name === a) {
        (s = s.slice()).splice(r, 1);
        break;
      }
    }
    e.tween = s;
  };
}

function tweenFunction(a, i, s) {
  var c, u;
  if ("function" != typeof s) throw new Error();
  return function () {
    var e = set$1(this, a),
        t = e.tween;

    if (t !== c) {
      u = (c = t).slice();

      for (var r = {
        name: i,
        value: s
      }, n = 0, o = u.length; n < o; ++n) {
        if (u[n].name === i) {
          u[n] = r;
          break;
        }
      }

      n === o && u.push(r);
    }

    e.tween = u;
  };
}

function transition_tween(e, t) {
  var r = this._id;

  if (e += "", arguments.length < 2) {
    for (var n, o = get$1(this.node(), r).tween, a = 0, i = o.length; a < i; ++a) {
      if ((n = o[a]).name === e) return n.value;
    }

    return null;
  }

  return this.each((null == t ? tweenRemove : tweenFunction)(r, e, t));
}

function tweenValue(e, t, r) {
  var n = e._id;
  return e.each(function () {
    var e = set$1(this, n);
    (e.value || (e.value = {}))[t] = r.apply(this, arguments);
  }), function (e) {
    return get$1(e, n).value[t];
  };
}

function interpolate(e, t) {
  var r;
  return ("number" == typeof t ? interpolateNumber : t instanceof color ? interpolateRgb : (r = color(t)) ? (t = r, interpolateRgb) : interpolateString)(e, t);
}

function attrRemove$1(e) {
  return function () {
    this.removeAttribute(e);
  };
}

function attrRemoveNS$1(e) {
  return function () {
    this.removeAttributeNS(e.space, e.local);
  };
}

function attrConstant$1(t, r, n) {
  var o,
      a,
      i = n + "";
  return function () {
    var e = this.getAttribute(t);
    return e === i ? null : e === o ? a : a = r(o = e, n);
  };
}

function attrConstantNS$1(t, r, n) {
  var o,
      a,
      i = n + "";
  return function () {
    var e = this.getAttributeNS(t.space, t.local);
    return e === i ? null : e === o ? a : a = r(o = e, n);
  };
}

function attrFunction$1(n, o, a) {
  var i, s, c;
  return function () {
    var e,
        t,
        r = a(this);
    if (null != r) return (e = this.getAttribute(n)) === (t = r + "") ? null : e === i && t === s ? c : (s = t, c = o(i = e, r));
    this.removeAttribute(n);
  };
}

function attrFunctionNS$1(n, o, a) {
  var i, s, c;
  return function () {
    var e,
        t,
        r = a(this);
    if (null != r) return (e = this.getAttributeNS(n.space, n.local)) === (t = r + "") ? null : e === i && t === s ? c : (s = t, c = o(i = e, r));
    this.removeAttributeNS(n.space, n.local);
  };
}

function transition_attr(e, t) {
  var r = namespace(e),
      n = "transform" === r ? interpolateTransformSvg : interpolate;
  return this.attrTween(e, "function" == typeof t ? (r.local ? attrFunctionNS$1 : attrFunction$1)(r, n, tweenValue(this, "attr." + e, t)) : null == t ? (r.local ? attrRemoveNS$1 : attrRemove$1)(r) : (r.local ? attrConstantNS$1 : attrConstant$1)(r, n, t));
}

function attrInterpolate(t, r) {
  return function (e) {
    this.setAttribute(t, r(e));
  };
}

function attrInterpolateNS(t, r) {
  return function (e) {
    this.setAttributeNS(t.space, t.local, r(e));
  };
}

function attrTweenNS(t, r) {
  var n, o;

  function e() {
    var e = r.apply(this, arguments);
    return e !== o && (n = (o = e) && attrInterpolateNS(t, e)), n;
  }

  return e._value = r, e;
}

function attrTween(t, r) {
  var n, o;

  function e() {
    var e = r.apply(this, arguments);
    return e !== o && (n = (o = e) && attrInterpolate(t, e)), n;
  }

  return e._value = r, e;
}

function transition_attrTween(e, t) {
  var r = "attr." + e;
  if (arguments.length < 2) return (r = this.tween(r)) && r._value;
  if (null == t) return this.tween(r, null);
  if ("function" != typeof t) throw new Error();
  var n = namespace(e);
  return this.tween(r, (n.local ? attrTweenNS : attrTween)(n, t));
}

function delayFunction(e, t) {
  return function () {
    init(this, e).delay = +t.apply(this, arguments);
  };
}

function delayConstant(e, t) {
  return t = +t, function () {
    init(this, e).delay = t;
  };
}

function transition_delay(e) {
  var t = this._id;
  return arguments.length ? this.each(("function" == typeof e ? delayFunction : delayConstant)(t, e)) : get$1(this.node(), t).delay;
}

function durationFunction(e, t) {
  return function () {
    set$1(this, e).duration = +t.apply(this, arguments);
  };
}

function durationConstant(e, t) {
  return t = +t, function () {
    set$1(this, e).duration = t;
  };
}

function transition_duration(e) {
  var t = this._id;
  return arguments.length ? this.each(("function" == typeof e ? durationFunction : durationConstant)(t, e)) : get$1(this.node(), t).duration;
}

function easeConstant(e, t) {
  if ("function" != typeof t) throw new Error();
  return function () {
    set$1(this, e).ease = t;
  };
}

function transition_ease(e) {
  var t = this._id;
  return arguments.length ? this.each(easeConstant(t, e)) : get$1(this.node(), t).ease;
}

function transition_filter(e) {
  "function" != typeof e && (e = matcher(e));

  for (var t = this._groups, r = t.length, n = new Array(r), o = 0; o < r; ++o) {
    for (var a, i = t[o], s = i.length, c = n[o] = [], u = 0; u < s; ++u) {
      (a = i[u]) && e.call(a, a.__data__, u, i) && c.push(a);
    }
  }

  return new Transition(n, this._parents, this._name, this._id);
}

function transition_merge(e) {
  if (e._id !== this._id) throw new Error();

  for (var t = this._groups, r = e._groups, n = t.length, o = r.length, a = Math.min(n, o), i = new Array(n), s = 0; s < a; ++s) {
    for (var c, u = t[s], l = r[s], f = u.length, p = i[s] = new Array(f), d = 0; d < f; ++d) {
      (c = u[d] || l[d]) && (p[d] = c);
    }
  }

  for (; s < n; ++s) {
    i[s] = t[s];
  }

  return new Transition(i, this._parents, this._name, this._id);
}

function start(e) {
  return (e + "").trim().split(/^|\s+/).every(function (e) {
    var t = e.indexOf(".");
    return 0 <= t && (e = e.slice(0, t)), !e || "start" === e;
  });
}

function onFunction(r, n, o) {
  var a,
      i,
      s = start(n) ? init : set$1;
  return function () {
    var e = s(this, r),
        t = e.on;
    t !== a && (i = (a = t).copy()).on(n, o), e.on = i;
  };
}

function transition_on(e, t) {
  var r = this._id;
  return arguments.length < 2 ? get$1(this.node(), r).on.on(e) : this.each(onFunction(r, e, t));
}

function removeFunction(r) {
  return function () {
    var e = this.parentNode;

    for (var t in this.__transition) {
      if (+t !== r) return;
    }

    e && e.removeChild(this);
  };
}

function transition_remove() {
  return this.on("end.remove", removeFunction(this._id));
}

function transition_select(e) {
  var t = this._name,
      r = this._id;
  "function" != typeof e && (e = selector(e));

  for (var n = this._groups, o = n.length, a = new Array(o), i = 0; i < o; ++i) {
    for (var s, c, u = n[i], l = u.length, f = a[i] = new Array(l), p = 0; p < l; ++p) {
      (s = u[p]) && (c = e.call(s, s.__data__, p, u)) && ("__data__" in s && (c.__data__ = s.__data__), f[p] = c, schedule(f[p], t, r, p, f, get$1(s, r)));
    }
  }

  return new Transition(a, this._parents, t, r);
}

function transition_selectAll(e) {
  var t = this._name,
      r = this._id;
  "function" != typeof e && (e = selectorAll(e));

  for (var n = this._groups, o = n.length, a = [], i = [], s = 0; s < o; ++s) {
    for (var c, u = n[s], l = u.length, f = 0; f < l; ++f) {
      if (c = u[f]) {
        for (var p, d = e.call(c, c.__data__, f, u), h = get$1(c, r), y = 0, m = d.length; y < m; ++y) {
          (p = d[y]) && schedule(p, t, r, y, d, h);
        }

        a.push(d), i.push(c);
      }
    }
  }

  return new Transition(a, i, t, r);
}

var Selection$1 = selection.prototype.constructor;

function transition_selection() {
  return new Selection$1(this._groups, this._parents);
}

function styleNull(r, n) {
  var o, a, i;
  return function () {
    var e = styleValue(this, r),
        t = (this.style.removeProperty(r), styleValue(this, r));
    return e === t ? null : e === o && t === a ? i : i = n(o = e, a = t);
  };
}

function styleRemove$1(e) {
  return function () {
    this.style.removeProperty(e);
  };
}

function styleConstant$1(t, r, n) {
  var o,
      a,
      i = n + "";
  return function () {
    var e = styleValue(this, t);
    return e === i ? null : e === o ? a : a = r(o = e, n);
  };
}

function styleFunction$1(n, o, a) {
  var i, s, c;
  return function () {
    var e = styleValue(this, n),
        t = a(this),
        r = t + "";
    return null == t && (this.style.removeProperty(n), r = t = styleValue(this, n)), e === r ? null : e === i && r === s ? c : (s = r, c = o(i = e, t));
  };
}

function styleMaybeRemove(n, o) {
  var a,
      i,
      s,
      c,
      u = "style." + o,
      l = "end." + u;
  return function () {
    var e = set$1(this, n),
        t = e.on,
        r = null == e.value[u] ? c || (c = styleRemove$1(o)) : void 0;
    t === a && s === r || (i = (a = t).copy()).on(l, s = r), e.on = i;
  };
}

function transition_style(e, t, r) {
  var n = "transform" == (e += "") ? interpolateTransformCss : interpolate;
  return null == t ? this.styleTween(e, styleNull(e, n)).on("end.style." + e, styleRemove$1(e)) : "function" == typeof t ? this.styleTween(e, styleFunction$1(e, n, tweenValue(this, "style." + e, t))).each(styleMaybeRemove(this._id, e)) : this.styleTween(e, styleConstant$1(e, n, t), r).on("end.style." + e, null);
}

function styleInterpolate(t, r, n) {
  return function (e) {
    this.style.setProperty(t, r(e), n);
  };
}

function styleTween(t, r, n) {
  var o, a;

  function e() {
    var e = r.apply(this, arguments);
    return e !== a && (o = (a = e) && styleInterpolate(t, e, n)), o;
  }

  return e._value = r, e;
}

function transition_styleTween(e, t, r) {
  var n = "style." + (e += "");
  if (arguments.length < 2) return (n = this.tween(n)) && n._value;
  if (null == t) return this.tween(n, null);
  if ("function" != typeof t) throw new Error();
  return this.tween(n, styleTween(e, t, null == r ? "" : r));
}

function textConstant$1(e) {
  return function () {
    this.textContent = e;
  };
}

function textFunction$1(t) {
  return function () {
    var e = t(this);
    this.textContent = null == e ? "" : e;
  };
}

function transition_text(e) {
  return this.tween("text", "function" == typeof e ? textFunction$1(tweenValue(this, "text", e)) : textConstant$1(null == e ? "" : e + ""));
}

function transition_transition() {
  for (var e = this._name, t = this._id, r = newId(), n = this._groups, o = n.length, a = 0; a < o; ++a) {
    for (var i, s = n[a], c = s.length, u = 0; u < c; ++u) {
      if (i = s[u]) {
        var l = get$1(i, t);
        schedule(i, e, r, u, s, {
          time: l.time + l.delay + l.duration,
          delay: 0,
          duration: l.duration,
          ease: l.ease
        });
      }
    }
  }

  return new Transition(n, this._parents, e, r);
}

function transition_end() {
  var o,
      a,
      i = this,
      s = i._id,
      c = i.size();
  return new Promise(function (e, t) {
    var r = {
      value: t
    },
        n = {
      value: function value() {
        0 == --c && e();
      }
    };
    i.each(function () {
      var e = set$1(this, s),
          t = e.on;
      t !== o && ((a = (o = t).copy())._.cancel.push(r), a._.interrupt.push(r), a._.end.push(n)), e.on = a;
    });
  });
}

var id = 0;

function Transition(e, t, r, n) {
  this._groups = e, this._parents = t, this._name = r, this._id = n;
}

function transition(e) {
  return selection().transition(e);
}

function newId() {
  return ++id;
}

var selection_prototype = selection.prototype;

function cubicInOut(e) {
  return ((e *= 2) <= 1 ? e * e * e : (e -= 2) * e * e + 2) / 2;
}

Transition.prototype = transition.prototype = {
  constructor: Transition,
  select: transition_select,
  selectAll: transition_selectAll,
  filter: transition_filter,
  merge: transition_merge,
  selection: transition_selection,
  transition: transition_transition,
  call: selection_prototype.call,
  nodes: selection_prototype.nodes,
  node: selection_prototype.node,
  size: selection_prototype.size,
  empty: selection_prototype.empty,
  each: selection_prototype.each,
  on: transition_on,
  attr: transition_attr,
  attrTween: transition_attrTween,
  style: transition_style,
  styleTween: transition_styleTween,
  text: transition_text,
  remove: transition_remove,
  tween: transition_tween,
  delay: transition_delay,
  duration: transition_duration,
  ease: transition_ease,
  end: transition_end
};
var pi = Math.PI,
    tau = 2 * Math.PI,
    defaultTiming = {
  time: null,
  delay: 0,
  duration: 250,
  ease: cubicInOut
};

function inherit(e, t) {
  for (var r; !(r = e.__transition) || !(r = r[t]);) {
    if (!(e = e.parentNode)) return defaultTiming.time = now(), defaultTiming;
  }

  return r;
}

function selection_transition(e) {
  var t, r;
  e = e instanceof Transition ? (t = e._id, e._name) : (t = newId(), (r = defaultTiming).time = now(), null == e ? null : e + "");

  for (var n = this._groups, o = n.length, a = 0; a < o; ++a) {
    for (var i, s = n[a], c = s.length, u = 0; u < c; ++u) {
      (i = s[u]) && schedule(i, e, t, u, s, r || inherit(i, t));
    }
  }

  return new Transition(n, this._parents, e, t);
}

selection.prototype.interrupt = selection_interrupt, selection.prototype.transition = selection_transition;
var pi$1 = Math.PI,
    pi$2 = Math.PI,
    tau$1 = 2 * pi$2,
    epsilon = 1e-6,
    tauEpsilon = tau$1 - epsilon;

function Path() {
  this._x0 = this._y0 = this._x1 = this._y1 = null, this._ = "";
}

function path$1() {
  return new Path();
}

Path.prototype = path$1.prototype = {
  constructor: Path,
  moveTo: function moveTo(e, t) {
    this._ += "M" + (this._x0 = this._x1 = +e) + "," + (this._y0 = this._y1 = +t);
  },
  closePath: function closePath() {
    null !== this._x1 && (this._x1 = this._x0, this._y1 = this._y0, this._ += "Z");
  },
  lineTo: function lineTo(e, t) {
    this._ += "L" + (this._x1 = +e) + "," + (this._y1 = +t);
  },
  quadraticCurveTo: function quadraticCurveTo(e, t, r, n) {
    this._ += "Q" + +e + "," + +t + "," + (this._x1 = +r) + "," + (this._y1 = +n);
  },
  bezierCurveTo: function bezierCurveTo(e, t, r, n, o, a) {
    this._ += "C" + +e + "," + +t + "," + +r + "," + +n + "," + (this._x1 = +o) + "," + (this._y1 = +a);
  },
  arcTo: function arcTo(e, t, r, n, o) {
    e = +e, t = +t, r = +r, n = +n, o = +o;
    var a = this._x1,
        i = this._y1,
        s = r - e,
        c = n - t,
        u = a - e,
        l = i - t,
        f = u * u + l * l;
    if (o < 0) throw new Error("negative radius: " + o);
    if (null === this._x1) this._ += "M" + (this._x1 = e) + "," + (this._y1 = t);else if (epsilon < f) {
      if (Math.abs(l * s - c * u) > epsilon && o) {
        var p = r - a,
            d = n - i,
            h = s * s + c * c,
            y = p * p + d * d,
            m = Math.sqrt(h),
            b = Math.sqrt(f),
            v = o * Math.tan((pi$2 - Math.acos((h + f - y) / (2 * m * b))) / 2),
            g = v / b,
            _ = v / m;

        Math.abs(g - 1) > epsilon && (this._ += "L" + (e + g * u) + "," + (t + g * l)), this._ += "A" + o + "," + o + ",0,0," + +(u * d < l * p) + "," + (this._x1 = e + _ * s) + "," + (this._y1 = t + _ * c);
      } else this._ += "L" + (this._x1 = e) + "," + (this._y1 = t);
    } else ;
  },
  arc: function arc(e, t, r, n, o, a) {
    e = +e, t = +t;
    var i = (r = +r) * Math.cos(n),
        s = r * Math.sin(n),
        c = e + i,
        u = t + s,
        l = 1 ^ a,
        f = a ? n - o : o - n;
    if (r < 0) throw new Error("negative radius: " + r);
    null === this._x1 ? this._ += "M" + c + "," + u : (Math.abs(this._x1 - c) > epsilon || Math.abs(this._y1 - u) > epsilon) && (this._ += "L" + c + "," + u), r && (f < 0 && (f = f % tau$1 + tau$1), tauEpsilon < f ? this._ += "A" + r + "," + r + ",0,1," + l + "," + (e - i) + "," + (t - s) + "A" + r + "," + r + ",0,1," + l + "," + (this._x1 = c) + "," + (this._y1 = u) : epsilon < f && (this._ += "A" + r + "," + r + ",0," + +(pi$2 <= f) + "," + l + "," + (this._x1 = e + r * Math.cos(o)) + "," + (this._y1 = t + r * Math.sin(o))));
  },
  rect: function rect(e, t, r, n) {
    this._ += "M" + (this._x0 = this._x1 = +e) + "," + (this._y0 = this._y1 = +t) + "h" + +r + "v" + +n + "h" + -r + "Z";
  },
  toString: function toString() {
    return this._;
  }
};
var prefix = "$";

function Map$1() {}

function map$1(e, t) {
  var r = new Map$1();
  if (e instanceof Map$1) e.each(function (e, t) {
    r.set(t, e);
  });else if (Array.isArray(e)) {
    var n,
        o = -1,
        a = e.length;
    if (null == t) for (; ++o < a;) {
      r.set(o, e[o]);
    } else for (; ++o < a;) {
      r.set(t(n = e[o], o, e), n);
    }
  } else if (e) for (var i in e) {
    r.set(i, e[i]);
  }
  return r;
}

function Set$1() {}

Map$1.prototype = map$1.prototype = {
  constructor: Map$1,
  has: function has(e) {
    return prefix + e in this;
  },
  get: function get(e) {
    return this[prefix + e];
  },
  set: function set(e, t) {
    return this[prefix + e] = t, this;
  },
  remove: function remove(e) {
    var t = prefix + e;
    return t in this && delete this[t];
  },
  clear: function clear() {
    for (var e in this) {
      e[0] === prefix && delete this[e];
    }
  },
  keys: function keys() {
    var e = [];

    for (var t in this) {
      t[0] === prefix && e.push(t.slice(1));
    }

    return e;
  },
  values: function values() {
    var e = [];

    for (var t in this) {
      t[0] === prefix && e.push(this[t]);
    }

    return e;
  },
  entries: function entries() {
    var e = [];

    for (var t in this) {
      t[0] === prefix && e.push({
        key: t.slice(1),
        value: this[t]
      });
    }

    return e;
  },
  size: function size() {
    var e = 0;

    for (var t in this) {
      t[0] === prefix && ++e;
    }

    return e;
  },
  empty: function empty() {
    for (var e in this) {
      if (e[0] === prefix) return !1;
    }

    return !0;
  },
  each: function each(e) {
    for (var t in this) {
      t[0] === prefix && e(this[t], t.slice(1), this);
    }
  }
};
var proto = map$1.prototype;

function set$2(e, t) {
  var r = new Set$1();
  if (e instanceof Set$1) e.each(function (e) {
    r.add(e);
  });else if (e) {
    var n = -1,
        o = e.length;
    if (null == t) for (; ++n < o;) {
      r.add(e[n]);
    } else for (; ++n < o;) {
      r.add(t(e[n], n, e));
    }
  }
  return r;
}

Set$1.prototype = set$2.prototype = {
  constructor: Set$1,
  has: proto.has,
  add: function add(e) {
    return this[prefix + (e += "")] = e, this;
  },
  remove: proto.remove,
  clear: proto.clear,
  values: proto.keys,
  size: proto.size,
  empty: proto.empty,
  each: proto.each
};
var EOL = {},
    EOF = {},
    QUOTE = 34,
    NEWLINE = 10,
    RETURN = 13;

function objectConverter(e) {
  return new Function("d", "return {" + e.map(function (e, t) {
    return JSON.stringify(e) + ": d[" + t + "]";
  }).join(",") + "}");
}

function customConverter(r, n) {
  var o = objectConverter(r);
  return function (e, t) {
    return n(o(e), t, r);
  };
}

function inferColumns(e) {
  var r = Object.create(null),
      n = [];
  return e.forEach(function (e) {
    for (var t in e) {
      t in r || n.push(r[t] = t);
    }
  }), n;
}

function pad(e, t) {
  var r = e + "",
      n = r.length;
  return n < t ? new Array(t - n + 1).join(0) + r : r;
}

function formatYear(e) {
  return e < 0 ? "-" + pad(-e, 6) : 9999 < e ? "+" + pad(e, 6) : pad(e, 4);
}

function formatDate(e) {
  var t = e.getUTCHours(),
      r = e.getUTCMinutes(),
      n = e.getUTCSeconds(),
      o = e.getUTCMilliseconds();
  return isNaN(e) ? "Invalid Date" : formatYear(e.getUTCFullYear(), 4) + "-" + pad(e.getUTCMonth() + 1, 2) + "-" + pad(e.getUTCDate(), 2) + (o ? "T" + pad(t, 2) + ":" + pad(r, 2) + ":" + pad(n, 2) + "." + pad(o, 3) + "Z" : n ? "T" + pad(t, 2) + ":" + pad(r, 2) + ":" + pad(n, 2) + "Z" : r || t ? "T" + pad(t, 2) + ":" + pad(r, 2) + "Z" : "");
}

function dsvFormat(n) {
  var t = new RegExp('["' + n + "\n\r]"),
      f = n.charCodeAt(0);

  function a(n, e) {
    var t,
        r = [],
        o = n.length,
        a = 0,
        i = 0,
        s = o <= 0,
        c = !1;

    function u() {
      if (s) return EOF;
      if (c) return c = !1, EOL;
      var e,
          t,
          r = a;

      if (n.charCodeAt(r) === QUOTE) {
        for (; a++ < o && n.charCodeAt(a) !== QUOTE || n.charCodeAt(++a) === QUOTE;) {
          ;
        }

        return (e = a) >= o ? s = !0 : (t = n.charCodeAt(a++)) === NEWLINE ? c = !0 : t === RETURN && (c = !0, n.charCodeAt(a) === NEWLINE && ++a), n.slice(r + 1, e - 1).replace(/""/g, '"');
      }

      for (; a < o;) {
        if ((t = n.charCodeAt(e = a++)) === NEWLINE) c = !0;else if (t === RETURN) c = !0, n.charCodeAt(a) === NEWLINE && ++a;else if (t !== f) continue;
        return n.slice(r, e);
      }

      return s = !0, n.slice(r, o);
    }

    for (n.charCodeAt(o - 1) === NEWLINE && --o, n.charCodeAt(o - 1) === RETURN && --o; (t = u()) !== EOF;) {
      for (var l = []; t !== EOL && t !== EOF;) {
        l.push(t), t = u();
      }

      e && null == (l = e(l, i++)) || r.push(l);
    }

    return r;
  }

  function r(e, r) {
    return e.map(function (t) {
      return r.map(function (e) {
        return i(t[e]);
      }).join(n);
    });
  }

  function o(e) {
    return e.map(i).join(n);
  }

  function i(e) {
    return null == e ? "" : e instanceof Date ? formatDate(e) : t.test(e += "") ? '"' + e.replace(/"/g, '""') + '"' : e;
  }

  return {
    parse: function parse(e, r) {
      var n,
          o,
          t = a(e, function (e, t) {
        if (n) return n(e, t - 1);
        o = e, n = r ? customConverter(e, r) : objectConverter(e);
      });
      return t.columns = o || [], t;
    },
    parseRows: a,
    format: function format(e, t) {
      return null == t && (t = inferColumns(e)), [t.map(i).join(n)].concat(r(e, t)).join("\n");
    },
    formatBody: function formatBody(e, t) {
      return null == t && (t = inferColumns(e)), r(e, t).join("\n");
    },
    formatRows: function formatRows(e) {
      return e.map(o).join("\n");
    }
  };
}

var csv = dsvFormat(","),
    tsv = dsvFormat("\t");

function tree_add(e) {
  var t = +this._x.call(null, e),
      r = +this._y.call(null, e);
  return add(this.cover(t, r), t, r, e);
}

function add(e, t, r, n) {
  if (isNaN(t) || isNaN(r)) return e;
  var o,
      a,
      i,
      s,
      c,
      u,
      l,
      f,
      p,
      d = e._root,
      h = {
    data: n
  },
      y = e._x0,
      m = e._y0,
      b = e._x1,
      v = e._y1;
  if (!d) return e._root = h, e;

  for (; d.length;) {
    if ((u = t >= (a = (y + b) / 2)) ? y = a : b = a, (l = r >= (i = (m + v) / 2)) ? m = i : v = i, !(d = (o = d)[f = l << 1 | u])) return o[f] = h, e;
  }

  if (s = +e._x.call(null, d.data), c = +e._y.call(null, d.data), t === s && r === c) return h.next = d, o ? o[f] = h : e._root = h, e;

  for (; o = o ? o[f] = new Array(4) : e._root = new Array(4), (u = t >= (a = (y + b) / 2)) ? y = a : b = a, (l = r >= (i = (m + v) / 2)) ? m = i : v = i, (f = l << 1 | u) == (p = (i <= c) << 1 | a <= s);) {
    ;
  }

  return o[p] = d, o[f] = h, e;
}

function addAll(e) {
  var t,
      r,
      n,
      o,
      a = e.length,
      i = new Array(a),
      s = new Array(a),
      c = 1 / 0,
      u = 1 / 0,
      l = -1 / 0,
      f = -1 / 0;

  for (r = 0; r < a; ++r) {
    isNaN(n = +this._x.call(null, t = e[r])) || isNaN(o = +this._y.call(null, t)) || ((i[r] = n) < c && (c = n), l < n && (l = n), (s[r] = o) < u && (u = o), f < o && (f = o));
  }

  if (l < c || f < u) return this;

  for (this.cover(c, u).cover(l, f), r = 0; r < a; ++r) {
    add(this, i[r], s[r], e[r]);
  }

  return this;
}

function tree_cover(e, t) {
  if (isNaN(e = +e) || isNaN(t = +t)) return this;
  var r = this._x0,
      n = this._y0,
      o = this._x1,
      a = this._y1;
  if (isNaN(r)) o = (r = Math.floor(e)) + 1, a = (n = Math.floor(t)) + 1;else {
    for (var i, s, c = o - r, u = this._root; e < r || o <= e || t < n || a <= t;) {
      switch (s = (t < n) << 1 | e < r, (i = new Array(4))[s] = u, u = i, c *= 2, s) {
        case 0:
          o = r + c, a = n + c;
          break;

        case 1:
          r = o - c, a = n + c;
          break;

        case 2:
          o = r + c, n = a - c;
          break;

        case 3:
          r = o - c, n = a - c;
      }
    }

    this._root && this._root.length && (this._root = u);
  }
  return this._x0 = r, this._y0 = n, this._x1 = o, this._y1 = a, this;
}

function tree_data() {
  var t = [];
  return this.visit(function (e) {
    if (!e.length) for (; t.push(e.data), e = e.next;) {
      ;
    }
  }), t;
}

function tree_extent(e) {
  return arguments.length ? this.cover(+e[0][0], +e[0][1]).cover(+e[1][0], +e[1][1]) : isNaN(this._x0) ? void 0 : [[this._x0, this._y0], [this._x1, this._y1]];
}

function Quad(e, t, r, n, o) {
  this.node = e, this.x0 = t, this.y0 = r, this.x1 = n, this.y1 = o;
}

function tree_find(e, t, r) {
  var n,
      o,
      a,
      i,
      s,
      c,
      u,
      l = this._x0,
      f = this._y0,
      p = this._x1,
      d = this._y1,
      h = [],
      y = this._root;

  for (y && h.push(new Quad(y, l, f, p, d)), null == r ? r = 1 / 0 : (l = e - r, f = t - r, p = e + r, d = t + r, r *= r); c = h.pop();) {
    if (!(!(y = c.node) || (o = c.x0) > p || (a = c.y0) > d || (i = c.x1) < l || (s = c.y1) < f)) if (y.length) {
      var m = (o + i) / 2,
          b = (a + s) / 2;
      h.push(new Quad(y[3], m, b, i, s), new Quad(y[2], o, b, m, s), new Quad(y[1], m, a, i, b), new Quad(y[0], o, a, m, b)), (u = (b <= t) << 1 | m <= e) && (c = h[h.length - 1], h[h.length - 1] = h[h.length - 1 - u], h[h.length - 1 - u] = c);
    } else {
      var v = e - +this._x.call(null, y.data),
          g = t - +this._y.call(null, y.data),
          _ = v * v + g * g;

      if (_ < r) {
        var w = Math.sqrt(r = _);
        l = e - w, f = t - w, p = e + w, d = t + w, n = y.data;
      }
    }
  }

  return n;
}

function tree_remove(e) {
  if (isNaN(a = +this._x.call(null, e)) || isNaN(i = +this._y.call(null, e))) return this;
  var t,
      r,
      n,
      o,
      a,
      i,
      s,
      c,
      u,
      l,
      f,
      p,
      d = this._root,
      h = this._x0,
      y = this._y0,
      m = this._x1,
      b = this._y1;
  if (!d) return this;
  if (d.length) for (;;) {
    if ((u = a >= (s = (h + m) / 2)) ? h = s : m = s, (l = i >= (c = (y + b) / 2)) ? y = c : b = c, !(d = (t = d)[f = l << 1 | u])) return this;
    if (!d.length) break;
    (t[f + 1 & 3] || t[f + 2 & 3] || t[f + 3 & 3]) && (r = t, p = f);
  }

  for (; d.data !== e;) {
    if (!(d = (n = d).next)) return this;
  }

  return (o = d.next) && delete d.next, n ? o ? n.next = o : delete n.next : t ? (o ? t[f] = o : delete t[f], (d = t[0] || t[1] || t[2] || t[3]) && d === (t[3] || t[2] || t[1] || t[0]) && !d.length && (r ? r[p] = d : this._root = d)) : this._root = o, this;
}

function removeAll(e) {
  for (var t = 0, r = e.length; t < r; ++t) {
    this.remove(e[t]);
  }

  return this;
}

function tree_root() {
  return this._root;
}

function tree_size() {
  var t = 0;
  return this.visit(function (e) {
    if (!e.length) for (; ++t, e = e.next;) {
      ;
    }
  }), t;
}

function tree_visit(e) {
  var t,
      r,
      n,
      o,
      a,
      i,
      s = [],
      c = this._root;

  for (c && s.push(new Quad(c, this._x0, this._y0, this._x1, this._y1)); t = s.pop();) {
    if (!e(c = t.node, n = t.x0, o = t.y0, a = t.x1, i = t.y1) && c.length) {
      var u = (n + a) / 2,
          l = (o + i) / 2;
      (r = c[3]) && s.push(new Quad(r, u, l, a, i)), (r = c[2]) && s.push(new Quad(r, n, l, u, i)), (r = c[1]) && s.push(new Quad(r, u, o, a, l)), (r = c[0]) && s.push(new Quad(r, n, o, u, l));
    }
  }

  return this;
}

function tree_visitAfter(e) {
  var t,
      r = [],
      n = [];

  for (this._root && r.push(new Quad(this._root, this._x0, this._y0, this._x1, this._y1)); t = r.pop();) {
    var o = t.node;

    if (o.length) {
      var a,
          i = t.x0,
          s = t.y0,
          c = t.x1,
          u = t.y1,
          l = (i + c) / 2,
          f = (s + u) / 2;
      (a = o[0]) && r.push(new Quad(a, i, s, l, f)), (a = o[1]) && r.push(new Quad(a, l, s, c, f)), (a = o[2]) && r.push(new Quad(a, i, f, l, u)), (a = o[3]) && r.push(new Quad(a, l, f, c, u));
    }

    n.push(t);
  }

  for (; t = n.pop();) {
    e(t.node, t.x0, t.y0, t.x1, t.y1);
  }

  return this;
}

function defaultX(e) {
  return e[0];
}

function tree_x(e) {
  return arguments.length ? (this._x = e, this) : this._x;
}

function defaultY(e) {
  return e[1];
}

function tree_y(e) {
  return arguments.length ? (this._y = e, this) : this._y;
}

function quadtree(e, t, r) {
  var n = new Quadtree(null == t ? defaultX : t, null == r ? defaultY : r, NaN, NaN, NaN, NaN);
  return null == e ? n : n.addAll(e);
}

function Quadtree(e, t, r, n, o, a) {
  this._x = e, this._y = t, this._x0 = r, this._y0 = n, this._x1 = o, this._y1 = a, this._root = void 0;
}

function leaf_copy(e) {
  for (var t = {
    data: e.data
  }, r = t; e = e.next;) {
    r = r.next = {
      data: e.data
    };
  }

  return t;
}

var treeProto = quadtree.prototype = Quadtree.prototype;
treeProto.copy = function () {
  var e,
      t,
      r = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1),
      n = this._root;
  if (!n) return r;
  if (!n.length) return r._root = leaf_copy(n), r;

  for (e = [{
    source: n,
    target: r._root = new Array(4)
  }]; n = e.pop();) {
    for (var o = 0; o < 4; ++o) {
      (t = n.source[o]) && (t.length ? e.push({
        source: t,
        target: n.target[o] = new Array(4)
      }) : n.target[o] = leaf_copy(t));
    }
  }

  return r;
}, treeProto.add = tree_add, treeProto.addAll = addAll, treeProto.cover = tree_cover, treeProto.data = tree_data, treeProto.extent = tree_extent, treeProto.find = tree_find, treeProto.remove = tree_remove, treeProto.removeAll = removeAll, treeProto.root = tree_root, treeProto.size = tree_size, treeProto.visit = tree_visit, treeProto.visitAfter = tree_visitAfter, treeProto.x = tree_x, treeProto.y = tree_y;
var initialAngle = Math.PI * (3 - Math.sqrt(5));

function formatDecimal(e, t) {
  if ((r = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e")) < 0) return null;
  var r,
      n = e.slice(0, r);
  return [1 < n.length ? n[0] + n.slice(2) : n, +e.slice(r + 1)];
}

function exponent(e) {
  return (e = formatDecimal(Math.abs(e))) ? e[1] : NaN;
}

function formatGroup(s, c) {
  return function (e, t) {
    for (var r = e.length, n = [], o = 0, a = s[0], i = 0; 0 < r && 0 < a && (t < i + a + 1 && (a = Math.max(1, t - i)), n.push(e.substring(r -= a, r + a)), !((i += a + 1) > t));) {
      a = s[o = (o + 1) % s.length];
    }

    return n.reverse().join(c);
  };
}

function formatNumerals(t) {
  return function (e) {
    return e.replace(/[0-9]/g, function (e) {
      return t[+e];
    });
  };
}

var prefixExponent,
    re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;

function formatSpecifier(e) {
  return new FormatSpecifier(e);
}

function FormatSpecifier(e) {
  if (!(t = re.exec(e))) throw new Error("invalid format: " + e);
  var t;
  this.fill = t[1] || " ", this.align = t[2] || ">", this.sign = t[3] || "-", this.symbol = t[4] || "", this.zero = !!t[5], this.width = t[6] && +t[6], this.comma = !!t[7], this.precision = t[8] && +t[8].slice(1), this.trim = !!t[9], this.type = t[10] || "";
}

function formatTrim(e) {
  e: for (var t, r = e.length, n = 1, o = -1; n < r; ++n) {
    switch (e[n]) {
      case ".":
        o = t = n;
        break;

      case "0":
        0 === o && (o = n), t = n;
        break;

      default:
        if (0 < o) {
          if (!+e[n]) break e;
          o = 0;
        }

    }
  }

  return 0 < o ? e.slice(0, o) + e.slice(t + 1) : e;
}

function formatPrefixAuto(e, t) {
  var r = formatDecimal(e, t);
  if (!r) return e + "";
  var n = r[0],
      o = r[1],
      a = o - (prefixExponent = 3 * Math.max(-8, Math.min(8, Math.floor(o / 3)))) + 1,
      i = n.length;
  return a === i ? n : i < a ? n + new Array(a - i + 1).join("0") : 0 < a ? n.slice(0, a) + "." + n.slice(a) : "0." + new Array(1 - a).join("0") + formatDecimal(e, Math.max(0, t + a - 1))[0];
}

function formatRounded(e, t) {
  var r = formatDecimal(e, t);
  if (!r) return e + "";
  var n = r[0],
      o = r[1];
  return o < 0 ? "0." + new Array(-o).join("0") + n : n.length > o + 1 ? n.slice(0, o + 1) + "." + n.slice(o + 1) : n + new Array(o - n.length + 2).join("0");
}

formatSpecifier.prototype = FormatSpecifier.prototype, FormatSpecifier.prototype.toString = function () {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (null == this.width ? "" : Math.max(1, 0 | this.width)) + (this.comma ? "," : "") + (null == this.precision ? "" : "." + Math.max(0, 0 | this.precision)) + (this.trim ? "~" : "") + this.type;
};
var formatTypes = {
  "%": function _(e, t) {
    return (100 * e).toFixed(t);
  },
  b: function b(e) {
    return Math.round(e).toString(2);
  },
  c: function c(e) {
    return e + "";
  },
  d: function d(e) {
    return Math.round(e).toString(10);
  },
  e: function e(_e2, t) {
    return _e2.toExponential(t);
  },
  f: function f(e, t) {
    return e.toFixed(t);
  },
  g: function g(e, t) {
    return e.toPrecision(t);
  },
  o: function o(e) {
    return Math.round(e).toString(8);
  },
  p: function p(e, t) {
    return formatRounded(100 * e, t);
  },
  r: formatRounded,
  s: formatPrefixAuto,
  X: function X(e) {
    return Math.round(e).toString(16).toUpperCase();
  },
  x: function x(e) {
    return Math.round(e).toString(16);
  }
};

function identity$1(e) {
  return e;
}

var locale,
    format,
    formatPrefix,
    prefixes = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];

function formatLocale(e) {
  var $ = e.grouping && e.thousands ? formatGroup(e.grouping, e.thousands) : identity$1,
      n = e.currency,
      S = e.decimal,
      T = e.numerals ? formatNumerals(e.numerals) : identity$1,
      o = e.percent || "%";

  function i(e) {
    var u = (e = formatSpecifier(e)).fill,
        l = e.align,
        f = e.sign,
        t = e.symbol,
        p = e.zero,
        d = e.width,
        h = e.comma,
        y = e.precision,
        m = e.trim,
        b = e.type;
    "n" === b ? (h = !0, b = "g") : formatTypes[b] || (null == y && (y = 12), m = !0, b = "g"), (p || "0" === u && "=" === l) && (p = !0, u = "0", l = "=");
    var v = "$" === t ? n[0] : "#" === t && /[boxX]/.test(b) ? "0" + b.toLowerCase() : "",
        g = "$" === t ? n[1] : /[%p]/.test(b) ? o : "",
        _ = formatTypes[b],
        w = /[defgprs%]/.test(b);

    function r(e) {
      var t,
          r,
          n,
          o = v,
          a = g;
      if ("c" === b) a = _(e) + a, e = "";else {
        var i = (e = +e) < 0;
        if (e = _(Math.abs(e), y), m && (e = formatTrim(e)), i && 0 == +e && (i = !1), o = (i ? "(" === f ? f : "-" : "-" === f || "(" === f ? "" : f) + o, a = ("s" === b ? prefixes[8 + prefixExponent / 3] : "") + a + (i && "(" === f ? ")" : ""), w) for (t = -1, r = e.length; ++t < r;) {
          if ((n = e.charCodeAt(t)) < 48 || 57 < n) {
            a = (46 === n ? S + e.slice(t + 1) : e.slice(t)) + a, e = e.slice(0, t);
            break;
          }
        }
      }
      h && !p && (e = $(e, 1 / 0));
      var s = o.length + e.length + a.length,
          c = s < d ? new Array(d - s + 1).join(u) : "";

      switch (h && p && (e = $(c + e, c.length ? d - a.length : 1 / 0), c = ""), l) {
        case "<":
          e = o + e + a + c;
          break;

        case "=":
          e = o + c + e + a;
          break;

        case "^":
          e = c.slice(0, s = c.length >> 1) + o + e + a + c.slice(s);
          break;

        default:
          e = c + o + e + a;
      }

      return T(e);
    }

    return y = null == y ? 6 : /[gprs]/.test(b) ? Math.max(1, Math.min(21, y)) : Math.max(0, Math.min(20, y)), r.toString = function () {
      return e + "";
    }, r;
  }

  return {
    format: i,
    formatPrefix: function formatPrefix(e, t) {
      var r = i(((e = formatSpecifier(e)).type = "f", e)),
          n = 3 * Math.max(-8, Math.min(8, Math.floor(exponent(t) / 3))),
          o = Math.pow(10, -n),
          a = prefixes[8 + n / 3];
      return function (e) {
        return r(o * e) + a;
      };
    }
  };
}

function defaultLocale(e) {
  return locale = formatLocale(e), format = locale.format, formatPrefix = locale.formatPrefix, locale;
}

function precisionFixed(e) {
  return Math.max(0, -exponent(Math.abs(e)));
}

function precisionPrefix(e, t) {
  return Math.max(0, 3 * Math.max(-8, Math.min(8, Math.floor(exponent(t) / 3))) - exponent(Math.abs(e)));
}

function precisionRound(e, t) {
  return e = Math.abs(e), t = Math.abs(t) - e, Math.max(0, exponent(t) - exponent(e)) + 1;
}

function adder() {
  return new Adder();
}

function Adder() {
  this.reset();
}

defaultLocale({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
}), Adder.prototype = {
  constructor: Adder,
  reset: function reset() {
    this.s = this.t = 0;
  },
  add: function add(e) {
    add$1(temp, e, this.t), add$1(this, temp.s, this.s), this.s ? this.t += temp.t : this.s = temp.t;
  },
  valueOf: function valueOf() {
    return this.s;
  }
};
var temp = new Adder();

function add$1(e, t, r) {
  var n = e.s = t + r,
      o = n - t,
      a = n - o;
  e.t = t - a + (r - o);
}

var pi$3 = Math.PI,
    areaRingSum = adder(),
    areaSum = adder(),
    deltaSum = adder(),
    sum = adder(),
    lengthSum = adder(),
    areaSum$1 = adder(),
    areaRingSum$1 = adder(),
    lengthSum$1 = adder();

function initRange(e, t) {
  switch (arguments.length) {
    case 0:
      break;

    case 1:
      this.range(e);
      break;

    default:
      this.range(t).domain(e);
  }

  return this;
}

var array$1 = Array.prototype,
    map$2 = array$1.map,
    slice$2 = array$1.slice;

function constant$2(e) {
  return function () {
    return e;
  };
}

function number(e) {
  return +e;
}

var unit = [0, 1];

function identity$2(e) {
  return e;
}

function normalize(t, r) {
  return (r -= t = +t) ? function (e) {
    return (e - t) / r;
  } : constant$2(isNaN(r) ? NaN : .5);
}

function clamper(e) {
  var t,
      r = e[0],
      n = e[e.length - 1];
  return n < r && (t = r, r = n, n = t), function (e) {
    return Math.max(r, Math.min(n, e));
  };
}

function bimap(e, t, r) {
  var n = e[0],
      o = e[1],
      a = t[0],
      i = t[1];
  return a = o < n ? (n = normalize(o, n), r(i, a)) : (n = normalize(n, o), r(a, i)), function (e) {
    return a(n(e));
  };
}

function polymap(r, e, t) {
  var n = Math.min(r.length, e.length) - 1,
      o = new Array(n),
      a = new Array(n),
      i = -1;

  for (r[n] < r[0] && (r = r.slice().reverse(), e = e.slice().reverse()); ++i < n;) {
    o[i] = normalize(r[i], r[i + 1]), a[i] = t(e[i], e[i + 1]);
  }

  return function (e) {
    var t = bisectRight(r, e, 1, n) - 1;
    return a[t](o[t](e));
  };
}

function copy(e, t) {
  return t.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp()).unknown(e.unknown());
}

function transformer() {
  var r,
      n,
      t,
      o,
      a,
      i,
      s = unit,
      c = unit,
      u = interpolateValue,
      l = identity$2;

  function f() {
    return o = 2 < Math.min(s.length, c.length) ? polymap : bimap, a = i = null, p;
  }

  function p(e) {
    return isNaN(e = +e) ? t : (a || (a = o(s.map(r), c, u)))(r(l(e)));
  }

  return p.invert = function (e) {
    return l(n((i || (i = o(c, s.map(r), interpolateNumber)))(e)));
  }, p.domain = function (e) {
    return arguments.length ? (s = map$2.call(e, number), l === identity$2 || (l = clamper(s)), f()) : s.slice();
  }, p.range = function (e) {
    return arguments.length ? (c = slice$2.call(e), f()) : c.slice();
  }, p.rangeRound = function (e) {
    return c = slice$2.call(e), u = interpolateRound, f();
  }, p.clamp = function (e) {
    return arguments.length ? (l = e ? clamper(s) : identity$2, p) : l !== identity$2;
  }, p.interpolate = function (e) {
    return arguments.length ? (u = e, f()) : u;
  }, p.unknown = function (e) {
    return arguments.length ? (t = e, p) : t;
  }, function (e, t) {
    return r = e, n = t, f();
  };
}

function continuous(e, t) {
  return transformer()(e, t);
}

function tickFormat(e, t, r, n) {
  var o,
      a = tickStep(e, t, r);

  switch ((n = formatSpecifier(null == n ? ",f" : n)).type) {
    case "s":
      var i = Math.max(Math.abs(e), Math.abs(t));
      return null != n.precision || isNaN(o = precisionPrefix(a, i)) || (n.precision = o), formatPrefix(n, i);

    case "":
    case "e":
    case "g":
    case "p":
    case "r":
      null != n.precision || isNaN(o = precisionRound(a, Math.max(Math.abs(e), Math.abs(t)))) || (n.precision = o - ("e" === n.type));
      break;

    case "f":
    case "%":
      null != n.precision || isNaN(o = precisionFixed(a)) || (n.precision = o - 2 * ("%" === n.type));
  }

  return format(n);
}

function linearish(s) {
  var c = s.domain;
  return s.ticks = function (e) {
    var t = c();
    return ticks(t[0], t[t.length - 1], null == e ? 10 : e);
  }, s.tickFormat = function (e, t) {
    var r = c();
    return tickFormat(r[0], r[r.length - 1], null == e ? 10 : e, t);
  }, s.nice = function (e) {
    null == e && (e = 10);
    var t,
        r = c(),
        n = 0,
        o = r.length - 1,
        a = r[n],
        i = r[o];
    return i < a && (t = a, a = i, i = t, t = n, n = o, o = t), 0 < (t = tickIncrement(a, i, e)) ? t = tickIncrement(a = Math.floor(a / t) * t, i = Math.ceil(i / t) * t, e) : t < 0 && (t = tickIncrement(a = Math.ceil(a * t) / t, i = Math.floor(i * t) / t, e)), 0 < t ? (r[n] = Math.floor(a / t) * t, r[o] = Math.ceil(i / t) * t, c(r)) : t < 0 && (r[n] = Math.ceil(a * t) / t, r[o] = Math.floor(i * t) / t, c(r)), s;
  }, s;
}

function linear$1() {
  var e = continuous(identity$2, identity$2);
  return e.copy = function () {
    return copy(e, linear$1());
  }, initRange.apply(e, arguments), linearish(e);
}

var t0$1 = new Date(),
    t1$1 = new Date();

function newInterval(a, i, r, n) {
  function s(e) {
    return a(e = new Date(+e)), e;
  }

  return (s.floor = s).ceil = function (e) {
    return a(e = new Date(e - 1)), i(e, 1), a(e), e;
  }, s.round = function (e) {
    var t = s(e),
        r = s.ceil(e);
    return e - t < r - e ? t : r;
  }, s.offset = function (e, t) {
    return i(e = new Date(+e), null == t ? 1 : Math.floor(t)), e;
  }, s.range = function (e, t, r) {
    var n,
        o = [];
    if (e = s.ceil(e), r = null == r ? 1 : Math.floor(r), !(e < t && 0 < r)) return o;

    for (; o.push(n = new Date(+e)), i(e, r), a(e), n < e && e < t;) {
      ;
    }

    return o;
  }, s.filter = function (r) {
    return newInterval(function (e) {
      if (e <= e) for (; a(e), !r(e);) {
        e.setTime(e - 1);
      }
    }, function (e, t) {
      if (e <= e) if (t < 0) for (; ++t <= 0;) {
        for (; i(e, -1), !r(e);) {
          ;
        }
      } else for (; 0 <= --t;) {
        for (; i(e, 1), !r(e);) {
          ;
        }
      }
    });
  }, r && (s.count = function (e, t) {
    return t0$1.setTime(+e), t1$1.setTime(+t), a(t0$1), a(t1$1), Math.floor(r(t0$1, t1$1));
  }, s.every = function (t) {
    return t = Math.floor(t), isFinite(t) && 0 < t ? 1 < t ? s.filter(n ? function (e) {
      return n(e) % t == 0;
    } : function (e) {
      return s.count(0, e) % t == 0;
    }) : s : null;
  }), s;
}

var millisecond = newInterval(function () {}, function (e, t) {
  e.setTime(+e + t);
}, function (e, t) {
  return t - e;
});

millisecond.every = function (r) {
  return r = Math.floor(r), isFinite(r) && 0 < r ? 1 < r ? newInterval(function (e) {
    e.setTime(Math.floor(e / r) * r);
  }, function (e, t) {
    e.setTime(+e + t * r);
  }, function (e, t) {
    return (t - e) / r;
  }) : millisecond : null;
};

var milliseconds = millisecond.range,
    durationSecond = 1e3,
    durationMinute = 6e4,
    durationHour = 36e5,
    durationDay = 864e5,
    durationWeek = 6048e5,
    second = newInterval(function (e) {
  e.setTime(e - e.getMilliseconds());
}, function (e, t) {
  e.setTime(+e + t * durationSecond);
}, function (e, t) {
  return (t - e) / durationSecond;
}, function (e) {
  return e.getUTCSeconds();
}),
    seconds = second.range,
    minute = newInterval(function (e) {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * durationSecond);
}, function (e, t) {
  e.setTime(+e + t * durationMinute);
}, function (e, t) {
  return (t - e) / durationMinute;
}, function (e) {
  return e.getMinutes();
}),
    minutes = minute.range,
    hour = newInterval(function (e) {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * durationSecond - e.getMinutes() * durationMinute);
}, function (e, t) {
  e.setTime(+e + t * durationHour);
}, function (e, t) {
  return (t - e) / durationHour;
}, function (e) {
  return e.getHours();
}),
    hours = hour.range,
    day = newInterval(function (e) {
  e.setHours(0, 0, 0, 0);
}, function (e, t) {
  e.setDate(e.getDate() + t);
}, function (e, t) {
  return (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * durationMinute) / durationDay;
}, function (e) {
  return e.getDate() - 1;
}),
    days = day.range;

function weekday(t) {
  return newInterval(function (e) {
    e.setDate(e.getDate() - (e.getDay() + 7 - t) % 7), e.setHours(0, 0, 0, 0);
  }, function (e, t) {
    e.setDate(e.getDate() + 7 * t);
  }, function (e, t) {
    return (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * durationMinute) / durationWeek;
  });
}

var sunday = weekday(0),
    monday = weekday(1),
    tuesday = weekday(2),
    wednesday = weekday(3),
    thursday = weekday(4),
    friday = weekday(5),
    saturday = weekday(6),
    sundays = sunday.range,
    mondays = monday.range,
    thursdays = thursday.range,
    month = newInterval(function (e) {
  e.setDate(1), e.setHours(0, 0, 0, 0);
}, function (e, t) {
  e.setMonth(e.getMonth() + t);
}, function (e, t) {
  return t.getMonth() - e.getMonth() + 12 * (t.getFullYear() - e.getFullYear());
}, function (e) {
  return e.getMonth();
}),
    months = month.range,
    year = newInterval(function (e) {
  e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, function (e, t) {
  e.setFullYear(e.getFullYear() + t);
}, function (e, t) {
  return t.getFullYear() - e.getFullYear();
}, function (e) {
  return e.getFullYear();
});

year.every = function (r) {
  return isFinite(r = Math.floor(r)) && 0 < r ? newInterval(function (e) {
    e.setFullYear(Math.floor(e.getFullYear() / r) * r), e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
  }, function (e, t) {
    e.setFullYear(e.getFullYear() + t * r);
  }) : null;
};

var years = year.range,
    utcMinute = newInterval(function (e) {
  e.setUTCSeconds(0, 0);
}, function (e, t) {
  e.setTime(+e + t * durationMinute);
}, function (e, t) {
  return (t - e) / durationMinute;
}, function (e) {
  return e.getUTCMinutes();
}),
    utcMinutes = utcMinute.range,
    utcHour = newInterval(function (e) {
  e.setUTCMinutes(0, 0, 0);
}, function (e, t) {
  e.setTime(+e + t * durationHour);
}, function (e, t) {
  return (t - e) / durationHour;
}, function (e) {
  return e.getUTCHours();
}),
    utcHours = utcHour.range,
    utcDay = newInterval(function (e) {
  e.setUTCHours(0, 0, 0, 0);
}, function (e, t) {
  e.setUTCDate(e.getUTCDate() + t);
}, function (e, t) {
  return (t - e) / durationDay;
}, function (e) {
  return e.getUTCDate() - 1;
}),
    utcDays = utcDay.range;

function utcWeekday(t) {
  return newInterval(function (e) {
    e.setUTCDate(e.getUTCDate() - (e.getUTCDay() + 7 - t) % 7), e.setUTCHours(0, 0, 0, 0);
  }, function (e, t) {
    e.setUTCDate(e.getUTCDate() + 7 * t);
  }, function (e, t) {
    return (t - e) / durationWeek;
  });
}

var utcSunday = utcWeekday(0),
    utcMonday = utcWeekday(1),
    utcTuesday = utcWeekday(2),
    utcWednesday = utcWeekday(3),
    utcThursday = utcWeekday(4),
    utcFriday = utcWeekday(5),
    utcSaturday = utcWeekday(6),
    utcSundays = utcSunday.range,
    utcMondays = utcMonday.range,
    utcThursdays = utcThursday.range,
    utcMonth = newInterval(function (e) {
  e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
}, function (e, t) {
  e.setUTCMonth(e.getUTCMonth() + t);
}, function (e, t) {
  return t.getUTCMonth() - e.getUTCMonth() + 12 * (t.getUTCFullYear() - e.getUTCFullYear());
}, function (e) {
  return e.getUTCMonth();
}),
    utcMonths = utcMonth.range,
    utcYear = newInterval(function (e) {
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, function (e, t) {
  e.setUTCFullYear(e.getUTCFullYear() + t);
}, function (e, t) {
  return t.getUTCFullYear() - e.getUTCFullYear();
}, function (e) {
  return e.getUTCFullYear();
});

utcYear.every = function (r) {
  return isFinite(r = Math.floor(r)) && 0 < r ? newInterval(function (e) {
    e.setUTCFullYear(Math.floor(e.getUTCFullYear() / r) * r), e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
  }, function (e, t) {
    e.setUTCFullYear(e.getUTCFullYear() + t * r);
  }) : null;
};

var utcYears = utcYear.range;

function localDate(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
    return t.setFullYear(e.y), t;
  }

  return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
}

function utcDate(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
    return t.setUTCFullYear(e.y), t;
  }

  return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
}

function newYear(e) {
  return {
    y: e,
    m: 0,
    d: 1,
    H: 0,
    M: 0,
    S: 0,
    L: 0
  };
}

function formatLocale$1(e) {
  var n = e.dateTime,
      o = e.date,
      a = e.time,
      t = e.periods,
      r = e.days,
      i = e.shortDays,
      s = e.months,
      c = e.shortMonths,
      u = formatRe(t),
      l = formatLookup(t),
      f = formatRe(r),
      p = formatLookup(r),
      d = formatRe(i),
      h = formatLookup(i),
      y = formatRe(s),
      m = formatLookup(s),
      _b = formatRe(c),
      v = formatLookup(c),
      g = {
    a: function a(e) {
      return i[e.getDay()];
    },
    A: function A(e) {
      return r[e.getDay()];
    },
    b: function b(e) {
      return c[e.getMonth()];
    },
    B: function B(e) {
      return s[e.getMonth()];
    },
    c: null,
    d: formatDayOfMonth,
    e: formatDayOfMonth,
    f: formatMicroseconds,
    H: formatHour24,
    I: formatHour12,
    j: formatDayOfYear,
    L: formatMilliseconds,
    m: formatMonthNumber,
    M: formatMinutes,
    p: function p(e) {
      return t[+(12 <= e.getHours())];
    },
    Q: formatUnixTimestamp,
    s: formatUnixTimestampSeconds,
    S: formatSeconds,
    u: formatWeekdayNumberMonday,
    U: formatWeekNumberSunday,
    V: formatWeekNumberISO,
    w: formatWeekdayNumberSunday,
    W: formatWeekNumberMonday,
    x: null,
    X: null,
    y: formatYear$1,
    Y: formatFullYear,
    Z: formatZone,
    "%": formatLiteralPercent
  },
      _ = {
    a: function a(e) {
      return i[e.getUTCDay()];
    },
    A: function A(e) {
      return r[e.getUTCDay()];
    },
    b: function b(e) {
      return c[e.getUTCMonth()];
    },
    B: function B(e) {
      return s[e.getUTCMonth()];
    },
    c: null,
    d: formatUTCDayOfMonth,
    e: formatUTCDayOfMonth,
    f: formatUTCMicroseconds,
    H: formatUTCHour24,
    I: formatUTCHour12,
    j: formatUTCDayOfYear,
    L: formatUTCMilliseconds,
    m: formatUTCMonthNumber,
    M: formatUTCMinutes,
    p: function p(e) {
      return t[+(12 <= e.getUTCHours())];
    },
    Q: formatUnixTimestamp,
    s: formatUnixTimestampSeconds,
    S: formatUTCSeconds,
    u: formatUTCWeekdayNumberMonday,
    U: formatUTCWeekNumberSunday,
    V: formatUTCWeekNumberISO,
    w: formatUTCWeekdayNumberSunday,
    W: formatUTCWeekNumberMonday,
    x: null,
    X: null,
    y: formatUTCYear,
    Y: formatUTCFullYear,
    Z: formatUTCZone,
    "%": formatLiteralPercent
  },
      w = {
    a: function a(e, t, r) {
      var n = d.exec(t.slice(r));
      return n ? (e.w = h[n[0].toLowerCase()], r + n[0].length) : -1;
    },
    A: function A(e, t, r) {
      var n = f.exec(t.slice(r));
      return n ? (e.w = p[n[0].toLowerCase()], r + n[0].length) : -1;
    },
    b: function b(e, t, r) {
      var n = _b.exec(t.slice(r));

      return n ? (e.m = v[n[0].toLowerCase()], r + n[0].length) : -1;
    },
    B: function B(e, t, r) {
      var n = y.exec(t.slice(r));
      return n ? (e.m = m[n[0].toLowerCase()], r + n[0].length) : -1;
    },
    c: function c(e, t, r) {
      return T(e, n, t, r);
    },
    d: parseDayOfMonth,
    e: parseDayOfMonth,
    f: parseMicroseconds,
    H: parseHour24,
    I: parseHour24,
    j: parseDayOfYear,
    L: parseMilliseconds,
    m: parseMonthNumber,
    M: parseMinutes,
    p: function p(e, t, r) {
      var n = u.exec(t.slice(r));
      return n ? (e.p = l[n[0].toLowerCase()], r + n[0].length) : -1;
    },
    Q: parseUnixTimestamp,
    s: parseUnixTimestampSeconds,
    S: parseSeconds,
    u: parseWeekdayNumberMonday,
    U: parseWeekNumberSunday,
    V: parseWeekNumberISO,
    w: parseWeekdayNumberSunday,
    W: parseWeekNumberMonday,
    x: function x(e, t, r) {
      return T(e, o, t, r);
    },
    X: function X(e, t, r) {
      return T(e, a, t, r);
    },
    y: parseYear,
    Y: parseFullYear,
    Z: parseZone,
    "%": parseLiteralPercent
  };

  function $(c, u) {
    return function (e) {
      var t,
          r,
          n,
          o = [],
          a = -1,
          i = 0,
          s = c.length;

      for (e instanceof Date || (e = new Date(+e)); ++a < s;) {
        37 === c.charCodeAt(a) && (o.push(c.slice(i, a)), null != (r = pads[t = c.charAt(++a)]) ? t = c.charAt(++a) : r = "e" === t ? " " : "0", (n = u[t]) && (t = n(e, r)), o.push(t), i = a + 1);
      }

      return o.push(c.slice(i, a)), o.join("");
    };
  }

  function S(o, a) {
    return function (e) {
      var t,
          r,
          n = newYear(1900);
      if (T(n, o, e += "", 0) != e.length) return null;
      if ("Q" in n) return new Date(n.Q);

      if ("p" in n && (n.H = n.H % 12 + 12 * n.p), "V" in n) {
        if (n.V < 1 || 53 < n.V) return null;
        "w" in n || (n.w = 1), n.d = "Z" in n ? (t = 4 < (r = (t = utcDate(newYear(n.y))).getUTCDay()) || 0 === r ? utcMonday.ceil(t) : utcMonday(t), t = utcDay.offset(t, 7 * (n.V - 1)), n.y = t.getUTCFullYear(), n.m = t.getUTCMonth(), t.getUTCDate() + (n.w + 6) % 7) : (t = 4 < (r = (t = a(newYear(n.y))).getDay()) || 0 === r ? monday.ceil(t) : monday(t), t = day.offset(t, 7 * (n.V - 1)), n.y = t.getFullYear(), n.m = t.getMonth(), t.getDate() + (n.w + 6) % 7);
      } else ("W" in n || "U" in n) && ("w" in n || (n.w = "u" in n ? n.u % 7 : "W" in n ? 1 : 0), r = "Z" in n ? utcDate(newYear(n.y)).getUTCDay() : a(newYear(n.y)).getDay(), n.m = 0, n.d = "W" in n ? (n.w + 6) % 7 + 7 * n.W - (r + 5) % 7 : n.w + 7 * n.U - (r + 6) % 7);

      return "Z" in n ? (n.H += n.Z / 100 | 0, n.M += n.Z % 100, utcDate(n)) : a(n);
    };
  }

  function T(e, t, r, n) {
    for (var o, a, i = 0, s = t.length, c = r.length; i < s;) {
      if (c <= n) return -1;

      if (37 === (o = t.charCodeAt(i++))) {
        if (o = t.charAt(i++), !(a = w[o in pads ? t.charAt(i++) : o]) || (n = a(e, r, n)) < 0) return -1;
      } else if (o != r.charCodeAt(n++)) return -1;
    }

    return n;
  }

  return g.x = $(o, g), g.X = $(a, g), g.c = $(n, g), _.x = $(o, _), _.X = $(a, _), _.c = $(n, _), {
    format: function format(e) {
      var t = $(e += "", g);
      return t.toString = function () {
        return e;
      }, t;
    },
    parse: function parse(e) {
      var t = S(e += "", localDate);
      return t.toString = function () {
        return e;
      }, t;
    },
    utcFormat: function utcFormat(e) {
      var t = $(e += "", _);
      return t.toString = function () {
        return e;
      }, t;
    },
    utcParse: function utcParse(e) {
      var t = S(e, utcDate);
      return t.toString = function () {
        return e;
      }, t;
    }
  };
}

var locale$1,
    timeFormat,
    timeParse,
    utcFormat,
    utcParse,
    pads = {
  "-": "",
  _: " ",
  0: "0"
},
    numberRe = /^\s*\d+/,
    percentRe = /^%/,
    requoteRe = /[\\^$*+?|[\]().{}]/g;

function pad$1(e, t, r) {
  var n = e < 0 ? "-" : "",
      o = (n ? -e : e) + "",
      a = o.length;
  return n + (a < r ? new Array(r - a + 1).join(t) + o : o);
}

function requote(e) {
  return e.replace(requoteRe, "\\$&");
}

function formatRe(e) {
  return new RegExp("^(?:" + e.map(requote).join("|") + ")", "i");
}

function formatLookup(e) {
  for (var t = {}, r = -1, n = e.length; ++r < n;) {
    t[e[r].toLowerCase()] = r;
  }

  return t;
}

function parseWeekdayNumberSunday(e, t, r) {
  var n = numberRe.exec(t.slice(r, r + 1));
  return n ? (e.w = +n[0], r + n[0].length) : -1;
}

function parseWeekdayNumberMonday(e, t, r) {
  var n = numberRe.exec(t.slice(r, r + 1));
  return n ? (e.u = +n[0], r + n[0].length) : -1;
}

function parseWeekNumberSunday(e, t, r) {
  var n = numberRe.exec(t.slice(r, r + 2));
  return n ? (e.U = +n[0], r + n[0].length) : -1;
}

function parseWeekNumberISO(e, t, r) {
  var n = numberRe.exec(t.slice(r, r + 2));
  return n ? (e.V = +n[0], r + n[0].length) : -1;
}

function parseWeekNumberMonday(e, t, r) {
  var n = numberRe.exec(t.slice(r, r + 2));
  return n ? (e.W = +n[0], r + n[0].length) : -1;
}

function parseFullYear(e, t, r) {
  var n = numberRe.exec(t.slice(r, r + 4));
  return n ? (e.y = +n[0], r + n[0].length) : -1;
}

function parseYear(e, t, r) {
  var n = numberRe.exec(t.slice(r, r + 2));
  return n ? (e.y = +n[0] + (68 < +n[0] ? 1900 : 2e3), r + n[0].length) : -1;
}

function parseZone(e, t, r) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(r, r + 6));
  return n ? (e.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), r + n[0].length) : -1;
}

function parseMonthNumber(e, t, r) {
  var n = numberRe.exec(t.slice(r, r + 2));
  return n ? (e.m = n[0] - 1, r + n[0].length) : -1;
}

function parseDayOfMonth(e, t, r) {
  var n = numberRe.exec(t.slice(r, r + 2));
  return n ? (e.d = +n[0], r + n[0].length) : -1;
}

function parseDayOfYear(e, t, r) {
  var n = numberRe.exec(t.slice(r, r + 3));
  return n ? (e.m = 0, e.d = +n[0], r + n[0].length) : -1;
}

function parseHour24(e, t, r) {
  var n = numberRe.exec(t.slice(r, r + 2));
  return n ? (e.H = +n[0], r + n[0].length) : -1;
}

function parseMinutes(e, t, r) {
  var n = numberRe.exec(t.slice(r, r + 2));
  return n ? (e.M = +n[0], r + n[0].length) : -1;
}

function parseSeconds(e, t, r) {
  var n = numberRe.exec(t.slice(r, r + 2));
  return n ? (e.S = +n[0], r + n[0].length) : -1;
}

function parseMilliseconds(e, t, r) {
  var n = numberRe.exec(t.slice(r, r + 3));
  return n ? (e.L = +n[0], r + n[0].length) : -1;
}

function parseMicroseconds(e, t, r) {
  var n = numberRe.exec(t.slice(r, r + 6));
  return n ? (e.L = Math.floor(n[0] / 1e3), r + n[0].length) : -1;
}

function parseLiteralPercent(e, t, r) {
  var n = percentRe.exec(t.slice(r, r + 1));
  return n ? r + n[0].length : -1;
}

function parseUnixTimestamp(e, t, r) {
  var n = numberRe.exec(t.slice(r));
  return n ? (e.Q = +n[0], r + n[0].length) : -1;
}

function parseUnixTimestampSeconds(e, t, r) {
  var n = numberRe.exec(t.slice(r));
  return n ? (e.Q = 1e3 * +n[0], r + n[0].length) : -1;
}

function formatDayOfMonth(e, t) {
  return pad$1(e.getDate(), t, 2);
}

function formatHour24(e, t) {
  return pad$1(e.getHours(), t, 2);
}

function formatHour12(e, t) {
  return pad$1(e.getHours() % 12 || 12, t, 2);
}

function formatDayOfYear(e, t) {
  return pad$1(1 + day.count(year(e), e), t, 3);
}

function formatMilliseconds(e, t) {
  return pad$1(e.getMilliseconds(), t, 3);
}

function formatMicroseconds(e, t) {
  return formatMilliseconds(e, t) + "000";
}

function formatMonthNumber(e, t) {
  return pad$1(e.getMonth() + 1, t, 2);
}

function formatMinutes(e, t) {
  return pad$1(e.getMinutes(), t, 2);
}

function formatSeconds(e, t) {
  return pad$1(e.getSeconds(), t, 2);
}

function formatWeekdayNumberMonday(e) {
  var t = e.getDay();
  return 0 === t ? 7 : t;
}

function formatWeekNumberSunday(e, t) {
  return pad$1(sunday.count(year(e), e), t, 2);
}

function formatWeekNumberISO(e, t) {
  var r = e.getDay();
  return e = 4 <= r || 0 === r ? thursday(e) : thursday.ceil(e), pad$1(thursday.count(year(e), e) + (4 === year(e).getDay()), t, 2);
}

function formatWeekdayNumberSunday(e) {
  return e.getDay();
}

function formatWeekNumberMonday(e, t) {
  return pad$1(monday.count(year(e), e), t, 2);
}

function formatYear$1(e, t) {
  return pad$1(e.getFullYear() % 100, t, 2);
}

function formatFullYear(e, t) {
  return pad$1(e.getFullYear() % 1e4, t, 4);
}

function formatZone(e) {
  var t = e.getTimezoneOffset();
  return (0 < t ? "-" : (t *= -1, "+")) + pad$1(t / 60 | 0, "0", 2) + pad$1(t % 60, "0", 2);
}

function formatUTCDayOfMonth(e, t) {
  return pad$1(e.getUTCDate(), t, 2);
}

function formatUTCHour24(e, t) {
  return pad$1(e.getUTCHours(), t, 2);
}

function formatUTCHour12(e, t) {
  return pad$1(e.getUTCHours() % 12 || 12, t, 2);
}

function formatUTCDayOfYear(e, t) {
  return pad$1(1 + utcDay.count(utcYear(e), e), t, 3);
}

function formatUTCMilliseconds(e, t) {
  return pad$1(e.getUTCMilliseconds(), t, 3);
}

function formatUTCMicroseconds(e, t) {
  return formatUTCMilliseconds(e, t) + "000";
}

function formatUTCMonthNumber(e, t) {
  return pad$1(e.getUTCMonth() + 1, t, 2);
}

function formatUTCMinutes(e, t) {
  return pad$1(e.getUTCMinutes(), t, 2);
}

function formatUTCSeconds(e, t) {
  return pad$1(e.getUTCSeconds(), t, 2);
}

function formatUTCWeekdayNumberMonday(e) {
  var t = e.getUTCDay();
  return 0 === t ? 7 : t;
}

function formatUTCWeekNumberSunday(e, t) {
  return pad$1(utcSunday.count(utcYear(e), e), t, 2);
}

function formatUTCWeekNumberISO(e, t) {
  var r = e.getUTCDay();
  return e = 4 <= r || 0 === r ? utcThursday(e) : utcThursday.ceil(e), pad$1(utcThursday.count(utcYear(e), e) + (4 === utcYear(e).getUTCDay()), t, 2);
}

function formatUTCWeekdayNumberSunday(e) {
  return e.getUTCDay();
}

function formatUTCWeekNumberMonday(e, t) {
  return pad$1(utcMonday.count(utcYear(e), e), t, 2);
}

function formatUTCYear(e, t) {
  return pad$1(e.getUTCFullYear() % 100, t, 2);
}

function formatUTCFullYear(e, t) {
  return pad$1(e.getUTCFullYear() % 1e4, t, 4);
}

function formatUTCZone() {
  return "+0000";
}

function formatLiteralPercent() {
  return "%";
}

function formatUnixTimestamp(e) {
  return +e;
}

function formatUnixTimestampSeconds(e) {
  return Math.floor(+e / 1e3);
}

function defaultLocale$1(e) {
  return locale$1 = formatLocale$1(e), timeFormat = locale$1.format, timeParse = locale$1.parse, utcFormat = locale$1.utcFormat, utcParse = locale$1.utcParse, locale$1;
}

defaultLocale$1({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";

function formatIsoNative(e) {
  return e.toISOString();
}

var formatIso = Date.prototype.toISOString ? formatIsoNative : utcFormat(isoSpecifier);

function parseIsoNative(e) {
  var t = new Date(e);
  return isNaN(t) ? null : t;
}

var parseIso = +new Date("2000-01-01T00:00:00.000Z") ? parseIsoNative : utcParse(isoSpecifier);

function colors(e) {
  for (var t = e.length / 6 | 0, r = new Array(t), n = 0; n < t;) {
    r[n] = "#" + e.slice(6 * n, 6 * ++n);
  }

  return r;
}

function ramp(e) {
  return rgbBasis(e[e.length - 1]);
}

colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"), colors("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666"), colors("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666"), colors("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928"), colors("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2"), colors("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc"), colors("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999"), colors("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3"), colors("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");
var scheme = new Array(3).concat("d8b365f5f5f55ab4ac", "a6611adfc27d80cdc1018571", "a6611adfc27df5f5f580cdc1018571", "8c510ad8b365f6e8c3c7eae55ab4ac01665e", "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e", "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e", "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e", "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30", "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30").map(colors);
ramp(scheme);
var scheme$1 = new Array(3).concat("af8dc3f7f7f77fbf7b", "7b3294c2a5cfa6dba0008837", "7b3294c2a5cff7f7f7a6dba0008837", "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837", "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837", "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837", "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837", "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b", "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b").map(colors);
ramp(scheme$1);
var scheme$2 = new Array(3).concat("e9a3c9f7f7f7a1d76a", "d01c8bf1b6dab8e1864dac26", "d01c8bf1b6daf7f7f7b8e1864dac26", "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221", "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221", "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221", "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221", "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419", "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419").map(colors);
ramp(scheme$2);
var scheme$3 = new Array(3).concat("998ec3f7f7f7f1a340", "5e3c99b2abd2fdb863e66101", "5e3c99b2abd2f7f7f7fdb863e66101", "542788998ec3d8daebfee0b6f1a340b35806", "542788998ec3d8daebf7f7f7fee0b6f1a340b35806", "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806", "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806", "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08", "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08").map(colors);
ramp(scheme$3);
var scheme$4 = new Array(3).concat("ef8a62f7f7f767a9cf", "ca0020f4a58292c5de0571b0", "ca0020f4a582f7f7f792c5de0571b0", "b2182bef8a62fddbc7d1e5f067a9cf2166ac", "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac", "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac", "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac", "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061", "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061").map(colors);
ramp(scheme$4);
var scheme$5 = new Array(3).concat("ef8a62ffffff999999", "ca0020f4a582bababa404040", "ca0020f4a582ffffffbababa404040", "b2182bef8a62fddbc7e0e0e09999994d4d4d", "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d", "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d", "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d", "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a", "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a").map(colors);
ramp(scheme$5);
var scheme$6 = new Array(3).concat("fc8d59ffffbf91bfdb", "d7191cfdae61abd9e92c7bb6", "d7191cfdae61ffffbfabd9e92c7bb6", "d73027fc8d59fee090e0f3f891bfdb4575b4", "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4", "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4", "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4", "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695", "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695").map(colors);
ramp(scheme$6);
var scheme$7 = new Array(3).concat("fc8d59ffffbf91cf60", "d7191cfdae61a6d96a1a9641", "d7191cfdae61ffffbfa6d96a1a9641", "d73027fc8d59fee08bd9ef8b91cf601a9850", "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850", "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850", "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850", "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837", "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837").map(colors);
ramp(scheme$7);
var scheme$8 = new Array(3).concat("fc8d59ffffbf99d594", "d7191cfdae61abdda42b83ba", "d7191cfdae61ffffbfabdda42b83ba", "d53e4ffc8d59fee08be6f59899d5943288bd", "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd", "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd", "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd", "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2", "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2").map(colors);
ramp(scheme$8);
var scheme$9 = new Array(3).concat("e5f5f999d8c92ca25f", "edf8fbb2e2e266c2a4238b45", "edf8fbb2e2e266c2a42ca25f006d2c", "edf8fbccece699d8c966c2a42ca25f006d2c", "edf8fbccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b").map(colors);
ramp(scheme$9);
var scheme$a = new Array(3).concat("e0ecf49ebcda8856a7", "edf8fbb3cde38c96c688419d", "edf8fbb3cde38c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b").map(colors);
ramp(scheme$a);
var scheme$b = new Array(3).concat("e0f3dba8ddb543a2ca", "f0f9e8bae4bc7bccc42b8cbe", "f0f9e8bae4bc7bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081").map(colors);
ramp(scheme$b);
var scheme$c = new Array(3).concat("fee8c8fdbb84e34a33", "fef0d9fdcc8afc8d59d7301f", "fef0d9fdcc8afc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000").map(colors);
ramp(scheme$c);
var scheme$d = new Array(3).concat("ece2f0a6bddb1c9099", "f6eff7bdc9e167a9cf02818a", "f6eff7bdc9e167a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636").map(colors);
ramp(scheme$d);
var scheme$e = new Array(3).concat("ece7f2a6bddb2b8cbe", "f1eef6bdc9e174a9cf0570b0", "f1eef6bdc9e174a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858").map(colors);
ramp(scheme$e);
var scheme$f = new Array(3).concat("e7e1efc994c7dd1c77", "f1eef6d7b5d8df65b0ce1256", "f1eef6d7b5d8df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f").map(colors);
ramp(scheme$f);
var scheme$g = new Array(3).concat("fde0ddfa9fb5c51b8a", "feebe2fbb4b9f768a1ae017e", "feebe2fbb4b9f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a").map(colors);
ramp(scheme$g);
var scheme$h = new Array(3).concat("edf8b17fcdbb2c7fb8", "ffffcca1dab441b6c4225ea8", "ffffcca1dab441b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58").map(colors);
ramp(scheme$h);
var scheme$i = new Array(3).concat("f7fcb9addd8e31a354", "ffffccc2e69978c679238443", "ffffccc2e69978c67931a354006837", "ffffccd9f0a3addd8e78c67931a354006837", "ffffccd9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529").map(colors);
ramp(scheme$i);
var scheme$j = new Array(3).concat("fff7bcfec44fd95f0e", "ffffd4fed98efe9929cc4c02", "ffffd4fed98efe9929d95f0e993404", "ffffd4fee391fec44ffe9929d95f0e993404", "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506").map(colors);
ramp(scheme$j);
var scheme$k = new Array(3).concat("ffeda0feb24cf03b20", "ffffb2fecc5cfd8d3ce31a1c", "ffffb2fecc5cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026").map(colors);
ramp(scheme$k);
var scheme$l = new Array(3).concat("deebf79ecae13182bd", "eff3ffbdd7e76baed62171b5", "eff3ffbdd7e76baed63182bd08519c", "eff3ffc6dbef9ecae16baed63182bd08519c", "eff3ffc6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b").map(colors);
ramp(scheme$l);
var scheme$m = new Array(3).concat("e5f5e0a1d99b31a354", "edf8e9bae4b374c476238b45", "edf8e9bae4b374c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b").map(colors);
ramp(scheme$m);
var scheme$n = new Array(3).concat("f0f0f0bdbdbd636363", "f7f7f7cccccc969696525252", "f7f7f7cccccc969696636363252525", "f7f7f7d9d9d9bdbdbd969696636363252525", "f7f7f7d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000").map(colors);
ramp(scheme$n);
var scheme$o = new Array(3).concat("efedf5bcbddc756bb1", "f2f0f7cbc9e29e9ac86a51a3", "f2f0f7cbc9e29e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d").map(colors);
ramp(scheme$o);
var scheme$p = new Array(3).concat("fee0d2fc9272de2d26", "fee5d9fcae91fb6a4acb181d", "fee5d9fcae91fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d").map(colors);
ramp(scheme$p);
var scheme$q = new Array(3).concat("fee6cefdae6be6550d", "feeddefdbe85fd8d3cd94701", "feeddefdbe85fd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704").map(colors);
ramp(scheme$q), cubehelixLong(cubehelix(300, .5, 0), cubehelix(-240, .5, 1));
var warm = cubehelixLong(cubehelix(-100, .75, .35), cubehelix(80, 1.5, .8)),
    cool = cubehelixLong(cubehelix(260, .75, .35), cubehelix(80, 1.5, .8)),
    c = cubehelix(),
    c$1 = rgb(),
    pi_1_3 = Math.PI / 3,
    pi_2_3 = 2 * Math.PI / 3;

function ramp$1(t) {
  var r = t.length;
  return function (e) {
    return t[Math.max(0, Math.min(r - 1, Math.floor(e * r)))];
  };
}

ramp$1(colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var magma = ramp$1(colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf")),
    inferno = ramp$1(colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4")),
    plasma = ramp$1(colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));

function constant$3(e) {
  return function () {
    return e;
  };
}

var epsilon$1 = 1e-12,
    pi$4 = Math.PI;

function Linear(e) {
  this._context = e;
}

function curveLinear(e) {
  return new Linear(e);
}

function x$1(e) {
  return e[0];
}

function y$1(e) {
  return e[1];
}

function line() {
  var i = x$1,
      s = y$1,
      c = constant$3(!0),
      u = null,
      l = curveLinear,
      f = null;

  function t(e) {
    var t,
        r,
        n,
        o = e.length,
        a = !1;

    for (null == u && (f = l(n = path$1())), t = 0; t <= o; ++t) {
      !(t < o && c(r = e[t], t, e)) === a && ((a = !a) ? f.lineStart() : f.lineEnd()), a && f.point(+i(r, t, e), +s(r, t, e));
    }

    if (n) return f = null, n + "" || null;
  }

  return t.x = function (e) {
    return arguments.length ? (i = "function" == typeof e ? e : constant$3(+e), t) : i;
  }, t.y = function (e) {
    return arguments.length ? (s = "function" == typeof e ? e : constant$3(+e), t) : s;
  }, t.defined = function (e) {
    return arguments.length ? (c = "function" == typeof e ? e : constant$3(!!e), t) : c;
  }, t.curve = function (e) {
    return arguments.length ? (l = e, null != u && (f = l(u)), t) : l;
  }, t.context = function (e) {
    return arguments.length ? (null == e ? u = f = null : f = l(u = e), t) : u;
  }, t;
}

function _point(e, t, r) {
  e._context.bezierCurveTo(e._x1 + e._k * (e._x2 - e._x0), e._y1 + e._k * (e._y2 - e._y0), e._x2 + e._k * (e._x1 - t), e._y2 + e._k * (e._y1 - r), e._x2, e._y2);
}

function Cardinal(e, t) {
  this._context = e, this._k = (1 - t) / 6;
}

function point$1(e, t, r) {
  var n = e._x1,
      o = e._y1,
      a = e._x2,
      i = e._y2;

  if (e._l01_a > epsilon$1) {
    var s = 2 * e._l01_2a + 3 * e._l01_a * e._l12_a + e._l12_2a,
        c = 3 * e._l01_a * (e._l01_a + e._l12_a);
    n = (n * s - e._x0 * e._l12_2a + e._x2 * e._l01_2a) / c, o = (o * s - e._y0 * e._l12_2a + e._y2 * e._l01_2a) / c;
  }

  if (e._l23_a > epsilon$1) {
    var u = 2 * e._l23_2a + 3 * e._l23_a * e._l12_a + e._l12_2a,
        l = 3 * e._l23_a * (e._l23_a + e._l12_a);
    a = (a * u + e._x1 * e._l23_2a - t * e._l12_2a) / l, i = (i * u + e._y1 * e._l23_2a - r * e._l12_2a) / l;
  }

  e._context.bezierCurveTo(n, o, a, i, e._x2, e._y2);
}

function CatmullRom(e, t) {
  this._context = e, this._alpha = t;
}

Linear.prototype = {
  areaStart: function areaStart() {
    this._line = 0;
  },
  areaEnd: function areaEnd() {
    this._line = NaN;
  },
  lineStart: function lineStart() {
    this._point = 0;
  },
  lineEnd: function lineEnd() {
    (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function point(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;

      case 1:
        this._point = 2;

      default:
        this._context.lineTo(e, t);

    }
  }
}, Cardinal.prototype = {
  areaStart: function areaStart() {
    this._line = 0;
  },
  areaEnd: function areaEnd() {
    this._line = NaN;
  },
  lineStart: function lineStart() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
  },
  lineEnd: function lineEnd() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);

        break;

      case 3:
        _point(this, this._x1, this._y1);

    }

    (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function point(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;

      case 1:
        this._point = 2, this._x1 = e, this._y1 = t;
        break;

      case 2:
        this._point = 3;

      default:
        _point(this, e, t);

    }

    this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
}, CatmullRom.prototype = {
  areaStart: function areaStart() {
    this._line = 0;
  },
  areaEnd: function areaEnd() {
    this._line = NaN;
  },
  lineStart: function lineStart() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function lineEnd() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);

        break;

      case 3:
        this.point(this._x2, this._y2);
    }

    (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function point(e, t) {
    if (e = +e, t = +t, this._point) {
      var r = this._x2 - e,
          n = this._y2 - t;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(r * r + n * n, this._alpha));
    }

    switch (this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;

      case 1:
        this._point = 2;
        break;

      case 2:
        this._point = 3;

      default:
        point$1(this, e, t);
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};

var catmullRom = function t(r) {
  function e(e) {
    return r ? new CatmullRom(e, r) : new Cardinal(e, 0);
  }

  return e.alpha = function (e) {
    return t(+e);
  }, e;
}(.5);

function sign$1(e) {
  return e < 0 ? -1 : 1;
}

function slope3(e, t, r) {
  var n = e._x1 - e._x0,
      o = t - e._x1,
      a = (e._y1 - e._y0) / (n || o < 0 && -0),
      i = (r - e._y1) / (o || n < 0 && -0),
      s = (a * o + i * n) / (n + o);
  return (sign$1(a) + sign$1(i)) * Math.min(Math.abs(a), Math.abs(i), .5 * Math.abs(s)) || 0;
}

function slope2(e, t) {
  var r = e._x1 - e._x0;
  return r ? (3 * (e._y1 - e._y0) / r - t) / 2 : t;
}

function point$2(e, t, r) {
  var n = e._x0,
      o = e._y0,
      a = e._x1,
      i = e._y1,
      s = (a - n) / 3;

  e._context.bezierCurveTo(n + s, o + s * t, a - s, i - s * r, a, i);
}

function MonotoneX(e) {
  this._context = e;
}

function MonotoneY(e) {
  this._context = new ReflectContext(e);
}

function ReflectContext(e) {
  this._context = e;
}

MonotoneX.prototype = {
  areaStart: function areaStart() {
    this._line = 0;
  },
  areaEnd: function areaEnd() {
    this._line = NaN;
  },
  lineStart: function lineStart() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function lineEnd() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);

        break;

      case 3:
        point$2(this, this._t0, slope2(this, this._t0));
    }

    (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function point(e, t) {
    var r = NaN;

    if (t = +t, (e = +e) !== this._x1 || t !== this._y1) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
          break;

        case 1:
          this._point = 2;
          break;

        case 2:
          this._point = 3, point$2(this, slope2(this, r = slope3(this, e, t)), r);
          break;

        default:
          point$2(this, this._t0, r = slope3(this, e, t));
      }

      this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t, this._t0 = r;
    }
  }
}, (MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function (e, t) {
  MonotoneX.prototype.point.call(this, t, e);
}, ReflectContext.prototype = {
  moveTo: function moveTo(e, t) {
    this._context.moveTo(t, e);
  },
  closePath: function closePath() {
    this._context.closePath();
  },
  lineTo: function lineTo(e, t) {
    this._context.lineTo(t, e);
  },
  bezierCurveTo: function bezierCurveTo(e, t, r, n, o, a) {
    this._context.bezierCurveTo(t, e, n, r, a, o);
  }
};

var getEcgCoordinatesByHexString = function getEcgCoordinatesByHexString(e) {
  for (var t = e.hexString, r = [], n = t.length - 8, o = 0, a = 0; a < n; a += 4) {
    var i = t.substring(a + 2, a + 4) + t.substring(a, a + 2),
        s = t.substring(a + 6, a + 8) + t.substring(a + 4, a + 6),
        c = parseInt(i, 16),
        u = parseInt(s, 16);
    32768 <= c && (c -= 65536), 32768 <= u && (u -= 65536);
    var l = 4033 * ((c + u) / 2) / 3145632;
    r.push({
      x: o += 1,
      y: l
    });
  }

  return r;
},
    s$f = {
  scaleExample: "styles-module_scaleExample__2kGCi",
  ecgWrapper: "styles-module_ecgWrapper__U_wii",
  ecgChartWrapper: "styles-module_ecgChartWrapper__KSk8x",
  axis: "styles-module_axis__22jto",
  "axis-labels": "styles-module_axis-labels__3KFLq",
  middleLine: "styles-module_middleLine__sNKBF",
  mainLine: "styles-module_mainLine__20wyS",
  gridline: "styles-module_gridline__3ZfQi",
  gridWrapper: "styles-module_gridWrapper__3-7mt"
},
    EcgChart = function (e) {
  function p() {
    return classCallCheck(this, p), possibleConstructorReturn(this, getPrototypeOf(p).apply(this, arguments));
  }

  return inherits(p, react_1), createClass(p, [{
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.hexString,
          r = e.className,
          n = e.showScale,
          o = e.heightUp,
          a = e.heightDown,
          i = getEcgCoordinatesByHexString({
        hexString: t
      }),
          s = o + a,
          c = i.length,
          u = linear$1().domain(extent(i, function (e) {
        return e.x;
      })).range([0, c]),
          l = linear$1().domain([-a, o]).range([s, 0]),
          f = line().x(function (e) {
        return u(e.x);
      }).y(function (e) {
        return l(100 * e.y);
      }).curve(catmullRom.alpha(.5));
      return react.createElement("div", {
        className: classnames(s$f.ecgWrapper, r)
      }, n && react.createElement("div", {
        className: s$f.scaleExample
      }, react.createElement("svg", {
        width: 65,
        height: s
      }, react.createElement("polyline", {
        points: "05,".concat(o, "\n                        15,").concat(o, "\n                        15,").concat(o - 100, "\n                        55,").concat(o - 100, "\n                        55,").concat(o, "\n                        65,").concat(o)
      }), react.createElement("text", {
        x: "10",
        y: o + 30
      }, "1mv"))), react.createElement("div", {
        className: s$f.ecgChartWrapper,
        height: s
      }, react.createElement("svg", {
        width: c,
        height: s
      }, react.createElement("g", {
        className: s$f["axis-labels"]
      }, p.getVerticalLines(u, c, s)), react.createElement("g", {
        className: s$f["axis-labels"]
      }, p.getHorizontalLines(l, c, o, a)), react.createElement("path", {
        d: f(i)
      }))));
    }
  }], [{
    key: "getHorizontalLines",
    value: function value(e, t, r, n) {
      for (var o = [], a = r + n, i = 10; i <= r; i += 10) {
        var s;
        o.push(react.createElement("g", {
          key: i,
          transform: "translate(0,".concat(r - i, ")"),
          className: classnames((s = {}, defineProperty(s, s$f.middleLine, !(i % 50)), defineProperty(s, s$f.mainLine, !(i % 200)), s))
        }, react.createElement("line", {
          className: s$f.gridlineUp,
          x1: 0,
          x2: t + 10,
          y1: 0,
          y2: 0,
          transform: "translate(-5,0)"
        })));
      }

      for (var c = 0; c <= n; c += 10) {
        var u;
        o.push(react.createElement("g", {
          key: c + a,
          transform: "translate(0,".concat(c + r, ")"),
          className: classnames((u = {}, defineProperty(u, s$f.middleLine, !(c % 50)), defineProperty(u, s$f.mainLine, !(c % 200) || 0 === c), u))
        }, react.createElement("line", {
          className: s$f.gridline,
          x1: 0,
          x2: t + 10,
          y1: 0,
          y2: 0,
          transform: "translate(-5,0)"
        })));
      }

      return o;
    }
  }, {
    key: "getVerticalLines",
    value: function value(e, t, r) {
      for (var n = [], o = 0; o <= t + 10; o += 10) {
        var a;
        n.push(react.createElement("g", {
          key: o,
          transform: "translate(".concat(o, ",").concat(r, ")"),
          className: classnames((a = {}, defineProperty(a, s$f.middleLine, !(o % 50)), defineProperty(a, s$f.mainLine, !(o % 250) || 0 === o), a))
        }, react.createElement("line", {
          x1: "0",
          x2: "0",
          y1: -r,
          y2: 0,
          transform: "translate(0,0)"
        })));
      }

      return n;
    }
  }]), p;
}();

defineProperty(EcgChart, "defaultProps", {
  className: null,
  showScale: !1,
  heightUp: 250,
  heightDown: 250
});

var s$g = {
  root: "styles-module_root__3iqRY"
},
    FieldError = function FieldError(e) {
  var t = e.children,
      r = e.className,
      n = objectWithoutProperties(e, ["children", "className"]);
  return react.createElement("div", _extends_1({
    className: classnames(s$g.root, r)
  }, n), t);
};

FieldError.defaultProps = {
  className: null
};

var s$h = {
  root: "styles-module_root__3IDir",
  margin: "styles-module_margin__2AO0J"
},
    Label = function Label(e) {
  var t = e.children,
      r = e.className,
      n = e.margin,
      o = e.required,
      a = objectWithoutProperties(e, ["children", "className", "margin", "required"]);
  return react.createElement("label", _extends_1({
    className: classnames(s$h.root, r, defineProperty({}, s$h.margin, n))
  }, a), t, o && "*");
};

Label.defaultProps = {
  className: null,
  margin: !1,
  required: !1
};

var s$i = {
  root: "styles-module_root__3oUcc"
},
    FieldBase = function FieldBase(e) {
  var t = e.children,
      r = e.formComponent,
      n = e.errorClassName,
      o = e.label,
      a = e.className,
      i = e.wrapperClassName,
      s = e.meta,
      c = s.touched,
      u = s.error,
      l = objectWithoutProperties(e, ["children", "formComponent", "errorClassName", "label", "className", "wrapperClassName", "meta"]);
  return react.createElement("div", {
    className: classnames(s$i.root, i, a)
  }, o && react.createElement(Label, {
    margin: !0
  }, o), react.createElement(r, _extends_1({
    error: !(!c || !u)
  }, l), t), !(!c || !u) && react.createElement(FieldError, {
    className: n
  }, u));
};

FieldBase.defaultProps = {
  children: null,
  errorClassName: null,
  className: null,
  label: null,
  meta: {},
  wrapperClassName: null
};

var s$j = {
  col: "styles-module_col__1h10W",
  flex: "styles-module_flex__2rOC- 1"
},
    FlexTableCol = function FlexTableCol(e) {
  var t = e.basis,
      r = e.flex,
      n = e.children,
      o = e.padding,
      a = e.className,
      i = objectWithoutProperties(e, ["basis", "flex", "children", "padding", "className"]);
  return react.createElement("div", _extends_1({}, i, {
    className: classnames(s$j.col, a, defineProperty({}, s$j.flex, r)),
    style: {
      padding: o,
      flexBasis: t,
      flexGrow: t || 1,
      minWidth: t
    }
  }), n);
};

FlexTableCol.defaultProps = {
  basis: void 0,
  flex: !1,
  padding: "",
  className: void 0,
  style: {}
};

var s$k = {
  row: "styles-module_row__3yHhB",
  default: "styles-module_default__19QD9",
  gray: "styles-module_gray__EHL0t",
  primary: "styles-module_primary__Iud3e",
  heading: "styles-module_heading__16rIS"
},
    FlexTableRow = function FlexTableRow(e) {
  var t = e.children,
      r = e.className,
      n = e.component,
      o = e.padding,
      a = e.heading,
      i = e.variant,
      s = objectWithoutProperties(e, ["children", "className", "component", "padding", "heading", "variant"]);
  return react.createElement(n, _extends_1({
    style: {
      padding: o
    },
    className: classnames(r, s$k.row, s$k[i], defineProperty({}, s$k.heading, a))
  }, s), t);
};

FlexTableRow.defaultProps = {
  className: null,
  children: null,
  component: "div",
  padding: "0 1.118rem",
  heading: !1,
  variant: "default"
};

var s$l = {
  formWrapper: "styles-module_formWrapper__2atzN",
  title: "styles-module_title__2bsFF"
},
    FormWrapper = function FormWrapper(e) {
  var t = e.children,
      r = e.className,
      n = e.title,
      o = objectWithoutProperties(e, ["children", "className", "title"]);
  return react.createElement("div", _extends_1({
    className: classnames(s$l.formWrapper, r)
  }, o), n && react.createElement("div", {
    className: s$l.title
  }, n), t);
};

FormWrapper.defaultProps = {
  className: void 0,
  title: null
};

var style = {
  headerTitle: "headerTitle-module_headerTitle__3Zecv"
},
    HeaderTitle = function HeaderTitle(e) {
  var t = e.children;
  return react.createElement("h1", {
    className: style.headerTitle
  }, t);
},
    s$m = {
  label: "styles-module_label__3DUAe",
  labelWrap: "styles-module_labelWrap__3fgeh",
  icon: "styles-module_icon__Y_26I"
},
    s$n = {
  checkboxWrapper: "styles-module_checkboxWrapper__2qeDy"
},
    CheckboxWrapper = function CheckboxWrapper(e) {
  var t = e.children;
  return react.createElement("div", {
    className: s$n.checkboxWrapper
  }, t);
},
    s$o = {
  radioWrapper: "styles-module_radioWrapper__2YAK_"
},
    RadioWrapper = function RadioWrapper(e) {
  var t = e.children;
  return react.createElement("div", {
    className: s$o.radioWrapper
  }, t);
},
    s$p = {
  textContent: "styles-module_textContent__3rmPP"
},
    TextContent = function TextContent(e) {
  var t = e.children;
  return react.createElement("div", {
    className: s$p.textContent
  }, t);
},
    InlineFormRow = function InlineFormRow(e) {
  var t = e.children,
      r = e.icon,
      n = e.label,
      o = e.labelRequired,
      a = e.xs,
      i = objectWithoutProperties(e, ["children", "icon", "label", "labelRequired", "xs"]);
  return react.createElement(lib_4, i, react.createElement(lib_2, {
    xs: a
  }, react.createElement("div", {
    className: s$m.labelWrap
  }, r && react.createElement("div", {
    className: s$m.icon
  }, r), react.createElement(Label, {
    className: s$m.label,
    required: o
  }, n))), t);
};

InlineFormRow.defaultProps = {
  icon: null,
  labelRequired: !1,
  xs: 3
};

var s$q = {
  row: "styles-module_row__-cpwP",
  noHorizontalSpace: "styles-module_noHorizontalSpace__1Rr3o",
  col: "styles-module_col__2rsRS",
  titleIcon: "styles-module_titleIcon__1uYVg",
  wrap: "styles-module_wrap__2VouU",
  title: "styles-module_title__2gnT5"
},
    InfoRow = function InfoRow(e) {
  var t,
      r = e.children,
      n = e.className,
      o = e.icon,
      a = e.noHorizontalSpace,
      i = e.title,
      s = e.wrap,
      c = objectWithoutProperties(e, ["children", "className", "icon", "noHorizontalSpace", "title", "wrap"]);
  return react.createElement("div", _extends_1({
    className: classnames(s$q.row, n, (t = {}, defineProperty(t, s$q.noHorizontalSpace, a), defineProperty(t, s$q.wrap, s), t))
  }, c), react.createElement("div", {
    className: classnames(s$q.col, s$q.title)
  }, o && react.createElement("div", {
    className: s$q.titleIcon
  }, o), react.createElement("div", null, i)), react.createElement("div", {
    className: s$q.col
  }, r));
};

InfoRow.defaultProps = {
  icon: null,
  className: null,
  noHorizontalSpace: !1,
  wrap: !1
};

var s$r = {
  root: "styles-module_root__AFXnD",
  error: "styles-module_error__ksZze"
},
    Input = function Input(e) {
  var t = e.className,
      r = e.error,
      n = objectWithoutProperties(e, ["className", "error"]);
  return react.createElement("input", _extends_1({
    className: classnames(s$r.root, t, defineProperty({}, s$r.error, r))
  }, n));
};

Input.defaultProps = {
  className: null,
  error: !1,
  type: "text"
};

var s$s = {
  modalWrapper: "styles-module_modalWrapper__3QrOl",
  overlay: "styles-module_overlay__1tg65",
  modal: "styles-module_modal__3ImBF"
},
    Modal = function Modal(e) {
  var t = e.className,
      r = e.children,
      n = e.onClose,
      o = objectWithoutProperties(e, ["className", "children", "onClose"]);
  return react.createElement("div", _extends_1({
    className: classnames(s$s.modalWrapper, t)
  }, o), react.createElement("div", {
    className: s$s.overlay,
    onClick: n
  }), react.createElement("div", {
    className: s$s.modal,
    "data-test": "modal"
  }, r));
};

function _extends$1() {
  return (_extends$1 = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }

    return e;
  }).apply(this, arguments);
}

Modal.defaultProps = {
  className: null,
  onClose: void 0
};

var _ref$1 = react.createElement("path", {
  d: "M405 136.798L375.202 107 256 226.202 136.798 107 107 136.798 226.202 256 107 375.202 136.798 405 256 285.798 375.202 405 405 375.202 285.798 256z"
}),
    SvgClose = function SvgClose(e) {
  return react.createElement("svg", _extends$1({
    viewBox: "0 0 512 512"
  }, e), _ref$1);
},
    s$t = {
  notification: "styles-module_notification__3RnSk",
  title: "styles-module_title__2v3Ls",
  close: "styles-module_close__2r5gs",
  success: "styles-module_success__1UUZi",
  warning: "styles-module_warning__1GJjb",
  danger: "styles-module_danger__3hD-f"
},
    _ref2$1 = react.createElement(SvgClose, null),
    Notification = function Notification(e) {
  var t = e.children,
      r = e.onCloseClick,
      n = e.title,
      o = e.variant,
      a = objectWithoutProperties(e, ["children", "onCloseClick", "title", "variant"]);
  return react.createElement("div", _extends_1({
    className: classnames(s$t.notification, s$t[o])
  }, a), react.createElement("button", {
    className: s$t.close,
    onClick: r,
    type: "button"
  }, _ref2$1), react.createElement("div", {
    className: s$t.title
  }, n), t);
};

Notification.defaultProps = {
  children: null
};

var s$u = {
  container: "styles-module_container__2wxx8",
  tight: "styles-module_tight__2gRrE"
},
    PageWrapper = function PageWrapper(e) {
  var t = e.children,
      r = e.tight,
      n = objectWithoutProperties(e, ["children", "tight"]);
  return react.createElement(Container, _extends_1({
    className: classnames(s$u.container, defineProperty({}, s$u.tight, r))
  }, n), t);
};

PageWrapper.defaultProps = {
  tight: !1
};
var PageView_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var s = n(react),
      r = n(propTypes);

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var o = function o(e) {
    var t = e.pageClassName,
        r = e.pageLinkClassName,
        n = e.onClick,
        o = e.href,
        a = e.ariaLabel || "Page " + e.page + (e.extraAriaContext ? " " + e.extraAriaContext : ""),
        i = null;
    return e.selected && (i = "page", a = e.ariaLabel || "Page " + e.page + " is your current page", t = void 0 !== t ? t + " " + e.activeClassName : e.activeClassName, void 0 !== r ? void 0 !== e.activeLinkClassName && (r = r + " " + e.activeLinkClassName) : r = e.activeLinkClassName), s.default.createElement("li", {
      className: t
    }, s.default.createElement("a", {
      onClick: n,
      role: "button",
      className: r,
      href: o,
      tabIndex: "0",
      "aria-label": a,
      "aria-current": i,
      onKeyPress: n
    }, e.page));
  };

  o.propTypes = {
    onClick: r.default.func.isRequired,
    selected: r.default.bool.isRequired,
    pageClassName: r.default.string,
    pageLinkClassName: r.default.string,
    activeClassName: r.default.string,
    activeLinkClassName: r.default.string,
    extraAriaContext: r.default.string,
    href: r.default.string,
    ariaLabel: r.default.string,
    page: r.default.number.isRequired
  }, t.default = o;
});
unwrapExports(PageView_1);
var BreakView_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var i = n(react),
      r = n(propTypes);

  function n(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var o = function o(e) {
    var t = e.breakLabel,
        r = e.breakClassName,
        n = e.breakLinkClassName,
        o = e.onClick,
        a = r || "break";
    return i.default.createElement("li", {
      className: a
    }, i.default.createElement("a", {
      className: n,
      onClick: o,
      role: "button",
      tabIndex: "0",
      onKeyPress: o
    }, t));
  };

  o.propTypes = {
    breakLabel: r.default.oneOfType([r.default.string, r.default.node]),
    breakClassName: r.default.string,
    breakLinkClassName: r.default.string,
    onClick: r.default.func.isRequired
  }, t.default = o;
});
unwrapExports(BreakView_1);
var PaginationBoxView_1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var n = function () {
    function n(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    return function (e, t, r) {
      return t && n(e.prototype, t), r && n(e, r), e;
    };
  }(),
      b = o(react),
      r = o(propTypes),
      c = o(PageView_1),
      v = o(BreakView_1);

  function o(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var a = function (e) {
    function r(e) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, r);

      var m = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (r.__proto__ || Object.getPrototypeOf(r)).call(this, e));

      m.handlePreviousPage = function (e) {
        var t = m.state.selected;
        e.preventDefault ? e.preventDefault() : e.returnValue = !1, 0 < t && m.handlePageSelected(t - 1, e);
      }, m.handleNextPage = function (e) {
        var t = m.state.selected,
            r = m.props.pageCount;
        e.preventDefault ? e.preventDefault() : e.returnValue = !1, t < r - 1 && m.handlePageSelected(t + 1, e);
      }, m.handlePageSelected = function (e, t) {
        t.preventDefault ? t.preventDefault() : t.returnValue = !1, m.state.selected !== e && (m.setState({
          selected: e
        }), m.callCallback(e));
      }, m.handleBreakClick = function (e, t) {
        t.preventDefault ? t.preventDefault() : t.returnValue = !1;
        var r = m.state.selected;
        m.handlePageSelected(r < e ? m.getForwardJump() : m.getBackwardJump(), t);
      }, m.callCallback = function (e) {
        void 0 !== m.props.onPageChange && "function" == typeof m.props.onPageChange && m.props.onPageChange({
          selected: e
        });
      }, m.pagination = function () {
        var e = [],
            t = m.props,
            r = t.pageRangeDisplayed,
            n = t.pageCount,
            o = t.marginPagesDisplayed,
            a = t.breakLabel,
            i = t.breakClassName,
            s = t.breakLinkClassName,
            c = m.state.selected;
        if (n <= r) for (var u = 0; u < n; u++) {
          e.push(m.getPageElement(u));
        } else {
          var l = r / 2,
              f = r - l;
          n - r / 2 < c ? l = r - (f = n - c) : c < r / 2 && (f = r - (l = c));

          var p = void 0,
              d = void 0,
              h = void 0,
              y = function y(e) {
            return m.getPageElement(e);
          };

          for (p = 0; p < n; p++) {
            (d = p + 1) <= o ? e.push(y(p)) : n - o < d ? e.push(y(p)) : c - l <= p && p <= c + f ? e.push(y(p)) : a && e[e.length - 1] !== h && (h = b.default.createElement(v.default, {
              key: p,
              breakLabel: a,
              breakClassName: i,
              breakLinkClassName: s,
              onClick: m.handleBreakClick.bind(null, p)
            }), e.push(h));
          }
        }
        return e;
      };
      var t = void 0;
      return t = e.initialPage ? e.initialPage : e.forcePage ? e.forcePage : 0, m.state = {
        selected: t
      }, m;
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(r, react.Component), n(r, [{
      key: "componentDidMount",
      value: function value() {
        var e = this.props,
            t = e.initialPage,
            r = e.disableInitialCallback,
            n = e.extraAriaContext;
        void 0 === t || r || this.callCallback(t), n && console.warn("DEPRECATED (react-paginate): The extraAriaContext prop is deprecated. You should now use the ariaLabelBuilder instead.");
      }
    }, {
      key: "UNSAFE_componentWillReceiveProps",
      value: function value(e) {
        void 0 !== e.forcePage && this.props.forcePage !== e.forcePage && this.setState({
          selected: e.forcePage
        });
      }
    }, {
      key: "getForwardJump",
      value: function value() {
        var e = this.state.selected,
            t = this.props,
            r = t.pageCount,
            n = e + t.pageRangeDisplayed;
        return r <= n ? r - 1 : n;
      }
    }, {
      key: "getBackwardJump",
      value: function value() {
        var e = this.state.selected - this.props.pageRangeDisplayed;
        return e < 0 ? 0 : e;
      }
    }, {
      key: "hrefBuilder",
      value: function value(e) {
        var t = this.props,
            r = t.hrefBuilder,
            n = t.pageCount;
        if (r && e !== this.state.selected && 0 <= e && e < n) return r(e + 1);
      }
    }, {
      key: "ariaLabelBuilder",
      value: function value(e) {
        var t = e === this.state.selected;

        if (this.props.ariaLabelBuilder && 0 <= e && e < this.props.pageCount) {
          var r = this.props.ariaLabelBuilder(e + 1, t);
          return this.props.extraAriaContext && !t && (r = r + " " + this.props.extraAriaContext), r;
        }
      }
    }, {
      key: "getPageElement",
      value: function value(e) {
        var t = this.state.selected,
            r = this.props,
            n = r.pageClassName,
            o = r.pageLinkClassName,
            a = r.activeClassName,
            i = r.activeLinkClassName,
            s = r.extraAriaContext;
        return b.default.createElement(c.default, {
          key: e,
          onClick: this.handlePageSelected.bind(null, e),
          selected: t === e,
          pageClassName: n,
          pageLinkClassName: o,
          activeClassName: a,
          activeLinkClassName: i,
          extraAriaContext: s,
          href: this.hrefBuilder(e),
          ariaLabel: this.ariaLabelBuilder(e),
          page: e + 1
        });
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
            t = e.disabledClassName,
            r = e.previousClassName,
            n = e.nextClassName,
            o = e.pageCount,
            a = e.containerClassName,
            i = e.previousLinkClassName,
            s = e.previousLabel,
            c = e.nextLinkClassName,
            u = e.nextLabel,
            l = this.state.selected,
            f = r + (0 === l ? " " + t : ""),
            p = n + (l === o - 1 ? " " + t : ""),
            d = 0 === l ? "true" : "false",
            h = l === o - 1 ? "true" : "false";
        return b.default.createElement("ul", {
          className: a
        }, b.default.createElement("li", {
          className: f
        }, b.default.createElement("a", {
          onClick: this.handlePreviousPage,
          className: i,
          href: this.hrefBuilder(l - 1),
          tabIndex: "0",
          role: "button",
          onKeyPress: this.handlePreviousPage,
          "aria-disabled": d
        }, s)), this.pagination(), b.default.createElement("li", {
          className: p
        }, b.default.createElement("a", {
          onClick: this.handleNextPage,
          className: c,
          href: this.hrefBuilder(l + 1),
          tabIndex: "0",
          role: "button",
          onKeyPress: this.handleNextPage,
          "aria-disabled": h
        }, u)));
      }
    }]), r;
  }();

  a.propTypes = {
    pageCount: r.default.number.isRequired,
    pageRangeDisplayed: r.default.number.isRequired,
    marginPagesDisplayed: r.default.number.isRequired,
    previousLabel: r.default.node,
    nextLabel: r.default.node,
    breakLabel: r.default.oneOfType([r.default.string, r.default.node]),
    hrefBuilder: r.default.func,
    onPageChange: r.default.func,
    initialPage: r.default.number,
    forcePage: r.default.number,
    disableInitialCallback: r.default.bool,
    containerClassName: r.default.string,
    pageClassName: r.default.string,
    pageLinkClassName: r.default.string,
    activeClassName: r.default.string,
    activeLinkClassName: r.default.string,
    previousClassName: r.default.string,
    nextClassName: r.default.string,
    previousLinkClassName: r.default.string,
    nextLinkClassName: r.default.string,
    disabledClassName: r.default.string,
    breakClassName: r.default.string,
    breakLinkClassName: r.default.string,
    extraAriaContext: r.default.string,
    ariaLabelBuilder: r.default.func
  }, a.defaultProps = {
    pageCount: 10,
    pageRangeDisplayed: 2,
    marginPagesDisplayed: 3,
    activeClassName: "selected",
    previousClassName: "previous",
    nextClassName: "next",
    previousLabel: "Previous",
    nextLabel: "Next",
    breakLabel: "...",
    disabledClassName: "disabled",
    disableInitialCallback: !1
  }, t.default = a;
});
unwrapExports(PaginationBoxView_1);
var dist$1 = createCommonjsModule(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r,
      n = (r = PaginationBoxView_1) && r.__esModule ? r : {
    default: r
  };
  t.default = n.default;
}),
    ReactPaginate = unwrapExports(dist$1);

function _extends$2() {
  return (_extends$2 = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }

    return e;
  }).apply(this, arguments);
}

var _ref$2 = react.createElement("path", {
  fill: "currentColor",
  d: "M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
}),
    SvgChevronLeftSolid = function SvgChevronLeftSolid(e) {
  return react.createElement("svg", _extends$2({
    "aria-hidden": "true",
    "data-prefix": "fas",
    "data-icon": "chevron-left",
    className: "chevron-left-solid_svg__svg-inline--fa chevron-left-solid_svg__fa-chevron-left chevron-left-solid_svg__fa-w-10",
    viewBox: "0 0 320 512"
  }, e), _ref$2);
};

function _extends$3() {
  return (_extends$3 = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }

    return e;
  }).apply(this, arguments);
}

var _ref$3 = react.createElement("path", {
  fill: "currentColor",
  d: "M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
}),
    SvgChevronRightSolid = function SvgChevronRightSolid(e) {
  return react.createElement("svg", _extends$3({
    "aria-hidden": "true",
    "data-prefix": "fas",
    "data-icon": "chevron-right",
    className: "chevron-right-solid_svg__svg-inline--fa chevron-right-solid_svg__fa-chevron-right chevron-right-solid_svg__fa-w-10",
    viewBox: "0 0 320 512"
  }, e), _ref$3);
},
    s$v = {
  container: "styles-module_container__2_ib9",
  arrow: "styles-module_arrow__27uRs",
  disabled: "styles-module_disabled__2Ptip",
  page: "styles-module_page__C-ZIT",
  activePage: "styles-module_activePage__2pvbl",
  break: "styles-module_break__2e4-_"
},
    _ref2$2 = react.createElement(SvgChevronLeftSolid, null),
    _ref3 = react.createElement(SvgChevronRightSolid, null),
    Pagination = function (e) {
  function a() {
    var e, r;
    classCallCheck(this, a);

    for (var t = arguments.length, n = new Array(t), o = 0; o < t; o++) {
      n[o] = arguments[o];
    }

    return r = possibleConstructorReturn(this, (e = getPrototypeOf(a)).call.apply(e, [this].concat(n))), defineProperty(assertThisInitialized(r), "onPageChange", function (e) {
      var t = e.selected;
      (0, r.props.onPageChange)(t);
    }), r;
  }

  return inherits(a, react_2), createClass(a, [{
    key: "renderPrev",
    value: function value() {
      var e = this.props.t;
      return react.createElement(react_3, null, _ref2$2, e("previousPage"));
    }
  }, {
    key: "renderNext",
    value: function value() {
      var e = this.props.t;
      return react.createElement(react_3, null, e("nextPage"), _ref3);
    }
  }, {
    key: "render",
    value: function value() {
      var e = this.props,
          t = (e.onPageChange, e.t, objectWithoutProperties(e, ["onPageChange", "t"]));
      return react.createElement(ReactPaginate, _extends_1({
        activeClassName: s$v.activePage,
        breakClassName: s$v.break,
        containerClassName: s$v.container,
        disabledClassName: s$v.disabled,
        nextLabel: this.renderNext(),
        nextLinkClassName: s$v.arrow,
        onPageChange: this.onPageChange,
        pageClassName: s$v.page,
        previousLinkClassName: s$v.arrow,
        previousLabel: this.renderPrev()
      }, t));
    }
  }]), a;
}();

defineProperty(Pagination, "defaultProps", {
  t: tDefault
});

var s$w = {
  root: "styles-module_root__2nZJk"
},
    Paper = function Paper(e) {
  var t = e.children,
      r = e.margin,
      n = e.className,
      o = objectWithoutProperties(e, ["children", "margin", "className"]);
  return react.createElement("div", _extends_1({}, o, {
    style: {
      margin: r
    },
    className: classnames(s$w.root, n)
  }), t);
};

Paper.defaultProps = {
  className: null,
  margin: void 0
};

var s$x = {
  paperContent: "styles-module_paperContent__1XDDM"
},
    PaperContent = function PaperContent(e) {
  var t = e.children,
      r = e.className,
      n = objectWithoutProperties(e, ["children", "className"]);
  return react.createElement("div", _extends_1({
    className: classnames(s$x.paperContent, r)
  }, n), t);
};

PaperContent.defaultProps = {
  children: null,
  className: null
};

var s$y = {
  paperMessage: "styles-module_paperMessage__p3at-"
},
    PaperMessage = function PaperMessage(e) {
  var t = e.children,
      r = e.className,
      n = objectWithoutProperties(e, ["children", "className"]);
  return react.createElement("div", _extends_1({
    className: classnames(s$y.paperMessage, r)
  }, n), t);
};

PaperMessage.defaultProps = {
  className: null
};

var s$z = {
  root: "styles-module_root__2CBMY",
  border: "styles-module_border__-8inx",
  md: "styles-module_md__1vHxE",
  lg: "styles-module_lg__15Hx5"
},
    PaperTitle = function PaperTitle(e) {
  var t = e.children,
      r = e.className,
      n = e.component,
      o = e.size,
      a = e.withBorder,
      i = objectWithoutProperties(e, ["children", "className", "component", "size", "withBorder"]);
  return react.createElement(n, _extends_1({
    className: classnames(s$z.root, r, s$z[o], defineProperty({}, s$z.border, a))
  }, i), t);
};

PaperTitle.defaultProps = {
  component: "h2",
  className: "",
  size: "lg",
  withBorder: !1
};

var s$A = {
  container: "styles-module_container__KjFEn",
  photo: "styles-module_photo__nl1sn",
  photoImg: "styles-module_photoImg__1vBXN",
  info: "styles-module_info__8wE-G",
  name: "styles-module_name__zuKiJ"
},
    PersonalInfo = function PersonalInfo(e) {
  var t = e.className,
      r = e.info,
      n = e.name,
      o = e.photoUrl,
      a = e.t,
      i = objectWithoutProperties(e, ["className", "info", "name", "photoUrl", "t"]);
  return react.createElement("div", _extends_1({
    className: classnames(s$A.container, t)
  }, i), react.createElement("div", {
    className: s$A.photo
  }, o && react.createElement("img", {
    className: s$A.photoImg,
    src: o,
    alt: ""
  })), react.createElement("div", {
    className: s$A.info
  }, react.createElement("strong", {
    className: s$A.name
  }, n), mapIndex(function (e, t) {
    return react.createElement("div", {
      key: t
    }, "".concat(a(e.transKey), ": ").concat(e.value));
  })(r)));
};

PersonalInfo.defaultProps = {
  className: null,
  t: tDefault,
  photoUrl: null,
  info: []
};

var s$B = {
  root: "styles-module_root__3t00e",
  input: "styles-module_input__3hjg_",
  error: "styles-module_error__q1yy8"
},
    _ref2$3 = react.createElement("div", null),
    Radio = function Radio(e) {
  var t = e.error,
      r = e.checked,
      n = objectWithoutProperties(e, ["error", "checked"]);
  return react.createElement("span", {
    className: classnames(s$B.root, defineProperty({}, s$B.error, t))
  }, react.createElement("input", _extends_1({
    className: s$B.input,
    type: "radio",
    checked: r
  }, n)), _ref2$3);
};

Radio.defaultProps = {
  error: !1,
  checked: !1
};

var s$C = {
  container: "styles-module_container__9uZIs"
},
    ReportTitle = function ReportTitle(e) {
  var t = e.children,
      r = e.className,
      n = objectWithoutProperties(e, ["children", "className"]);
  return react.createElement("div", _extends_1({
    className: classnames(s$C.container, r)
  }, n), t);
};

function _extends$4() {
  return (_extends$4 = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }

    return e;
  }).apply(this, arguments);
}

ReportTitle.defaultProps = {
  className: null
};

var _ref$4 = react.createElement("path", {
  fill: "currentColor",
  d: "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
}),
    SvgSearchSolid = function SvgSearchSolid(e) {
  return react.createElement("svg", _extends$4({
    "aria-hidden": "true",
    "data-prefix": "fas",
    "data-icon": "search",
    className: "search-solid_svg__svg-inline--fa search-solid_svg__fa-search search-solid_svg__fa-w-16",
    viewBox: "0 0 512 512"
  }, e), _ref$4);
},
    Clean = function Clean(e) {
  var t = e.size,
      r = e.fill;
  return react.createElement("svg", {
    version: "1.1",
    x: "0px",
    y: "0px",
    height: t,
    viewBox: "0 0 20 20"
  }, react.createElement("g", null, react.createElement("path", {
    fill: r,
    d: "M14.9,3.6c0.1-0.1,0.2-0.1,0.3,0l1.3,1.3c0.1,0.1,0.1,0.2,0,0.3L11.6,10l4.9,4.9c0.1,0.1,0.1,0.2,0,0.3 l-1.3,1.3c-0.1,0.1-0.2,0.1-0.3,0L10,11.6l-4.9,4.9c-0.1,0.1-0.2,0.1-0.3,0l-1.3-1.3c-0.1-0.1-0.1-0.2,0-0.3L8.4,10L3.6,5.1 c-0.1-0.1-0.1-0.2,0-0.3l1.3-1.3c0.1-0.1,0.2-0.1,0.3,0L10,8.4L14.9,3.6z"
  })));
};

Clean.defaultProps = {
  size: 20,
  fill: "#999999"
};

var s$D = {
  search: "styles-module_search__2tCfr",
  icon: "styles-module_icon__3EAlr",
  clearIcon: "styles-module_clearIcon__1BhJi",
  input: "styles-module_input__DqMP_"
},
    _ref2$4 = react.createElement(SvgSearchSolid, null),
    _ref3$1 = react.createElement(Clean, null),
    Search = function Search(e) {
  var t = e.className,
      r = objectWithoutProperties(e, ["className"]);
  return react.createElement("div", {
    className: classnames(s$D.search, t)
  }, react.createElement("span", {
    className: s$D.icon
  }, _ref2$4), react.createElement(Input, _extends_1({
    className: s$D.input
  }, r)), r.value && react.createElement("span", {
    className: s$D.clearIcon,
    onClick: function onClick() {
      r.onChange("");
    }
  }, _ref3$1));
};

Search.defaultProps = {
  className: ""
};

var s$E = {
  root: "styles-module_root__2M9Og"
},
    SegmentedControl = function SegmentedControl(e) {
  var t = e.children,
      r = objectWithoutProperties(e, ["children"]);
  return react.createElement("div", _extends_1({
    className: s$E.root
  }, r), t);
},
    s$F = {
  wrapper: "styles-module_wrapper__3g34a",
  select: "styles-module_select__1W8Az",
  placeholder: "styles-module_placeholder__1_ud0",
  error: "styles-module_error__2NUWj"
},
    Select = function Select(e) {
  var t,
      r = e.children,
      n = e.placeholder,
      o = e.error,
      a = e.value,
      i = objectWithoutProperties(e, ["children", "placeholder", "error", "value"]);
  return react.createElement("div", {
    className: s$F.wrapper
  }, react.createElement("select", _extends_1({
    className: classnames(s$F.select, (t = {}, defineProperty(t, s$F.error, o), defineProperty(t, s$F.placeholder, !a), t)),
    value: a
  }, i), n && react.createElement("option", {
    value: "",
    disabled: !0,
    hidden: !0
  }, n), r));
};

function _extends$5() {
  return (_extends$5 = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }

    return e;
  }).apply(this, arguments);
}

Select.defaultProps = {
  error: !1,
  placeholder: "",
  value: ""
};

var _ref$5 = react.createElement("path", {
  d: "M9 13.5V2.7h2v10.7l3.4-3.4 1.4 1.4-5.8 5.9-5.9-5.9L5.6 10 9 13.5z"
}),
    SvgSortDown = function SvgSortDown(e) {
  return react.createElement("svg", _extends$5({
    viewBox: "0 0 20 20"
  }, e), _ref$5);
},
    s$G = {
  root: "styles-module_root__2e5Qz",
  desc: "styles-module_desc__1kvPi",
  asc: "styles-module_asc__2bAsv"
},
    SortArrow = function SortArrow(e) {
  var t = e.direction;
  return react.createElement(SvgSortDown, {
    className: classnames(s$G.root, s$G[t])
  });
},
    s$H = {
  iconWrapper: "styles-module_iconWrapper__3eL_E",
  icon: "styles-module_icon__3mj-a",
  activeSortTitle: "styles-module_activeSortTitle__2EUZi"
},
    SortButton = function (e) {
  function a() {
    var e, r;
    classCallCheck(this, a);

    for (var t = arguments.length, n = new Array(t), o = 0; o < t; o++) {
      n[o] = arguments[o];
    }

    return r = possibleConstructorReturn(this, (e = getPrototypeOf(a)).call.apply(e, [this].concat(n))), defineProperty(assertThisInitialized(r), "handleClickButton", function () {
      var e = r.props,
          t = e.sortName;
      (0, e.onClick)({
        field: t
      });
    }), r;
  }

  return inherits(a, e), createClass(a, [{
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.direction,
          r = e.children,
          n = e.active;
      return react.createElement("div", {
        onClick: this.handleClickButton,
        className: classnames(s$H.iconWrapper, defineProperty({}, s$H.activeSortTitle, n))
      }, r, react.createElement("div", {
        className: s$H.icon
      }, n && react.createElement(SortArrow, {
        direction: t,
        onClick: this.handleClickButton
      })));
    }
  }]), a;
}(react.PureComponent);

defineProperty(SortButton, "defaultProps", {
  sortName: void 0
});

var s$I = {
  statusBar: "styles-module_statusBar__1Oyl2",
  icon: "styles-module_icon__2rfqW",
  content: "styles-module_content__w2Tef",
  title: "styles-module_title__2vkDg",
  success: "styles-module_success__1OfB8",
  warning: "styles-module_warning__nTh2b",
  danger: "styles-module_danger__2iQ1N"
},
    StatusBar = function StatusBar(e) {
  var t = e.children,
      r = e.icon,
      n = e.title,
      o = e.variant,
      a = objectWithoutProperties(e, ["children", "icon", "title", "variant"]);
  return react.createElement("div", _extends_1({
    className: classnames(s$I.statusBar, s$I[o])
  }, a), r && react.createElement("div", {
    className: s$I.icon
  }, r), react.createElement("div", {
    className: s$I.content
  }, n && react.createElement("h3", {
    className: s$I.title
  }, n), t));
};

StatusBar.defaultProps = {
  children: null,
  icon: null,
  title: null
};

var s$J = {
  container: "styles-module_container__cop3-",
  radioWrapper: "styles-module_radioWrapper__etIIC",
  radio: "styles-module_radio__12rUL",
  input: "styles-module_input__17k-H",
  radioDot: "styles-module_radioDot__2ARQJ",
  success: "styles-module_success__2lYN1",
  warning: "styles-module_warning__2tEX_",
  danger: "styles-module_danger__1A3h4",
  notApplicable: "styles-module_notApplicable__20nHG"
},
    StatusItem = function StatusItem(e) {
  var t = e.className,
      r = e.children,
      n = e.variant,
      o = objectWithoutProperties(e, ["className", "children", "variant"]);
  return react.createElement("div", {
    className: classnames(s$J.container, t, s$J[n])
  }, react.createElement("div", {
    className: s$J.radioWrapper
  }, react.createElement("input", _extends_1({
    className: s$J.input,
    type: "radio"
  }, o)), react.createElement("div", {
    className: s$J.radio
  }, react.createElement("div", {
    className: s$J.radioDot
  }))), react.createElement("div", null, r));
};

StatusItem.defaultProps = {
  active: !0,
  className: ""
};

var s$K = {
  root: "styles-module_root__3emRF",
  sm: "styles-module_sm__AoZHc",
  md: "styles-module_md__2qIsQ",
  default: "styles-module_default__14Huv",
  primary: "styles-module_primary__2fZGp"
},
    Table = function Table(e) {
  var t = e.className,
      r = e.children,
      n = e.size,
      o = e.striped,
      a = e.variant,
      i = objectWithoutProperties(e, ["className", "children", "size", "striped", "variant"]);
  return react.createElement("table", _extends_1({}, i, {
    className: classnames(s$K.root, s$K[n], t, defineProperty({}, s$K[a], o))
  }), r);
};

Table.defaultProps = {
  className: null,
  size: "md",
  striped: !1,
  variant: "default"
};

var s$L = {
  targetStatus: "styles-module_targetStatus__irbgQ",
  success: "styles-module_success__MZhlh",
  warning: "styles-module_warning__1isFG",
  danger: "styles-module_danger__3V7wA",
  notApplicable: "styles-module_notApplicable__3sZqt"
},
    _ref2$5 = react.createElement("div", null),
    TargetStatus = function TargetStatus(e) {
  var t = e.variant,
      r = e.className,
      n = objectWithoutProperties(e, ["variant", "className"]);
  return react.createElement("div", _extends_1({}, n, {
    className: classnames(s$L[t], s$L.targetStatus, r)
  }), _ref2$5);
};

TargetStatus.defaultProps = {
  className: null
};

var s$M = {
  root: "styles-module_root__L_2OX",
  error: "styles-module_error__3y3Xj"
},
    Textarea = function Textarea(e) {
  var t = e.className,
      r = e.error,
      n = objectWithoutProperties(e, ["className", "error"]);
  return react.createElement("textarea", _extends_1({
    className: classnames(s$M.root, t, defineProperty({}, s$M.error, r))
  }, n));
};

Textarea.defaultProps = {
  className: null,
  error: !1,
  rows: 3,
  type: "text",
  value: ""
};

var __DEV__ = "production" !== process.env.NODE_ENV,
    warning = function warning() {};

if (__DEV__) {
  var printWarning$2 = function printWarning$2(e, t) {
    var r = arguments.length;
    t = new Array(1 < r ? r - 1 : 0);

    for (var n = 1; n < r; n++) {
      t[n - 1] = arguments[n];
    }

    var o = 0,
        a = "Warning: " + e.replace(/%s/g, function () {
      return t[o++];
    });
    "undefined" != typeof console && console.error(a);

    try {
      throw new Error(a);
    } catch (e) {}
  };

  warning = function warning(e, t, r) {
    var n = arguments.length;
    r = new Array(2 < n ? n - 2 : 0);

    for (var o = 2; o < n; o++) {
      r[o - 2] = arguments[o];
    }

    if (void 0 === t) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
    e || printWarning$2.apply(null, [t].concat(r));
  };
}

var warning_1 = warning,
    warning$1 = function warning$1() {};

"production" !== process.env.NODE_ENV && (warning$1 = function warning$1(e, t, r) {
  var n = arguments.length;
  r = new Array(2 < n ? n - 2 : 0);

  for (var o = 2; o < n; o++) {
    r[o - 2] = arguments[o];
  }

  if (void 0 === t) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
  if (t.length < 10 || /^[s\W]*$/.test(t)) throw new Error("The warning format should be able to uniquely identify this warning. Please, use a more descriptive format than: " + t);

  if (!e) {
    var a = 0,
        i = "Warning: " + t.replace(/%s/g, function () {
      return r[a++];
    });
    "undefined" != typeof console && console.error(i);

    try {
      throw new Error(i);
    } catch (e) {}
  }
});

var browser = warning$1,
    invariant = function invariant(e, t, r, n, o, a, i, s) {
  if ("production" !== process.env.NODE_ENV && void 0 === t) throw new Error("invariant requires an error message argument");

  if (!e) {
    var c;
    if (void 0 === t) c = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
      var u = [r, n, o, a, i, s],
          l = 0;
      (c = new Error(t.replace(/%s/g, function () {
        return u[l++];
      }))).name = "Invariant Violation";
    }
    throw c.framesToPop = 1, c;
  }
},
    browser$1 = invariant;

function isAbsolute(e) {
  return "/" === e.charAt(0);
}

function spliceOne(e, t) {
  for (var r = t, n = r + 1, o = e.length; n < o; r += 1, n += 1) {
    e[r] = e[n];
  }

  e.pop();
}

function resolvePathname(e) {
  var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "",
      r = e && e.split("/") || [],
      n = t && t.split("/") || [],
      o = e && isAbsolute(e),
      a = t && isAbsolute(t),
      i = o || a;
  if (e && isAbsolute(e) ? n = r : r.length && (n.pop(), n = n.concat(r)), !n.length) return "/";
  var s = void 0;

  if (n.length) {
    var c = n[n.length - 1];
    s = "." === c || ".." === c || "" === c;
  } else s = !1;

  for (var u = 0, l = n.length; 0 <= l; l--) {
    var f = n[l];
    "." === f ? spliceOne(n, l) : ".." === f ? (spliceOne(n, l), u++) : u && (spliceOne(n, l), u--);
  }

  if (!i) for (; u--; u) {
    n.unshift("..");
  }
  !i || "" === n[0] || n[0] && isAbsolute(n[0]) || n.unshift("");
  var p = n.join("/");
  return s && "/" !== p.substr(-1) && (p += "/"), p;
}

var _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
  return typeof e;
} : function (e) {
  return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
};

function valueEqual(t, r) {
  if (t === r) return !0;
  if (null == t || null == r) return !1;
  if (Array.isArray(t)) return Array.isArray(r) && t.length === r.length && t.every(function (e, t) {
    return valueEqual(e, r[t]);
  });
  var e = void 0 === t ? "undefined" : _typeof(t);
  if (e !== (void 0 === r ? "undefined" : _typeof(r))) return !1;
  if ("object" !== e) return !1;
  var n = t.valueOf(),
      o = r.valueOf();
  if (n !== t || o !== r) return valueEqual(n, o);
  var a = Object.keys(t),
      i = Object.keys(r);
  return a.length === i.length && a.every(function (e) {
    return valueEqual(t[e], r[e]);
  });
}

var addLeadingSlash = function addLeadingSlash(e) {
  return "/" === e.charAt(0) ? e : "/" + e;
},
    stripLeadingSlash = function stripLeadingSlash(e) {
  return "/" === e.charAt(0) ? e.substr(1) : e;
},
    hasBasename = function hasBasename(e, t) {
  return new RegExp("^" + t + "(\\/|\\?|#|$)", "i").test(e);
},
    stripBasename = function stripBasename(e, t) {
  return hasBasename(e, t) ? e.substr(t.length) : e;
},
    stripTrailingSlash = function stripTrailingSlash(e) {
  return "/" === e.charAt(e.length - 1) ? e.slice(0, -1) : e;
},
    parsePath = function parsePath(e) {
  var t = e || "/",
      r = "",
      n = "",
      o = t.indexOf("#");
  -1 !== o && (n = t.substr(o), t = t.substr(0, o));
  var a = t.indexOf("?");
  return -1 !== a && (r = t.substr(a), t = t.substr(0, a)), {
    pathname: t,
    search: "?" === r ? "" : r,
    hash: "#" === n ? "" : n
  };
},
    createPath = function createPath(e) {
  var t = e.pathname,
      r = e.search,
      n = e.hash,
      o = t || "/";
  return r && "?" !== r && (o += "?" === r.charAt(0) ? r : "?" + r), n && "#" !== n && (o += "#" === n.charAt(0) ? n : "#" + n), o;
},
    _extends$6 = Object.assign || function (e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];

    for (var n in r) {
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
  }

  return e;
},
    createLocation = function createLocation(e, t, r, n) {
  var o = void 0;
  "string" == typeof e ? (o = parsePath(e)).state = t : (void 0 === (o = _extends$6({}, e)).pathname && (o.pathname = ""), o.search ? "?" !== o.search.charAt(0) && (o.search = "?" + o.search) : o.search = "", o.hash ? "#" !== o.hash.charAt(0) && (o.hash = "#" + o.hash) : o.hash = "", void 0 !== t && void 0 === o.state && (o.state = t));

  try {
    o.pathname = decodeURI(o.pathname);
  } catch (e) {
    throw e instanceof URIError ? new URIError('Pathname "' + o.pathname + '" could not be decoded. This is likely caused by an invalid percent-encoding.') : e;
  }

  return r && (o.key = r), n ? o.pathname ? "/" !== o.pathname.charAt(0) && (o.pathname = resolvePathname(o.pathname, n.pathname)) : o.pathname = n.pathname : o.pathname || (o.pathname = "/"), o;
},
    locationsAreEqual = function locationsAreEqual(e, t) {
  return e.pathname === t.pathname && e.search === t.search && e.hash === t.hash && e.key === t.key && valueEqual(e.state, t.state);
},
    createTransitionManager = function createTransitionManager() {
  var a = null,
      n = [];
  return {
    setPrompt: function setPrompt(e) {
      return browser(null == a, "A history supports only one prompt at a time"), a = e, function () {
        a === e && (a = null);
      };
    },
    confirmTransitionTo: function confirmTransitionTo(e, t, r, n) {
      if (null != a) {
        var o = "function" == typeof a ? a(e, t) : a;
        "string" == typeof o ? "function" == typeof r ? r(o, n) : (browser(!1, "A history needs a getUserConfirmation function in order to use a prompt message"), n(!0)) : n(!1 !== o);
      } else n(!0);
    },
    appendListener: function appendListener(e) {
      var t = !0,
          r = function r() {
        t && e.apply(void 0, arguments);
      };

      return n.push(r), function () {
        t = !1, n = n.filter(function (e) {
          return e !== r;
        });
      };
    },
    notifyListeners: function notifyListeners() {
      for (var e = arguments.length, t = Array(e), r = 0; r < e; r++) {
        t[r] = arguments[r];
      }

      n.forEach(function (e) {
        return e.apply(void 0, t);
      });
    }
  };
},
    canUseDOM = !("undefined" == typeof window || !window.document || !window.document.createElement),
    addEventListener = function addEventListener(e, t, r) {
  return e.addEventListener ? e.addEventListener(t, r, !1) : e.attachEvent("on" + t, r);
},
    removeEventListener = function removeEventListener(e, t, r) {
  return e.removeEventListener ? e.removeEventListener(t, r, !1) : e.detachEvent("on" + t, r);
},
    getConfirmation = function getConfirmation(e, t) {
  return t(window.confirm(e));
},
    supportsHistory = function supportsHistory() {
  var e = window.navigator.userAgent;
  return (-1 === e.indexOf("Android 2.") && -1 === e.indexOf("Android 4.0") || -1 === e.indexOf("Mobile Safari") || -1 !== e.indexOf("Chrome") || -1 !== e.indexOf("Windows Phone")) && window.history && "pushState" in window.history;
},
    supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return -1 === window.navigator.userAgent.indexOf("Trident");
},
    supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return -1 === window.navigator.userAgent.indexOf("Firefox");
},
    isExtraneousPopstateEvent = function isExtraneousPopstateEvent(e) {
  return void 0 === e.state && -1 === navigator.userAgent.indexOf("CriOS");
},
    _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
  return typeof e;
} : function (e) {
  return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
},
    _extends$7 = Object.assign || function (e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];

    for (var n in r) {
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
  }

  return e;
},
    PopStateEvent = "popstate",
    HashChangeEvent = "hashchange",
    getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    return {};
  }
},
    createBrowserHistory = function createBrowserHistory() {
  var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
  browser$1(canUseDOM, "Browser history needs a DOM");

  var s = window.history,
      c = supportsHistory(),
      t = !supportsPopStateOnHashChange(),
      r = e.forceRefresh,
      u = void 0 !== r && r,
      n = e.getUserConfirmation,
      o = void 0 === n ? getConfirmation : n,
      a = e.keyLength,
      i = void 0 === a ? 6 : a,
      l = e.basename ? stripTrailingSlash(addLeadingSlash(e.basename)) : "",
      f = function f(e) {
    var t = e || {},
        r = t.key,
        n = t.state,
        o = window.location,
        a = o.pathname + o.search + o.hash;
    return browser(!l || hasBasename(a, l), 'You are attempting to use a basename on a page whose URL path does not begin with the basename. Expected path "' + a + '" to begin with "' + l + '".'), l && (a = stripBasename(a, l)), createLocation(a, n, r);
  },
      p = function p() {
    return Math.random().toString(36).substr(2, i);
  },
      d = createTransitionManager(),
      h = function h(e) {
    _extends$7(E, e), E.length = s.length, d.notifyListeners(E.location, E.action);
  },
      y = function y(e) {
    isExtraneousPopstateEvent(e) || v(f(e.state));
  },
      m = function m() {
    v(f(getHistoryState()));
  },
      b = !1,
      v = function v(t) {
    if (b) b = !1, h();else {
      d.confirmTransitionTo(t, "POP", o, function (e) {
        e ? h({
          action: "POP",
          location: t
        }) : g(t);
      });
    }
  },
      g = function g(e) {
    var t = E.location,
        r = w.indexOf(t.key);
    -1 === r && (r = 0);
    var n = w.indexOf(e.key);
    -1 === n && (n = 0);
    var o = r - n;
    o && (b = !0, S(o));
  },
      _ = f(getHistoryState()),
      w = [_.key],
      $ = function $(e) {
    return l + createPath(e);
  },
      S = function S(e) {
    s.go(e);
  },
      T = 0,
      P = function P(e) {
    1 === (T += e) ? (addEventListener(window, PopStateEvent, y), t && addEventListener(window, HashChangeEvent, m)) : 0 === T && (removeEventListener(window, PopStateEvent, y), t && removeEventListener(window, HashChangeEvent, m));
  },
      x = !1,
      E = {
    length: s.length,
    action: "POP",
    location: _,
    createHref: $,
    push: function push(e, t) {
      browser(!("object" === (void 0 === e ? "undefined" : _typeof$1(e)) && void 0 !== e.state && void 0 !== t), "You should avoid providing a 2nd state argument to push when the 1st argument is a location-like object that already has state; it is ignored");
      var i = createLocation(e, t, p(), E.location);
      d.confirmTransitionTo(i, "PUSH", o, function (e) {
        if (e) {
          var t = $(i),
              r = i.key,
              n = i.state;
          if (c) {
            if (s.pushState({
              key: r,
              state: n
            }, null, t), u) window.location.href = t;else {
              var o = w.indexOf(E.location.key),
                  a = w.slice(0, -1 === o ? 0 : o + 1);
              a.push(i.key), w = a, h({
                action: "PUSH",
                location: i
              });
            }
          } else browser(void 0 === n, "Browser history cannot push state in browsers that do not support HTML5 history"), window.location.href = t;
        }
      });
    },
    replace: function replace(e, t) {
      browser(!("object" === (void 0 === e ? "undefined" : _typeof$1(e)) && void 0 !== e.state && void 0 !== t), "You should avoid providing a 2nd state argument to replace when the 1st argument is a location-like object that already has state; it is ignored");
      var a = createLocation(e, t, p(), E.location);
      d.confirmTransitionTo(a, "REPLACE", o, function (e) {
        if (e) {
          var t = $(a),
              r = a.key,
              n = a.state;
          if (c) {
            if (s.replaceState({
              key: r,
              state: n
            }, null, t), u) window.location.replace(t);else {
              var o = w.indexOf(E.location.key);
              -1 !== o && (w[o] = a.key), h({
                action: "REPLACE",
                location: a
              });
            }
          } else browser(void 0 === n, "Browser history cannot replace state in browsers that do not support HTML5 history"), window.location.replace(t);
        }
      });
    },
    go: S,
    goBack: function goBack() {
      return S(-1);
    },
    goForward: function goForward() {
      return S(1);
    },
    block: function block() {
      var e = 0 < arguments.length && void 0 !== arguments[0] && arguments[0],
          t = d.setPrompt(e);
      return x || (P(1), x = !0), function () {
        return x && (x = !1, P(-1)), t();
      };
    },
    listen: function listen(e) {
      var t = d.appendListener(e);
      return P(1), function () {
        P(-1), t();
      };
    }
  };

  return E;
},
    _extends$8 = Object.assign || function (e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];

    for (var n in r) {
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
  }

  return e;
},
    HashChangeEvent$1 = "hashchange",
    HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(e) {
      return "!" === e.charAt(0) ? e : "!/" + stripLeadingSlash(e);
    },
    decodePath: function decodePath(e) {
      return "!" === e.charAt(0) ? e.substr(1) : e;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
},
    getHashPath = function getHashPath() {
  var e = window.location.href,
      t = e.indexOf("#");
  return -1 === t ? "" : e.substring(t + 1);
},
    pushHashPath = function pushHashPath(e) {
  return window.location.hash = e;
},
    replaceHashPath = function replaceHashPath(e) {
  var t = window.location.href.indexOf("#");
  window.location.replace(window.location.href.slice(0, 0 <= t ? t : 0) + "#" + e);
},
    createHashHistory = function createHashHistory() {
  var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
  browser$1(canUseDOM, "Hash history needs a DOM");

  var t = window.history,
      r = supportsGoWithoutReloadUsingHash(),
      n = e.getUserConfirmation,
      i = void 0 === n ? getConfirmation : n,
      o = e.hashType,
      a = void 0 === o ? "slash" : o,
      s = e.basename ? stripTrailingSlash(addLeadingSlash(e.basename)) : "",
      c = HashPathCoders[a],
      u = c.encodePath,
      l = c.decodePath,
      f = function f() {
    var e = l(getHashPath());
    return browser(!s || hasBasename(e, s), 'You are attempting to use a basename on a page whose URL path does not begin with the basename. Expected path "' + e + '" to begin with "' + s + '".'), s && (e = stripBasename(e, s)), createLocation(e);
  },
      p = createTransitionManager(),
      d = function d(e) {
    _extends$8(E, e), E.length = t.length, p.notifyListeners(E.location, E.action);
  },
      h = !1,
      y = null,
      m = function m() {
    var e = getHashPath(),
        t = u(e);
    if (e !== t) replaceHashPath(t);else {
      var r = f(),
          n = E.location;
      if (!h && locationsAreEqual(n, r)) return;
      if (y === createPath(r)) return;
      y = null, b(r);
    }
  },
      b = function b(t) {
    if (h) h = !1, d();else {
      p.confirmTransitionTo(t, "POP", i, function (e) {
        e ? d({
          action: "POP",
          location: t
        }) : v(t);
      });
    }
  },
      v = function v(e) {
    var t = E.location,
        r = $.lastIndexOf(createPath(t));
    -1 === r && (r = 0);
    var n = $.lastIndexOf(createPath(e));
    -1 === n && (n = 0);
    var o = r - n;
    o && (h = !0, S(o));
  },
      g = getHashPath(),
      _ = u(g);

  g !== _ && replaceHashPath(_);

  var w = f(),
      $ = [createPath(w)],
      S = function S(e) {
    browser(r, "Hash history go(n) causes a full page reload in this browser"), t.go(e);
  },
      T = 0,
      P = function P(e) {
    1 === (T += e) ? addEventListener(window, HashChangeEvent$1, m) : 0 === T && removeEventListener(window, HashChangeEvent$1, m);
  },
      x = !1,
      E = {
    length: t.length,
    action: "POP",
    location: w,
    createHref: function createHref(e) {
      return "#" + u(s + createPath(e));
    },
    push: function push(e, t) {
      browser(void 0 === t, "Hash history cannot push state; it is ignored");
      var a = createLocation(e, void 0, void 0, E.location);
      p.confirmTransitionTo(a, "PUSH", i, function (e) {
        if (e) {
          var t = createPath(a),
              r = u(s + t);

          if (getHashPath() !== r) {
            y = t, pushHashPath(r);
            var n = $.lastIndexOf(createPath(E.location)),
                o = $.slice(0, -1 === n ? 0 : n + 1);
            o.push(t), $ = o, d({
              action: "PUSH",
              location: a
            });
          } else browser(!1, "Hash history cannot PUSH the same path; a new entry will not be added to the history stack"), d();
        }
      });
    },
    replace: function replace(e, t) {
      browser(void 0 === t, "Hash history cannot replace state; it is ignored");
      var o = createLocation(e, void 0, void 0, E.location);
      p.confirmTransitionTo(o, "REPLACE", i, function (e) {
        if (e) {
          var t = createPath(o),
              r = u(s + t);
          getHashPath() !== r && (y = t, replaceHashPath(r));
          var n = $.indexOf(createPath(E.location));
          -1 !== n && ($[n] = t), d({
            action: "REPLACE",
            location: o
          });
        }
      });
    },
    go: S,
    goBack: function goBack() {
      return S(-1);
    },
    goForward: function goForward() {
      return S(1);
    },
    block: function block() {
      var e = 0 < arguments.length && void 0 !== arguments[0] && arguments[0],
          t = p.setPrompt(e);
      return x || (P(1), x = !0), function () {
        return x && (x = !1, P(-1)), t();
      };
    },
    listen: function listen(e) {
      var t = p.appendListener(e);
      return P(1), function () {
        P(-1), t();
      };
    }
  };

  return E;
},
    _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
  return typeof e;
} : function (e) {
  return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
},
    _extends$9 = Object.assign || function (e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];

    for (var n in r) {
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
  }

  return e;
},
    clamp = function clamp(e, t, r) {
  return Math.min(Math.max(e, t), r);
},
    createMemoryHistory = function createMemoryHistory() {
  var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
      o = e.getUserConfirmation,
      t = e.initialEntries,
      r = void 0 === t ? ["/"] : t,
      n = e.initialIndex,
      a = void 0 === n ? 0 : n,
      i = e.keyLength,
      s = void 0 === i ? 6 : i,
      c = createTransitionManager(),
      u = function u(e) {
    _extends$9(y, e), y.length = y.entries.length, c.notifyListeners(y.location, y.action);
  },
      l = function l() {
    return Math.random().toString(36).substr(2, s);
  },
      f = clamp(a, 0, r.length - 1),
      p = r.map(function (e) {
    return createLocation(e, void 0, "string" == typeof e ? l() : e.key || l());
  }),
      d = createPath,
      h = function h(e) {
    var t = clamp(y.index + e, 0, y.entries.length - 1),
        r = y.entries[t];
    c.confirmTransitionTo(r, "POP", o, function (e) {
      e ? u({
        action: "POP",
        location: r,
        index: t
      }) : u();
    });
  },
      y = {
    length: p.length,
    action: "POP",
    location: p[f],
    index: f,
    entries: p,
    createHref: d,
    push: function push(e, t) {
      browser(!("object" === (void 0 === e ? "undefined" : _typeof$2(e)) && void 0 !== e.state && void 0 !== t), "You should avoid providing a 2nd state argument to push when the 1st argument is a location-like object that already has state; it is ignored");
      var n = createLocation(e, t, l(), y.location);
      c.confirmTransitionTo(n, "PUSH", o, function (e) {
        if (e) {
          var t = y.index + 1,
              r = y.entries.slice(0);
          r.length > t ? r.splice(t, r.length - t, n) : r.push(n), u({
            action: "PUSH",
            location: n,
            index: t,
            entries: r
          });
        }
      });
    },
    replace: function replace(e, t) {
      browser(!("object" === (void 0 === e ? "undefined" : _typeof$2(e)) && void 0 !== e.state && void 0 !== t), "You should avoid providing a 2nd state argument to replace when the 1st argument is a location-like object that already has state; it is ignored");
      var r = createLocation(e, t, l(), y.location);
      c.confirmTransitionTo(r, "REPLACE", o, function (e) {
        e && (y.entries[y.index] = r, u({
          action: "REPLACE",
          location: r
        }));
      });
    },
    go: h,
    goBack: function goBack() {
      return h(-1);
    },
    goForward: function goForward() {
      return h(1);
    },
    canGo: function canGo(e) {
      var t = y.index + e;
      return 0 <= t && t < y.entries.length;
    },
    block: function block() {
      var e = 0 < arguments.length && void 0 !== arguments[0] && arguments[0];
      return c.setPrompt(e);
    },
    listen: function listen(e) {
      return c.appendListener(e);
    }
  };

  return y;
},
    __DEV__$1 = "production" !== process.env.NODE_ENV,
    warning$2 = function warning$2() {};

if (__DEV__$1) {
  var printWarning$3 = function printWarning$3(e, t) {
    var r = arguments.length;
    t = new Array(1 < r ? r - 1 : 0);

    for (var n = 1; n < r; n++) {
      t[n - 1] = arguments[n];
    }

    var o = 0,
        a = "Warning: " + e.replace(/%s/g, function () {
      return t[o++];
    });
    "undefined" != typeof console && console.error(a);

    try {
      throw new Error(a);
    } catch (e) {}
  };

  warning$2 = function warning$2(e, t, r) {
    var n = arguments.length;
    r = new Array(2 < n ? n - 2 : 0);

    for (var o = 2; o < n; o++) {
      r[o - 2] = arguments[o];
    }

    if (void 0 === t) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
    e || printWarning$3.apply(null, [t].concat(r));
  };
}

var warning_1$1 = warning$2,
    _extends$a = Object.assign || function (e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];

    for (var n in r) {
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
  }

  return e;
};

function _classCallCheck$1(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _possibleConstructorReturn$1(e, t) {
  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !t || "object" != typeof t && "function" != typeof t ? e : t;
}

function _inherits$1(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}

var Router = function (a) {
  function i() {
    var e, t;

    _classCallCheck$1(this, i);

    for (var r = arguments.length, n = Array(r), o = 0; o < r; o++) {
      n[o] = arguments[o];
    }

    return (e = t = _possibleConstructorReturn$1(this, a.call.apply(a, [this].concat(n)))).state = {
      match: t.computeMatch(t.props.history.location.pathname)
    }, _possibleConstructorReturn$1(t, e);
  }

  return _inherits$1(i, a), i.prototype.getChildContext = function () {
    return {
      router: _extends$a({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  }, i.prototype.computeMatch = function (e) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: "/" === e
    };
  }, i.prototype.componentWillMount = function () {
    var e = this,
        t = this.props,
        r = t.children,
        n = t.history;
    browser$1(null == r || 1 === react.Children.count(r), "A <Router> may have only one child element"), this.unlisten = n.listen(function () {
      e.setState({
        match: e.computeMatch(n.location.pathname)
      });
    });
  }, i.prototype.componentWillReceiveProps = function (e) {
    warning_1$1(this.props.history === e.history, "You cannot change <Router history>");
  }, i.prototype.componentWillUnmount = function () {
    this.unlisten();
  }, i.prototype.render = function () {
    var e = this.props.children;
    return e ? react.Children.only(e) : null;
  }, i;
}(react.Component);

function _classCallCheck$2(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _possibleConstructorReturn$2(e, t) {
  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !t || "object" != typeof t && "function" != typeof t ? e : t;
}

function _inherits$2(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}

Router.propTypes = {
  history: propTypes.object.isRequired,
  children: propTypes.node
}, Router.contextTypes = {
  router: propTypes.object
}, Router.childContextTypes = {
  router: propTypes.object.isRequired
};

var BrowserRouter = function (a) {
  function i() {
    var e, t;

    _classCallCheck$2(this, i);

    for (var r = arguments.length, n = Array(r), o = 0; o < r; o++) {
      n[o] = arguments[o];
    }

    return (e = t = _possibleConstructorReturn$2(this, a.call.apply(a, [this].concat(n)))).history = createBrowserHistory(t.props), _possibleConstructorReturn$2(t, e);
  }

  return _inherits$2(i, a), i.prototype.componentWillMount = function () {
    warning_1(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  }, i.prototype.render = function () {
    return react.createElement(Router, {
      history: this.history,
      children: this.props.children
    });
  }, i;
}(react.Component);

function _classCallCheck$3(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _possibleConstructorReturn$3(e, t) {
  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !t || "object" != typeof t && "function" != typeof t ? e : t;
}

function _inherits$3(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}

BrowserRouter.propTypes = {
  basename: propTypes.string,
  forceRefresh: propTypes.bool,
  getUserConfirmation: propTypes.func,
  keyLength: propTypes.number,
  children: propTypes.node
};

var HashRouter = function (a) {
  function i() {
    var e, t;

    _classCallCheck$3(this, i);

    for (var r = arguments.length, n = Array(r), o = 0; o < r; o++) {
      n[o] = arguments[o];
    }

    return (e = t = _possibleConstructorReturn$3(this, a.call.apply(a, [this].concat(n)))).history = createHashHistory(t.props), _possibleConstructorReturn$3(t, e);
  }

  return _inherits$3(i, a), i.prototype.componentWillMount = function () {
    warning_1(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, use `import { Router }` instead of `import { HashRouter as Router }`.");
  }, i.prototype.render = function () {
    return react.createElement(Router, {
      history: this.history,
      children: this.props.children
    });
  }, i;
}(react.Component);

HashRouter.propTypes = {
  basename: propTypes.string,
  getUserConfirmation: propTypes.func,
  hashType: propTypes.oneOf(["hashbang", "noslash", "slash"]),
  children: propTypes.node
};

var _extends$b = Object.assign || function (e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];

    for (var n in r) {
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$1(e, t) {
  var r = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
  }

  return r;
}

function _classCallCheck$4(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _possibleConstructorReturn$4(e, t) {
  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !t || "object" != typeof t && "function" != typeof t ? e : t;
}

function _inherits$4(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}

var isModifiedEvent = function isModifiedEvent(e) {
  return !!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
},
    Link = function (o) {
  function i() {
    var e, a;

    _classCallCheck$4(this, i);

    for (var t = arguments.length, r = Array(t), n = 0; n < t; n++) {
      r[n] = arguments[n];
    }

    return (e = a = _possibleConstructorReturn$4(this, o.call.apply(o, [this].concat(r)))).handleClick = function (e) {
      if (a.props.onClick && a.props.onClick(e), !e.defaultPrevented && 0 === e.button && !a.props.target && !isModifiedEvent(e)) {
        e.preventDefault();
        var t = a.context.router.history,
            r = a.props,
            n = r.replace,
            o = r.to;
        n ? t.replace(o) : t.push(o);
      }
    }, _possibleConstructorReturn$4(a, e);
  }

  return _inherits$4(i, o), i.prototype.render = function () {
    var e = this.props,
        t = (e.replace, e.to),
        r = e.innerRef,
        n = _objectWithoutProperties$1(e, ["replace", "to", "innerRef"]);

    browser$1(this.context.router, "You should not use <Link> outside a <Router>"), browser$1(void 0 !== t, 'You must specify the "to" property');
    var o = this.context.router.history,
        a = "string" == typeof t ? createLocation(t, null, null, o.location) : t,
        i = o.createHref(a);
    return react.createElement("a", _extends$b({}, n, {
      onClick: this.handleClick,
      href: i,
      ref: r
    }));
  }, i;
}(react.Component);

function _classCallCheck$5(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _possibleConstructorReturn$5(e, t) {
  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !t || "object" != typeof t && "function" != typeof t ? e : t;
}

function _inherits$5(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}

Link.propTypes = {
  onClick: propTypes.func,
  target: propTypes.string,
  replace: propTypes.bool,
  to: propTypes.oneOfType([propTypes.string, propTypes.object]).isRequired,
  innerRef: propTypes.oneOfType([propTypes.string, propTypes.func])
}, Link.defaultProps = {
  replace: !1
}, Link.contextTypes = {
  router: propTypes.shape({
    history: propTypes.shape({
      push: propTypes.func.isRequired,
      replace: propTypes.func.isRequired,
      createHref: propTypes.func.isRequired
    }).isRequired
  }).isRequired
};

var MemoryRouter = function (a) {
  function i() {
    var e, t;

    _classCallCheck$5(this, i);

    for (var r = arguments.length, n = Array(r), o = 0; o < r; o++) {
      n[o] = arguments[o];
    }

    return (e = t = _possibleConstructorReturn$5(this, a.call.apply(a, [this].concat(n)))).history = createMemoryHistory(t.props), _possibleConstructorReturn$5(t, e);
  }

  return _inherits$5(i, a), i.prototype.componentWillMount = function () {
    warning_1$1(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  }, i.prototype.render = function () {
    return react.createElement(Router, {
      history: this.history,
      children: this.props.children
    });
  }, i;
}(react.Component);

MemoryRouter.propTypes = {
  initialEntries: propTypes.array,
  initialIndex: propTypes.number,
  getUserConfirmation: propTypes.func,
  keyLength: propTypes.number,
  children: propTypes.node
};

var isarray = Array.isArray || function (e) {
  return "[object Array]" == Object.prototype.toString.call(e);
},
    pathToRegexp_1 = pathToRegexp,
    parse_1 = parse,
    compile_1 = compile,
    tokensToFunction_1 = tokensToFunction,
    tokensToRegExp_1 = tokensToRegExp,
    PATH_REGEXP = new RegExp(["(\\\\.)", "([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"].join("|"), "g");

function parse(e, t) {
  for (var r, n = [], o = 0, a = 0, i = "", s = t && t.delimiter || "/"; null != (r = PATH_REGEXP.exec(e));) {
    var c = r[0],
        u = r[1],
        l = r.index;
    if (i += e.slice(a, l), a = l + c.length, u) i += u[1];else {
      var f = e[a],
          p = r[2],
          d = r[3],
          h = r[4],
          y = r[5],
          m = r[6],
          b = r[7];
      i && (n.push(i), i = "");

      var v = null != p && null != f && f !== p,
          g = "+" === m || "*" === m,
          _ = "?" === m || "*" === m,
          w = r[2] || s,
          $ = h || y;

      n.push({
        name: d || o++,
        prefix: p || "",
        delimiter: w,
        optional: _,
        repeat: g,
        partial: v,
        asterisk: !!b,
        pattern: $ ? escapeGroup($) : b ? ".*" : "[^" + escapeString(w) + "]+?"
      });
    }
  }

  return a < e.length && (i += e.substr(a)), i && n.push(i), n;
}

function compile(e, t) {
  return tokensToFunction(parse(e, t));
}

function encodeURIComponentPretty(e) {
  return encodeURI(e).replace(/[\/?#]/g, function (e) {
    return "%" + e.charCodeAt(0).toString(16).toUpperCase();
  });
}

function encodeAsterisk(e) {
  return encodeURI(e).replace(/[?#]/g, function (e) {
    return "%" + e.charCodeAt(0).toString(16).toUpperCase();
  });
}

function tokensToFunction(l) {
  for (var f = new Array(l.length), e = 0; e < l.length; e++) {
    "object" == typeof l[e] && (f[e] = new RegExp("^(?:" + l[e].pattern + ")$"));
  }

  return function (e, t) {
    for (var r = "", n = e || {}, o = (t || {}).pretty ? encodeURIComponentPretty : encodeURIComponent, a = 0; a < l.length; a++) {
      var i = l[a];

      if ("string" != typeof i) {
        var s,
            c = n[i.name];

        if (null == c) {
          if (i.optional) {
            i.partial && (r += i.prefix);
            continue;
          }

          throw new TypeError('Expected "' + i.name + '" to be defined');
        }

        if (isarray(c)) {
          if (!i.repeat) throw new TypeError('Expected "' + i.name + '" to not repeat, but received `' + JSON.stringify(c) + "`");

          if (0 === c.length) {
            if (i.optional) continue;
            throw new TypeError('Expected "' + i.name + '" to not be empty');
          }

          for (var u = 0; u < c.length; u++) {
            if (s = o(c[u]), !f[a].test(s)) throw new TypeError('Expected all "' + i.name + '" to match "' + i.pattern + '", but received `' + JSON.stringify(s) + "`");
            r += (0 === u ? i.prefix : i.delimiter) + s;
          }
        } else {
          if (s = i.asterisk ? encodeAsterisk(c) : o(c), !f[a].test(s)) throw new TypeError('Expected "' + i.name + '" to match "' + i.pattern + '", but received "' + s + '"');
          r += i.prefix + s;
        }
      } else r += i;
    }

    return r;
  };
}

function escapeString(e) {
  return e.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");
}

function escapeGroup(e) {
  return e.replace(/([=!:$\/()])/g, "\\$1");
}

function attachKeys(e, t) {
  return e.keys = t, e;
}

function flags(e) {
  return e.sensitive ? "" : "i";
}

function regexpToRegexp(e, t) {
  var r = e.source.match(/\((?!\?)/g);
  if (r) for (var n = 0; n < r.length; n++) {
    t.push({
      name: n,
      prefix: null,
      delimiter: null,
      optional: !1,
      repeat: !1,
      partial: !1,
      asterisk: !1,
      pattern: null
    });
  }
  return attachKeys(e, t);
}

function arrayToRegexp(e, t, r) {
  for (var n = [], o = 0; o < e.length; o++) {
    n.push(pathToRegexp(e[o], t, r).source);
  }

  return attachKeys(new RegExp("(?:" + n.join("|") + ")", flags(r)), t);
}

function stringToRegexp(e, t, r) {
  return tokensToRegExp(parse(e, r), t, r);
}

function tokensToRegExp(e, t, r) {
  isarray(t) || (r = t || r, t = []);

  for (var n = (r = r || {}).strict, o = !1 !== r.end, a = "", i = 0; i < e.length; i++) {
    var s = e[i];
    if ("string" == typeof s) a += escapeString(s);else {
      var c = escapeString(s.prefix),
          u = "(?:" + s.pattern + ")";
      t.push(s), s.repeat && (u += "(?:" + c + u + ")*"), a += u = s.optional ? s.partial ? c + "(" + u + ")?" : "(?:" + c + "(" + u + "))?" : c + "(" + u + ")";
    }
  }

  var l = escapeString(r.delimiter || "/"),
      f = a.slice(-l.length) === l;
  return n || (a = (f ? a.slice(0, -l.length) : a) + "(?:" + l + "(?=$))?"), a += o ? "$" : n && f ? "" : "(?=" + l + "|$)", attachKeys(new RegExp("^" + a, flags(r)), t);
}

function pathToRegexp(e, t, r) {
  return isarray(t) || (r = t || r, t = []), r = r || {}, e instanceof RegExp ? regexpToRegexp(e, t) : isarray(e) ? arrayToRegexp(e, t, r) : stringToRegexp(e, t, r);
}

pathToRegexp_1.parse = parse_1, pathToRegexp_1.compile = compile_1, pathToRegexp_1.tokensToFunction = tokensToFunction_1, pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

var patternCache = {},
    cacheLimit = 1e4,
    cacheCount = 0,
    compilePath = function compilePath(e, t) {
  var r = "" + t.end + t.strict + t.sensitive,
      n = patternCache[r] || (patternCache[r] = {});
  if (n[e]) return n[e];
  var o = [],
      a = {
    re: pathToRegexp_1(e, o, t),
    keys: o
  };
  return cacheCount < cacheLimit && (n[e] = a, cacheCount++), a;
},
    matchPath = function matchPath(e) {
  var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
      r = arguments[2];
  "string" == typeof t && (t = {
    path: t
  });
  var n = t,
      o = n.path,
      a = n.exact,
      i = void 0 !== a && a,
      s = n.strict,
      c = void 0 !== s && s,
      u = n.sensitive;
  if (null == o) return r;
  var l = compilePath(o, {
    end: i,
    strict: c,
    sensitive: void 0 !== u && u
  }),
      f = l.re,
      p = l.keys,
      d = f.exec(e);
  if (!d) return null;
  var h = d[0],
      y = d.slice(1),
      m = e === h;
  return i && !m ? null : {
    path: o,
    url: "/" === o && "" === h ? "/" : h,
    isExact: m,
    params: p.reduce(function (e, t, r) {
      return e[t.name] = y[r], e;
    }, {})
  };
},
    _extends$c = Object.assign || function (e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];

    for (var n in r) {
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
  }

  return e;
};

function _classCallCheck$6(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _possibleConstructorReturn$6(e, t) {
  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !t || "object" != typeof t && "function" != typeof t ? e : t;
}

function _inherits$6(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}

var isEmptyChildren = function isEmptyChildren(e) {
  return 0 === react.Children.count(e);
},
    Route = function (a) {
  function i() {
    var e, t;

    _classCallCheck$6(this, i);

    for (var r = arguments.length, n = Array(r), o = 0; o < r; o++) {
      n[o] = arguments[o];
    }

    return (e = t = _possibleConstructorReturn$6(this, a.call.apply(a, [this].concat(n)))).state = {
      match: t.computeMatch(t.props, t.context.router)
    }, _possibleConstructorReturn$6(t, e);
  }

  return _inherits$6(i, a), i.prototype.getChildContext = function () {
    return {
      router: _extends$c({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  }, i.prototype.computeMatch = function (e, t) {
    var r = e.computedMatch,
        n = e.location,
        o = e.path,
        a = e.strict,
        i = e.exact,
        s = e.sensitive;
    if (r) return r;
    browser$1(t, "You should not use <Route> or withRouter() outside a <Router>");
    var c = t.route,
        u = (n || c.location).pathname;
    return matchPath(u, {
      path: o,
      strict: a,
      exact: i,
      sensitive: s
    }, c.match);
  }, i.prototype.componentWillMount = function () {
    warning_1$1(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored"), warning_1$1(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored"), warning_1$1(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  }, i.prototype.componentWillReceiveProps = function (e, t) {
    warning_1$1(!(e.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.'), warning_1$1(!(!e.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.'), this.setState({
      match: this.computeMatch(e, t.router)
    });
  }, i.prototype.render = function () {
    var e = this.state.match,
        t = this.props,
        r = t.children,
        n = t.component,
        o = t.render,
        a = this.context.router,
        i = a.history,
        s = a.route,
        c = a.staticContext,
        u = {
      match: e,
      location: this.props.location || s.location,
      history: i,
      staticContext: c
    };
    return n ? e ? react.createElement(n, u) : null : o ? e ? o(u) : null : "function" == typeof r ? r(u) : r && !isEmptyChildren(r) ? react.Children.only(r) : null;
  }, i;
}(react.Component);

Route.propTypes = {
  computedMatch: propTypes.object,
  path: propTypes.string,
  exact: propTypes.bool,
  strict: propTypes.bool,
  sensitive: propTypes.bool,
  component: propTypes.func,
  render: propTypes.func,
  children: propTypes.oneOfType([propTypes.func, propTypes.node]),
  location: propTypes.object
}, Route.contextTypes = {
  router: propTypes.shape({
    history: propTypes.object.isRequired,
    route: propTypes.object.isRequired,
    staticContext: propTypes.object
  })
}, Route.childContextTypes = {
  router: propTypes.object.isRequired
};

var _extends$d = Object.assign || function (e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];

    for (var n in r) {
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
  }

  return e;
},
    _typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
  return typeof e;
} : function (e) {
  return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
};

function _objectWithoutProperties$2(e, t) {
  var r = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
  }

  return r;
}

var NavLink = function NavLink(e) {
  var o = e.to,
      t = e.exact,
      r = e.strict,
      n = e.location,
      a = e.activeClassName,
      i = e.className,
      s = e.activeStyle,
      c = e.style,
      u = e.isActive,
      l = e["aria-current"],
      f = _objectWithoutProperties$2(e, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]),
      p = "object" === (void 0 === o ? "undefined" : _typeof$3(o)) ? o.pathname : o,
      d = p && p.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return react.createElement(Route, {
    path: d,
    exact: t,
    strict: r,
    location: n,
    children: function children(e) {
      var t = e.location,
          r = e.match,
          n = !!(u ? u(r, t) : r);
      return react.createElement(Link, _extends$d({
        to: o,
        className: n ? [i, a].filter(function (e) {
          return e;
        }).join(" ") : i,
        style: n ? _extends$d({}, c, s) : c,
        "aria-current": n && l || null
      }, f));
    }
  });
};

function _classCallCheck$7(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _possibleConstructorReturn$7(e, t) {
  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !t || "object" != typeof t && "function" != typeof t ? e : t;
}

function _inherits$7(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}

NavLink.propTypes = {
  to: Link.propTypes.to,
  exact: propTypes.bool,
  strict: propTypes.bool,
  location: propTypes.object,
  activeClassName: propTypes.string,
  className: propTypes.string,
  activeStyle: propTypes.object,
  style: propTypes.object,
  isActive: propTypes.func,
  "aria-current": propTypes.oneOf(["page", "step", "location", "date", "time", "true"])
}, NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

var Prompt = function (e) {
  function t() {
    return _classCallCheck$7(this, t), _possibleConstructorReturn$7(this, e.apply(this, arguments));
  }

  return _inherits$7(t, e), t.prototype.enable = function (e) {
    this.unblock && this.unblock(), this.unblock = this.context.router.history.block(e);
  }, t.prototype.disable = function () {
    this.unblock && (this.unblock(), this.unblock = null);
  }, t.prototype.componentWillMount = function () {
    browser$1(this.context.router, "You should not use <Prompt> outside a <Router>"), this.props.when && this.enable(this.props.message);
  }, t.prototype.componentWillReceiveProps = function (e) {
    e.when ? this.props.when && this.props.message === e.message || this.enable(e.message) : this.disable();
  }, t.prototype.componentWillUnmount = function () {
    this.disable();
  }, t.prototype.render = function () {
    return null;
  }, t;
}(react.Component);

Prompt.propTypes = {
  when: propTypes.bool,
  message: propTypes.oneOfType([propTypes.func, propTypes.string]).isRequired
}, Prompt.defaultProps = {
  when: !0
}, Prompt.contextTypes = {
  router: propTypes.shape({
    history: propTypes.shape({
      block: propTypes.func.isRequired
    }).isRequired
  }).isRequired
};

var patternCache$1 = {},
    cacheLimit$1 = 1e4,
    cacheCount$1 = 0,
    compileGenerator = function compileGenerator(e) {
  var t = e,
      r = patternCache$1[t] || (patternCache$1[t] = {});
  if (r[e]) return r[e];
  var n = pathToRegexp_1.compile(e);
  return cacheCount$1 < cacheLimit$1 && (r[e] = n, cacheCount$1++), n;
},
    generatePath = function generatePath() {
  var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : "/",
      t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
  return "/" === e ? e : compileGenerator(e)(t, {
    pretty: !0
  });
},
    _extends$e = Object.assign || function (e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];

    for (var n in r) {
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
  }

  return e;
};

function _classCallCheck$8(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _possibleConstructorReturn$8(e, t) {
  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !t || "object" != typeof t && "function" != typeof t ? e : t;
}

function _inherits$8(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}

var Redirect = function (e) {
  function t() {
    return _classCallCheck$8(this, t), _possibleConstructorReturn$8(this, e.apply(this, arguments));
  }

  return _inherits$8(t, e), t.prototype.isStatic = function () {
    return this.context.router && this.context.router.staticContext;
  }, t.prototype.componentWillMount = function () {
    browser$1(this.context.router, "You should not use <Redirect> outside a <Router>"), this.isStatic() && this.perform();
  }, t.prototype.componentDidMount = function () {
    this.isStatic() || this.perform();
  }, t.prototype.componentDidUpdate = function (e) {
    var t = createLocation(e.to),
        r = createLocation(this.props.to);
    locationsAreEqual(t, r) ? warning_1$1(!1, "You tried to redirect to the same route you're currently on: \"" + r.pathname + r.search + '"') : this.perform();
  }, t.prototype.computeTo = function (e) {
    var t = e.computedMatch,
        r = e.to;
    return t ? "string" == typeof r ? generatePath(r, t.params) : _extends$e({}, r, {
      pathname: generatePath(r.pathname, t.params)
    }) : r;
  }, t.prototype.perform = function () {
    var e = this.context.router.history,
        t = this.props.push,
        r = this.computeTo(this.props);
    t ? e.push(r) : e.replace(r);
  }, t.prototype.render = function () {
    return null;
  }, t;
}(react.Component);

Redirect.propTypes = {
  computedMatch: propTypes.object,
  push: propTypes.bool,
  from: propTypes.string,
  to: propTypes.oneOfType([propTypes.string, propTypes.object]).isRequired
}, Redirect.defaultProps = {
  push: !1
}, Redirect.contextTypes = {
  router: propTypes.shape({
    history: propTypes.shape({
      push: propTypes.func.isRequired,
      replace: propTypes.func.isRequired
    }).isRequired,
    staticContext: propTypes.object
  }).isRequired
};

var _extends$f = Object.assign || function (e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];

    for (var n in r) {
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$3(e, t) {
  var r = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
  }

  return r;
}

function _classCallCheck$9(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _possibleConstructorReturn$9(e, t) {
  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !t || "object" != typeof t && "function" != typeof t ? e : t;
}

function _inherits$9(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}

var addLeadingSlash$1 = function addLeadingSlash$1(e) {
  return "/" === e.charAt(0) ? e : "/" + e;
},
    addBasename = function addBasename(e, t) {
  return e ? _extends$f({}, t, {
    pathname: addLeadingSlash$1(e) + t.pathname
  }) : t;
},
    stripBasename$1 = function stripBasename$1(e, t) {
  if (!e) return t;
  var r = addLeadingSlash$1(e);
  return 0 !== t.pathname.indexOf(r) ? t : _extends$f({}, t, {
    pathname: t.pathname.substr(r.length)
  });
},
    createURL = function createURL(e) {
  return "string" == typeof e ? e : createPath(e);
},
    staticHandler = function staticHandler(e) {
  return function () {
    browser$1(!1, "You cannot %s with <StaticRouter>", e);
  };
},
    noop$1 = function noop$1() {},
    StaticRouter = function (a) {
  function i() {
    var e, o;

    _classCallCheck$9(this, i);

    for (var t = arguments.length, r = Array(t), n = 0; n < t; n++) {
      r[n] = arguments[n];
    }

    return (e = o = _possibleConstructorReturn$9(this, a.call.apply(a, [this].concat(r)))).createHref = function (e) {
      return addLeadingSlash$1(o.props.basename + createURL(e));
    }, o.handlePush = function (e) {
      var t = o.props,
          r = t.basename,
          n = t.context;
      n.action = "PUSH", n.location = addBasename(r, createLocation(e)), n.url = createURL(n.location);
    }, o.handleReplace = function (e) {
      var t = o.props,
          r = t.basename,
          n = t.context;
      n.action = "REPLACE", n.location = addBasename(r, createLocation(e)), n.url = createURL(n.location);
    }, o.handleListen = function () {
      return noop$1;
    }, o.handleBlock = function () {
      return noop$1;
    }, _possibleConstructorReturn$9(o, e);
  }

  return _inherits$9(i, a), i.prototype.getChildContext = function () {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  }, i.prototype.componentWillMount = function () {
    warning_1$1(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, use `import { Router }` instead of `import { StaticRouter as Router }`.");
  }, i.prototype.render = function () {
    var e = this.props,
        t = e.basename,
        r = (e.context, e.location),
        n = _objectWithoutProperties$3(e, ["basename", "context", "location"]),
        o = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename$1(t, createLocation(r)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return react.createElement(Router, _extends$f({}, n, {
      history: o
    }));
  }, i;
}(react.Component);

function _classCallCheck$a(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _possibleConstructorReturn$a(e, t) {
  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !t || "object" != typeof t && "function" != typeof t ? e : t;
}

function _inherits$a(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}

StaticRouter.propTypes = {
  basename: propTypes.string,
  context: propTypes.object.isRequired,
  location: propTypes.oneOfType([propTypes.string, propTypes.object])
}, StaticRouter.defaultProps = {
  basename: "",
  location: "/"
}, StaticRouter.childContextTypes = {
  router: propTypes.object.isRequired
};

var Switch = function (e) {
  function t() {
    return _classCallCheck$a(this, t), _possibleConstructorReturn$a(this, e.apply(this, arguments));
  }

  return _inherits$a(t, e), t.prototype.componentWillMount = function () {
    browser$1(this.context.router, "You should not use <Switch> outside a <Router>");
  }, t.prototype.componentWillReceiveProps = function (e) {
    warning_1$1(!(e.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.'), warning_1$1(!(!e.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  }, t.prototype.render = function () {
    var c = this.context.router.route,
        e = this.props.children,
        u = this.props.location || c.location,
        l = void 0,
        f = void 0;
    return react.Children.forEach(e, function (e) {
      if (null == l && react.isValidElement(e)) {
        var t = e.props,
            r = t.path,
            n = t.exact,
            o = t.strict,
            a = t.sensitive,
            i = t.from,
            s = r || i;
        f = e, l = matchPath(u.pathname, {
          path: s,
          exact: n,
          strict: o,
          sensitive: a
        }, c.match);
      }
    }), l ? react.cloneElement(f, {
      location: u,
      computedMatch: l
    }) : null;
  }, t;
}(react.Component);

Switch.contextTypes = {
  router: propTypes.shape({
    route: propTypes.object.isRequired
  }).isRequired
}, Switch.propTypes = {
  children: propTypes.node,
  location: propTypes.object
};
var REACT_STATICS = {
  childContextTypes: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
},
    KNOWN_STATICS = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
},
    defineProperty$2 = Object.defineProperty,
    getOwnPropertyNames = Object.getOwnPropertyNames,
    getOwnPropertySymbols$1 = Object.getOwnPropertySymbols,
    getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor,
    getPrototypeOf$1 = Object.getPrototypeOf,
    objectPrototype = getPrototypeOf$1 && getPrototypeOf$1(Object);

function hoistNonReactStatics(e, t, r) {
  if ("string" == typeof t) return e;

  if (objectPrototype) {
    var n = getPrototypeOf$1(t);
    n && n !== objectPrototype && hoistNonReactStatics(e, n, r);
  }

  var o = getOwnPropertyNames(t);
  getOwnPropertySymbols$1 && (o = o.concat(getOwnPropertySymbols$1(t)));

  for (var a = 0; a < o.length; ++a) {
    var i = o[a];

    if (!(REACT_STATICS[i] || KNOWN_STATICS[i] || r && r[i])) {
      var s = getOwnPropertyDescriptor(t, i);

      try {
        defineProperty$2(e, i, s);
      } catch (e) {}
    }
  }

  return e;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics,
    s$N = {
  topMenuItem: "styles-module_topMenuItem__v_KPS",
  active: "styles-module_active__7pij_"
},
    TopMenuItem = function TopMenuItem(e) {
  var t = e.className,
      r = objectWithoutProperties(e, ["className"]);
  return react.createElement(NavLink, _extends_1({
    activeClassName: s$N.active,
    className: classnames(s$N.topMenuItem, t)
  }, r));
};

TopMenuItem.defaultProps = {
  className: null
};

var s$O = {
  title: "styles-module_title__2sjJH"
},
    TopMenu = function TopMenu(e) {
  var t = e.items,
      r = objectWithoutProperties(e, ["items"]);
  return react.createElement("div", _extends_1({
    className: s$O.title
  }, r), t.map(function (e, t) {
    var r = e.text,
        n = objectWithoutProperties(e, ["text"]);
    return react.createElement(TopMenuItem, _extends_1({
      key: t
    }, n), r);
  }));
},
    prefix$1 = "@@redux-form/",
    ARRAY_INSERT = prefix$1 + "ARRAY_INSERT",
    ARRAY_MOVE = prefix$1 + "ARRAY_MOVE",
    ARRAY_POP = prefix$1 + "ARRAY_POP",
    ARRAY_PUSH = prefix$1 + "ARRAY_PUSH",
    ARRAY_REMOVE = prefix$1 + "ARRAY_REMOVE",
    ARRAY_REMOVE_ALL = prefix$1 + "ARRAY_REMOVE_ALL",
    ARRAY_SHIFT = prefix$1 + "ARRAY_SHIFT",
    ARRAY_SPLICE = prefix$1 + "ARRAY_SPLICE",
    ARRAY_UNSHIFT = prefix$1 + "ARRAY_UNSHIFT",
    ARRAY_SWAP = prefix$1 + "ARRAY_SWAP",
    AUTOFILL = prefix$1 + "AUTOFILL",
    BLUR = prefix$1 + "BLUR",
    CHANGE = prefix$1 + "CHANGE",
    CLEAR_FIELDS = prefix$1 + "CLEAR_FIELDS",
    CLEAR_SUBMIT = prefix$1 + "CLEAR_SUBMIT",
    CLEAR_SUBMIT_ERRORS = prefix$1 + "CLEAR_SUBMIT_ERRORS",
    CLEAR_ASYNC_ERROR = prefix$1 + "CLEAR_ASYNC_ERROR",
    DESTROY = prefix$1 + "DESTROY",
    FOCUS = prefix$1 + "FOCUS",
    INITIALIZE = prefix$1 + "INITIALIZE",
    REGISTER_FIELD = prefix$1 + "REGISTER_FIELD",
    RESET = prefix$1 + "RESET",
    RESET_SECTION = prefix$1 + "RESET_SECTION",
    SET_SUBMIT_FAILED = prefix$1 + "SET_SUBMIT_FAILED",
    SET_SUBMIT_SUCCEEDED = prefix$1 + "SET_SUBMIT_SUCCEEDED",
    START_ASYNC_VALIDATION = prefix$1 + "START_ASYNC_VALIDATION",
    START_SUBMIT = prefix$1 + "START_SUBMIT",
    STOP_ASYNC_VALIDATION = prefix$1 + "STOP_ASYNC_VALIDATION",
    STOP_SUBMIT = prefix$1 + "STOP_SUBMIT",
    SUBMIT = prefix$1 + "SUBMIT",
    TOUCH = prefix$1 + "TOUCH",
    UNREGISTER_FIELD = prefix$1 + "UNREGISTER_FIELD",
    UNTOUCH = prefix$1 + "UNTOUCH",
    UPDATE_SYNC_ERRORS = prefix$1 + "UPDATE_SYNC_ERRORS",
    UPDATE_SYNC_WARNINGS = prefix$1 + "UPDATE_SYNC_WARNINGS",
    _extends$g = Object.assign || function (e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];

    for (var n in r) {
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
  }

  return e;
},
    arrayInsert = function arrayInsert(e, t, r, n) {
  return {
    type: ARRAY_INSERT,
    meta: {
      form: e,
      field: t,
      index: r
    },
    payload: n
  };
},
    arrayMove = function arrayMove(e, t, r, n) {
  return {
    type: ARRAY_MOVE,
    meta: {
      form: e,
      field: t,
      from: r,
      to: n
    }
  };
},
    arrayPop = function arrayPop(e, t) {
  return {
    type: ARRAY_POP,
    meta: {
      form: e,
      field: t
    }
  };
},
    arrayPush = function arrayPush(e, t, r) {
  return {
    type: ARRAY_PUSH,
    meta: {
      form: e,
      field: t
    },
    payload: r
  };
},
    arrayRemove = function arrayRemove(e, t, r) {
  return {
    type: ARRAY_REMOVE,
    meta: {
      form: e,
      field: t,
      index: r
    }
  };
},
    arrayRemoveAll = function arrayRemoveAll(e, t) {
  return {
    type: ARRAY_REMOVE_ALL,
    meta: {
      form: e,
      field: t
    }
  };
},
    arrayShift = function arrayShift(e, t) {
  return {
    type: ARRAY_SHIFT,
    meta: {
      form: e,
      field: t
    }
  };
},
    arraySplice = function arraySplice(e, t, r, n, o) {
  var a = {
    type: ARRAY_SPLICE,
    meta: {
      form: e,
      field: t,
      index: r,
      removeNum: n
    }
  };
  return void 0 !== o && (a.payload = o), a;
},
    arraySwap = function arraySwap(e, t, r, n) {
  if (r === n) throw new Error("Swap indices cannot be equal");
  if (r < 0 || n < 0) throw new Error("Swap indices cannot be negative");
  return {
    type: ARRAY_SWAP,
    meta: {
      form: e,
      field: t,
      indexA: r,
      indexB: n
    }
  };
},
    arrayUnshift = function arrayUnshift(e, t, r) {
  return {
    type: ARRAY_UNSHIFT,
    meta: {
      form: e,
      field: t
    },
    payload: r
  };
},
    autofill = function autofill(e, t, r) {
  return {
    type: AUTOFILL,
    meta: {
      form: e,
      field: t
    },
    payload: r
  };
},
    blur = function blur(e, t, r, n) {
  return {
    type: BLUR,
    meta: {
      form: e,
      field: t,
      touch: n
    },
    payload: r
  };
},
    change = function change(e, t, r, n, o) {
  return {
    type: CHANGE,
    meta: {
      form: e,
      field: t,
      touch: n,
      persistentSubmitErrors: o
    },
    payload: r
  };
},
    clearSubmit = function clearSubmit(e) {
  return {
    type: CLEAR_SUBMIT,
    meta: {
      form: e
    }
  };
},
    clearSubmitErrors = function clearSubmitErrors(e) {
  return {
    type: CLEAR_SUBMIT_ERRORS,
    meta: {
      form: e
    }
  };
},
    clearAsyncError = function clearAsyncError(e, t) {
  return {
    type: CLEAR_ASYNC_ERROR,
    meta: {
      form: e,
      field: t
    }
  };
},
    clearFields = function clearFields(e, t, r) {
  for (var n = arguments.length, o = Array(3 < n ? n - 3 : 0), a = 3; a < n; a++) {
    o[a - 3] = arguments[a];
  }

  return {
    type: CLEAR_FIELDS,
    meta: {
      form: e,
      keepTouched: t,
      persistentSubmitErrors: r,
      fields: o
    }
  };
},
    destroy = function destroy() {
  for (var e = arguments.length, t = Array(e), r = 0; r < e; r++) {
    t[r] = arguments[r];
  }

  return {
    type: DESTROY,
    meta: {
      form: t
    }
  };
},
    focus = function focus(e, t) {
  return {
    type: FOCUS,
    meta: {
      form: e,
      field: t
    }
  };
},
    initialize$1 = function initialize$1(e, t, r) {
  var n = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : {};
  return r instanceof Object && (n = r, r = !1), {
    type: INITIALIZE,
    meta: _extends$g({
      form: e,
      keepDirty: r
    }, n),
    payload: t
  };
},
    registerField = function registerField(e, t, r) {
  return {
    type: REGISTER_FIELD,
    meta: {
      form: e
    },
    payload: {
      name: t,
      type: r
    }
  };
},
    reset = function reset(e) {
  return {
    type: RESET,
    meta: {
      form: e
    }
  };
},
    resetSection = function resetSection(e) {
  for (var t = arguments.length, r = Array(1 < t ? t - 1 : 0), n = 1; n < t; n++) {
    r[n - 1] = arguments[n];
  }

  return {
    type: RESET_SECTION,
    meta: {
      form: e,
      sections: r
    }
  };
},
    startAsyncValidation = function startAsyncValidation(e, t) {
  return {
    type: START_ASYNC_VALIDATION,
    meta: {
      form: e,
      field: t
    }
  };
},
    startSubmit = function startSubmit(e) {
  return {
    type: START_SUBMIT,
    meta: {
      form: e
    }
  };
},
    stopAsyncValidation = function stopAsyncValidation(e, t) {
  return {
    type: STOP_ASYNC_VALIDATION,
    meta: {
      form: e
    },
    payload: t,
    error: !(!t || !Object.keys(t).length)
  };
},
    stopSubmit = function stopSubmit(e, t) {
  return {
    type: STOP_SUBMIT,
    meta: {
      form: e
    },
    payload: t,
    error: !(!t || !Object.keys(t).length)
  };
},
    submit = function submit(e) {
  return {
    type: SUBMIT,
    meta: {
      form: e
    }
  };
},
    setSubmitFailed = function setSubmitFailed(e) {
  for (var t = arguments.length, r = Array(1 < t ? t - 1 : 0), n = 1; n < t; n++) {
    r[n - 1] = arguments[n];
  }

  return {
    type: SET_SUBMIT_FAILED,
    meta: {
      form: e,
      fields: r
    },
    error: !0
  };
},
    setSubmitSucceeded = function setSubmitSucceeded(e) {
  for (var t = arguments.length, r = Array(1 < t ? t - 1 : 0), n = 1; n < t; n++) {
    r[n - 1] = arguments[n];
  }

  return {
    type: SET_SUBMIT_SUCCEEDED,
    meta: {
      form: e,
      fields: r
    },
    error: !1
  };
},
    touch = function touch(e) {
  for (var t = arguments.length, r = Array(1 < t ? t - 1 : 0), n = 1; n < t; n++) {
    r[n - 1] = arguments[n];
  }

  return {
    type: TOUCH,
    meta: {
      form: e,
      fields: r
    }
  };
},
    unregisterField = function unregisterField(e, t) {
  var r = !(2 < arguments.length && void 0 !== arguments[2]) || arguments[2];
  return {
    type: UNREGISTER_FIELD,
    meta: {
      form: e
    },
    payload: {
      name: t,
      destroyOnUnmount: r
    }
  };
},
    untouch = function untouch(e) {
  for (var t = arguments.length, r = Array(1 < t ? t - 1 : 0), n = 1; n < t; n++) {
    r[n - 1] = arguments[n];
  }

  return {
    type: UNTOUCH,
    meta: {
      form: e,
      fields: r
    }
  };
},
    updateSyncErrors = function updateSyncErrors(e) {
  var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
      r = arguments[2];
  return {
    type: UPDATE_SYNC_ERRORS,
    meta: {
      form: e
    },
    payload: {
      syncErrors: t,
      error: r
    }
  };
},
    updateSyncWarnings = function updateSyncWarnings(e) {
  var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
      r = arguments[2];
  return {
    type: UPDATE_SYNC_WARNINGS,
    meta: {
      form: e
    },
    payload: {
      syncWarnings: t,
      warning: r
    }
  };
},
    actions = {
  arrayInsert: arrayInsert,
  arrayMove: arrayMove,
  arrayPop: arrayPop,
  arrayPush: arrayPush,
  arrayRemove: arrayRemove,
  arrayRemoveAll: arrayRemoveAll,
  arrayShift: arrayShift,
  arraySplice: arraySplice,
  arraySwap: arraySwap,
  arrayUnshift: arrayUnshift,
  autofill: autofill,
  blur: blur,
  change: change,
  clearFields: clearFields,
  clearSubmit: clearSubmit,
  clearSubmitErrors: clearSubmitErrors,
  clearAsyncError: clearAsyncError,
  destroy: destroy,
  focus: focus,
  initialize: initialize$1,
  registerField: registerField,
  reset: reset,
  resetSection: resetSection,
  startAsyncValidation: startAsyncValidation,
  startSubmit: startSubmit,
  stopAsyncValidation: stopAsyncValidation,
  stopSubmit: stopSubmit,
  submit: submit,
  setSubmitFailed: setSubmitFailed,
  setSubmitSucceeded: setSubmitSucceeded,
  touch: touch,
  unregisterField: unregisterField,
  untouch: untouch,
  updateSyncErrors: updateSyncErrors,
  updateSyncWarnings: updateSyncWarnings
},
    defaultShouldAsyncValidate = function defaultShouldAsyncValidate(e) {
  var t = e.initialized,
      r = e.trigger,
      n = e.pristine;
  if (!e.syncValidationPasses) return !1;

  switch (r) {
    case "blur":
    case "change":
      return !0;

    case "submit":
      return !n || !t;

    default:
      return !1;
  }
},
    defaultShouldValidate = function defaultShouldValidate(e) {
  var t = e.values,
      r = e.nextProps,
      n = e.initialRender,
      o = e.lastFieldValidatorKeys,
      a = e.fieldValidatorKeys,
      i = e.structure;
  return !!n || !i.deepEqual(t, r && r.values) || !i.deepEqual(o, a);
},
    defaultShouldError = function defaultShouldError(e) {
  var t = e.values,
      r = e.nextProps,
      n = e.initialRender,
      o = e.lastFieldValidatorKeys,
      a = e.fieldValidatorKeys,
      i = e.structure;
  return !!n || !i.deepEqual(t, r && r.values) || !i.deepEqual(o, a);
},
    defaultShouldWarn = function defaultShouldWarn(e) {
  var t = e.values,
      r = e.nextProps,
      n = e.initialRender,
      o = e.lastFieldValidatorKeys,
      a = e.fieldValidatorKeys,
      i = e.structure;
  return !!n || !i.deepEqual(t, r && r.values) || !i.deepEqual(o, a);
};

function componentWillMount() {
  var e = this.constructor.getDerivedStateFromProps(this.props, this.state);
  null != e && this.setState(e);
}

function componentWillReceiveProps(r) {
  this.setState(function (e) {
    var t = this.constructor.getDerivedStateFromProps(r, e);
    return null != t ? t : null;
  }.bind(this));
}

function componentWillUpdate(e, t) {
  try {
    var r = this.props,
        n = this.state;
    this.props = e, this.state = t, this.__reactInternalSnapshotFlag = !0, this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(r, n);
  } finally {
    this.props = r, this.state = n;
  }
}

function polyfill$2(e) {
  var t = e.prototype;
  if (!t || !t.isReactComponent) throw new Error("Can only polyfill class components");
  if ("function" != typeof e.getDerivedStateFromProps && "function" != typeof t.getSnapshotBeforeUpdate) return e;
  var r = null,
      n = null,
      o = null;

  if ("function" == typeof t.componentWillMount ? r = "componentWillMount" : "function" == typeof t.UNSAFE_componentWillMount && (r = "UNSAFE_componentWillMount"), "function" == typeof t.componentWillReceiveProps ? n = "componentWillReceiveProps" : "function" == typeof t.UNSAFE_componentWillReceiveProps && (n = "UNSAFE_componentWillReceiveProps"), "function" == typeof t.componentWillUpdate ? o = "componentWillUpdate" : "function" == typeof t.UNSAFE_componentWillUpdate && (o = "UNSAFE_componentWillUpdate"), null !== r || null !== n || null !== o) {
    var a = e.displayName || e.name,
        i = "function" == typeof e.getDerivedStateFromProps ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
    throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + a + " uses " + i + " but also contains the following legacy lifecycles:" + (null !== r ? "\n  " + r : "") + (null !== n ? "\n  " + n : "") + (null !== o ? "\n  " + o : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://fb.me/react-async-component-lifecycle-hooks");
  }

  if ("function" == typeof e.getDerivedStateFromProps && (t.componentWillMount = componentWillMount, t.componentWillReceiveProps = componentWillReceiveProps), "function" == typeof t.getSnapshotBeforeUpdate) {
    if ("function" != typeof t.componentDidUpdate) throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
    t.componentWillUpdate = componentWillUpdate;
    var s = t.componentDidUpdate;

    t.componentDidUpdate = function (e, t, r) {
      var n = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : r;
      s.call(this, e, t, n);
    };
  }

  return e;
}

componentWillMount.__suppressDeprecationWarning = !0, componentWillReceiveProps.__suppressDeprecationWarning = !0, componentWillUpdate.__suppressDeprecationWarning = !0;

var _createClass$1 = function () {
  function n(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  return function (e, t, r) {
    return t && n(e.prototype, t), r && n(e, r), e;
  };
}();

function _classCallCheck$b(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _possibleConstructorReturn$b(e, t) {
  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !t || "object" != typeof t && "function" != typeof t ? e : t;
}

function _inherits$b(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}

var Form = function (e) {
  function n(e, t) {
    _classCallCheck$b(this, n);

    var r = _possibleConstructorReturn$b(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, e, t));

    if (!t._reduxForm) throw new Error("Form must be inside a component decorated with reduxForm()");
    return r;
  }

  return _inherits$b(n, react_1), _createClass$1(n, [{
    key: "componentWillMount",
    value: function value() {
      this.context._reduxForm.registerInnerOnSubmit(this.props.onSubmit);
    }
  }, {
    key: "render",
    value: function value() {
      return react.createElement("form", this.props);
    }
  }]), n;
}();

Form.propTypes = {
  onSubmit: propTypes.func.isRequired
}, Form.contextTypes = {
  _reduxForm: propTypes.object
}, polyfill$2(Form);

var FormName = function FormName(e, t) {
  var r = e.children,
      n = t._reduxForm;
  return r({
    form: n && n.form
  });
};

FormName.contextTypes = {
  _reduxForm: propTypes.shape({
    form: propTypes.string.isRequired
  }).isRequired
};

var formatName = function formatName(e, t) {
  var r = e._reduxForm.sectionPrefix;
  return r ? r + "." + t : t;
},
    _extends$h = Object.assign || function (e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];

    for (var n in r) {
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
  }

  return e;
},
    _createClass$2 = function () {
  function n(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  return function (e, t, r) {
    return t && n(e.prototype, t), r && n(e, r), e;
  };
}();

function _objectWithoutProperties$4(e, t) {
  var r = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
  }

  return r;
}

function _classCallCheck$c(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _possibleConstructorReturn$c(e, t) {
  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !t || "object" != typeof t && "function" != typeof t ? e : t;
}

function _inherits$c(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}

var FormSection = function (e) {
  function n(e, t) {
    _classCallCheck$c(this, n);

    var r = _possibleConstructorReturn$c(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, e, t));

    if (!t._reduxForm) throw new Error("FormSection must be inside a component decorated with reduxForm()");
    return r;
  }

  return _inherits$c(n, react_1), _createClass$2(n, [{
    key: "getChildContext",
    value: function value() {
      var e = this.context,
          t = this.props.name;
      return {
        _reduxForm: _extends$h({}, e._reduxForm, {
          sectionPrefix: formatName(e, t)
        })
      };
    }
  }, {
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.children,
          r = (e.name, e.component),
          n = _objectWithoutProperties$4(e, ["children", "name", "component"]);

      return react.isValidElement(t) ? t : react_5(r, _extends$h({}, n, {
        children: t
      }));
    }
  }]), n;
}();

function _classCallCheck$d(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _possibleConstructorReturn$d(e, t) {
  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !t || "object" != typeof t && "function" != typeof t ? e : t;
}

function _inherits$d(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}

function _extendableBuiltin(e) {
  function t() {
    e.apply(this, arguments);
  }

  return t.prototype = Object.create(e.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e, t;
}

FormSection.propTypes = {
  name: propTypes.string.isRequired,
  component: propTypes.oneOfType([propTypes.func, propTypes.string, propTypes.node])
}, FormSection.defaultProps = {
  component: "div"
}, FormSection.childContextTypes = {
  _reduxForm: propTypes.object.isRequired
}, FormSection.contextTypes = {
  _reduxForm: propTypes.object
};

var ExtendableError = function (e) {
  function r() {
    var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : "";

    _classCallCheck$d(this, r);

    var t = _possibleConstructorReturn$d(this, (r.__proto__ || Object.getPrototypeOf(r)).call(this, e));

    return Object.defineProperty(t, "message", {
      configurable: !0,
      enumerable: !1,
      value: e,
      writable: !0
    }), Object.defineProperty(t, "name", {
      configurable: !0,
      enumerable: !1,
      value: t.constructor.name,
      writable: !0
    }), Error.hasOwnProperty("captureStackTrace") ? (Error.captureStackTrace(t, t.constructor), _possibleConstructorReturn$d(t)) : (Object.defineProperty(t, "stack", {
      configurable: !0,
      enumerable: !1,
      value: new Error(e).stack,
      writable: !0
    }), t);
  }

  return _inherits$d(r, _extendableBuiltin(Error)), r;
}();

function _classCallCheck$e(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _possibleConstructorReturn$e(e, t) {
  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !t || "object" != typeof t && "function" != typeof t ? e : t;
}

function _inherits$e(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}

var SubmissionError = function (e) {
  function r(e) {
    _classCallCheck$e(this, r);

    var t = _possibleConstructorReturn$e(this, (r.__proto__ || Object.getPrototypeOf(r)).call(this, "Submit Validation Failed"));

    return t.errors = e, t;
  }

  return _inherits$e(r, ExtendableError), r;
}(),
    any = propTypes.any,
    bool = propTypes.bool,
    func = propTypes.func,
    shape = propTypes.shape,
    string = propTypes.string,
    oneOfType = propTypes.oneOfType,
    object$1 = propTypes.object,
    number$1 = propTypes.number,
    formPropTypes = {
  anyTouched: bool.isRequired,
  asyncValidating: oneOfType([bool, string]).isRequired,
  dirty: bool.isRequired,
  error: any,
  form: string.isRequired,
  invalid: bool.isRequired,
  initialized: bool.isRequired,
  initialValues: object$1,
  pristine: bool.isRequired,
  pure: bool.isRequired,
  submitting: bool.isRequired,
  submitFailed: bool.isRequired,
  submitSucceeded: bool.isRequired,
  valid: bool.isRequired,
  warning: any,
  array: shape({
    insert: func.isRequired,
    move: func.isRequired,
    pop: func.isRequired,
    push: func.isRequired,
    remove: func.isRequired,
    removeAll: func.isRequired,
    shift: func.isRequired,
    splice: func.isRequired,
    swap: func.isRequired,
    unshift: func.isRequired
  }),
  asyncValidate: func.isRequired,
  autofill: func.isRequired,
  blur: func.isRequired,
  change: func.isRequired,
  clearAsyncError: func.isRequired,
  clearFields: func.isRequired,
  clearSubmitErrors: func.isRequired,
  destroy: func.isRequired,
  dispatch: func.isRequired,
  handleSubmit: func.isRequired,
  initialize: func.isRequired,
  reset: func.isRequired,
  resetSection: func.isRequired,
  touch: func.isRequired,
  submit: func.isRequired,
  untouch: func.isRequired,
  triggerSubmit: bool,
  clearSubmit: func.isRequired
},
    fieldInputPropTypes = {
  checked: bool,
  name: string.isRequired,
  onBlur: func.isRequired,
  onChange: func.isRequired,
  onDragStart: func.isRequired,
  onDrop: func.isRequired,
  onFocus: func.isRequired,
  value: any
},
    fieldMetaPropTypes = {
  active: bool.isRequired,
  asyncValidating: bool.isRequired,
  autofilled: bool.isRequired,
  dirty: bool.isRequired,
  dispatch: func.isRequired,
  error: any,
  form: string.isRequired,
  invalid: bool.isRequired,
  pristine: bool.isRequired,
  submitting: bool.isRequired,
  submitFailed: bool.isRequired,
  touched: bool.isRequired,
  valid: bool.isRequired,
  visited: bool.isRequired,
  warning: string
},
    fieldArrayMetaPropTypes = {
  dirty: bool.isRequired,
  error: any,
  form: string.isRequired,
  invalid: bool.isRequired,
  pristine: bool.isRequired,
  submitFailed: bool,
  submitting: bool,
  valid: bool.isRequired,
  warning: string
},
    fieldArrayFieldsPropTypes = {
  name: string.isRequired,
  forEach: func.isRequired,
  get: func.isRequired,
  getAll: func.isRequired,
  insert: func.isRequired,
  length: number$1.isRequired,
  map: func.isRequired,
  move: func.isRequired,
  pop: func.isRequired,
  push: func.isRequired,
  reduce: func.isRequired,
  remove: func.isRequired,
  removeAll: func.isRequired,
  shift: func.isRequired,
  swap: func.isRequired,
  unshift: func.isRequired
},
    fieldPropTypes = {
  input: shape(fieldInputPropTypes).isRequired,
  meta: shape(fieldMetaPropTypes).isRequired
},
    fieldArrayPropTypes = {
  fields: shape(fieldArrayFieldsPropTypes).isRequired,
  meta: shape(fieldArrayMetaPropTypes).isRequired
};

function _inheritsLoose(e, t) {
  e.prototype = Object.create(t.prototype), (e.prototype.constructor = e).__proto__ = t;
}

var subscriptionShape = propTypes.shape({
  trySubscribe: propTypes.func.isRequired,
  tryUnsubscribe: propTypes.func.isRequired,
  notifyNestedSubs: propTypes.func.isRequired,
  isSubscribed: propTypes.func.isRequired
}),
    storeShape = propTypes.shape({
  subscribe: propTypes.func.isRequired,
  dispatch: propTypes.func.isRequired,
  getState: propTypes.func.isRequired
});

function warning$3(e) {
  "undefined" != typeof console && "function" == typeof console.error && console.error(e);

  try {
    throw new Error(e);
  } catch (e) {}
}

var didWarnAboutReceivingStore = !1;

function warnAboutReceivingStore() {
  didWarnAboutReceivingStore || (didWarnAboutReceivingStore = !0, warning$3("<Provider> does not support changing `store` on the fly. It is most likely that you see this error because you updated to Redux 2.x and React Redux 2.x which no longer hot reload reducers automatically. See https://github.com/reduxjs/react-redux/releases/tag/v2.0.0 for the migration instructions."));
}

function createProvider(o) {
  var e;
  void 0 === o && (o = "store");

  var r = o + "Subscription",
      t = function (n) {
    _inheritsLoose(t, n);

    var e = t.prototype;

    function t(e, t) {
      var r;
      return (r = n.call(this, e, t) || this)[o] = e.store, r;
    }

    return e.getChildContext = function () {
      var e;
      return (e = {})[o] = this[o], e[r] = null, e;
    }, e.render = function () {
      return react_4.only(this.props.children);
    }, t;
  }(react_1);

  return "production" !== process.env.NODE_ENV && (t.prototype.componentWillReceiveProps = function (e) {
    this[o] !== e.store && warnAboutReceivingStore();
  }), t.propTypes = {
    store: storeShape.isRequired,
    children: propTypes.element.isRequired
  }, t.childContextTypes = ((e = {})[o] = storeShape.isRequired, e[r] = subscriptionShape, e), t;
}

function _assertThisInitialized$1(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function _extends$i() {
  return (_extends$i = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function _objectWithoutPropertiesLoose$1(e, t) {
  if (null == e) return {};
  var r,
      n,
      o = {},
      a = Object.keys(e);

  for (n = 0; n < a.length; n++) {
    r = a[n], 0 <= t.indexOf(r) || (o[r] = e[r]);
  }

  return o;
}

createProvider();
var REACT_STATICS$1 = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
},
    KNOWN_STATICS$1 = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
},
    FORWARD_REF_STATICS = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
},
    MEMO_STATICS = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
},
    TYPE_STATICS = {};

function getStatics(e) {
  return reactIs.isMemo(e) ? MEMO_STATICS : TYPE_STATICS[e.$$typeof] || REACT_STATICS$1;
}

TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
var defineProperty$3 = Object.defineProperty,
    getOwnPropertyNames$1 = Object.getOwnPropertyNames,
    getOwnPropertySymbols$2 = Object.getOwnPropertySymbols,
    getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor,
    getPrototypeOf$2 = Object.getPrototypeOf,
    objectPrototype$1 = Object.prototype;

function hoistNonReactStatics$1(e, t, r) {
  if ("string" == typeof t) return e;

  if (objectPrototype$1) {
    var n = getPrototypeOf$2(t);
    n && n !== objectPrototype$1 && hoistNonReactStatics$1(e, n, r);
  }

  var o = getOwnPropertyNames$1(t);
  getOwnPropertySymbols$2 && (o = o.concat(getOwnPropertySymbols$2(t)));

  for (var a = getStatics(e), i = getStatics(t), s = 0; s < o.length; ++s) {
    var c = o[s];

    if (!(KNOWN_STATICS$1[c] || r && r[c] || i && i[c] || a && a[c])) {
      var u = getOwnPropertyDescriptor$1(t, c);

      try {
        defineProperty$3(e, c, u);
      } catch (e) {}
    }
  }

  return e;
}

var hoistNonReactStatics_cjs$1 = hoistNonReactStatics$1,
    CLEARED = null,
    nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  var r = [],
      n = [];
  return {
    clear: function clear() {
      r = n = CLEARED;
    },
    notify: function notify() {
      for (var e = r = n, t = 0; t < e.length; t++) {
        e[t]();
      }
    },
    get: function get() {
      return n;
    },
    subscribe: function subscribe(e) {
      var t = !0;
      return n === r && (n = r.slice()), n.push(e), function () {
        t && r !== CLEARED && (t = !1, n === r && (n = r.slice()), n.splice(n.indexOf(e), 1));
      };
    }
  };
}

var Subscription = function () {
  function e(e, t, r) {
    this.store = e, this.parentSub = t, this.onStateChange = r, this.unsubscribe = null, this.listeners = nullListeners;
  }

  var t = e.prototype;
  return t.addNestedSub = function (e) {
    return this.trySubscribe(), this.listeners.subscribe(e);
  }, t.notifyNestedSubs = function () {
    this.listeners.notify();
  }, t.isSubscribed = function () {
    return Boolean(this.unsubscribe);
  }, t.trySubscribe = function () {
    this.unsubscribe || (this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange), this.listeners = createListenerCollection());
  }, t.tryUnsubscribe = function () {
    this.unsubscribe && (this.unsubscribe(), this.unsubscribe = null, this.listeners.clear(), this.listeners = nullListeners);
  }, e;
}(),
    hotReloadingVersion = 0,
    dummyState = {};

function noop$2() {}

function makeSelectorStateful(r, n) {
  var o = {
    run: function run(e) {
      try {
        var t = r(n.getState(), e);
        (t !== o.props || o.error) && (o.shouldComponentUpdate = !0, o.props = t, o.error = null);
      } catch (e) {
        o.shouldComponentUpdate = !0, o.error = e;
      }
    }
  };
  return o;
}

function connectAdvanced(i, e) {
  var t, r;
  void 0 === e && (e = {});

  var n = e,
      o = n.getDisplayName,
      s = void 0 === o ? function (e) {
    return "ConnectAdvanced(" + e + ")";
  } : o,
      a = n.methodName,
      c = void 0 === a ? "connectAdvanced" : a,
      u = n.renderCountProp,
      l = void 0 === u ? void 0 : u,
      f = n.shouldHandleStateChanges,
      p = void 0 === f || f,
      d = n.storeKey,
      h = void 0 === d ? "store" : d,
      y = n.withRef,
      m = void 0 !== y && y,
      b = _objectWithoutPropertiesLoose$1(n, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]),
      v = h + "Subscription",
      g = hotReloadingVersion++,
      _ = ((t = {})[h] = storeShape, t[v] = subscriptionShape, t),
      w = ((r = {})[v] = subscriptionShape, r);

  return function (r) {
    browser$1(reactIs_1(r), "You must pass a component to the function returned by " + c + ". Instead received " + JSON.stringify(r));

    var e = r.displayName || r.name || "Component",
        o = s(e),
        a = _extends$i({}, b, {
      getDisplayName: s,
      methodName: c,
      renderCountProp: l,
      shouldHandleStateChanges: p,
      storeKey: h,
      withRef: m,
      displayName: o,
      wrappedComponentName: e,
      WrappedComponent: r
    }),
        t = function (n) {
      function e(e, t) {
        var r;
        return (r = n.call(this, e, t) || this).version = g, r.state = {}, r.renderCount = 0, r.store = e[h] || t[h], r.propsMode = Boolean(e[h]), r.setWrappedInstance = r.setWrappedInstance.bind(_assertThisInitialized$1(_assertThisInitialized$1(r))), browser$1(r.store, 'Could not find "' + h + '" in either the context or props of "' + o + '". Either wrap the root component in a <Provider>, or explicitly pass "' + h + '" as a prop to "' + o + '".'), r.initSelector(), r.initSubscription(), r;
      }

      _inheritsLoose(e, n);

      var t = e.prototype;
      return t.getChildContext = function () {
        var e,
            t = this.propsMode ? null : this.subscription;
        return (e = {})[v] = t || this.context[v], e;
      }, t.componentDidMount = function () {
        p && (this.subscription.trySubscribe(), this.selector.run(this.props), this.selector.shouldComponentUpdate && this.forceUpdate());
      }, t.componentWillReceiveProps = function (e) {
        this.selector.run(e);
      }, t.shouldComponentUpdate = function () {
        return this.selector.shouldComponentUpdate;
      }, t.componentWillUnmount = function () {
        this.subscription && this.subscription.tryUnsubscribe(), this.subscription = null, this.notifyNestedSubs = noop$2, this.store = null, this.selector.run = noop$2, this.selector.shouldComponentUpdate = !1;
      }, t.getWrappedInstance = function () {
        return browser$1(m, "To access the wrapped instance, you need to specify { withRef: true } in the options argument of the " + c + "() call."), this.wrappedInstance;
      }, t.setWrappedInstance = function (e) {
        this.wrappedInstance = e;
      }, t.initSelector = function () {
        var e = i(this.store.dispatch, a);
        this.selector = makeSelectorStateful(e, this.store), this.selector.run(this.props);
      }, t.initSubscription = function () {
        if (p) {
          var e = (this.propsMode ? this.props : this.context)[v];
          this.subscription = new Subscription(this.store, e, this.onStateChange.bind(this)), this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
        }
      }, t.onStateChange = function () {
        this.selector.run(this.props), this.selector.shouldComponentUpdate ? (this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate, this.setState(dummyState)) : this.notifyNestedSubs();
      }, t.notifyNestedSubsOnComponentDidUpdate = function () {
        this.componentDidUpdate = void 0, this.notifyNestedSubs();
      }, t.isSubscribed = function () {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      }, t.addExtraProps = function (e) {
        if (!(m || l || this.propsMode && this.subscription)) return e;

        var t = _extends$i({}, e);

        return m && (t.ref = this.setWrappedInstance), l && (t[l] = this.renderCount++), this.propsMode && this.subscription && (t[v] = this.subscription), t;
      }, t.render = function () {
        var e = this.selector;
        if (e.shouldComponentUpdate = !1, e.error) throw e.error;
        return react_5(r, this.addExtraProps(e.props));
      }, e;
    }(react_1);

    return t.WrappedComponent = r, t.displayName = o, t.childContextTypes = w, t.contextTypes = _, t.propTypes = _, "production" !== process.env.NODE_ENV && (t.prototype.componentWillUpdate = function () {
      var t = this;

      if (this.version !== g) {
        this.version = g, this.initSelector();
        var e = [];
        this.subscription && (e = this.subscription.listeners.get(), this.subscription.tryUnsubscribe()), this.initSubscription(), p && (this.subscription.trySubscribe(), e.forEach(function (e) {
          return t.subscription.listeners.subscribe(e);
        }));
      }
    }), hoistNonReactStatics_cjs$1(t, r);
  };
}

var root$1,
    hasOwn = Object.prototype.hasOwnProperty;

function is(e, t) {
  return e === t ? 0 !== e || 0 !== t || 1 / e == 1 / t : e != e && t != t;
}

function shallowEqual(e, t) {
  if (is(e, t)) return !0;
  if ("object" != typeof e || null === e || "object" != typeof t || null === t) return !1;
  var r = Object.keys(e),
      n = Object.keys(t);
  if (r.length !== n.length) return !1;

  for (var o = 0; o < r.length; o++) {
    if (!hasOwn.call(t, r[o]) || !is(e[r[o]], t[r[o]])) return !1;
  }

  return !0;
}

function symbolObservablePonyfill(e) {
  var t,
      r = e.Symbol;
  return "function" == typeof r ? r.observable ? t = r.observable : (t = r("observable"), r.observable = t) : t = "@@observable", t;
}

var result = symbolObservablePonyfill(root$1 = "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof module ? module : Function("return this")()),
    randomString = function randomString() {
  return Math.random().toString(36).substring(7).split("").join(".");
},
    ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

function warning$4(e) {
  "undefined" != typeof console && "function" == typeof console.error && console.error(e);

  try {
    throw new Error(e);
  } catch (e) {}
}

function bindActionCreator(e, t) {
  return function () {
    return t(e.apply(this, arguments));
  };
}

function bindActionCreators(e, t) {
  if ("function" == typeof e) return bindActionCreator(e, t);
  if ("object" != typeof e || null === e) throw new Error("bindActionCreators expected an object or a function, instead received " + (null === e ? "null" : typeof e) + '. Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');

  for (var r = Object.keys(e), n = {}, o = 0; o < r.length; o++) {
    var a = r[o],
        i = e[a];
    "function" == typeof i && (n[a] = bindActionCreator(i, t));
  }

  return n;
}

function isCrushed() {}

function isPlainObject(e) {
  if ("object" != typeof e || null === e) return !1;
  var t = Object.getPrototypeOf(e);
  if (null === t) return !0;

  for (var r = t; null !== Object.getPrototypeOf(r);) {
    r = Object.getPrototypeOf(r);
  }

  return t === r;
}

function verifyPlainObject(e, t, r) {
  isPlainObject(e) || warning$3(r + "() in " + t + " must return a plain object. Instead received " + e + ".");
}

function wrapMapToPropsConstant(o) {
  return function (e, t) {
    var r = o(e, t);

    function n() {
      return r;
    }

    return n.dependsOnOwnProps = !1, n;
  };
}

function getDependsOnOwnProps(e) {
  return null !== e.dependsOnOwnProps && void 0 !== e.dependsOnOwnProps ? Boolean(e.dependsOnOwnProps) : 1 !== e.length;
}

function wrapMapToPropsFunc(a, i) {
  return function (e, t) {
    var n = t.displayName,
        o = function o(e, t) {
      return o.dependsOnOwnProps ? o.mapToProps(e, t) : o.mapToProps(e);
    };

    return o.dependsOnOwnProps = !0, o.mapToProps = function (e, t) {
      o.mapToProps = a, o.dependsOnOwnProps = getDependsOnOwnProps(a);
      var r = o(e, t);
      return "function" == typeof r && (o.mapToProps = r, o.dependsOnOwnProps = getDependsOnOwnProps(r), r = o(e, t)), "production" !== process.env.NODE_ENV && verifyPlainObject(r, n, i), r;
    }, o;
  };
}

function whenMapDispatchToPropsIsFunction(e) {
  return "function" == typeof e ? wrapMapToPropsFunc(e, "mapDispatchToProps") : void 0;
}

function whenMapDispatchToPropsIsMissing(e) {
  return e ? void 0 : wrapMapToPropsConstant(function (e) {
    return {
      dispatch: e
    };
  });
}

function whenMapDispatchToPropsIsObject(t) {
  return t && "object" == typeof t ? wrapMapToPropsConstant(function (e) {
    return bindActionCreators(t, e);
  }) : void 0;
}

"production" !== process.env.NODE_ENV && "string" == typeof isCrushed.name && "isCrushed" !== isCrushed.name && warning$4('You are currently using minified code outside of NODE_ENV === "production". This means that you are running a slower development build of Redux. You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) to ensure you have the correct code for your production build.');
var defaultMapDispatchToPropsFactories = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

function whenMapStateToPropsIsFunction(e) {
  return "function" == typeof e ? wrapMapToPropsFunc(e, "mapStateToProps") : void 0;
}

function whenMapStateToPropsIsMissing(e) {
  return e ? void 0 : wrapMapToPropsConstant(function () {
    return {};
  });
}

var defaultMapStateToPropsFactories = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

function defaultMergeProps(e, t, r) {
  return _extends$i({}, r, e, t);
}

function wrapMergePropsFunc(u) {
  return function (e, t) {
    var o,
        a = t.displayName,
        i = t.pure,
        s = t.areMergedPropsEqual,
        c = !1;
    return function (e, t, r) {
      var n = u(e, t, r);
      return c ? i && s(n, o) || (o = n) : (c = !0, o = n, "production" !== process.env.NODE_ENV && verifyPlainObject(o, a, "mergeProps")), o;
    };
  };
}

function whenMergePropsIsFunction(e) {
  return "function" == typeof e ? wrapMergePropsFunc(e) : void 0;
}

function whenMergePropsIsOmitted(e) {
  return e ? void 0 : function () {
    return defaultMergeProps;
  };
}

var defaultMergePropsFactories = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

function verify(e, t, r) {
  if (!e) throw new Error("Unexpected value for " + t + " in " + r + ".");
  "mapStateToProps" !== t && "mapDispatchToProps" !== t || e.hasOwnProperty("dependsOnOwnProps") || warning$3("The selector for " + t + " of " + r + " did not specify a value for dependsOnOwnProps.");
}

function verifySubselectors(e, t, r, n) {
  verify(e, "mapStateToProps", n), verify(t, "mapDispatchToProps", n), verify(r, "mergeProps", n);
}

function impureFinalPropsSelectorFactory(r, n, o, a) {
  return function (e, t) {
    return o(r(e, t), n(a, t), t);
  };
}

function pureFinalPropsSelectorFactory(i, s, c, u, e) {
  var l,
      f,
      p,
      d,
      h,
      y = e.areStatesEqual,
      m = e.areOwnPropsEqual,
      b = e.areStatePropsEqual,
      r = !1;

  function n(e, t) {
    var r,
        n,
        o = !m(t, f),
        a = !y(e, l);
    return l = e, f = t, o && a ? (p = i(l, f), s.dependsOnOwnProps && (d = s(u, f)), h = c(p, d, f)) : o ? (i.dependsOnOwnProps && (p = i(l, f)), s.dependsOnOwnProps && (d = s(u, f)), h = c(p, d, f)) : (a && (r = i(l, f), n = !b(r, p), p = r, n && (h = c(p, d, f))), h);
  }

  return function (e, t) {
    return r ? n(e, t) : (p = i(l = e, f = t), d = s(u, f), h = c(p, d, f), r = !0, h);
  };
}

function finalPropsSelectorFactory(e, t) {
  var r = t.initMapStateToProps,
      n = t.initMapDispatchToProps,
      o = t.initMergeProps,
      a = _objectWithoutPropertiesLoose$1(t, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]),
      i = r(e, a),
      s = n(e, a),
      c = o(e, a);

  return "production" !== process.env.NODE_ENV && verifySubselectors(i, s, c, a.displayName), (a.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory)(i, s, c, e, a);
}

function match(r, e, n) {
  for (var t = e.length - 1; 0 <= t; t--) {
    var o = e[t](r);
    if (o) return o;
  }

  return function (e, t) {
    throw new Error("Invalid value of type " + typeof r + " for " + n + " argument when connecting component " + t.wrappedComponentName + ".");
  };
}

function strictEqual(e, t) {
  return e === t;
}

function createConnect(e) {
  var t = void 0 === e ? {} : e,
      r = t.connectHOC,
      g = void 0 === r ? connectAdvanced : r,
      n = t.mapStateToPropsFactories,
      _ = void 0 === n ? defaultMapStateToPropsFactories : n,
      o = t.mapDispatchToPropsFactories,
      w = void 0 === o ? defaultMapDispatchToPropsFactories : o,
      a = t.mergePropsFactories,
      $ = void 0 === a ? defaultMergePropsFactories : a,
      i = t.selectorFactory,
      S = void 0 === i ? finalPropsSelectorFactory : i;

  return function (e, t, r, n) {
    void 0 === n && (n = {});

    var o = n,
        a = o.pure,
        i = void 0 === a || a,
        s = o.areStatesEqual,
        c = void 0 === s ? strictEqual : s,
        u = o.areOwnPropsEqual,
        l = void 0 === u ? shallowEqual : u,
        f = o.areStatePropsEqual,
        p = void 0 === f ? shallowEqual : f,
        d = o.areMergedPropsEqual,
        h = void 0 === d ? shallowEqual : d,
        y = _objectWithoutPropertiesLoose$1(o, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]),
        m = match(e, _, "mapStateToProps"),
        b = match(t, w, "mapDispatchToProps"),
        v = match(r, $, "mergeProps");

    return g(S, _extends$i({
      methodName: "connect",
      getDisplayName: function getDisplayName(e) {
        return "Connect(" + e + ")";
      },
      shouldHandleStateChanges: Boolean(e),
      initMapStateToProps: m,
      initMapDispatchToProps: b,
      initMergeProps: v,
      pure: i,
      areStatesEqual: c,
      areOwnPropsEqual: l,
      areStatePropsEqual: p,
      areMergedPropsEqual: h
    }, y));
  };
}

var connect = createConnect(),
    _extends$j = Object.assign || function (e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];

    for (var n in r) {
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$5(e, t) {
  var r = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
  }

  return r;
}

var processProps = function processProps(e, t, r, n) {
  var o = t.value;
  return "checkbox" === e ? _extends$j({}, t, {
    checked: !!o
  }) : "radio" === e ? _extends$j({}, t, {
    checked: n(o, r),
    value: r
  }) : "select-multiple" === e ? _extends$j({}, t, {
    value: o || []
  }) : "file" === e ? _extends$j({}, t, {
    value: o || void 0
  }) : t;
},
    createFieldProps = function createFieldProps(e, n, t) {
  var r = e.getIn,
      o = e.toJS,
      a = e.deepEqual,
      i = t.asyncError,
      s = t.asyncValidating,
      c = t.onBlur,
      u = t.onChange,
      l = t.onDrop,
      f = t.onDragStart,
      p = t.dirty,
      d = t.dispatch,
      h = t.onFocus,
      y = t.form,
      m = t.format,
      b = t.initial,
      v = (t.parse, t.pristine),
      g = t.props,
      _ = t.state,
      w = t.submitError,
      $ = t.submitFailed,
      S = t.submitting,
      T = t.syncError,
      P = t.syncWarning,
      x = (t.validate, t.value),
      E = t._value,
      C = (t.warn, _objectWithoutProperties$5(t, ["asyncError", "asyncValidating", "onBlur", "onChange", "onDrop", "onDragStart", "dirty", "dispatch", "onFocus", "form", "format", "initial", "parse", "pristine", "props", "state", "submitError", "submitFailed", "submitting", "syncError", "syncWarning", "validate", "value", "_value", "warn"])),
      O = T || i || w,
      A = P,
      R = function (e, t) {
    if (null === t) return e;
    var r = null == e ? "" : e;
    return t ? t(e, n) : r;
  }(x, m);

  return {
    input: processProps(C.type, {
      name: n,
      onBlur: c,
      onChange: u,
      onDragStart: f,
      onDrop: l,
      onFocus: h,
      value: R
    }, E, a),
    meta: _extends$j({}, o(_), {
      active: !(!_ || !r(_, "active")),
      asyncValidating: s,
      autofilled: !(!_ || !r(_, "autofilled")),
      dirty: p,
      dispatch: d,
      error: O,
      form: y,
      initial: b,
      warning: A,
      invalid: !!O,
      pristine: v,
      submitting: !!S,
      submitFailed: !!$,
      touched: !(!_ || !r(_, "touched")),
      valid: !O,
      visited: !(!_ || !r(_, "visited"))
    }),
    custom: _extends$j({}, C, g)
  };
},
    isEvent = function isEvent(e) {
  return !!(e && e.stopPropagation && e.preventDefault);
},
    getSelectedValues = function getSelectedValues(e) {
  var t = [];
  if (e) for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.selected && t.push(n.value);
  }
  return t;
},
    getValue = function getValue(e, t) {
  if (isEvent(e)) {
    if (!t && e.nativeEvent && void 0 !== e.nativeEvent.text) return e.nativeEvent.text;
    if (t && void 0 !== e.nativeEvent) return e.nativeEvent.text;
    var r = e,
        n = r.target,
        o = n.type,
        a = n.value,
        i = n.checked,
        s = n.files,
        c = r.dataTransfer;
    return "checkbox" === o ? !!i : "file" === o ? s || c && c.files : "select-multiple" === o ? getSelectedValues(e.target.options) : a;
  }

  return e;
},
    isReactNative = "undefined" != typeof window && window.navigator && window.navigator.product && "ReactNative" === window.navigator.product,
    onChangeValue = function onChangeValue(e, t) {
  var r = t.name,
      n = t.parse,
      o = t.normalize,
      a = getValue(e, isReactNative);
  return n && (a = n(a, r)), o && (a = o(r, a)), a;
},
    dataKey = "text";

function _toConsumableArray(e) {
  if (Array.isArray(e)) {
    for (var t = 0, r = Array(e.length); t < e.length; t++) {
      r[t] = e[t];
    }

    return r;
  }

  return Array.from(e);
}

var splice = function splice(e, t, r, n) {
  if (t < (e = e || []).length) {
    if (void 0 === n && !r) {
      var o = [].concat(_toConsumableArray(e));
      return o.splice(t, 0, !0), o[t] = void 0, o;
    }

    if (null != n) {
      var a = [].concat(_toConsumableArray(e));
      return a.splice(t, r, n), a;
    }

    var i = [].concat(_toConsumableArray(e));
    return i.splice(t, r), i;
  }

  if (r) return e;
  var s = [].concat(_toConsumableArray(e));
  return s[t] = n, s;
};

function arrayMap(e, t) {
  for (var r = -1, n = null == e ? 0 : e.length, o = Array(n); ++r < n;) {
    o[r] = t(e[r], r, e);
  }

  return o;
}

function copyArray(e, t) {
  var r = -1,
      n = e.length;

  for (t || (t = Array(n)); ++r < n;) {
    t[r] = e[r];
  }

  return t;
}

var isArray = Array.isArray,
    freeGlobal = "object" == typeof global && global && global.Object === Object && global,
    freeSelf = "object" == typeof self && self && self.Object === Object && self,
    root$2 = freeGlobal || freeSelf || Function("return this")(),
    Symbol$1 = root$2.Symbol,
    objectProto = Object.prototype,
    hasOwnProperty$1 = objectProto.hasOwnProperty,
    nativeObjectToString = objectProto.toString,
    symToStringTag = Symbol$1 ? Symbol$1.toStringTag : void 0;

function getRawTag(e) {
  var t = hasOwnProperty$1.call(e, symToStringTag),
      r = e[symToStringTag];

  try {
    var n = !(e[symToStringTag] = void 0);
  } catch (e) {}

  var o = nativeObjectToString.call(e);
  return n && (t ? e[symToStringTag] = r : delete e[symToStringTag]), o;
}

var objectProto$1 = Object.prototype,
    nativeObjectToString$1 = objectProto$1.toString;

function objectToString(e) {
  return nativeObjectToString$1.call(e);
}

var nullTag = "[object Null]",
    undefinedTag = "[object Undefined]",
    symToStringTag$1 = Symbol$1 ? Symbol$1.toStringTag : void 0;

function baseGetTag(e) {
  return null == e ? void 0 === e ? undefinedTag : nullTag : symToStringTag$1 && symToStringTag$1 in Object(e) ? getRawTag(e) : objectToString(e);
}

function isObjectLike(e) {
  return null != e && "object" == typeof e;
}

var symbolTag = "[object Symbol]";

function isSymbol$1(e) {
  return "symbol" == typeof e || isObjectLike(e) && baseGetTag(e) == symbolTag;
}

function isObject(e) {
  var t = typeof e;
  return null != e && ("object" == t || "function" == t);
}

var asyncTag = "[object AsyncFunction]",
    funcTag = "[object Function]",
    genTag = "[object GeneratorFunction]",
    proxyTag = "[object Proxy]";

function isFunction$1(e) {
  if (!isObject(e)) return !1;
  var t = baseGetTag(e);
  return t == funcTag || t == genTag || t == asyncTag || t == proxyTag;
}

var coreJsData = root$2["__core-js_shared__"],
    maskSrcKey = function () {
  var e = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();

function isMasked(e) {
  return !!maskSrcKey && maskSrcKey in e;
}

var funcProto = Function.prototype,
    funcToString = funcProto.toString;

function toSource(e) {
  if (null != e) {
    try {
      return funcToString.call(e);
    } catch (e) {}

    try {
      return e + "";
    } catch (e) {}
  }

  return "";
}

var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
    reIsHostCtor = /^\[object .+?Constructor\]$/,
    funcProto$1 = Function.prototype,
    objectProto$2 = Object.prototype,
    funcToString$1 = funcProto$1.toString,
    hasOwnProperty$2 = objectProto$2.hasOwnProperty,
    reIsNative = RegExp("^" + funcToString$1.call(hasOwnProperty$2).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");

function baseIsNative(e) {
  return !(!isObject(e) || isMasked(e)) && (isFunction$1(e) ? reIsNative : reIsHostCtor).test(toSource(e));
}

function getValue$1(e, t) {
  return null == e ? void 0 : e[t];
}

function getNative(e, t) {
  var r = getValue$1(e, t);
  return baseIsNative(r) ? r : void 0;
}

var nativeCreate = getNative(Object, "create");

function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {}, this.size = 0;
}

function hashDelete(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}

var HASH_UNDEFINED = "__lodash_hash_undefined__",
    objectProto$3 = Object.prototype,
    hasOwnProperty$3 = objectProto$3.hasOwnProperty;

function hashGet(e) {
  var t = this.__data__;

  if (nativeCreate) {
    var r = t[e];
    return r === HASH_UNDEFINED ? void 0 : r;
  }

  return hasOwnProperty$3.call(t, e) ? t[e] : void 0;
}

var objectProto$4 = Object.prototype,
    hasOwnProperty$4 = objectProto$4.hasOwnProperty;

function hashHas(e) {
  var t = this.__data__;
  return nativeCreate ? void 0 !== t[e] : hasOwnProperty$4.call(t, e);
}

var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";

function hashSet(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = nativeCreate && void 0 === t ? HASH_UNDEFINED$1 : t, this;
}

function Hash(e) {
  var t = -1,
      r = null == e ? 0 : e.length;

  for (this.clear(); ++t < r;) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}

function listCacheClear() {
  this.__data__ = [], this.size = 0;
}

function eq(e, t) {
  return e === t || e != e && t != t;
}

function assocIndexOf(e, t) {
  for (var r = e.length; r--;) {
    if (eq(e[r][0], t)) return r;
  }

  return -1;
}

Hash.prototype.clear = hashClear, Hash.prototype.delete = hashDelete, Hash.prototype.get = hashGet, Hash.prototype.has = hashHas, Hash.prototype.set = hashSet;
var arrayProto = Array.prototype,
    splice$1 = arrayProto.splice;

function listCacheDelete(e) {
  var t = this.__data__,
      r = assocIndexOf(t, e);
  return !(r < 0) && (r == t.length - 1 ? t.pop() : splice$1.call(t, r, 1), --this.size, !0);
}

function listCacheGet(e) {
  var t = this.__data__,
      r = assocIndexOf(t, e);
  return r < 0 ? void 0 : t[r][1];
}

function listCacheHas(e) {
  return -1 < assocIndexOf(this.__data__, e);
}

function listCacheSet(e, t) {
  var r = this.__data__,
      n = assocIndexOf(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}

function ListCache(e) {
  var t = -1,
      r = null == e ? 0 : e.length;

  for (this.clear(); ++t < r;) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}

ListCache.prototype.clear = listCacheClear, ListCache.prototype.delete = listCacheDelete, ListCache.prototype.get = listCacheGet, ListCache.prototype.has = listCacheHas, ListCache.prototype.set = listCacheSet;
var Map$2 = getNative(root$2, "Map");

function mapCacheClear() {
  this.size = 0, this.__data__ = {
    hash: new Hash(),
    map: new (Map$2 || ListCache)(),
    string: new Hash()
  };
}

function isKeyable(e) {
  var t = typeof e;
  return "string" == t || "number" == t || "symbol" == t || "boolean" == t ? "__proto__" !== e : null === e;
}

function getMapData(e, t) {
  var r = e.__data__;
  return isKeyable(t) ? r["string" == typeof t ? "string" : "hash"] : r.map;
}

function mapCacheDelete(e) {
  var t = getMapData(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}

function mapCacheGet(e) {
  return getMapData(this, e).get(e);
}

function mapCacheHas(e) {
  return getMapData(this, e).has(e);
}

function mapCacheSet(e, t) {
  var r = getMapData(this, e),
      n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}

function MapCache(e) {
  var t = -1,
      r = null == e ? 0 : e.length;

  for (this.clear(); ++t < r;) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}

MapCache.prototype.clear = mapCacheClear, MapCache.prototype.delete = mapCacheDelete, MapCache.prototype.get = mapCacheGet, MapCache.prototype.has = mapCacheHas, MapCache.prototype.set = mapCacheSet;
var FUNC_ERROR_TEXT = "Expected a function";

function memoize(o, a) {
  if ("function" != typeof o || null != a && "function" != typeof a) throw new TypeError(FUNC_ERROR_TEXT);

  var i = function i() {
    var e = arguments,
        t = a ? a.apply(this, e) : e[0],
        r = i.cache;
    if (r.has(t)) return r.get(t);
    var n = o.apply(this, e);
    return i.cache = r.set(t, n) || r, n;
  };

  return i.cache = new (memoize.Cache || MapCache)(), i;
}

memoize.Cache = MapCache;
var MAX_MEMOIZE_SIZE = 500;

function memoizeCapped(e) {
  var t = memoize(e, function (e) {
    return r.size === MAX_MEMOIZE_SIZE && r.clear(), e;
  }),
      r = t.cache;
  return t;
}

var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
    reEscapeChar = /\\(\\)?/g,
    stringToPath = memoizeCapped(function (e) {
  var o = [];
  return 46 === e.charCodeAt(0) && o.push(""), e.replace(rePropName, function (e, t, r, n) {
    o.push(r ? n.replace(reEscapeChar, "$1") : t || e);
  }), o;
}),
    INFINITY = 1 / 0;

function toKey(e) {
  if ("string" == typeof e || isSymbol$1(e)) return e;
  var t = e + "";
  return "0" == t && 1 / e == -INFINITY ? "-0" : t;
}

var INFINITY$1 = 1 / 0,
    symbolProto = Symbol$1 ? Symbol$1.prototype : void 0,
    symbolToString = symbolProto ? symbolProto.toString : void 0;

function baseToString(e) {
  if ("string" == typeof e) return e;
  if (isArray(e)) return arrayMap(e, baseToString) + "";
  if (isSymbol$1(e)) return symbolToString ? symbolToString.call(e) : "";
  var t = e + "";
  return "0" == t && 1 / e == -INFINITY$1 ? "-0" : t;
}

function toString$1(e) {
  return null == e ? "" : baseToString(e);
}

function toPath(e) {
  return isArray(e) ? arrayMap(e, toKey) : isSymbol$1(e) ? [e] : copyArray(stringToPath(toString$1(e)));
}

var getIn = function getIn(e, t) {
  if (!e) return e;
  var r = toPath(t),
      n = r.length;

  if (n) {
    for (var o = e, a = 0; a < n && o; ++a) {
      o = o[r[a]];
    }

    return o;
  }
},
    _extends$k = Object.assign || function (e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];

    for (var n in r) {
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
  }

  return e;
};

function _defineProperty$1(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}

var setInWithPath = function e(t, r, n, o) {
  if (o >= n.length) return r;
  var a = n[o],
      i = e(t && (Array.isArray(t) ? t[Number(a)] : t[a]), r, n, o + 1);

  if (!t) {
    if (isNaN(a)) return _defineProperty$1({}, a, i);
    var s = [];
    return s[parseInt(a, 10)] = i, s;
  }

  if (Array.isArray(t)) {
    var c = [].concat(t);
    return c[parseInt(a, 10)] = i, c;
  }

  return _extends$k({}, t, _defineProperty$1({}, a, i));
},
    setIn = function setIn(e, t, r) {
  return setInWithPath(e, r, toPath(t), 0);
};

function stackClear() {
  this.__data__ = new ListCache(), this.size = 0;
}

function stackDelete(e) {
  var t = this.__data__,
      r = t.delete(e);
  return this.size = t.size, r;
}

function stackGet(e) {
  return this.__data__.get(e);
}

function stackHas(e) {
  return this.__data__.has(e);
}

var LARGE_ARRAY_SIZE = 200;

function stackSet(e, t) {
  var r = this.__data__;

  if (r instanceof ListCache) {
    var n = r.__data__;
    if (!Map$2 || n.length < LARGE_ARRAY_SIZE - 1) return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new MapCache(n);
  }

  return r.set(e, t), this.size = r.size, this;
}

function Stack(e) {
  var t = this.__data__ = new ListCache(e);
  this.size = t.size;
}

Stack.prototype.clear = stackClear, Stack.prototype.delete = stackDelete, Stack.prototype.get = stackGet, Stack.prototype.has = stackHas, Stack.prototype.set = stackSet;
var HASH_UNDEFINED$2 = "__lodash_hash_undefined__";

function setCacheAdd(e) {
  return this.__data__.set(e, HASH_UNDEFINED$2), this;
}

function setCacheHas(e) {
  return this.__data__.has(e);
}

function SetCache(e) {
  var t = -1,
      r = null == e ? 0 : e.length;

  for (this.__data__ = new MapCache(); ++t < r;) {
    this.add(e[t]);
  }
}

function arraySome(e, t) {
  for (var r = -1, n = null == e ? 0 : e.length; ++r < n;) {
    if (t(e[r], r, e)) return !0;
  }

  return !1;
}

function cacheHas(e, t) {
  return e.has(t);
}

SetCache.prototype.add = SetCache.prototype.push = setCacheAdd, SetCache.prototype.has = setCacheHas;
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

function equalArrays(e, t, r, n, o, a) {
  var i = r & COMPARE_PARTIAL_FLAG,
      s = e.length,
      c = t.length;
  if (s != c && !(i && s < c)) return !1;
  var u = a.get(e);
  if (u && a.get(t)) return u == t;
  var l = -1,
      f = !0,
      p = r & COMPARE_UNORDERED_FLAG ? new SetCache() : void 0;

  for (a.set(e, t), a.set(t, e); ++l < s;) {
    var d = e[l],
        h = t[l];
    if (n) var y = i ? n(h, d, l, t, e, a) : n(d, h, l, e, t, a);

    if (void 0 !== y) {
      if (y) continue;
      f = !1;
      break;
    }

    if (p) {
      if (!arraySome(t, function (e, t) {
        if (!cacheHas(p, t) && (d === e || o(d, e, r, n, a))) return p.push(t);
      })) {
        f = !1;
        break;
      }
    } else if (d !== h && !o(d, h, r, n, a)) {
      f = !1;
      break;
    }
  }

  return a.delete(e), a.delete(t), f;
}

var Uint8Array$1 = root$2.Uint8Array;

function mapToArray(e) {
  var r = -1,
      n = Array(e.size);
  return e.forEach(function (e, t) {
    n[++r] = [t, e];
  }), n;
}

function setToArray(e) {
  var t = -1,
      r = Array(e.size);
  return e.forEach(function (e) {
    r[++t] = e;
  }), r;
}

var COMPARE_PARTIAL_FLAG$1 = 1,
    COMPARE_UNORDERED_FLAG$1 = 2,
    boolTag = "[object Boolean]",
    dateTag = "[object Date]",
    errorTag = "[object Error]",
    mapTag = "[object Map]",
    numberTag = "[object Number]",
    regexpTag = "[object RegExp]",
    setTag = "[object Set]",
    stringTag = "[object String]",
    symbolTag$1 = "[object Symbol]",
    arrayBufferTag = "[object ArrayBuffer]",
    dataViewTag = "[object DataView]",
    symbolProto$1 = Symbol$1 ? Symbol$1.prototype : void 0,
    symbolValueOf = symbolProto$1 ? symbolProto$1.valueOf : void 0;

function equalByTag(e, t, r, n, o, a, i) {
  switch (r) {
    case dataViewTag:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
      e = e.buffer, t = t.buffer;

    case arrayBufferTag:
      return !(e.byteLength != t.byteLength || !a(new Uint8Array$1(e), new Uint8Array$1(t)));

    case boolTag:
    case dateTag:
    case numberTag:
      return eq(+e, +t);

    case errorTag:
      return e.name == t.name && e.message == t.message;

    case regexpTag:
    case stringTag:
      return e == t + "";

    case mapTag:
      var s = mapToArray;

    case setTag:
      var c = n & COMPARE_PARTIAL_FLAG$1;
      if (s || (s = setToArray), e.size != t.size && !c) return !1;
      var u = i.get(e);
      if (u) return u == t;
      n |= COMPARE_UNORDERED_FLAG$1, i.set(e, t);
      var l = equalArrays(s(e), s(t), n, o, a, i);
      return i.delete(e), l;

    case symbolTag$1:
      if (symbolValueOf) return symbolValueOf.call(e) == symbolValueOf.call(t);
  }

  return !1;
}

function arrayPush$1(e, t) {
  for (var r = -1, n = t.length, o = e.length; ++r < n;) {
    e[o + r] = t[r];
  }

  return e;
}

function baseGetAllKeys(e, t, r) {
  var n = t(e);
  return isArray(e) ? n : arrayPush$1(n, r(e));
}

function arrayFilter(e, t) {
  for (var r = -1, n = null == e ? 0 : e.length, o = 0, a = []; ++r < n;) {
    var i = e[r];
    t(i, r, e) && (a[o++] = i);
  }

  return a;
}

function stubArray() {
  return [];
}

var objectProto$5 = Object.prototype,
    propertyIsEnumerable = objectProto$5.propertyIsEnumerable,
    nativeGetSymbols = Object.getOwnPropertySymbols,
    getSymbols = nativeGetSymbols ? function (t) {
  return null == t ? [] : (t = Object(t), arrayFilter(nativeGetSymbols(t), function (e) {
    return propertyIsEnumerable.call(t, e);
  }));
} : stubArray;

function baseTimes(e, t) {
  for (var r = -1, n = Array(e); ++r < e;) {
    n[r] = t(r);
  }

  return n;
}

var argsTag = "[object Arguments]";

function baseIsArguments(e) {
  return isObjectLike(e) && baseGetTag(e) == argsTag;
}

var objectProto$6 = Object.prototype,
    hasOwnProperty$5 = objectProto$6.hasOwnProperty,
    propertyIsEnumerable$1 = objectProto$6.propertyIsEnumerable,
    isArguments$1 = baseIsArguments(function () {
  return arguments;
}()) ? baseIsArguments : function (e) {
  return isObjectLike(e) && hasOwnProperty$5.call(e, "callee") && !propertyIsEnumerable$1.call(e, "callee");
};

function stubFalse() {
  return !1;
}

var freeExports = "object" == typeof exports && exports && !exports.nodeType && exports,
    freeModule = freeExports && "object" == typeof module && module && !module.nodeType && module,
    moduleExports = freeModule && freeModule.exports === freeExports,
    Buffer = moduleExports ? root$2.Buffer : void 0,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : void 0,
    isBuffer = nativeIsBuffer || stubFalse,
    MAX_SAFE_INTEGER$2 = 9007199254740991,
    reIsUint = /^(?:0|[1-9]\d*)$/;

function isIndex(e, t) {
  var r = typeof e;
  return !!(t = null == t ? MAX_SAFE_INTEGER$2 : t) && ("number" == r || "symbol" != r && reIsUint.test(e)) && -1 < e && e % 1 == 0 && e < t;
}

var MAX_SAFE_INTEGER$3 = 9007199254740991;

function isLength(e) {
  return "number" == typeof e && -1 < e && e % 1 == 0 && e <= MAX_SAFE_INTEGER$3;
}

var argsTag$1 = "[object Arguments]",
    arrayTag = "[object Array]",
    boolTag$1 = "[object Boolean]",
    dateTag$1 = "[object Date]",
    errorTag$1 = "[object Error]",
    funcTag$1 = "[object Function]",
    mapTag$1 = "[object Map]",
    numberTag$1 = "[object Number]",
    objectTag = "[object Object]",
    regexpTag$1 = "[object RegExp]",
    setTag$1 = "[object Set]",
    stringTag$1 = "[object String]",
    weakMapTag = "[object WeakMap]",
    arrayBufferTag$1 = "[object ArrayBuffer]",
    dataViewTag$1 = "[object DataView]",
    float32Tag = "[object Float32Array]",
    float64Tag = "[object Float64Array]",
    int8Tag = "[object Int8Array]",
    int16Tag = "[object Int16Array]",
    int32Tag = "[object Int32Array]",
    uint8Tag = "[object Uint8Array]",
    uint8ClampedTag = "[object Uint8ClampedArray]",
    uint16Tag = "[object Uint16Array]",
    uint32Tag = "[object Uint32Array]",
    typedArrayTags = {};

function baseIsTypedArray(e) {
  return isObjectLike(e) && isLength(e.length) && !!typedArrayTags[baseGetTag(e)];
}

function baseUnary(t) {
  return function (e) {
    return t(e);
  };
}

typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = !0, typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag$1] = typedArrayTags[boolTag$1] = typedArrayTags[dataViewTag$1] = typedArrayTags[dateTag$1] = typedArrayTags[errorTag$1] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag$1] = typedArrayTags[numberTag$1] = typedArrayTags[objectTag] = typedArrayTags[regexpTag$1] = typedArrayTags[setTag$1] = typedArrayTags[stringTag$1] = typedArrayTags[weakMapTag] = !1;

var freeExports$1 = "object" == typeof exports && exports && !exports.nodeType && exports,
    freeModule$1 = freeExports$1 && "object" == typeof module && module && !module.nodeType && module,
    moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1,
    freeProcess = moduleExports$1 && freeGlobal.process,
    nodeUtil = function () {
  try {
    var e = freeModule$1 && freeModule$1.require && freeModule$1.require("util").types;

    return e || freeProcess && freeProcess.binding && freeProcess.binding("util");
  } catch (e) {}
}(),
    nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray,
    isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray,
    objectProto$7 = Object.prototype,
    hasOwnProperty$6 = objectProto$7.hasOwnProperty;

function arrayLikeKeys(e, t) {
  var r = isArray(e),
      n = !r && isArguments$1(e),
      o = !r && !n && isBuffer(e),
      a = !r && !n && !o && isTypedArray(e),
      i = r || n || o || a,
      s = i ? baseTimes(e.length, String) : [],
      c = s.length;

  for (var u in e) {
    !t && !hasOwnProperty$6.call(e, u) || i && ("length" == u || o && ("offset" == u || "parent" == u) || a && ("buffer" == u || "byteLength" == u || "byteOffset" == u) || isIndex(u, c)) || s.push(u);
  }

  return s;
}

var objectProto$8 = Object.prototype;

function isPrototype(e) {
  var t = e && e.constructor;
  return e === ("function" == typeof t && t.prototype || objectProto$8);
}

function overArg(t, r) {
  return function (e) {
    return t(r(e));
  };
}

var nativeKeys = overArg(Object.keys, Object),
    objectProto$9 = Object.prototype,
    hasOwnProperty$7 = objectProto$9.hasOwnProperty;

function baseKeys(e) {
  if (!isPrototype(e)) return nativeKeys(e);
  var t = [];

  for (var r in Object(e)) {
    hasOwnProperty$7.call(e, r) && "constructor" != r && t.push(r);
  }

  return t;
}

function isArrayLike(e) {
  return null != e && isLength(e.length) && !isFunction$1(e);
}

function keys$1(e) {
  return isArrayLike(e) ? arrayLikeKeys(e) : baseKeys(e);
}

function getAllKeys(e) {
  return baseGetAllKeys(e, keys$1, getSymbols);
}

var COMPARE_PARTIAL_FLAG$2 = 1,
    objectProto$a = Object.prototype,
    hasOwnProperty$8 = objectProto$a.hasOwnProperty;

function equalObjects(e, t, r, n, o, a) {
  var i = r & COMPARE_PARTIAL_FLAG$2,
      s = getAllKeys(e),
      c = s.length;
  if (c != getAllKeys(t).length && !i) return !1;

  for (var u = c; u--;) {
    var l = s[u];
    if (!(i ? l in t : hasOwnProperty$8.call(t, l))) return !1;
  }

  var f = a.get(e);
  if (f && a.get(t)) return f == t;
  var p = !0;
  a.set(e, t), a.set(t, e);

  for (var d = i; ++u < c;) {
    var h = e[l = s[u]],
        y = t[l];
    if (n) var m = i ? n(y, h, l, t, e, a) : n(h, y, l, e, t, a);

    if (!(void 0 === m ? h === y || o(h, y, r, n, a) : m)) {
      p = !1;
      break;
    }

    d || (d = "constructor" == l);
  }

  if (p && !d) {
    var b = e.constructor,
        v = t.constructor;
    b != v && "constructor" in e && "constructor" in t && !("function" == typeof b && b instanceof b && "function" == typeof v && v instanceof v) && (p = !1);
  }

  return a.delete(e), a.delete(t), p;
}

var DataView$1 = getNative(root$2, "DataView"),
    Promise$1 = getNative(root$2, "Promise"),
    Set$2 = getNative(root$2, "Set"),
    WeakMap$1 = getNative(root$2, "WeakMap"),
    mapTag$2 = "[object Map]",
    objectTag$1 = "[object Object]",
    promiseTag = "[object Promise]",
    setTag$2 = "[object Set]",
    weakMapTag$1 = "[object WeakMap]",
    dataViewTag$2 = "[object DataView]",
    dataViewCtorString = toSource(DataView$1),
    mapCtorString = toSource(Map$2),
    promiseCtorString = toSource(Promise$1),
    setCtorString = toSource(Set$2),
    weakMapCtorString = toSource(WeakMap$1),
    getTag = baseGetTag;
(DataView$1 && getTag(new DataView$1(new ArrayBuffer(1))) != dataViewTag$2 || Map$2 && getTag(new Map$2()) != mapTag$2 || Promise$1 && getTag(Promise$1.resolve()) != promiseTag || Set$2 && getTag(new Set$2()) != setTag$2 || WeakMap$1 && getTag(new WeakMap$1()) != weakMapTag$1) && (getTag = function getTag(e) {
  var t = baseGetTag(e),
      r = t == objectTag$1 ? e.constructor : void 0,
      n = r ? toSource(r) : "";
  if (n) switch (n) {
    case dataViewCtorString:
      return dataViewTag$2;

    case mapCtorString:
      return mapTag$2;

    case promiseCtorString:
      return promiseTag;

    case setCtorString:
      return setTag$2;

    case weakMapCtorString:
      return weakMapTag$1;
  }
  return t;
});
var getTag$1 = getTag,
    COMPARE_PARTIAL_FLAG$3 = 1,
    argsTag$2 = "[object Arguments]",
    arrayTag$1 = "[object Array]",
    objectTag$2 = "[object Object]",
    objectProto$b = Object.prototype,
    hasOwnProperty$9 = objectProto$b.hasOwnProperty;

function baseIsEqualDeep(e, t, r, n, o, a) {
  var i = isArray(e),
      s = isArray(t),
      c = i ? arrayTag$1 : getTag$1(e),
      u = s ? arrayTag$1 : getTag$1(t),
      l = (c = c == argsTag$2 ? objectTag$2 : c) == objectTag$2,
      f = (u = u == argsTag$2 ? objectTag$2 : u) == objectTag$2,
      p = c == u;

  if (p && isBuffer(e)) {
    if (!isBuffer(t)) return !1;
    l = !(i = !0);
  }

  if (p && !l) return a || (a = new Stack()), i || isTypedArray(e) ? equalArrays(e, t, r, n, o, a) : equalByTag(e, t, c, r, n, o, a);

  if (!(r & COMPARE_PARTIAL_FLAG$3)) {
    var d = l && hasOwnProperty$9.call(e, "__wrapped__"),
        h = f && hasOwnProperty$9.call(t, "__wrapped__");

    if (d || h) {
      var y = d ? e.value() : e,
          m = h ? t.value() : t;
      return a || (a = new Stack()), o(y, m, r, n, a);
    }
  }

  return !!p && (a || (a = new Stack()), equalObjects(e, t, r, n, o, a));
}

function baseIsEqual(e, t, r, n, o) {
  return e === t || (null == e || null == t || !isObjectLike(e) && !isObjectLike(t) ? e != e && t != t : baseIsEqualDeep(e, t, r, n, baseIsEqual, o));
}

function isEqualWith(e, t, r) {
  var n = (r = "function" == typeof r ? r : void 0) ? r(e, t) : void 0;
  return void 0 === n ? baseIsEqual(e, t, void 0, r) : !!n;
}

var customizer = function customizer(e, t) {
  return e === t || (e || t ? (!e || !t || e._error === t._error) && (!e || !t || e._warning === t._warning) && !react.isValidElement(e) && !react.isValidElement(t) && void 0 : (null == e || "" === e) === (null == t || "" === t));
},
    deepEqual = function deepEqual(e, t) {
  return isEqualWith(e, t, customizer);
},
    _extends$l = Object.assign || function (e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];

    for (var n in r) {
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
  }

  return e;
};

function _defineProperty$2(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}

function _toConsumableArray$1(e) {
  if (Array.isArray(e)) {
    for (var t = 0, r = Array(e.length); t < e.length; t++) {
      r[t] = e[t];
    }

    return r;
  }

  return Array.from(e);
}

function deleteInWithPath(e, t) {
  if (null == e || null == t) return e;

  for (var r = arguments.length, n = Array(2 < r ? r - 2 : 0), o = 2; o < r; o++) {
    n[o - 2] = arguments[o];
  }

  if (n.length) {
    if (Array.isArray(e)) {
      if (isNaN(t)) throw new Error('Must access array elements with a number, not "' + String(t) + '".');
      var a = Number(t);

      if (a < e.length) {
        var i = deleteInWithPath.apply(void 0, [e && e[a]].concat(_toConsumableArray$1(n)));

        if (i !== e[a]) {
          var s = [].concat(_toConsumableArray$1(e));
          return s[a] = i, s;
        }
      }

      return e;
    }

    if (t in e) {
      var c = deleteInWithPath.apply(void 0, [e && e[t]].concat(_toConsumableArray$1(n)));
      return e[t] === c ? e : _extends$l({}, e, _defineProperty$2({}, t, c));
    }

    return e;
  }

  if (Array.isArray(e)) {
    if (isNaN(t)) throw new Error('Cannot delete non-numerical index from an array. Given: "' + String(t));
    var u = Number(t);

    if (u < e.length) {
      var l = [].concat(_toConsumableArray$1(e));
      return l.splice(u, 1), l;
    }

    return e;
  }

  if (t in e) {
    var f = _extends$l({}, e);

    return delete f[t], f;
  }

  return e;
}

var deleteIn = function deleteIn(e, t) {
  return deleteInWithPath.apply(void 0, [e].concat(_toConsumableArray$1(toPath(t))));
};

function keys$2(e) {
  return e ? Array.isArray(e) ? e.map(function (e) {
    return e.name;
  }) : Object.keys(e) : [];
}

var structure = {
  allowsArrayErrors: !0,
  empty: {},
  emptyList: [],
  getIn: getIn,
  setIn: setIn,
  deepEqual: deepEqual,
  deleteIn: deleteIn,
  forEach: function forEach(e, t) {
    return e.forEach(t);
  },
  fromJS: function fromJS(e) {
    return e;
  },
  keys: keys$2,
  size: function size(e) {
    return e ? e.length : 0;
  },
  some: function some(e, t) {
    return e.some(t);
  },
  splice: splice,
  toJS: function toJS(e) {
    return e;
  }
},
    _extends$m = Object.assign || function (e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];

    for (var n in r) {
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
  }

  return e;
},
    _createClass$3 = function () {
  function n(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  return function (e, t, r) {
    return t && n(e.prototype, t), r && n(e, r), e;
  };
}(),
    _typeof$4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
  return typeof e;
} : function (e) {
  return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
};

function _objectWithoutProperties$6(e, t) {
  var r = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
  }

  return r;
}

function _classCallCheck$f(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _possibleConstructorReturn$f(e, t) {
  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !t || "object" != typeof t && "function" != typeof t ? e : t;
}

function _inherits$f(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}

var propsToNotUpdateFor = ["_reduxForm"],
    isObject$1 = function isObject$1(e) {
  return e && "object" === (void 0 === e ? "undefined" : _typeof$4(e));
},
    isFunction$2 = function isFunction$2(e) {
  return e && "function" == typeof e;
},
    eventPreventDefault = function eventPreventDefault(e) {
  isObject$1(e) && isFunction$2(e.preventDefault) && e.preventDefault();
},
    eventDataTransferGetData = function eventDataTransferGetData(e, t) {
  if (isObject$1(e) && isObject$1(e.dataTransfer) && isFunction$2(e.dataTransfer.getData)) return e.dataTransfer.getData(t);
},
    eventDataTransferSetData = function eventDataTransferSetData(e, t, r) {
  isObject$1(e) && isObject$1(e.dataTransfer) && isFunction$2(e.dataTransfer.setData) && e.dataTransfer.setData(t, r);
},
    createConnectedField = function createConnectedField(l) {
  var v = l.deepEqual,
      g = l.getIn,
      e = function (e) {
    function a() {
      var e, t, p;

      _classCallCheck$f(this, a);

      for (var r = arguments.length, n = Array(r), o = 0; o < r; o++) {
        n[o] = arguments[o];
      }

      return (t = p = _possibleConstructorReturn$f(this, (e = a.__proto__ || Object.getPrototypeOf(a)).call.apply(e, [this].concat(n)))).saveRef = function (e) {
        return p.ref = e;
      }, p.isPristine = function () {
        return p.props.pristine;
      }, p.getValue = function () {
        return p.props.value;
      }, p.handleChange = function (e) {
        var t = p.props,
            r = t.name,
            n = t.dispatch,
            o = t.parse,
            a = t.normalize,
            i = t.onChange,
            s = t._reduxForm,
            c = t.value,
            u = onChangeValue(e, {
          name: r,
          parse: o,
          normalize: a
        }),
            l = !1;
        i && i(isReactNative ? e : _extends$m({}, e, {
          preventDefault: function preventDefault() {
            return l = !0, eventPreventDefault(e);
          }
        }), u, c, r), l || (n(s.change(r, u)), s.asyncValidate && s.asyncValidate(r, u, "change"));
      }, p.handleFocus = function (e) {
        var t = p.props,
            r = t.name,
            n = t.dispatch,
            o = t.onFocus,
            a = t._reduxForm,
            i = !1;
        o && o(isReactNative ? e : _extends$m({}, e, {
          preventDefault: function preventDefault() {
            return i = !0, eventPreventDefault(e);
          }
        }), r), i || n(a.focus(r));
      }, p.handleBlur = function (e) {
        var t = p.props,
            r = t.name,
            n = t.dispatch,
            o = t.parse,
            a = t.normalize,
            i = t.onBlur,
            s = t._reduxForm,
            c = t._value,
            u = t.value,
            l = onChangeValue(e, {
          name: r,
          parse: o,
          normalize: a
        });
        l === c && void 0 !== c && (l = u);
        var f = !1;
        i && i(isReactNative ? e : _extends$m({}, e, {
          preventDefault: function preventDefault() {
            return f = !0, eventPreventDefault(e);
          }
        }), l, u, r), f || (n(s.blur(r, l)), s.asyncValidate && s.asyncValidate(r, l, "blur"));
      }, p.handleDragStart = function (e) {
        var t = p.props,
            r = t.name,
            n = t.onDragStart,
            o = t.value;
        eventDataTransferSetData(e, dataKey, null == o ? "" : o), n && n(e, r);
      }, p.handleDrop = function (e) {
        var t = p.props,
            r = t.name,
            n = t.dispatch,
            o = t.onDrop,
            a = t._reduxForm,
            i = t.value,
            s = eventDataTransferGetData(e, dataKey),
            c = !1;
        o && o(_extends$m({}, e, {
          preventDefault: function preventDefault() {
            return c = !0, eventPreventDefault(e);
          }
        }), s, i, r), c || (n(a.change(r, s)), eventPreventDefault(e));
      }, _possibleConstructorReturn$f(p, t);
    }

    return _inherits$f(a, react_1), _createClass$3(a, [{
      key: "shouldComponentUpdate",
      value: function value(t) {
        var r = this,
            e = Object.keys(t),
            n = Object.keys(this.props);
        return !!(this.props.children || t.children || e.length !== n.length || e.some(function (e) {
          return ~(t.immutableProps || []).indexOf(e) ? r.props[e] !== t[e] : !~propsToNotUpdateFor.indexOf(e) && !v(r.props[e], t[e]);
        }));
      }
    }, {
      key: "getRenderedComponent",
      value: function value() {
        return this.ref;
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
            t = e.component,
            r = e.withRef,
            n = e.name,
            o = e._reduxForm,
            a = (e.normalize, e.onBlur, e.onChange, e.onFocus, e.onDragStart, e.onDrop, e.immutableProps, _objectWithoutProperties$6(e, ["component", "withRef", "name", "_reduxForm", "normalize", "onBlur", "onChange", "onFocus", "onDragStart", "onDrop", "immutableProps"])),
            i = createFieldProps(l, n, _extends$m({}, a, {
          form: o.form,
          onBlur: this.handleBlur,
          onChange: this.handleChange,
          onDrop: this.handleDrop,
          onDragStart: this.handleDragStart,
          onFocus: this.handleFocus
        })),
            s = i.custom,
            c = _objectWithoutProperties$6(i, ["custom"]);

        if (r && (s.ref = this.saveRef), "string" != typeof t) return react_5(t, _extends$m({}, c, s));
        var u = c.input;
        return react_5(t, _extends$m({}, u, s));
      }
    }]), a;
  }();

  return e.propTypes = {
    component: propTypes.oneOfType([propTypes.func, propTypes.string, propTypes.node]).isRequired,
    props: propTypes.object
  }, connect(function (e, t) {
    var r,
        n,
        o,
        a,
        i,
        s = t.name,
        c = t._reduxForm,
        u = c.initialValues,
        l = (0, c.getFormState)(e),
        f = g(l, "initial." + s),
        p = void 0 !== f ? f : u && g(u, s),
        d = g(l, "values." + s),
        h = g(l, "submitting"),
        y = (r = g(l, "syncErrors"), n = s, (o = structure.getIn(r, n)) && o._error ? o._error : o),
        m = (a = g(l, "syncWarnings"), (i = g(a, s)) && i._warning ? i._warning : i),
        b = v(d, p);
    return {
      asyncError: g(l, "asyncErrors." + s),
      asyncValidating: g(l, "asyncValidating") === s,
      dirty: !b,
      pristine: b,
      state: g(l, "fields." + s),
      submitError: g(l, "submitErrors." + s),
      submitFailed: g(l, "submitFailed"),
      submitting: h,
      syncError: y,
      syncWarning: m,
      initial: p,
      value: d,
      _value: t.value
    };
  }, void 0, void 0, {
    withRef: !0
  })(e);
},
    customizer$1 = function customizer$1(e, t, r, n, o, a) {
  if (a) return e === t;
},
    shallowCompare = function shallowCompare(e, t, r) {
  var n = isEqualWith(e.props, t, customizer$1),
      o = isEqualWith(e.state, r, customizer$1);
  return !n || !o;
},
    _extends$n = Object.assign || function (e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];

    for (var n in r) {
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
  }

  return e;
},
    _createClass$4 = function () {
  function n(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  return function (e, t, r) {
    return t && n(e.prototype, t), r && n(e, r), e;
  };
}();

function _classCallCheck$g(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _possibleConstructorReturn$g(e, t) {
  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !t || "object" != typeof t && "function" != typeof t ? e : t;
}

function _inherits$g(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}

var createField = function createField(e) {
  var t = createConnectedField(e),
      a = e.setIn,
      r = function (e) {
    function r(e, t) {
      _classCallCheck$g(this, r);

      var o = _possibleConstructorReturn$g(this, (r.__proto__ || Object.getPrototypeOf(r)).call(this, e, t));

      if (o.saveRef = function (e) {
        return o.ref = e;
      }, o.normalize = function (e, t) {
        var r = o.props.normalize;
        if (!r) return t;

        var n = o.context._reduxForm.getValues();

        return r(t, o.value, a(n, e, t), n);
      }, !t._reduxForm) throw new Error("Field must be inside a component decorated with reduxForm()");
      return o;
    }

    return _inherits$g(r, react_1), _createClass$4(r, [{
      key: "componentDidMount",
      value: function value() {
        var e = this;

        this.context._reduxForm.register(this.name, "Field", function () {
          return e.props.validate;
        }, function () {
          return e.props.warn;
        });
      }
    }, {
      key: "shouldComponentUpdate",
      value: function value(e, t) {
        return shallowCompare(this, e, t);
      }
    }, {
      key: "componentWillReceiveProps",
      value: function value(e, t) {
        var r = formatName(this.context, this.props.name),
            n = formatName(t, e.name);
        r === n && structure.deepEqual(this.props.validate, e.validate) && structure.deepEqual(this.props.warn, e.warn) || (this.context._reduxForm.unregister(r), this.context._reduxForm.register(n, "Field", function () {
          return e.validate;
        }, function () {
          return e.warn;
        }));
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.context._reduxForm.unregister(this.name);
      }
    }, {
      key: "getRenderedComponent",
      value: function value() {
        return browser$1(this.props.withRef, "If you want to access getRenderedComponent(), you must specify a withRef prop to Field"), this.ref ? this.ref.getWrappedInstance().getRenderedComponent() : void 0;
      }
    }, {
      key: "render",
      value: function value() {
        return react_5(t, _extends$n({}, this.props, {
          name: this.name,
          normalize: this.normalize,
          _reduxForm: this.context._reduxForm,
          ref: this.saveRef
        }));
      }
    }, {
      key: "name",
      get: function get() {
        return formatName(this.context, this.props.name);
      }
    }, {
      key: "dirty",
      get: function get() {
        return !this.pristine;
      }
    }, {
      key: "pristine",
      get: function get() {
        return !(!this.ref || !this.ref.getWrappedInstance().isPristine());
      }
    }, {
      key: "value",
      get: function get() {
        return this.ref && this.ref.getWrappedInstance().getValue();
      }
    }]), r;
  }();

  return r.propTypes = {
    name: propTypes.string.isRequired,
    component: propTypes.oneOfType([propTypes.func, propTypes.string, propTypes.node]).isRequired,
    format: propTypes.func,
    normalize: propTypes.func,
    onBlur: propTypes.func,
    onChange: propTypes.func,
    onFocus: propTypes.func,
    onDragStart: propTypes.func,
    onDrop: propTypes.func,
    parse: propTypes.func,
    props: propTypes.object,
    validate: propTypes.oneOfType([propTypes.func, propTypes.arrayOf(propTypes.func)]),
    warn: propTypes.oneOfType([propTypes.func, propTypes.arrayOf(propTypes.func)]),
    withRef: propTypes.bool,
    immutableProps: propTypes.arrayOf(propTypes.string)
  }, r.contextTypes = {
    _reduxForm: propTypes.object
  }, polyfill$2(r), r;
},
    Field = createField(structure),
    _extends$o = Object.assign || function (e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];

    for (var n in r) {
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
  }

  return e;
},
    _createClass$5 = function () {
  function n(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  return function (e, t, r) {
    return t && n(e.prototype, t), r && n(e, r), e;
  };
}();

function _objectWithoutProperties$7(e, t) {
  var r = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
  }

  return r;
}

function _classCallCheck$h(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _possibleConstructorReturn$h(e, t) {
  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !t || "object" != typeof t && "function" != typeof t ? e : t;
}

function _inherits$h(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}

var propsToNotUpdateFor$1 = ["_reduxForm"],
    createConnectedFields = function createConnectedFields(p) {
  var o = p.deepEqual,
      m = p.getIn,
      r = p.size,
      e = function (e) {
    function t(e) {
      _classCallCheck$h(this, t);

      var s = _possibleConstructorReturn$h(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));

      return s.onChangeFns = {}, s.onFocusFns = {}, s.onBlurFns = {}, s.prepareEventHandlers = function (e) {
        return e.names.forEach(function (t) {
          s.onChangeFns[t] = function (e) {
            return s.handleChange(t, e);
          }, s.onFocusFns[t] = function () {
            return s.handleFocus(t);
          }, s.onBlurFns[t] = function (e) {
            return s.handleBlur(t, e);
          };
        });
      }, s.handleChange = function (e, t) {
        var r = s.props,
            n = r.dispatch,
            o = r.parse,
            a = r._reduxForm,
            i = onChangeValue(t, {
          name: e,
          parse: o
        });
        n(a.change(e, i)), a.asyncValidate && a.asyncValidate(e, i, "change");
      }, s.handleFocus = function (e) {
        var t = s.props;
        (0, t.dispatch)(t._reduxForm.focus(e));
      }, s.handleBlur = function (e, t) {
        var r = s.props,
            n = r.dispatch,
            o = r.parse,
            a = r._reduxForm,
            i = onChangeValue(t, {
          name: e,
          parse: o
        });
        n(a.blur(e, i)), a.asyncValidate && a.asyncValidate(e, i, "blur");
      }, s.saveRef = function (e) {
        s.ref = e;
      }, s.prepareEventHandlers(e), s;
    }

    return _inherits$h(t, react_1), _createClass$5(t, [{
      key: "componentWillReceiveProps",
      value: function value(e) {
        var t = this;
        this.props.names === e.names || r(this.props.names) === r(e.names) && !e.names.some(function (e) {
          return !t.props._fields[e];
        }) || this.prepareEventHandlers(e);
      }
    }, {
      key: "shouldComponentUpdate",
      value: function value(t) {
        var r = this,
            e = Object.keys(t),
            n = Object.keys(this.props);
        return !!(this.props.children || t.children || e.length !== n.length || e.some(function (e) {
          return !~propsToNotUpdateFor$1.indexOf(e) && !o(r.props[e], t[e]);
        }));
      }
    }, {
      key: "isDirty",
      value: function value() {
        var t = this.props._fields;
        return Object.keys(t).some(function (e) {
          return t[e].dirty;
        });
      }
    }, {
      key: "getValues",
      value: function value() {
        var r = this.props._fields;
        return Object.keys(r).reduce(function (e, t) {
          return structure.setIn(e, t, r[t].value);
        }, {});
      }
    }, {
      key: "getRenderedComponent",
      value: function value() {
        return this.ref;
      }
    }, {
      key: "render",
      value: function value() {
        var s = this,
            e = this.props,
            t = e.component,
            r = e.withRef,
            c = e._fields,
            n = e._reduxForm,
            u = _objectWithoutProperties$7(e, ["component", "withRef", "_fields", "_reduxForm"]),
            l = n.sectionPrefix,
            f = n.form,
            o = Object.keys(c).reduce(function (e, t) {
          var r = c[t],
              n = createFieldProps(p, t, _extends$o({}, r, u, {
            form: f,
            onBlur: s.onBlurFns[t],
            onChange: s.onChangeFns[t],
            onFocus: s.onFocusFns[t]
          })),
              o = n.custom,
              a = _objectWithoutProperties$7(n, ["custom"]);

          e.custom = o;
          var i = l ? t.replace(l + ".", "") : t;
          return structure.setIn(e, i, a);
        }, {}),
            a = o.custom,
            i = _objectWithoutProperties$7(o, ["custom"]);

        return r && (i.ref = this.saveRef), react_5(t, _extends$o({}, i, a));
      }
    }]), t;
  }();

  return e.propTypes = {
    component: propTypes.oneOfType([propTypes.func, propTypes.string, propTypes.node]).isRequired,
    _fields: propTypes.object.isRequired,
    props: propTypes.object
  }, connect(function (e, d) {
    var t = d.names,
        r = d._reduxForm,
        h = r.initialValues,
        y = (0, r.getFormState)(e);
    return {
      _fields: t.reduce(function (e, t) {
        var r,
            n,
            o,
            a,
            i = m(y, "initial." + t),
            s = void 0 !== i ? i : h && m(h, t),
            c = m(y, "values." + t),
            u = (r = m(y, "syncErrors"), n = t, structure.getIn(r, n + "._error") || structure.getIn(r, n)),
            l = (o = m(y, "syncWarnings"), (a = m(o, t)) && a._warning ? a._warning : a),
            f = m(y, "submitting"),
            p = c === s;
        return e[t] = {
          asyncError: m(y, "asyncErrors." + t),
          asyncValidating: m(y, "asyncValidating") === t,
          dirty: !p,
          initial: s,
          pristine: p,
          state: m(y, "fields." + t),
          submitError: m(y, "submitErrors." + t),
          submitFailed: m(y, "submitFailed"),
          submitting: f,
          syncError: u,
          syncWarning: l,
          value: c,
          _value: d.value
        }, e;
      }, {})
    };
  }, void 0, void 0, {
    withRef: !0
  })(e);
},
    _extends$p = Object.assign || function (e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];

    for (var n in r) {
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
  }

  return e;
},
    _createClass$6 = function () {
  function n(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  return function (e, t, r) {
    return t && n(e.prototype, t), r && n(e, r), e;
  };
}();

function _classCallCheck$i(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _possibleConstructorReturn$i(e, t) {
  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !t || "object" != typeof t && "function" != typeof t ? e : t;
}

function _inherits$i(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}

var validateNameProp = function validateNameProp(e) {
  return e ? Array.isArray(e) || e._isFieldArray ? void 0 : new Error('Invalid prop "names" supplied to <Fields/>. Must be either an array of strings or the fields array generated by FieldArray.') : new Error('No "names" prop was specified <Fields/>');
},
    createFields = function createFields(e) {
  var r = createConnectedFields(e),
      t = function (e) {
    function o(e, t) {
      _classCallCheck$i(this, o);

      var r = _possibleConstructorReturn$i(this, (o.__proto__ || Object.getPrototypeOf(o)).call(this, e, t));

      if (!t._reduxForm) throw new Error("Fields must be inside a component decorated with reduxForm()");
      var n = validateNameProp(e.names);
      if (n) throw n;
      return r;
    }

    return _inherits$i(o, react_1), _createClass$6(o, [{
      key: "shouldComponentUpdate",
      value: function value(e) {
        return shallowCompare(this, e);
      }
    }, {
      key: "componentDidMount",
      value: function value() {
        var t = this.context._reduxForm.register;
        this.names.forEach(function (e) {
          return t(e, "Field");
        });
      }
    }, {
      key: "componentWillReceiveProps",
      value: function value(e) {
        if (!structure.deepEqual(this.props.names, e.names)) {
          var t = this.context,
              r = t._reduxForm,
              n = r.register,
              o = r.unregister;
          this.props.names.forEach(function (e) {
            return o(formatName(t, e));
          }), e.names.forEach(function (e) {
            return n(formatName(t, e), "Field");
          });
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        var t = this.context,
            r = t._reduxForm.unregister;
        this.props.names.forEach(function (e) {
          return r(formatName(t, e));
        });
      }
    }, {
      key: "getRenderedComponent",
      value: function value() {
        return browser$1(this.props.withRef, "If you want to access getRenderedComponent(), you must specify a withRef prop to Fields"), this.refs.connected.getWrappedInstance().getRenderedComponent();
      }
    }, {
      key: "render",
      value: function value() {
        var t = this.context;
        return react_5(r, _extends$p({}, this.props, {
          names: this.props.names.map(function (e) {
            return formatName(t, e);
          }),
          _reduxForm: this.context._reduxForm,
          ref: "connected"
        }));
      }
    }, {
      key: "names",
      get: function get() {
        var t = this.context;
        return this.props.names.map(function (e) {
          return formatName(t, e);
        });
      }
    }, {
      key: "dirty",
      get: function get() {
        return this.refs.connected.getWrappedInstance().isDirty();
      }
    }, {
      key: "pristine",
      get: function get() {
        return !this.dirty;
      }
    }, {
      key: "values",
      get: function get() {
        return this.refs.connected && this.refs.connected.getWrappedInstance().getValues();
      }
    }]), o;
  }();

  return t.propTypes = {
    names: function names(e, t) {
      return validateNameProp(e[t]);
    },
    component: propTypes.oneOfType([propTypes.func, propTypes.string, propTypes.node]).isRequired,
    format: propTypes.func,
    parse: propTypes.func,
    props: propTypes.object,
    withRef: propTypes.bool
  }, t.contextTypes = {
    _reduxForm: propTypes.object
  }, polyfill$2(t), t;
};

createFields(structure);

var defineProperty$4 = function () {
  try {
    var e = getNative(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch (e) {}
}();

function baseAssignValue(e, t, r) {
  "__proto__" == t && defineProperty$4 ? defineProperty$4(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}

function createBaseFor(c) {
  return function (e, t, r) {
    for (var n = -1, o = Object(e), a = r(e), i = a.length; i--;) {
      var s = a[c ? i : ++n];
      if (!1 === t(o[s], s, o)) break;
    }

    return e;
  };
}

var baseFor = createBaseFor();

function baseForOwn(e, t) {
  return e && baseFor(e, t, keys$1);
}

var COMPARE_PARTIAL_FLAG$4 = 1,
    COMPARE_UNORDERED_FLAG$2 = 2;

function baseIsMatch(e, t, r, n) {
  var o = r.length,
      a = o,
      i = !n;
  if (null == e) return !a;

  for (e = Object(e); o--;) {
    var s = r[o];
    if (i && s[2] ? s[1] !== e[s[0]] : !(s[0] in e)) return !1;
  }

  for (; ++o < a;) {
    var c = (s = r[o])[0],
        u = e[c],
        l = s[1];

    if (i && s[2]) {
      if (void 0 === u && !(c in e)) return !1;
    } else {
      var f = new Stack();
      if (n) var p = n(u, l, c, e, t, f);
      if (!(void 0 === p ? baseIsEqual(l, u, COMPARE_PARTIAL_FLAG$4 | COMPARE_UNORDERED_FLAG$2, n, f) : p)) return !1;
    }
  }

  return !0;
}

function isStrictComparable(e) {
  return e == e && !isObject(e);
}

function getMatchData(e) {
  for (var t = keys$1(e), r = t.length; r--;) {
    var n = t[r],
        o = e[n];
    t[r] = [n, o, isStrictComparable(o)];
  }

  return t;
}

function matchesStrictComparable(t, r) {
  return function (e) {
    return null != e && e[t] === r && (void 0 !== r || t in Object(e));
  };
}

function baseMatches(t) {
  var r = getMatchData(t);
  return 1 == r.length && r[0][2] ? matchesStrictComparable(r[0][0], r[0][1]) : function (e) {
    return e === t || baseIsMatch(e, t, r);
  };
}

var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

function isKey(e, t) {
  if (isArray(e)) return !1;
  var r = typeof e;
  return !("number" != r && "symbol" != r && "boolean" != r && null != e && !isSymbol$1(e)) || reIsPlainProp.test(e) || !reIsDeepProp.test(e) || null != t && e in Object(t);
}

function castPath(e, t) {
  return isArray(e) ? e : isKey(e, t) ? [e] : stringToPath(toString$1(e));
}

function baseGet(e, t) {
  for (var r = 0, n = (t = castPath(t, e)).length; null != e && r < n;) {
    e = e[toKey(t[r++])];
  }

  return r && r == n ? e : void 0;
}

function get$2(e, t, r) {
  var n = null == e ? void 0 : baseGet(e, t);
  return void 0 === n ? r : n;
}

function baseHasIn(e, t) {
  return null != e && t in Object(e);
}

function hasPath(e, t, r) {
  for (var n = -1, o = (t = castPath(t, e)).length, a = !1; ++n < o;) {
    var i = toKey(t[n]);
    if (!(a = null != e && r(e, i))) break;
    e = e[i];
  }

  return a || ++n != o ? a : !!(o = null == e ? 0 : e.length) && isLength(o) && isIndex(i, o) && (isArray(e) || isArguments$1(e));
}

function hasIn(e, t) {
  return null != e && hasPath(e, t, baseHasIn);
}

var COMPARE_PARTIAL_FLAG$5 = 1,
    COMPARE_UNORDERED_FLAG$3 = 2;

function baseMatchesProperty(r, n) {
  return isKey(r) && isStrictComparable(n) ? matchesStrictComparable(toKey(r), n) : function (e) {
    var t = get$2(e, r);
    return void 0 === t && t === n ? hasIn(e, r) : baseIsEqual(n, t, COMPARE_PARTIAL_FLAG$5 | COMPARE_UNORDERED_FLAG$3);
  };
}

function identity$3(e) {
  return e;
}

function baseProperty(t) {
  return function (e) {
    return null == e ? void 0 : e[t];
  };
}

function basePropertyDeep(t) {
  return function (e) {
    return baseGet(e, t);
  };
}

function property(e) {
  return isKey(e) ? baseProperty(toKey(e)) : basePropertyDeep(e);
}

function baseIteratee(e) {
  return "function" == typeof e ? e : null == e ? identity$3 : "object" == typeof e ? isArray(e) ? baseMatchesProperty(e[0], e[1]) : baseMatches(e) : property(e);
}

function mapValues(e, n) {
  var o = {};
  return n = baseIteratee(n, 3), baseForOwn(e, function (e, t, r) {
    baseAssignValue(o, t, n(e, t, r));
  }), o;
}

var _extends$q = Object.assign || function (e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];

    for (var n in r) {
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
  }

  return e;
};

function _objectWithoutProperties$8(e, t) {
  var r = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
  }

  return r;
}

var createFieldArrayProps = function createFieldArrayProps(e, t, r, n, o, a) {
  var i = e.getIn,
      s = a.arrayInsert,
      c = a.arrayMove,
      u = a.arrayPop,
      l = a.arrayPush,
      f = a.arrayRemove,
      p = a.arrayRemoveAll,
      d = a.arrayShift,
      h = a.arraySplice,
      y = a.arraySwap,
      m = a.arrayUnshift,
      b = a.asyncError,
      v = a.dirty,
      g = a.length,
      _ = a.pristine,
      w = a.submitError,
      $ = (a.state, a.submitFailed),
      S = a.submitting,
      T = a.syncError,
      P = a.syncWarning,
      x = a.value,
      E = a.props,
      C = _objectWithoutProperties$8(a, ["arrayInsert", "arrayMove", "arrayPop", "arrayPush", "arrayRemove", "arrayRemoveAll", "arrayShift", "arraySplice", "arraySwap", "arrayUnshift", "asyncError", "dirty", "length", "pristine", "submitError", "state", "submitFailed", "submitting", "syncError", "syncWarning", "value", "props"]),
      O = T || b || w,
      A = P,
      R = n ? t.replace(n + ".", "") : t,
      N = _extends$q({
    fields: {
      _isFieldArray: !0,
      forEach: function forEach(r) {
        return (x || []).forEach(function (e, t) {
          return r(R + "[" + t + "]", t, N.fields);
        });
      },
      get: o,
      getAll: function getAll() {
        return x;
      },
      insert: s,
      length: g,
      map: function map(r) {
        return (x || []).map(function (e, t) {
          return r(R + "[" + t + "]", t, N.fields);
        });
      },
      move: c,
      name: t,
      pop: function pop() {
        return u(), i(x, String(g - 1));
      },
      push: l,
      reduce: function reduce(n, e) {
        return (x || []).reduce(function (e, t, r) {
          return n(e, R + "[" + r + "]", r, N.fields);
        }, e);
      },
      remove: f,
      removeAll: p,
      shift: function shift() {
        return d(), i(x, "0");
      },
      splice: h,
      swap: y,
      unshift: m
    },
    meta: {
      dirty: v,
      error: O,
      form: r,
      warning: A,
      invalid: !!O,
      pristine: _,
      submitting: S,
      submitFailed: $,
      valid: !O
    }
  }, E, C);

  return N;
},
    _createClass$7 = function () {
  function n(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  return function (e, t, r) {
    return t && n(e.prototype, t), r && n(e, r), e;
  };
}();

function _objectWithoutProperties$9(e, t) {
  var r = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
  }

  return r;
}

function _classCallCheck$j(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _possibleConstructorReturn$j(e, t) {
  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !t || "object" != typeof t && "function" != typeof t ? e : t;
}

function _inherits$j(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}

var propsToNotUpdateFor$2 = ["_reduxForm", "value"],
    createConnectedFieldArray = function createConnectedFieldArray(s) {
  var y = s.deepEqual,
      m = s.getIn,
      b = s.size,
      e = function (e) {
    function i() {
      var e, t, r;

      _classCallCheck$j(this, i);

      for (var n = arguments.length, o = Array(n), a = 0; a < n; a++) {
        o[a] = arguments[a];
      }

      return (t = r = _possibleConstructorReturn$j(this, (e = i.__proto__ || Object.getPrototypeOf(i)).call.apply(e, [this].concat(o)))).saveRef = function (e) {
        r.ref = e;
      }, r.getValue = function (e) {
        return r.props.value && m(r.props.value, String(e));
      }, _possibleConstructorReturn$j(r, t);
    }

    return _inherits$j(i, react_1), _createClass$7(i, [{
      key: "shouldComponentUpdate",
      value: function value(t) {
        var r = this,
            n = this.props.value,
            o = t.value;

        if (n && o) {
          var e = o.every(function (e) {
            return ~n.indexOf(e);
          }),
              a = o.some(function (e, t) {
            return e !== n[t];
          });
          if (n.length !== o.length || e && a || t.rerenderOnEveryChange && n.some(function (e, t) {
            return !y(e, o[t]);
          })) return !0;
        }

        var i = Object.keys(t),
            s = Object.keys(this.props);
        return !!(this.props.children || t.children || i.length !== s.length || i.some(function (e) {
          return !~propsToNotUpdateFor$2.indexOf(e) && !y(r.props[e], t[e]);
        }));
      }
    }, {
      key: "getRenderedComponent",
      value: function value() {
        return this.ref;
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
            t = e.component,
            r = e.withRef,
            n = e.name,
            o = e._reduxForm,
            a = (e.validate, e.warn, e.rerenderOnEveryChange, _objectWithoutProperties$9(e, ["component", "withRef", "name", "_reduxForm", "validate", "warn", "rerenderOnEveryChange"])),
            i = createFieldArrayProps(s, n, o.form, o.sectionPrefix, this.getValue, a);
        return r && (i.ref = this.saveRef), react_5(t, i);
      }
    }, {
      key: "dirty",
      get: function get() {
        return this.props.dirty;
      }
    }, {
      key: "pristine",
      get: function get() {
        return this.props.pristine;
      }
    }, {
      key: "value",
      get: function get() {
        return this.props.value;
      }
    }]), i;
  }();

  return e.propTypes = {
    component: propTypes.oneOfType([propTypes.func, propTypes.string, propTypes.node]).isRequired,
    props: propTypes.object,
    rerenderOnEveryChange: propTypes.bool
  }, e.defaultProps = {
    rerenderOnEveryChange: !1
  }, e.contextTypes = {
    _reduxForm: propTypes.object
  }, connect(function (e, t) {
    var r,
        n,
        o,
        a = t.name,
        i = t._reduxForm,
        s = i.initialValues,
        c = (0, i.getFormState)(e),
        u = m(c, "initial." + a) || s && m(s, a),
        l = m(c, "values." + a),
        f = m(c, "submitting"),
        p = (r = m(c, "syncErrors"), n = a, structure.getIn(r, n + "._error")),
        d = (o = m(c, "syncWarnings"), m(o, a + "._warning")),
        h = y(l, u);
    return {
      asyncError: m(c, "asyncErrors." + a + "._error"),
      dirty: !h,
      pristine: h,
      state: m(c, "fields." + a),
      submitError: m(c, "submitErrors." + a + "._error"),
      submitFailed: m(c, "submitFailed"),
      submitting: f,
      syncError: p,
      syncWarning: d,
      value: l,
      length: b(l)
    };
  }, function (t, e) {
    var r = e.name,
        n = e._reduxForm;
    return mapValues({
      arrayInsert: n.arrayInsert,
      arrayMove: n.arrayMove,
      arrayPop: n.arrayPop,
      arrayPush: n.arrayPush,
      arrayRemove: n.arrayRemove,
      arrayRemoveAll: n.arrayRemoveAll,
      arrayShift: n.arrayShift,
      arraySplice: n.arraySplice,
      arraySwap: n.arraySwap,
      arrayUnshift: n.arrayUnshift
    }, function (e) {
      return bindActionCreators(e.bind(null, r), t);
    });
  }, void 0, {
    withRef: !0
  })(e);
},
    _extends$r = Object.assign || function (e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];

    for (var n in r) {
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
  }

  return e;
},
    _createClass$8 = function () {
  function n(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  return function (e, t, r) {
    return t && n(e.prototype, t), r && n(e, r), e;
  };
}();

function _classCallCheck$k(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _possibleConstructorReturn$k(e, t) {
  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !t || "object" != typeof t && "function" != typeof t ? e : t;
}

function _inherits$k(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}

function _defineProperty$3(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}

var toArray = function toArray(e) {
  return Array.isArray(e) ? e : [e];
},
    wrapError = function wrapError(n, o) {
  return n && function () {
    for (var e = toArray(n), t = 0; t < e.length; t++) {
      var r = e[t].apply(e, arguments);
      if (r) return _defineProperty$3({}, o, r);
    }
  };
},
    createFieldArray = function createFieldArray(e) {
  var t = createConnectedFieldArray(e),
      r = function (e) {
    function n(e, t) {
      _classCallCheck$k(this, n);

      var r = _possibleConstructorReturn$k(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, e, t));

      if (r.saveRef = function (e) {
        r.ref = e;
      }, !t._reduxForm) throw new Error("FieldArray must be inside a component decorated with reduxForm()");
      return r;
    }

    return _inherits$k(n, react_1), _createClass$8(n, [{
      key: "componentDidMount",
      value: function value() {
        var e = this;

        this.context._reduxForm.register(this.name, "FieldArray", function () {
          return wrapError(e.props.validate, "_error");
        }, function () {
          return wrapError(e.props.warn, "_warning");
        });
      }
    }, {
      key: "componentWillReceiveProps",
      value: function value(e, t) {
        var r = formatName(this.context, this.props.name),
            n = formatName(t, e.name);
        r !== n && (this.context._reduxForm.unregister(r), this.context._reduxForm.register(n, "FieldArray"));
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.context._reduxForm.unregister(this.name);
      }
    }, {
      key: "getRenderedComponent",
      value: function value() {
        return browser$1(this.props.withRef, "If you want to access getRenderedComponent(), you must specify a withRef prop to FieldArray"), this.ref && this.ref.getWrappedInstance().getRenderedComponent();
      }
    }, {
      key: "render",
      value: function value() {
        return react_5(t, _extends$r({}, this.props, {
          name: this.name,
          _reduxForm: this.context._reduxForm,
          ref: this.saveRef
        }));
      }
    }, {
      key: "name",
      get: function get() {
        return formatName(this.context, this.props.name);
      }
    }, {
      key: "dirty",
      get: function get() {
        return !this.ref || this.ref.getWrappedInstance().dirty;
      }
    }, {
      key: "pristine",
      get: function get() {
        return !(!this.ref || !this.ref.getWrappedInstance().pristine);
      }
    }, {
      key: "value",
      get: function get() {
        return this.ref ? this.ref.getWrappedInstance().value : void 0;
      }
    }]), n;
  }();

  return r.propTypes = {
    name: propTypes.string.isRequired,
    component: propTypes.oneOfType([propTypes.func, propTypes.string, propTypes.node]).isRequired,
    props: propTypes.object,
    validate: propTypes.oneOfType([propTypes.func, propTypes.arrayOf(propTypes.func)]),
    warn: propTypes.oneOfType([propTypes.func, propTypes.arrayOf(propTypes.func)]),
    withRef: propTypes.bool
  }, r.contextTypes = {
    _reduxForm: propTypes.object
  }, polyfill$2(r), r;
};

createFieldArray(structure);

var createFormValueSelector = function createFormValueSelector(e) {
  var i = e.getIn;
  return function (o, e) {
    browser$1(o, "Form value must be specified");

    var a = e || function (e) {
      return i(e, "form");
    };

    return function (n) {
      for (var e = arguments.length, t = Array(1 < e ? e - 1 : 0), r = 1; r < e; r++) {
        t[r - 1] = arguments[r];
      }

      return browser$1(t.length, "No fields specified"), 1 === t.length ? i(a(n), o + ".values." + t[0]) : t.reduce(function (e, t) {
        var r = i(a(n), o + ".values." + t);
        return void 0 === r ? e : structure.setIn(e, t, r);
      }, {});
    };
  };
};

function isEqual(e, t) {
  return baseIsEqual(e, t);
}

createFormValueSelector(structure);
var mapTag$3 = "[object Map]",
    setTag$3 = "[object Set]",
    objectProto$c = Object.prototype,
    hasOwnProperty$a = objectProto$c.hasOwnProperty;

function isEmpty(e) {
  if (null == e) return !0;
  if (isArrayLike(e) && (isArray(e) || "string" == typeof e || "function" == typeof e.splice || isBuffer(e) || isTypedArray(e) || isArguments$1(e))) return !e.length;
  var t = getTag$1(e);
  if (t == mapTag$3 || t == setTag$3) return !e.size;
  if (isPrototype(e)) return !baseKeys(e).length;

  for (var r in e) {
    if (hasOwnProperty$a.call(e, r)) return !1;
  }

  return !0;
}

var _extends$s = Object.assign || function (e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];

    for (var n in r) {
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
  }

  return e;
},
    _createClass$9 = function () {
  function n(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  return function (e, t, r) {
    return t && n(e.prototype, t), r && n(e, r), e;
  };
}();

function _objectWithoutProperties$a(e, t) {
  var r = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
  }

  return r;
}

function _defineProperty$4(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}

function _classCallCheck$l(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _possibleConstructorReturn$l(e, t) {
  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !t || "object" != typeof t && "function" != typeof t ? e : t;
}

function _inherits$l(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}

var createValues = function createValues(e) {
  var i = e.getIn;
  return function (o) {
    for (var e = arguments.length, a = Array(1 < e ? e - 1 : 0), t = 1; t < e; t++) {
      a[t - 1] = arguments[t];
    }

    return function (r) {
      var e = function (e) {
        function n(e, t) {
          _classCallCheck$l(this, n);

          var r = _possibleConstructorReturn$l(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, e, t));

          if (!t._reduxForm) throw new Error("formValues() must be used inside a React tree decorated with reduxForm()");
          return r.updateComponent(e), r;
        }

        return _inherits$l(n, react.Component), _createClass$9(n, [{
          key: "componentWillReceiveProps",
          value: function value(e) {
            "function" == typeof o && this.updateComponent(e);
          }
        }, {
          key: "render",
          value: function value() {
            var e = this.Component;
            return react.createElement(e, _extends$s({
              sectionPrefix: this.context._reduxForm.sectionPrefix
            }, this.props));
          }
        }, {
          key: "updateComponent",
          value: function value(e) {
            var t = void 0,
                r = "function" == typeof o ? o(e) : o;
            if (isEmpty(t = "string" == typeof r ? a.reduce(function (e, t) {
              return e[t] = t, e;
            }, _defineProperty$4({}, r, r)) : r)) throw new Error("formValues(): You must specify values to get as formValues(name1, name2, ...) or formValues({propName1: propPath1, ...}) or formValues((props) => name) or formValues((props) => ({propName1: propPath1, ...}))");
            isEqual(t, this._valuesMap) || (this._valuesMap = t, this.setComponent());
          }
        }, {
          key: "setComponent",
          value: function value() {
            var n = this;
            this.Component = connect(function (e, t) {
              t.sectionPrefix;
              var r = (0, n.context._reduxForm.getValues)();
              return mapValues(n._valuesMap, function (e) {
                return i(r, formatName(n.context, e));
              });
            }, function () {
              return {};
            })(function (e) {
              e.sectionPrefix;

              var t = _objectWithoutProperties$a(e, ["sectionPrefix"]);

              return react.createElement(r, t);
            });
          }
        }]), n;
      }();

      return e.contextTypes = {
        _reduxForm: propTypes.object
      }, e;
    };
  };
};

createValues(structure);

var createGetFormError = function createGetFormError(e) {
  var n = e.getIn;
  return function (t, r) {
    return function (e) {
      return n((r || function (e) {
        return n(e, "form");
      })(e), t + ".error");
    };
  };
};

function createGetFormNames(e) {
  var r = e.getIn,
      n = e.keys;
  return function (t) {
    return function (e) {
      return n((t || function (e) {
        return r(e, "form");
      })(e));
    };
  };
}

createGetFormError(structure), createGetFormNames(structure);

var createGetFormValues = function createGetFormValues(e) {
  var n = e.getIn;
  return function (t, r) {
    return function (e) {
      return n((r || function (e) {
        return n(e, "form");
      })(e), t + ".values");
    };
  };
};

createGetFormValues(structure);

var createGetFormInitialValues = function createGetFormInitialValues(e) {
  var n = e.getIn;
  return function (t, r) {
    return function (e) {
      return n((r || function (e) {
        return n(e, "form");
      })(e), t + ".initial");
    };
  };
};

createGetFormInitialValues(structure);

var createGetFormSyncErrors = function createGetFormSyncErrors(e) {
  var n = e.getIn,
      o = e.empty;
  return function (t, r) {
    return function (e) {
      return n((r || function (e) {
        return n(e, "form");
      })(e), t + ".syncErrors") || o;
    };
  };
};

createGetFormSyncErrors(structure);

var createGetFormMeta = function createGetFormMeta(e) {
  var n = e.getIn,
      o = e.empty;
  return function (t, r) {
    return function (e) {
      return n((r || function (e) {
        return n(e, "form");
      })(e), t + ".fields") || o;
    };
  };
};

createGetFormMeta(structure);

var createGetFormAsyncErrors = function createGetFormAsyncErrors(e) {
  var n = e.getIn;
  return function (t, r) {
    return function (e) {
      return n((r || function (e) {
        return n(e, "form");
      })(e), t + ".asyncErrors");
    };
  };
};

createGetFormAsyncErrors(structure);

var createGetFormSyncWarnings = function createGetFormSyncWarnings(e) {
  var n = e.getIn,
      o = e.empty;
  return function (t, r) {
    return function (e) {
      return n((r || function (e) {
        return n(e, "form");
      })(e), t + ".syncWarnings") || o;
    };
  };
};

createGetFormSyncWarnings(structure);

var createGetFormSubmitErrors = function createGetFormSubmitErrors(e) {
  var n = e.getIn,
      o = e.empty;
  return function (t, r) {
    return function (e) {
      return n((r || function (e) {
        return n(e, "form");
      })(e), t + ".submitErrors") || o;
    };
  };
};

createGetFormSubmitErrors(structure);

var createIsAsyncValidating = function createIsAsyncValidating(e) {
  var n = e.getIn;
  return function (t, r) {
    return function (e) {
      return !!n((r || function (e) {
        return n(e, "form");
      })(e), t + ".asyncValidating");
    };
  };
};

createIsAsyncValidating(structure);

var createIsPristine = function createIsPristine(e) {
  var u = e.deepEqual,
      l = e.empty,
      f = e.getIn;
  return function (s, c) {
    return function (e) {
      for (var t = arguments.length, r = Array(1 < t ? t - 1 : 0), n = 1; n < t; n++) {
        r[n - 1] = arguments[n];
      }

      var o = (c || function (e) {
        return f(e, "form");
      })(e);

      if (r && r.length) return r.every(function (e) {
        var t = f(o, s + ".initial." + e),
            r = f(o, s + ".values." + e);
        return u(t, r);
      });
      var a = f(o, s + ".initial") || l,
          i = f(o, s + ".values") || a;
      return u(a, i);
    };
  };
},
    getErrorKeys = function getErrorKeys(e, t) {
  switch (t) {
    case "Field":
      return [e, e + "._error"];

    case "FieldArray":
      return [e + "._error"];

    default:
      throw new Error("Unknown field type");
  }
},
    createHasError = function createHasError(e) {
  var i = e.getIn;
  return function (e, t, r, n) {
    if (!t && !r && !n) return !1;
    var o = i(e, "name"),
        a = i(e, "type");
    return getErrorKeys(o, a).some(function (e) {
      return i(t, e) || i(r, e) || i(n, e);
    });
  };
},
    createIsValid = function createIsValid(e) {
  var u = e.getIn,
      l = e.keys,
      f = createHasError(e);
  return function (i, s) {
    var c = 2 < arguments.length && void 0 !== arguments[2] && arguments[2];
    return function (e) {
      var t = (s || function (e) {
        return u(e, "form");
      })(e);

      if (u(t, i + ".syncError")) return !1;
      if (!c && u(t, i + ".error")) return !1;
      var r = u(t, i + ".syncErrors"),
          n = u(t, i + ".asyncErrors"),
          o = c ? void 0 : u(t, i + ".submitErrors");
      if (!r && !n && !o) return !0;
      var a = u(t, i + ".registeredFields");
      return !a || !l(a).filter(function (e) {
        return 0 < u(a, "['" + e + "'].count");
      }).some(function (e) {
        return f(u(a, "['" + e + "']"), r, n, o);
      });
    };
  };
};

createIsPristine(structure), createIsValid(structure);

var createIsSubmitting = function createIsSubmitting(e) {
  var n = e.getIn;
  return function (t, r) {
    return function (e) {
      return !!n((r || function (e) {
        return n(e, "form");
      })(e), t + ".submitting");
    };
  };
};

createIsSubmitting(structure);

var createHasSubmitSucceeded = function createHasSubmitSucceeded(e) {
  var n = e.getIn;
  return function (t, r) {
    return function (e) {
      return !!n((r || function (e) {
        return n(e, "form");
      })(e), t + ".submitSucceeded");
    };
  };
};

createHasSubmitSucceeded(structure);

var createHasSubmitFailed = function createHasSubmitFailed(e) {
  var n = e.getIn;
  return function (t, r) {
    return function (e) {
      return !!n((r || function (e) {
        return n(e, "form");
      })(e), t + ".submitFailed");
    };
  };
};

function assignMergeValue(e, t, r) {
  (void 0 === r || eq(e[t], r)) && (void 0 !== r || t in e) || baseAssignValue(e, t, r);
}

createHasSubmitFailed(structure);
var freeExports$2 = "object" == typeof exports && exports && !exports.nodeType && exports,
    freeModule$2 = freeExports$2 && "object" == typeof module && module && !module.nodeType && module,
    moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2,
    Buffer$1 = moduleExports$2 ? root$2.Buffer : void 0,
    allocUnsafe = Buffer$1 ? Buffer$1.allocUnsafe : void 0;

function cloneBuffer(e, t) {
  if (t) return e.slice();
  var r = e.length,
      n = allocUnsafe ? allocUnsafe(r) : new e.constructor(r);
  return e.copy(n), n;
}

function cloneArrayBuffer(e) {
  var t = new e.constructor(e.byteLength);
  return new Uint8Array$1(t).set(new Uint8Array$1(e)), t;
}

function cloneTypedArray(e, t) {
  var r = t ? cloneArrayBuffer(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.length);
}

var objectCreate = Object.create,
    baseCreate = function () {
  function r() {}

  return function (e) {
    if (!isObject(e)) return {};
    if (objectCreate) return objectCreate(e);
    r.prototype = e;
    var t = new r();
    return r.prototype = void 0, t;
  };
}(),
    getPrototype = overArg(Object.getPrototypeOf, Object);

function initCloneObject(e) {
  return "function" != typeof e.constructor || isPrototype(e) ? {} : baseCreate(getPrototype(e));
}

function isArrayLikeObject(e) {
  return isObjectLike(e) && isArrayLike(e);
}

var objectTag$3 = "[object Object]",
    funcProto$2 = Function.prototype,
    objectProto$d = Object.prototype,
    funcToString$2 = funcProto$2.toString,
    hasOwnProperty$b = objectProto$d.hasOwnProperty,
    objectCtorString = funcToString$2.call(Object);

function isPlainObject$1(e) {
  if (!isObjectLike(e) || baseGetTag(e) != objectTag$3) return !1;
  var t = getPrototype(e);
  if (null === t) return !0;
  var r = hasOwnProperty$b.call(t, "constructor") && t.constructor;
  return "function" == typeof r && r instanceof r && funcToString$2.call(r) == objectCtorString;
}

function safeGet(e, t) {
  if ("__proto__" != t) return e[t];
}

var objectProto$e = Object.prototype,
    hasOwnProperty$c = objectProto$e.hasOwnProperty;

function assignValue(e, t, r) {
  var n = e[t];
  hasOwnProperty$c.call(e, t) && eq(n, r) && (void 0 !== r || t in e) || baseAssignValue(e, t, r);
}

function copyObject(e, t, r, n) {
  var o = !r;
  r || (r = {});

  for (var a = -1, i = t.length; ++a < i;) {
    var s = t[a],
        c = n ? n(r[s], e[s], s, r, e) : void 0;
    void 0 === c && (c = e[s]), o ? baseAssignValue(r, s, c) : assignValue(r, s, c);
  }

  return r;
}

function nativeKeysIn(e) {
  var t = [];
  if (null != e) for (var r in Object(e)) {
    t.push(r);
  }
  return t;
}

var objectProto$f = Object.prototype,
    hasOwnProperty$d = objectProto$f.hasOwnProperty;

function baseKeysIn(e) {
  if (!isObject(e)) return nativeKeysIn(e);
  var t = isPrototype(e),
      r = [];

  for (var n in e) {
    ("constructor" != n || !t && hasOwnProperty$d.call(e, n)) && r.push(n);
  }

  return r;
}

function keysIn(e) {
  return isArrayLike(e) ? arrayLikeKeys(e, !0) : baseKeysIn(e);
}

function toPlainObject(e) {
  return copyObject(e, keysIn(e));
}

function baseMergeDeep(e, t, r, n, o, a, i) {
  var s = safeGet(e, r),
      c = safeGet(t, r),
      u = i.get(c);
  if (u) assignMergeValue(e, r, u);else {
    var l = a ? a(s, c, r + "", e, t, i) : void 0,
        f = void 0 === l;

    if (f) {
      var p = isArray(c),
          d = !p && isBuffer(c),
          h = !p && !d && isTypedArray(c);
      l = c, p || d || h ? l = isArray(s) ? s : isArrayLikeObject(s) ? copyArray(s) : d ? cloneBuffer(c, !(f = !1)) : h ? cloneTypedArray(c, !(f = !1)) : [] : isPlainObject$1(c) || isArguments$1(c) ? isArguments$1(l = s) ? l = toPlainObject(s) : isObject(s) && !isFunction$1(s) || (l = initCloneObject(c)) : f = !1;
    }

    f && (i.set(c, l), o(l, c, n, a, i), i.delete(c)), assignMergeValue(e, r, l);
  }
}

function baseMerge(n, o, a, i, s) {
  n !== o && baseFor(o, function (e, t) {
    if (isObject(e)) s || (s = new Stack()), baseMergeDeep(n, o, t, a, baseMerge, i, s);else {
      var r = i ? i(safeGet(n, t), e, t + "", n, o, s) : void 0;
      void 0 === r && (r = e), assignMergeValue(n, t, r);
    }
  }, keysIn);
}

function apply(e, t, r) {
  switch (r.length) {
    case 0:
      return e.call(t);

    case 1:
      return e.call(t, r[0]);

    case 2:
      return e.call(t, r[0], r[1]);

    case 3:
      return e.call(t, r[0], r[1], r[2]);
  }

  return e.apply(t, r);
}

var nativeMax = Math.max;

function overRest(a, i, s) {
  return i = nativeMax(void 0 === i ? a.length - 1 : i, 0), function () {
    for (var e = arguments, t = -1, r = nativeMax(e.length - i, 0), n = Array(r); ++t < r;) {
      n[t] = e[i + t];
    }

    t = -1;

    for (var o = Array(i + 1); ++t < i;) {
      o[t] = e[t];
    }

    return o[i] = s(n), apply(a, this, o);
  };
}

function constant$4(e) {
  return function () {
    return e;
  };
}

var baseSetToString = defineProperty$4 ? function (e, t) {
  return defineProperty$4(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: constant$4(t),
    writable: !0
  });
} : identity$3,
    HOT_COUNT = 800,
    HOT_SPAN = 16,
    nativeNow = Date.now;

function shortOut(r) {
  var n = 0,
      o = 0;
  return function () {
    var e = nativeNow(),
        t = HOT_SPAN - (e - o);

    if (o = e, 0 < t) {
      if (++n >= HOT_COUNT) return arguments[0];
    } else n = 0;

    return r.apply(void 0, arguments);
  };
}

var setToString = shortOut(baseSetToString);

function baseRest(e, t) {
  return setToString(overRest(e, t, identity$3), e + "");
}

function isIterateeCall(e, t, r) {
  if (!isObject(r)) return !1;
  var n = typeof t;
  return !!("number" == n ? isArrayLike(r) && isIndex(t, r.length) : "string" == n && t in r) && eq(r[t], e);
}

function createAssigner(s) {
  return baseRest(function (e, t) {
    var r = -1,
        n = t.length,
        o = 1 < n ? t[n - 1] : void 0,
        a = 2 < n ? t[2] : void 0;

    for (o = 3 < s.length && "function" == typeof o ? (n--, o) : void 0, a && isIterateeCall(t[0], t[1], a) && (o = n < 3 ? void 0 : o, n = 1), e = Object(e); ++r < n;) {
      var i = t[r];
      i && s(e, i, r, o);
    }

    return e;
  });
}

var merge = createAssigner(function (e, t, r) {
  baseMerge(e, t, r);
}),
    isPromise_1 = isPromise;

function isPromise(e) {
  return !!e && ("object" == typeof e || "function" == typeof e) && "function" == typeof e.then;
}

var asyncValidation = function asyncValidation(e, t, r, n) {
  t(n);
  var o = e();
  if (!isPromise_1(o)) throw new Error("asyncValidate function passed to reduxForm must return a promise");

  var a = function a(t) {
    return function (e) {
      if (t) {
        if (e && Object.keys(e).length) return r(e), e;
        throw r(), new Error("Asynchronous validation promise was rejected without errors.");
      }

      return r(), Promise.resolve();
    };
  };

  return o.then(a(!1), a(!0));
},
    silenceEvent = function silenceEvent(e) {
  var t = isEvent(e);
  return t && e.preventDefault(), t;
},
    silenceEvents = function silenceEvents(o) {
  return function (e) {
    for (var t = arguments.length, r = Array(1 < t ? t - 1 : 0), n = 1; n < t; n++) {
      r[n - 1] = arguments[n];
    }

    return silenceEvent(e) ? o.apply(void 0, r) : o.apply(void 0, [e].concat(r));
  };
},
    toArray$1 = function toArray$1(e) {
  return Array.isArray(e) ? e : [e];
},
    getError = function getError(e, t, r, n, o) {
  for (var a = toArray$1(n), i = 0; i < a.length; i++) {
    var s = a[i](e, t, r, o);
    if (s) return s;
  }
},
    generateValidator = function generateValidator(i, e) {
  var s = e.getIn;
  return function (n, o) {
    var a = {};
    return Object.keys(i).forEach(function (e) {
      var t = s(n, e),
          r = getError(t, n, o, i[e], e);
      r && (a = structure.setIn(a, e, r));
    }), a;
  };
},
    _extends$t = Object.assign || function (e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];

    for (var n in r) {
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
  }

  return e;
};

function _toConsumableArray$2(e) {
  if (Array.isArray(e)) {
    for (var t = 0, r = Array(e.length); t < e.length; t++) {
      r[t] = e[t];
    }

    return r;
  }

  return Array.from(e);
}

var handleSubmit = function handleSubmit(r, n, e, t, o) {
  var a = n.dispatch,
      i = n.onSubmitFail,
      s = n.onSubmitSuccess,
      c = n.startSubmit,
      u = n.stopSubmit,
      l = n.setSubmitFailed,
      f = n.setSubmitSucceeded,
      p = n.syncErrors,
      d = n.asyncErrors,
      h = n.touch,
      y = n.values,
      m = n.persistentSubmitErrors;

  if (h.apply(void 0, _toConsumableArray$2(o)), e || m) {
    var b = function b() {
      var e = void 0;

      try {
        e = r(y, a, n);
      } catch (e) {
        var t = e instanceof SubmissionError ? e.errors : void 0;
        if (u(t), l.apply(void 0, _toConsumableArray$2(o)), i && i(t, a, e, n), t || i) return t;
        throw e;
      }

      return isPromise_1(e) ? (c(), e.then(function (e) {
        return u(), f(), s && s(e, a, n), e;
      }, function (e) {
        var t = e instanceof SubmissionError ? e.errors : void 0;
        if (u(t), l.apply(void 0, _toConsumableArray$2(o)), i && i(t, a, e, n), t || i) return t;
        throw e;
      })) : (f(), s && s(e, a, n), e);
    },
        v = t && t();

    return v ? v.then(function (e) {
      if (e) throw e;
      return b();
    }).catch(function (e) {
      return l.apply(void 0, _toConsumableArray$2(o)), i && i(e, a, null, n), Promise.reject(e);
    }) : b();
  }

  l.apply(void 0, _toConsumableArray$2(o));

  var g = _extends$t({}, d, p);

  return i && i(g, a, null, n), g;
},
    getDisplayName = function getDisplayName(e) {
  return e.displayName || e.name || "Component";
},
    isHotReloading = function isHotReloading() {
  return !("undefined" == typeof module || !module.hot || "function" != typeof module.hot.status || "apply" !== module.hot.status());
},
    _createClass$a = function () {
  function n(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  return function (e, t, r) {
    return t && n(e.prototype, t), r && n(e, r), e;
  };
}(),
    _extends$u = Object.assign || function (e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];

    for (var n in r) {
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
  }

  return e;
},
    _typeof$5 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
  return typeof e;
} : function (e) {
  return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
};

function _defineProperty$5(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}

function _classCallCheck$m(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _possibleConstructorReturn$m(e, t) {
  if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return !t || "object" != typeof t && "function" != typeof t ? e : t;
}

function _inherits$m(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}

function _toConsumableArray$3(e) {
  if (Array.isArray(e)) {
    for (var t = 0, r = Array(e.length); t < e.length; t++) {
      r[t] = e[t];
    }

    return r;
  }

  return Array.from(e);
}

function _objectWithoutProperties$b(e, t) {
  var r = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
  }

  return r;
}

var isClassComponent = function isClassComponent(e) {
  return Boolean(e && e.prototype && "object" === _typeof$5(e.prototype.isReactComponent));
},
    arrayInsert$1 = actions.arrayInsert,
    arrayMove$1 = actions.arrayMove,
    arrayPop$1 = actions.arrayPop,
    arrayPush$2 = actions.arrayPush,
    arrayRemove$1 = actions.arrayRemove,
    arrayRemoveAll$1 = actions.arrayRemoveAll,
    arrayShift$1 = actions.arrayShift,
    arraySplice$1 = actions.arraySplice,
    arraySwap$1 = actions.arraySwap,
    arrayUnshift$1 = actions.arrayUnshift,
    blur$1 = actions.blur,
    change$1 = actions.change,
    focus$1 = actions.focus,
    formActions = _objectWithoutProperties$b(actions, ["arrayInsert", "arrayMove", "arrayPop", "arrayPush", "arrayRemove", "arrayRemoveAll", "arrayShift", "arraySplice", "arraySwap", "arrayUnshift", "blur", "change", "focus"]),
    arrayActions = {
  arrayInsert: arrayInsert$1,
  arrayMove: arrayMove$1,
  arrayPop: arrayPop$1,
  arrayPush: arrayPush$2,
  arrayRemove: arrayRemove$1,
  arrayRemoveAll: arrayRemoveAll$1,
  arrayShift: arrayShift$1,
  arraySplice: arraySplice$1,
  arraySwap: arraySwap$1,
  arrayUnshift: arrayUnshift$1
},
    propsToNotUpdateFor$3 = [].concat(_toConsumableArray$3(Object.keys(actions)), ["array", "asyncErrors", "initialValues", "syncErrors", "syncWarnings", "values", "registeredFields"]),
    checkSubmit = function checkSubmit(e) {
  if (!e || "function" != typeof e) throw new Error("You must either pass handleSubmit() an onSubmit function or pass onSubmit as a prop");
  return e;
},
    createReduxForm = function createReduxForm(p) {
  var C = p.deepEqual,
      O = p.empty,
      R = p.getIn,
      $ = p.setIn,
      s = p.keys,
      c = p.fromJS,
      N = createIsValid(p);
  return function (e) {
    var i = _extends$u({
      touchOnBlur: !0,
      touchOnChange: !1,
      persistentSubmitErrors: !1,
      destroyOnUnmount: !0,
      shouldAsyncValidate: defaultShouldAsyncValidate,
      shouldValidate: defaultShouldValidate,
      shouldError: defaultShouldError,
      shouldWarn: defaultShouldWarn,
      enableReinitialize: !1,
      keepDirtyOnReinitialize: !1,
      updateUnregisteredFields: !1,
      getFormState: function getFormState(e) {
        return R(e, "form");
      },
      pure: !0,
      forceUnregisterOnUnmount: !1
    }, e);

    return function (A) {
      var e = function (e) {
        function a() {
          var e, t, w;

          _classCallCheck$m(this, a);

          for (var r = arguments.length, n = Array(r), o = 0; o < r; o++) {
            n[o] = arguments[o];
          }

          return (t = w = _possibleConstructorReturn$m(this, (e = a.__proto__ || Object.getPrototypeOf(a)).call.apply(e, [this].concat(n)))).destroyed = !1, w.fieldCounts = {}, w.fieldValidators = {}, w.lastFieldValidatorKeys = [], w.fieldWarners = {}, w.lastFieldWarnerKeys = [], w.innerOnSubmit = void 0, w.submitPromise = void 0, w.getValues = function () {
            return w.props.values;
          }, w.isValid = function () {
            return w.props.valid;
          }, w.isPristine = function () {
            return w.props.pristine;
          }, w.register = function (e, t, r, n) {
            var o = (w.fieldCounts[e] || 0) + 1;
            w.fieldCounts[e] = o, w.props.registerField(e, t), r && (w.fieldValidators[e] = r), n && (w.fieldWarners[e] = n);
          }, w.unregister = function (t) {
            var e = w.fieldCounts[t];

            if (1 === e ? delete w.fieldCounts[t] : null != e && (w.fieldCounts[t] = e - 1), !w.destroyed) {
              var r = w.props,
                  n = r.destroyOnUnmount,
                  o = r.forceUnregisterOnUnmount,
                  a = r.unregisterField;
              n || o ? (a(t, n), w.fieldCounts[t] || (delete w.fieldValidators[t], delete w.fieldWarners[t], w.lastFieldValidatorKeys = w.lastFieldValidatorKeys.filter(function (e) {
                return e !== t;
              }))) : a(t, !1);
            }
          }, w.getFieldList = function (e) {
            var t = w.props.registeredFields,
                r = [];
            if (!t) return r;
            var n = s(t);
            return e && e.excludeFieldArray && (n = n.filter(function (e) {
              return "FieldArray" !== R(t, "['" + e + "'].type");
            })), c(n.reduce(function (e, t) {
              return e.push(t), e;
            }, r));
          }, w.getValidators = function () {
            var r = {};
            return Object.keys(w.fieldValidators).forEach(function (e) {
              var t = w.fieldValidators[e]();
              t && (r[e] = t);
            }), r;
          }, w.generateValidator = function () {
            var e = w.getValidators();
            return Object.keys(e).length ? generateValidator(e, p) : void 0;
          }, w.getWarners = function () {
            var r = {};
            return Object.keys(w.fieldWarners).forEach(function (e) {
              var t = w.fieldWarners[e]();
              t && (r[e] = t);
            }), r;
          }, w.generateWarner = function () {
            var e = w.getWarners();
            return Object.keys(e).length ? generateValidator(e, p) : void 0;
          }, w.asyncValidate = function (e, t, r) {
            var n,
                o,
                a = w.props,
                i = a.asyncBlurFields,
                s = a.asyncChangeFields,
                c = a.asyncErrors,
                u = a.asyncValidate,
                l = a.dispatch,
                f = a.initialized,
                p = a.pristine,
                d = a.shouldAsyncValidate,
                h = a.startAsyncValidation,
                y = a.stopAsyncValidation,
                m = a.syncErrors,
                b = a.values,
                v = !e;

            if (u) {
              var g = v ? b : $(b, e, t),
                  _ = v || !R(m, e);

              if (n = i && e && ~i.indexOf(e.replace(/\[[0-9]+\]/g, "[]")), o = s && e && ~s.indexOf(e.replace(/\[[0-9]+\]/g, "[]")), (v || !i && !s || ("blur" === r ? n : o)) && d({
                asyncErrors: c,
                initialized: f,
                trigger: v ? "submit" : r,
                blurredField: e,
                pristine: p,
                syncValidationPasses: _
              })) return asyncValidation(function () {
                return u(g, l, w.props, e);
              }, h, y, e);
            }
          }, w.submitCompleted = function (e) {
            return delete w.submitPromise, e;
          }, w.submitFailed = function (e) {
            throw delete w.submitPromise, e;
          }, w.listenToSubmit = function (e) {
            return isPromise_1(e) ? (w.submitPromise = e).then(w.submitCompleted, w.submitFailed) : e;
          }, w.submit = function (e) {
            var t = w.props,
                r = t.onSubmit,
                n = t.blur,
                o = t.change,
                a = t.dispatch;
            return e && !silenceEvent(e) ? silenceEvents(function () {
              return !w.submitPromise && w.listenToSubmit(handleSubmit(checkSubmit(e), _extends$u({}, w.props, bindActionCreators({
                blur: n,
                change: o
              }, a)), w.props.validExceptSubmit, w.asyncValidate, w.getFieldList({
                excludeFieldArray: !0
              })));
            }) : w.submitPromise ? void 0 : w.innerOnSubmit && w.innerOnSubmit !== w.submit ? w.innerOnSubmit() : w.listenToSubmit(handleSubmit(checkSubmit(r), _extends$u({}, w.props, bindActionCreators({
              blur: n,
              change: o
            }, a)), w.props.validExceptSubmit, w.asyncValidate, w.getFieldList({
              excludeFieldArray: !0
            })));
          }, w.reset = function () {
            return w.props.reset();
          }, w.saveRef = function (e) {
            w.wrapped = e;
          }, _possibleConstructorReturn$m(w, t);
        }

        return _inherits$m(a, react_1), _createClass$a(a, [{
          key: "getChildContext",
          value: function value() {
            var t = this;
            return {
              _reduxForm: _extends$u({}, this.props, {
                getFormState: function getFormState(e) {
                  return R(t.props.getFormState(e), t.props.form);
                },
                asyncValidate: this.asyncValidate,
                getValues: this.getValues,
                sectionPrefix: void 0,
                register: this.register,
                unregister: this.unregister,
                registerInnerOnSubmit: function registerInnerOnSubmit(e) {
                  return t.innerOnSubmit = e;
                }
              })
            };
          }
        }, {
          key: "initIfNeeded",
          value: function value(e) {
            var t = this.props.enableReinitialize;

            if (e) {
              if ((t || !e.initialized) && !C(this.props.initialValues, e.initialValues)) {
                var r = e.initialized && this.props.keepDirtyOnReinitialize;
                this.props.initialize(e.initialValues, r, {
                  keepValues: e.keepValues,
                  lastInitialValues: this.props.initialValues,
                  updateUnregisteredFields: e.updateUnregisteredFields
                });
              }
            } else !this.props.initialValues || this.props.initialized && !t || this.props.initialize(this.props.initialValues, this.props.keepDirtyOnReinitialize, {
              keepValues: this.props.keepValues,
              updateUnregisteredFields: this.props.updateUnregisteredFields
            });
          }
        }, {
          key: "updateSyncErrorsIfNeeded",
          value: function value(e, t, r) {
            var n = this.props,
                o = n.error,
                a = n.updateSyncErrors,
                i = !(r && Object.keys(r).length || o),
                s = !(e && Object.keys(e).length || t);
            i && s || structure.deepEqual(r, e) && structure.deepEqual(o, t) || a(e, t);
          }
        }, {
          key: "clearSubmitPromiseIfNeeded",
          value: function value(e) {
            var t = this.props.submitting;
            this.submitPromise && t && !e.submitting && delete this.submitPromise;
          }
        }, {
          key: "submitIfNeeded",
          value: function value(e) {
            var t = this.props,
                r = t.clearSubmit;
            !t.triggerSubmit && e.triggerSubmit && (r(), this.submit());
          }
        }, {
          key: "shouldErrorFunction",
          value: function value() {
            var e = this.props,
                t = e.shouldValidate,
                r = e.shouldError;
            return t !== defaultShouldValidate && !(r !== defaultShouldError) ? t : r;
          }
        }, {
          key: "validateIfNeeded",
          value: function value(e) {
            var t = this.props,
                r = t.validate,
                n = t.values,
                o = this.shouldErrorFunction(),
                a = this.generateValidator();

            if (r || a) {
              var i = void 0 === e,
                  s = Object.keys(this.getValidators());

              if (o({
                values: n,
                nextProps: e,
                props: this.props,
                initialRender: i,
                lastFieldValidatorKeys: this.lastFieldValidatorKeys,
                fieldValidatorKeys: s,
                structure: p
              })) {
                var c = i || !e ? this.props : e,
                    u = merge(r && r(c.values, c) || {}, a && a(c.values, c) || {}),
                    l = u._error,
                    f = _objectWithoutProperties$b(u, ["_error"]);

                this.lastFieldValidatorKeys = s, this.updateSyncErrorsIfNeeded(f, l, c.syncErrors);
              }
            } else this.lastFieldValidatorKeys = [];
          }
        }, {
          key: "updateSyncWarningsIfNeeded",
          value: function value(e, t, r) {
            var n = this.props,
                o = n.warning,
                a = n.syncWarnings,
                i = n.updateSyncWarnings,
                s = !(a && Object.keys(a).length || o),
                c = !(e && Object.keys(e).length || t);
            s && c || structure.deepEqual(r, e) && structure.deepEqual(o, t) || i(e, t);
          }
        }, {
          key: "shouldWarnFunction",
          value: function value() {
            var e = this.props,
                t = e.shouldValidate,
                r = e.shouldWarn;
            return t !== defaultShouldValidate && !(r !== defaultShouldWarn) ? t : r;
          }
        }, {
          key: "warnIfNeeded",
          value: function value(e) {
            var t = this.props,
                r = t.warn,
                n = t.values,
                o = this.shouldWarnFunction(),
                a = this.generateWarner();

            if (r || a) {
              var i = void 0 === e,
                  s = Object.keys(this.getWarners());

              if (o({
                values: n,
                nextProps: e,
                props: this.props,
                initialRender: i,
                lastFieldValidatorKeys: this.lastFieldWarnerKeys,
                fieldValidatorKeys: s,
                structure: p
              })) {
                var c = i || !e ? this.props : e,
                    u = merge(r ? r(c.values, c) : {}, a ? a(c.values, c) : {}),
                    l = u._warning,
                    f = _objectWithoutProperties$b(u, ["_warning"]);

                this.lastFieldWarnerKeys = s, this.updateSyncWarningsIfNeeded(f, l, c.syncWarnings);
              }
            }
          }
        }, {
          key: "componentWillMount",
          value: function value() {
            isHotReloading() || (this.initIfNeeded(), this.validateIfNeeded(), this.warnIfNeeded()), browser$1(this.props.shouldValidate, "shouldValidate() is deprecated and will be removed in v8.0.0. Use shouldWarn() or shouldError() instead.");
          }
        }, {
          key: "componentWillReceiveProps",
          value: function value(e) {
            this.initIfNeeded(e), this.validateIfNeeded(e), this.warnIfNeeded(e), this.clearSubmitPromiseIfNeeded(e), this.submitIfNeeded(e);
            var t = e.onChange,
                r = e.values,
                n = e.dispatch;
            t && !C(r, this.props.values) && t(r, n, e, this.props.values);
          }
        }, {
          key: "shouldComponentUpdate",
          value: function value(t) {
            var r = this;
            if (!this.props.pure) return !0;
            var e = i.immutableProps,
                n = void 0 === e ? [] : e;
            return !!(this.props.children || t.children || Object.keys(t).some(function (e) {
              return ~n.indexOf(e) ? r.props[e] !== t[e] : !~propsToNotUpdateFor$3.indexOf(e) && !C(r.props[e], t[e]);
            }));
          }
        }, {
          key: "componentDidMount",
          value: function value() {
            isHotReloading() || (this.initIfNeeded(this.props), this.validateIfNeeded(), this.warnIfNeeded()), browser$1(this.props.shouldValidate, "shouldValidate() is deprecated and will be removed in v8.0.0. Use shouldWarn() or shouldError() instead.");
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            var e = this.props,
                t = e.destroyOnUnmount,
                r = e.destroy;
            t && !isHotReloading() && (this.destroyed = !0, r());
          }
        }, {
          key: "render",
          value: function value() {
            var e = this.props,
                t = e.anyTouched,
                r = e.array,
                n = (e.arrayInsert, e.arrayMove, e.arrayPop, e.arrayPush, e.arrayRemove, e.arrayRemoveAll, e.arrayShift, e.arraySplice, e.arraySwap, e.arrayUnshift, e.asyncErrors, e.asyncValidate, e.asyncValidating),
                o = e.blur,
                a = e.change,
                i = e.clearSubmit,
                s = e.destroy,
                c = (e.destroyOnUnmount, e.forceUnregisterOnUnmount, e.dirty),
                u = e.dispatch,
                l = (e.enableReinitialize, e.error),
                f = (e.focus, e.form),
                p = (e.getFormState, e.immutableProps, e.initialize),
                d = e.initialized,
                h = e.initialValues,
                y = e.invalid,
                m = (e.keepDirtyOnReinitialize, e.keepValues, e.updateUnregisteredFields, e.pristine),
                b = e.propNamespace,
                v = (e.registeredFields, e.registerField, e.reset),
                g = e.resetSection,
                _ = (e.setSubmitFailed, e.setSubmitSucceeded, e.shouldAsyncValidate, e.shouldValidate, e.shouldError, e.shouldWarn, e.startAsyncValidation, e.startSubmit, e.stopAsyncValidation, e.stopSubmit, e.submitting),
                w = e.submitFailed,
                $ = e.submitSucceeded,
                S = e.touch,
                T = (e.touchOnBlur, e.touchOnChange, e.persistentSubmitErrors, e.syncErrors, e.syncWarnings, e.unregisterField, e.untouch),
                P = (e.updateSyncErrors, e.updateSyncWarnings, e.valid),
                x = (e.validExceptSubmit, e.values, e.warning),
                E = _objectWithoutProperties$b(e, ["anyTouched", "array", "arrayInsert", "arrayMove", "arrayPop", "arrayPush", "arrayRemove", "arrayRemoveAll", "arrayShift", "arraySplice", "arraySwap", "arrayUnshift", "asyncErrors", "asyncValidate", "asyncValidating", "blur", "change", "clearSubmit", "destroy", "destroyOnUnmount", "forceUnregisterOnUnmount", "dirty", "dispatch", "enableReinitialize", "error", "focus", "form", "getFormState", "immutableProps", "initialize", "initialized", "initialValues", "invalid", "keepDirtyOnReinitialize", "keepValues", "updateUnregisteredFields", "pristine", "propNamespace", "registeredFields", "registerField", "reset", "resetSection", "setSubmitFailed", "setSubmitSucceeded", "shouldAsyncValidate", "shouldValidate", "shouldError", "shouldWarn", "startAsyncValidation", "startSubmit", "stopAsyncValidation", "stopSubmit", "submitting", "submitFailed", "submitSucceeded", "touch", "touchOnBlur", "touchOnChange", "persistentSubmitErrors", "syncErrors", "syncWarnings", "unregisterField", "untouch", "updateSyncErrors", "updateSyncWarnings", "valid", "validExceptSubmit", "values", "warning"]),
                C = _extends$u({
              array: r,
              anyTouched: t,
              asyncValidate: this.asyncValidate,
              asyncValidating: n
            }, bindActionCreators({
              blur: o,
              change: a
            }, u), {
              clearSubmit: i,
              destroy: s,
              dirty: c,
              dispatch: u,
              error: l,
              form: f,
              handleSubmit: this.submit,
              initialize: p,
              initialized: d,
              initialValues: h,
              invalid: y,
              pristine: m,
              reset: v,
              resetSection: g,
              submitting: _,
              submitFailed: w,
              submitSucceeded: $,
              touch: S,
              untouch: T,
              valid: P,
              warning: x
            }),
                O = _extends$u({}, b ? _defineProperty$5({}, b, C) : C, E);

            return isClassComponent(A) && (O.ref = this.saveRef), react_5(A, O);
          }
        }]), a;
      }();

      e.displayName = "Form(" + getDisplayName(A) + ")", e.WrappedComponent = A, e.childContextTypes = {
        _reduxForm: propTypes.object.isRequired
      }, e.propTypes = {
        destroyOnUnmount: propTypes.bool,
        forceUnregisterOnUnmount: propTypes.bool,
        form: propTypes.string.isRequired,
        immutableProps: propTypes.arrayOf(propTypes.string),
        initialValues: propTypes.oneOfType([propTypes.array, propTypes.object]),
        getFormState: propTypes.func,
        onSubmitFail: propTypes.func,
        onSubmitSuccess: propTypes.func,
        propNamespace: propTypes.string,
        validate: propTypes.func,
        warn: propTypes.func,
        touchOnBlur: propTypes.bool,
        touchOnChange: propTypes.bool,
        triggerSubmit: propTypes.bool,
        persistentSubmitErrors: propTypes.bool,
        registeredFields: propTypes.any
      };
      var t = connect(function (e, t) {
        var r = t.form,
            n = t.getFormState,
            o = t.initialValues,
            a = t.enableReinitialize,
            i = t.keepDirtyOnReinitialize,
            s = R(n(e) || O, r) || O,
            c = R(s, "initial"),
            u = !!c,
            l = a && u && !C(o, c),
            f = l && !i,
            p = o || c || O;
        l && (p = c || O);
        var d = R(s, "values") || p;
        f && (d = p);

        var h = f || C(p, d),
            y = R(s, "asyncErrors"),
            m = R(s, "syncErrors") || structure.empty,
            b = R(s, "syncWarnings") || structure.empty,
            v = R(s, "registeredFields"),
            g = N(r, n, !1)(e),
            _ = N(r, n, !0)(e),
            w = !!R(s, "anyTouched"),
            $ = !!R(s, "submitting"),
            S = !!R(s, "submitFailed"),
            T = !!R(s, "submitSucceeded"),
            P = R(s, "error"),
            x = R(s, "warning"),
            E = R(s, "triggerSubmit");

        return {
          anyTouched: w,
          asyncErrors: y,
          asyncValidating: R(s, "asyncValidating") || !1,
          dirty: !h,
          error: P,
          initialized: u,
          invalid: !g,
          pristine: h,
          registeredFields: v,
          submitting: $,
          submitFailed: S,
          submitSucceeded: T,
          syncErrors: m,
          syncWarnings: b,
          triggerSubmit: E,
          values: d,
          valid: g,
          validExceptSubmit: _,
          warning: x
        };
      }, function (e, r) {
        var t = function t(e) {
          return e.bind(null, r.form);
        },
            n = mapValues(formActions, t),
            o = mapValues(arrayActions, t),
            a = t(focus$1),
            i = bindActionCreators(n, e),
            s = {
          insert: bindActionCreators(o.arrayInsert, e),
          move: bindActionCreators(o.arrayMove, e),
          pop: bindActionCreators(o.arrayPop, e),
          push: bindActionCreators(o.arrayPush, e),
          remove: bindActionCreators(o.arrayRemove, e),
          removeAll: bindActionCreators(o.arrayRemoveAll, e),
          shift: bindActionCreators(o.arrayShift, e),
          splice: bindActionCreators(o.arraySplice, e),
          swap: bindActionCreators(o.arraySwap, e),
          unshift: bindActionCreators(o.arrayUnshift, e)
        },
            c = _extends$u({}, i, o, {
          blur: function blur(e, t) {
            return blur$1(r.form, e, t, !!r.touchOnBlur);
          },
          change: function change(e, t) {
            return change$1(r.form, e, t, !!r.touchOnChange, !!r.persistentSubmitErrors);
          },
          array: s,
          focus: a,
          dispatch: e
        });

        return function () {
          return c;
        };
      }, void 0, {
        withRef: !0
      }),
          o = hoistNonReactStatics_cjs(t(e), A);
      o.defaultProps = i;

      var r = function (e) {
        function t() {
          return _classCallCheck$m(this, t), _possibleConstructorReturn$m(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
        }

        return _inherits$m(t, react_1), _createClass$a(t, [{
          key: "submit",
          value: function value() {
            return this.ref && this.ref.getWrappedInstance().submit();
          }
        }, {
          key: "reset",
          value: function value() {
            this.ref && this.ref.getWrappedInstance().reset();
          }
        }, {
          key: "render",
          value: function value() {
            var t = this,
                e = this.props,
                r = e.initialValues,
                n = _objectWithoutProperties$b(e, ["initialValues"]);

            return react_5(o, _extends$u({}, n, {
              ref: function ref(e) {
                t.ref = e;
              },
              initialValues: c(r)
            }));
          }
        }, {
          key: "valid",
          get: function get() {
            return !(!this.ref || !this.ref.getWrappedInstance().isValid());
          }
        }, {
          key: "invalid",
          get: function get() {
            return !this.valid;
          }
        }, {
          key: "pristine",
          get: function get() {
            return !(!this.ref || !this.ref.getWrappedInstance().isPristine());
          }
        }, {
          key: "dirty",
          get: function get() {
            return !this.pristine;
          }
        }, {
          key: "values",
          get: function get() {
            return this.ref ? this.ref.getWrappedInstance().getValues() : O;
          }
        }, {
          key: "fieldList",
          get: function get() {
            return this.ref ? this.ref.getWrappedInstance().getFieldList() : [];
          }
        }, {
          key: "wrappedInstance",
          get: function get() {
            return this.ref && this.ref.getWrappedInstance().wrapped;
          }
        }]), t;
      }();

      return polyfill$2(r), hoistNonReactStatics_cjs(r, A);
    };
  };
};

function createDeleteInWithCleanUp(u) {
  var e = function e(r) {
    return function (e, t) {
      return void 0 !== r.getIn(e, t);
    };
  },
      l = u.deepEqual,
      f = u.empty,
      p = u.getIn,
      d = u.deleteIn,
      h = u.setIn;

  return function () {
    var c = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : e;
    return function e(t, r) {
      if ("]" === r[r.length - 1]) {
        var n = toPath(r);
        return n.pop(), p(t, n.join(".")) ? h(t, r) : t;
      }

      var o = t;
      c(u)(t, r) && (o = d(t, r));
      var a = r.lastIndexOf(".");

      if (0 < a) {
        var i = r.substring(0, a);

        if ("]" !== i[i.length - 1]) {
          var s = p(o, i);
          if (l(s, f)) return e(o, i);
        }
      }

      return o;
    };
  };
}

function _defineProperty$6(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}

function _objectWithoutProperties$c(e, t) {
  var r = {};

  for (var n in e) {
    0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
  }

  return r;
}

createReduxForm(structure);

var shouldDelete = function shouldDelete(e) {
  var o = e.getIn;
  return function (e, t) {
    var r = null;
    t.startsWith("values") && (r = t.replace("values", "initial"));
    var n = !r || void 0 === o(e, r);
    return void 0 !== o(e, t) && n;
  };
},
    isReduxFormAction = function isReduxFormAction(e) {
  return e && e.type && e.type.length > prefix$1.length && e.type.substring(0, prefix$1.length) === prefix$1;
};

function createReducer(e) {
  var t,
      a,
      _ = e.deepEqual,
      w = e.empty,
      $ = e.forEach,
      S = e.getIn,
      T = e.setIn,
      f = e.deleteIn,
      P = e.fromJS,
      x = e.keys,
      u = e.size,
      c = e.some,
      l = e.splice,
      p = createDeleteInWithCleanUp(e)(shouldDelete),
      d = createDeleteInWithCleanUp(structure)(shouldDelete),
      s = function s(e, t, r, n, o, a, i) {
    var s = S(e, t + "." + r);
    return s || i ? T(e, t + "." + r, l(s, n, o, a)) : e;
  },
      h = function h(e, t, r, n, o, a, i) {
    var s = S(e, t),
        c = structure.getIn(s, r);
    return c || i ? T(e, t, structure.setIn(s, r, structure.splice(c, n, o, a))) : e;
  },
      y = ["values", "fields", "submitErrors", "asyncErrors"],
      m = function m(e, t, r, n, o) {
    var a = e,
        i = null != o ? w : void 0;
    return a = s(a, "values", t, r, n, o, !0), a = s(a, "fields", t, r, n, i), a = h(a, "syncErrors", t, r, n, void 0), a = h(a, "syncWarnings", t, r, n, void 0), a = s(a, "submitErrors", t, r, n, void 0), a = s(a, "asyncErrors", t, r, n, void 0);
  },
      n = (_defineProperty$6(t = {}, ARRAY_INSERT, function (e, t) {
    var r = t.meta,
        n = r.field,
        o = r.index,
        a = t.payload;
    return m(e, n, o, 0, a);
  }), _defineProperty$6(t, ARRAY_MOVE, function (e, t) {
    var r = t.meta,
        n = r.field,
        o = r.from,
        a = r.to,
        i = S(e, "values." + n),
        s = i ? u(i) : 0,
        c = e;
    return s && y.forEach(function (e) {
      var t = e + "." + n;

      if (S(c, t)) {
        var r = S(c, t + "[" + o + "]");
        c = T(c, t, l(S(c, t), o, 1)), c = T(c, t, l(S(c, t), a, 0, r));
      }
    }), c;
  }), _defineProperty$6(t, ARRAY_POP, function (e, t) {
    var r = t.meta.field,
        n = S(e, "values." + r),
        o = n ? u(n) : 0;
    return o ? m(e, r, o - 1, 1) : e;
  }), _defineProperty$6(t, ARRAY_PUSH, function (e, t) {
    var r = t.meta.field,
        n = t.payload,
        o = S(e, "values." + r),
        a = o ? u(o) : 0;
    return m(e, r, a, 0, n);
  }), _defineProperty$6(t, ARRAY_REMOVE, function (e, t) {
    var r = t.meta,
        n = r.field,
        o = r.index;
    return m(e, n, o, 1);
  }), _defineProperty$6(t, ARRAY_REMOVE_ALL, function (e, t) {
    var r = t.meta.field,
        n = S(e, "values." + r),
        o = n ? u(n) : 0;
    return o ? m(e, r, 0, o) : e;
  }), _defineProperty$6(t, ARRAY_SHIFT, function (e, t) {
    var r = t.meta.field;
    return m(e, r, 0, 1);
  }), _defineProperty$6(t, ARRAY_SPLICE, function (e, t) {
    var r = t.meta,
        n = r.field,
        o = r.index,
        a = r.removeNum,
        i = t.payload;
    return m(e, n, o, a, i);
  }), _defineProperty$6(t, ARRAY_SWAP, function (e, t) {
    var r = t.meta,
        n = r.field,
        o = r.indexA,
        a = r.indexB,
        i = e;
    return y.forEach(function (e) {
      var t = S(i, e + "." + n + "[" + o + "]"),
          r = S(i, e + "." + n + "[" + a + "]");
      void 0 === t && void 0 === r || (i = T(i, e + "." + n + "[" + o + "]", r), i = T(i, e + "." + n + "[" + a + "]", t));
    }), i;
  }), _defineProperty$6(t, ARRAY_UNSHIFT, function (e, t) {
    var r = t.meta.field,
        n = t.payload;
    return m(e, r, 0, 0, n);
  }), _defineProperty$6(t, AUTOFILL, function (e, t) {
    var r = t.meta.field,
        n = t.payload,
        o = e;
    return o = p(o, "asyncErrors." + r), o = p(o, "submitErrors." + r), o = T(o, "fields." + r + ".autofilled", !0), o = T(o, "values." + r, n);
  }), _defineProperty$6(t, BLUR, function (e, t) {
    var r = t.meta,
        n = r.field,
        o = r.touch,
        a = t.payload,
        i = e;
    return void 0 === S(i, "initial." + n) && "" === a ? i = p(i, "values." + n) : void 0 !== a && (i = T(i, "values." + n, a)), n === S(i, "active") && (i = f(i, "active")), i = f(i, "fields." + n + ".active"), o && (i = T(i, "fields." + n + ".touched", !0), i = T(i, "anyTouched", !0)), i;
  }), _defineProperty$6(t, CHANGE, function (e, t) {
    var r = t.meta,
        n = r.field,
        o = r.touch,
        a = r.persistentSubmitErrors,
        i = t.payload,
        s = e;
    return void 0 === S(s, "initial." + n) && "" === i ? s = p(s, "values." + n) : void 0 !== i && (s = T(s, "values." + n, i)), s = p(s, "asyncErrors." + n), a || (s = p(s, "submitErrors." + n)), s = p(s, "fields." + n + ".autofilled"), o && (s = T(s, "fields." + n + ".touched", !0), s = T(s, "anyTouched", !0)), s;
  }), _defineProperty$6(t, CLEAR_SUBMIT, function (e) {
    return f(e, "triggerSubmit");
  }), _defineProperty$6(t, CLEAR_SUBMIT_ERRORS, function (e) {
    var t = e;
    return t = p(t, "submitErrors"), t = f(t, "error");
  }), _defineProperty$6(t, CLEAR_ASYNC_ERROR, function (e, t) {
    var r = t.meta.field;
    return f(e, "asyncErrors." + r);
  }), _defineProperty$6(t, CLEAR_FIELDS, function (e, t) {
    var r = t.meta,
        n = r.keepTouched,
        o = r.persistentSubmitErrors,
        a = r.fields,
        i = e;
    a.forEach(function (e) {
      i = p(i, "values." + e), i = p(i, "asyncErrors." + e), o || (i = p(i, "submitErrors." + e)), i = p(i, "fields." + e + ".autofilled"), n || (i = f(i, "fields." + e + ".touched"));
    });
    var s = c(x(S(i, "registeredFields")), function (e) {
      return S(i, "fields." + e + ".touched");
    });
    return i = s ? T(i, "anyTouched", !0) : f(i, "anyTouched");
  }), _defineProperty$6(t, FOCUS, function (e, t) {
    var r = t.meta.field,
        n = e,
        o = S(e, "active");
    return n = f(n, "fields." + o + ".active"), n = T(n, "fields." + r + ".visited", !0), n = T(n, "fields." + r + ".active", !0), n = T(n, "active", r);
  }), _defineProperty$6(t, INITIALIZE, function (e, t) {
    var r = t.payload,
        n = t.meta,
        o = n.keepDirty,
        a = n.keepSubmitSucceeded,
        i = n.updateUnregisteredFields,
        s = n.keepValues,
        c = P(r),
        u = w,
        l = S(e, "warning");
    l && (u = T(u, "warning", l));
    var f = S(e, "syncWarnings");
    f && (u = T(u, "syncWarnings", f));
    var p = S(e, "error");
    p && (u = T(u, "error", p));
    var d = S(e, "syncErrors");
    d && (u = T(u, "syncErrors", d));
    var h = S(e, "registeredFields");
    h && (u = T(u, "registeredFields", h));
    var y = S(e, "values"),
        m = S(e, "initial"),
        b = c,
        v = y;

    if (o && h) {
      if (!_(b, m)) {
        var g = function g(e) {
          var t = S(m, e),
              r = S(y, e);

          if (_(r, t)) {
            var n = S(b, e);
            S(v, e) !== n && (v = T(v, e, n));
          }
        };

        i || $(x(h), function (e) {
          return g(e);
        }), $(x(b), function (e) {
          if (void 0 === S(m, e)) {
            var t = S(b, e);
            v = T(v, e, t);
          }

          i && g(e);
        });
      }
    } else v = b;

    return s && ($(x(y), function (e) {
      var t = S(y, e);
      v = T(v, e, t);
    }), $(x(m), function (e) {
      var t = S(m, e);
      b = T(b, e, t);
    })), a && S(e, "submitSucceeded") && (u = T(u, "submitSucceeded", !0)), u = T(u, "values", v), u = T(u, "initial", b);
  }), _defineProperty$6(t, REGISTER_FIELD, function (e, t) {
    var r = t.payload,
        n = r.name,
        o = r.type,
        a = "registeredFields['" + n + "']",
        i = S(e, a);

    if (i) {
      var s = S(i, "count") + 1;
      i = T(i, "count", s);
    } else i = P({
      name: n,
      type: o,
      count: 1
    });

    return T(e, a, i);
  }), _defineProperty$6(t, RESET, function (e) {
    var t = w,
        r = S(e, "registeredFields");
    r && (t = T(t, "registeredFields", r));
    var n = S(e, "initial");
    return n && (t = T(t, "values", n), t = T(t, "initial", n)), t;
  }), _defineProperty$6(t, RESET_SECTION, function (r, e) {
    var t = e.meta.sections,
        n = r;
    t.forEach(function (e) {
      n = p(n, "asyncErrors." + e), n = p(n, "submitErrors." + e), n = p(n, "fields." + e);
      var t = S(r, "initial." + e);
      n = t ? T(n, "values." + e, t) : p(n, "values." + e);
    });
    var o = c(x(S(n, "registeredFields")), function (e) {
      return S(n, "fields." + e + ".touched");
    });
    return n = o ? T(n, "anyTouched", !0) : f(n, "anyTouched");
  }), _defineProperty$6(t, SUBMIT, function (e) {
    return T(e, "triggerSubmit", !0);
  }), _defineProperty$6(t, START_ASYNC_VALIDATION, function (e, t) {
    var r = t.meta.field;
    return T(e, "asyncValidating", r || !0);
  }), _defineProperty$6(t, START_SUBMIT, function (e) {
    return T(e, "submitting", !0);
  }), _defineProperty$6(t, STOP_ASYNC_VALIDATION, function (e, t) {
    var r = t.payload,
        n = e;

    if (n = f(n, "asyncValidating"), r && Object.keys(r).length) {
      var o = r._error,
          a = _objectWithoutProperties$c(r, ["_error"]);

      o && (n = T(n, "error", o)), Object.keys(a).length && (n = T(n, "asyncErrors", P(a)));
    } else n = f(n, "error"), n = f(n, "asyncErrors");

    return n;
  }), _defineProperty$6(t, STOP_SUBMIT, function (e, t) {
    var r = t.payload,
        n = e;

    if (n = f(n, "submitting"), n = f(n, "submitFailed"), n = f(n, "submitSucceeded"), r && Object.keys(r).length) {
      var o = r._error,
          a = _objectWithoutProperties$c(r, ["_error"]);

      n = o ? T(n, "error", o) : f(n, "error"), n = Object.keys(a).length ? T(n, "submitErrors", P(a)) : f(n, "submitErrors"), n = T(n, "submitFailed", !0);
    } else n = f(n, "error"), n = f(n, "submitErrors");

    return n;
  }), _defineProperty$6(t, SET_SUBMIT_FAILED, function (e, t) {
    var r = t.meta.fields,
        n = e;
    return n = T(n, "submitFailed", !0), n = f(n, "submitSucceeded"), n = f(n, "submitting"), r.forEach(function (e) {
      return n = T(n, "fields." + e + ".touched", !0);
    }), r.length && (n = T(n, "anyTouched", !0)), n;
  }), _defineProperty$6(t, SET_SUBMIT_SUCCEEDED, function (e) {
    var t = e;
    return t = f(t, "submitFailed"), t = T(t, "submitSucceeded", !0);
  }), _defineProperty$6(t, TOUCH, function (e, t) {
    var r = t.meta.fields,
        n = e;
    return r.forEach(function (e) {
      return n = T(n, "fields." + e + ".touched", !0);
    }), n = T(n, "anyTouched", !0);
  }), _defineProperty$6(t, UNREGISTER_FIELD, function (e, t) {
    var r = t.payload,
        n = r.name,
        o = r.destroyOnUnmount,
        a = e,
        i = "registeredFields['" + n + "']",
        s = S(a, i);
    if (!s) return a;
    var c = S(s, "count") - 1;

    if (c <= 0 && o) {
      a = f(a, i), _(S(a, "registeredFields"), w) && (a = f(a, "registeredFields"));
      var u = S(a, "syncErrors");
      u && (u = d(u, n), a = structure.deepEqual(u, structure.empty) ? f(a, "syncErrors") : T(a, "syncErrors", u));
      var l = S(a, "syncWarnings");
      l && (l = d(l, n), a = structure.deepEqual(l, structure.empty) ? f(a, "syncWarnings") : T(a, "syncWarnings", l)), a = p(a, "submitErrors." + n), a = p(a, "asyncErrors." + n);
    } else s = T(s, "count", c), a = T(a, i, s);

    return a;
  }), _defineProperty$6(t, UNTOUCH, function (e, t) {
    var r = t.meta.fields,
        n = e;
    r.forEach(function (e) {
      return n = f(n, "fields." + e + ".touched");
    });
    var o = c(x(S(n, "registeredFields")), function (e) {
      return S(n, "fields." + e + ".touched");
    });
    return n = o ? T(n, "anyTouched", !0) : f(n, "anyTouched");
  }), _defineProperty$6(t, UPDATE_SYNC_ERRORS, function (e, t) {
    var r = t.payload,
        n = r.syncErrors,
        o = r.error,
        a = e;
    return a = o ? (a = T(a, "error", o), T(a, "syncError", !0)) : (a = f(a, "error"), f(a, "syncError")), a = Object.keys(n).length ? T(a, "syncErrors", n) : f(a, "syncErrors");
  }), _defineProperty$6(t, UPDATE_SYNC_WARNINGS, function (e, t) {
    var r = t.payload,
        n = r.syncWarnings,
        o = r.warning,
        a = e;
    return a = o ? T(a, "warning", o) : f(a, "warning"), a = Object.keys(n).length ? T(a, "syncWarnings", n) : f(a, "syncWarnings");
  }), t);

  return function e(t) {
    return t.plugin = function (i) {
      var n = this;
      return e(function () {
        var o = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : w,
            a = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {
          type: "NONE"
        },
            e = function e(_e3, t) {
          var r = S(_e3, t),
              n = i[t](r, a, S(o, t));
          return n !== r ? T(_e3, t, n) : _e3;
        },
            t = n(o, a),
            r = a && a.meta && a.meta.form;

        return r ? i[r] ? e(t, r) : t : Object.keys(i).reduce(e, t);
      });
    }, t;
  }((a = function a() {
    var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : w,
        t = arguments[1],
        r = n[t.type];
    return r ? r(e, t) : e;
  }, function () {
    var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : w,
        t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {
      type: "NONE"
    },
        r = t && t.meta && t.meta.form;
    if (!r || !isReduxFormAction(t)) return e;
    if (t.type === DESTROY && t.meta && t.meta.form) return t.meta.form.reduce(function (e, t) {
      return p(e, t);
    }, e);
    var n = S(e, r),
        o = a(n, t);
    return o === n ? e : T(e, r, o);
  }));
}

createReducer(structure);

var _extends$v = Object.assign || function (e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];

    for (var n in r) {
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
  }

  return e;
};

function _defineProperty$7(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}

var createValues$1 = function createValues$1(e) {
  var a = e.getIn;
  return function (e) {
    var t = _extends$v({
      prop: "values",
      getFormState: function getFormState(e) {
        return a(e, "form");
      }
    }, e),
        r = t.form,
        n = t.prop,
        o = t.getFormState;

    return connect(function (e) {
      return _defineProperty$7({}, n, a(o(e), r + ".values"));
    });
  };
};

createValues$1(structure);

var s$P = {
  root: "styles-module_root__1tFzh",
  spaceLg: "styles-module_spaceLg__t9xVB",
  label: "styles-module_label__3SLqa",
  labelDisabled: "styles-module_labelDisabled__h9xIk"
},
    FormCheckbox = function FormCheckbox(e) {
  var t = e.disabled,
      r = e.label,
      n = e.meta,
      o = n.touched,
      a = n.error,
      i = e.spaceLg,
      s = objectWithoutProperties(e, ["disabled", "label", "meta", "spaceLg"]);
  return react.createElement("label", {
    className: classnames(s$P.root, defineProperty({}, s$P.spaceLg, i))
  }, react.createElement(Checkbox, _extends_1({
    disabled: t,
    error: !(!o || !a)
  }, s)), react.createElement("span", {
    className: classnames(s$P.label, defineProperty({}, s$P.labelDisabled, t))
  }, r));
};

FormCheckbox.defaultProps = {
  disabled: !1,
  spaceLg: !1
};

var FormInput = function FormInput(e) {
  return react.createElement(FieldBase, _extends_1({
    formComponent: Input
  }, e));
},
    s$Q = {
  root: "styles-module_root__3Oysk",
  spaceLg: "styles-module_spaceLg__2Hm1R",
  label: "styles-module_label__3htdu",
  labelDisabled: "styles-module_labelDisabled__oV16O"
},
    FormRadio = function FormRadio(e) {
  var t = e.disabled,
      r = e.label,
      n = e.spaceLg,
      o = e.meta,
      a = o.touched,
      i = o.error,
      s = objectWithoutProperties(e, ["disabled", "label", "spaceLg", "meta"]);
  return react.createElement("label", {
    className: classnames(s$Q.root, defineProperty({}, s$Q.spaceLg, n))
  }, react.createElement(Radio, _extends_1({
    disabled: t,
    error: !(!a || !i)
  }, s)), react.createElement("span", {
    className: classnames(s$Q.label, defineProperty({}, s$Q.labelDisabled, t))
  }, r));
};

FormRadio.defaultProps = {
  disabled: !1,
  spaceLg: !1
};

var FormSelect = function FormSelect(e) {
  return react.createElement(FieldBase, _extends_1({
    formComponent: Select
  }, e));
},
    FormTextarea = function FormTextarea(e) {
  return react.createElement(FieldBase, _extends_1({
    formComponent: Textarea
  }, e));
},
    RFFormCheckbox = function RFFormCheckbox(e) {
  var t = e.input,
      r = objectWithoutProperties(e, ["input"]);
  return react.createElement(FormCheckbox, _extends_1({
    checked: t.value,
    onChange: t.onChange
  }, r));
},
    GroupError = function GroupError(e) {
  var t = e.meta,
      r = t.touched,
      n = t.error;
  return !(!r || !n) && react.createElement(FieldError, null, n);
},
    s$R = {
  inline: "styles-module_inline__1xGSZ"
},
    FormCheckboxGroup = function FormCheckboxGroup(e) {
  var t = e.inline,
      n = e.groupName,
      r = e.checkboxes;
  return react.createElement(react_3, null, react.createElement("div", {
    className: classnames(defineProperty({}, s$R.inline, t))
  }, map(function (e) {
    var t = e.name,
        r = objectWithoutProperties(e, ["name"]);
    return react.createElement(Field, _extends_1({
      "data-test": "checkbox-".concat(n, ".").concat(t),
      type: "checkbox",
      component: RFFormCheckbox,
      key: t,
      name: "".concat(n, ".").concat(t)
    }, r));
  }, r)), react.createElement(Field, {
    component: GroupError,
    name: n
  }));
};

FormCheckboxGroup.defaultProps = {
  inline: !1
};

var RFFormInput = function RFFormInput(e) {
  var t = e.input,
      r = e.meta,
      n = objectWithoutProperties(e, ["input", "meta"]);
  return react.createElement(FormInput, _extends_1({
    onChange: t.onChange,
    value: t.value,
    meta: r
  }, n));
},
    RFFormRadio = function RFFormRadio(e) {
  var t = e.input,
      r = objectWithoutProperties(e, ["input"]);
  return react.createElement(FormRadio, _extends_1({
    checked: t.checked,
    onChange: t.onChange,
    name: t.name,
    value: t.value
  }, r));
},
    mapIndex$1 = addIndex(map),
    s$S = {
  inline: "styles-module_inline__XQrjL"
},
    FormRadioGroup = function FormRadioGroup(e) {
  var t = e.inline,
      r = e.radioButtons,
      n = e.groupName;
  return react.createElement(react_3, null, react.createElement("div", {
    className: classnames(defineProperty({}, s$S.inline, t))
  }, mapIndex$1(function (e, t) {
    return react.createElement(Field, _extends_1({
      name: n,
      component: RFFormRadio,
      key: "".concat(n, ".").concat(t),
      type: "radio"
    }, e));
  }, r)), react.createElement(Field, {
    component: GroupError,
    name: "".concat(n, ".error")
  }));
};

FormRadioGroup.defaultProps = {
  inline: !1
};

var RFFormSelect = function RFFormSelect(e) {
  var t = e.input,
      r = e.meta,
      n = objectWithoutProperties(e, ["input", "meta"]);
  return react.createElement(FormSelect, _extends_1({
    onChange: t.onChange,
    value: t.value,
    meta: r
  }, n));
},
    RFFormInput$1 = function RFFormInput$1(e) {
  var t = e.input,
      r = e.meta,
      n = objectWithoutProperties(e, ["input", "meta"]);
  return react.createElement(FormTextarea, _extends_1({
    onChange: t.onChange,
    value: t.value,
    meta: r
  }, n));
},
    RFStatusItem = function RFStatusItem(e) {
  var t = e.input,
      r = objectWithoutProperties(e, ["input"]);
  return react.createElement(StatusItem, _extends_1({
    checked: t.checked,
    onChange: t.onChange,
    name: t.name,
    value: t.value
  }, r));
},
    s$T = {
  notifications: "styles-module_notifications__21GWV"
},
    Notifications = function Notifications(e) {
  var t = e.notifications,
      a = e.notificationsClose;
  return react.createElement("div", {
    className: s$T.notifications
  }, 0 < t.length && map(function (e) {
    var t = e.id,
        r = e.title,
        n = e.description,
        o = e.variant;
    return react.createElement(Notification, {
      key: t,
      onCloseClick: function onCloseClick() {
        return a({
          id: t
        });
      },
      title: r,
      variant: o
    }, n);
  }, t));
},
    getNotifications = prop("notifications"),
    ADD_NOTIFICATION = "NOTIFICATIONS/ADD_NOTIFICATION",
    CLOSE_NOTIFICATION = "NOTIFICATIONS/CLOSE_NOTIFICATION",
    CLEAR_NOTIFICATIONS = "NOTIFICATIONS/CLEAR_NOTIFICATIONS",
    notificationsAdd = function notificationsAdd(e) {
  var t = e.id,
      r = e.title,
      n = e.description,
      o = e.variant;
  return {
    type: ADD_NOTIFICATION,
    payload: {
      id: t,
      title: r,
      description: n,
      variant: o
    }
  };
},
    notificationsClose = function notificationsClose(e) {
  var t = e.id;
  return {
    type: CLOSE_NOTIFICATION,
    payload: {
      id: t
    }
  };
},
    notificationsClear = function notificationsClear() {
  return {
    type: CLEAR_NOTIFICATIONS
  };
},
    mapStateToProps = function mapStateToProps(e) {
  return {
    notifications: getNotifications(e)
  };
},
    mapDispatchToProps = {
  notificationsClose: notificationsClose
},
    connectData = connect(mapStateToProps, mapDispatchToProps)(Notifications),
    initialState = [],
    reducer = function reducer() {
  var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : initialState,
      t = 1 < arguments.length ? arguments[1] : void 0;

  switch (t.type) {
    case ADD_NOTIFICATION:
      var r = t.payload,
          n = r.id,
          o = r.title,
          a = r.description,
          i = r.variant;
      return prepend({
        id: n,
        title: o,
        description: a,
        variant: i
      })(e);

    case CLOSE_NOTIFICATION:
      var s = t.payload.id;
      return reject(propEq("id", s))(e);

    case CLEAR_NOTIFICATIONS:
      return [];

    default:
      return e;
  }
},
    runtime = createCommonjsModule(function (R) {
  !function (e) {
    var c,
        t = Object.prototype,
        u = t.hasOwnProperty,
        r = "function" == typeof Symbol ? Symbol : {},
        o = r.iterator || "@@iterator",
        n = r.asyncIterator || "@@asyncIterator",
        a = r.toStringTag || "@@toStringTag",
        i = e.regeneratorRuntime;
    if (i) R.exports = i;else {
      (i = e.regeneratorRuntime = R.exports).wrap = v;
      var f = "suspendedStart",
          p = "suspendedYield",
          d = "executing",
          h = "completed",
          y = {},
          s = {};

      s[o] = function () {
        return this;
      };

      var l = Object.getPrototypeOf,
          m = l && l(l(O([])));
      m && m !== t && u.call(m, o) && (s = m);
      var b = $.prototype = _.prototype = Object.create(s);
      w.prototype = b.constructor = $, $.constructor = w, $[a] = w.displayName = "GeneratorFunction", i.isGeneratorFunction = function (e) {
        var t = "function" == typeof e && e.constructor;
        return !!t && (t === w || "GeneratorFunction" === (t.displayName || t.name));
      }, i.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, $) : (e.__proto__ = $, a in e || (e[a] = "GeneratorFunction")), e.prototype = Object.create(b), e;
      }, i.awrap = function (e) {
        return {
          __await: e
        };
      }, S(T.prototype), T.prototype[n] = function () {
        return this;
      }, i.AsyncIterator = T, i.async = function (e, t, r, n) {
        var o = new T(v(e, t, r, n));
        return i.isGeneratorFunction(t) ? o : o.next().then(function (e) {
          return e.done ? e.value : o.next();
        });
      }, S(b), b[a] = "Generator", b[o] = function () {
        return this;
      }, b.toString = function () {
        return "[object Generator]";
      }, i.keys = function (r) {
        var n = [];

        for (var e in r) {
          n.push(e);
        }

        return n.reverse(), function e() {
          for (; n.length;) {
            var t = n.pop();
            if (t in r) return e.value = t, e.done = !1, e;
          }

          return e.done = !0, e;
        };
      }, i.values = O, C.prototype = {
        constructor: C,
        reset: function reset(e) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = c, this.done = !1, this.delegate = null, this.method = "next", this.arg = c, this.tryEntries.forEach(E), !e) for (var t in this) {
            "t" === t.charAt(0) && u.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = c);
          }
        },
        stop: function stop() {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(r) {
          if (this.done) throw r;
          var n = this;

          function e(e, t) {
            return a.type = "throw", a.arg = r, n.next = e, t && (n.method = "next", n.arg = c), !!t;
          }

          for (var t = this.tryEntries.length - 1; 0 <= t; --t) {
            var o = this.tryEntries[t],
                a = o.completion;
            if ("root" === o.tryLoc) return e("end");

            if (o.tryLoc <= this.prev) {
              var i = u.call(o, "catchLoc"),
                  s = u.call(o, "finallyLoc");

              if (i && s) {
                if (this.prev < o.catchLoc) return e(o.catchLoc, !0);
                if (this.prev < o.finallyLoc) return e(o.finallyLoc);
              } else if (i) {
                if (this.prev < o.catchLoc) return e(o.catchLoc, !0);
              } else {
                if (!s) throw new Error("try statement without catch or finally");
                if (this.prev < o.finallyLoc) return e(o.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(e, t) {
          for (var r = this.tryEntries.length - 1; 0 <= r; --r) {
            var n = this.tryEntries[r];

            if (n.tryLoc <= this.prev && u.call(n, "finallyLoc") && this.prev < n.finallyLoc) {
              var o = n;
              break;
            }
          }

          o && ("break" === e || "continue" === e) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
          var a = o ? o.completion : {};
          return a.type = e, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), y;
        },
        finish: function finish(e) {
          for (var t = this.tryEntries.length - 1; 0 <= t; --t) {
            var r = this.tryEntries[t];
            if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), E(r), y;
          }
        },
        catch: function _catch(e) {
          for (var t = this.tryEntries.length - 1; 0 <= t; --t) {
            var r = this.tryEntries[t];

            if (r.tryLoc === e) {
              var n = r.completion;

              if ("throw" === n.type) {
                var o = n.arg;
                E(r);
              }

              return o;
            }
          }

          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, t, r) {
          return this.delegate = {
            iterator: O(e),
            resultName: t,
            nextLoc: r
          }, "next" === this.method && (this.arg = c), y;
        }
      };
    }

    function v(e, t, r, n) {
      var a,
          i,
          s,
          c,
          o = t && t.prototype instanceof _ ? t : _,
          u = Object.create(o.prototype),
          l = new C(n || []);
      return u._invoke = (a = e, i = r, s = l, c = f, function (e, t) {
        if (c === d) throw new Error("Generator is already running");

        if (c === h) {
          if ("throw" === e) throw t;
          return A();
        }

        for (s.method = e, s.arg = t;;) {
          var r = s.delegate;

          if (r) {
            var n = P(r, s);

            if (n) {
              if (n === y) continue;
              return n;
            }
          }

          if ("next" === s.method) s.sent = s._sent = s.arg;else if ("throw" === s.method) {
            if (c === f) throw c = h, s.arg;
            s.dispatchException(s.arg);
          } else "return" === s.method && s.abrupt("return", s.arg);
          c = d;
          var o = g(a, i, s);

          if ("normal" === o.type) {
            if (c = s.done ? h : p, o.arg === y) continue;
            return {
              value: o.arg,
              done: s.done
            };
          }

          "throw" === o.type && (c = h, s.method = "throw", s.arg = o.arg);
        }
      }), u;
    }

    function g(e, t, r) {
      try {
        return {
          type: "normal",
          arg: e.call(t, r)
        };
      } catch (e) {
        return {
          type: "throw",
          arg: e
        };
      }
    }

    function _() {}

    function w() {}

    function $() {}

    function S(e) {
      ["next", "throw", "return"].forEach(function (t) {
        e[t] = function (e) {
          return this._invoke(t, e);
        };
      });
    }

    function T(c) {
      var t;

      this._invoke = function (r, n) {
        function e() {
          return new Promise(function (e, t) {
            !function t(e, r, n, o) {
              var a = g(c[e], c, r);

              if ("throw" !== a.type) {
                var i = a.arg,
                    s = i.value;
                return s && "object" == typeof s && u.call(s, "__await") ? Promise.resolve(s.__await).then(function (e) {
                  t("next", e, n, o);
                }, function (e) {
                  t("throw", e, n, o);
                }) : Promise.resolve(s).then(function (e) {
                  i.value = e, n(i);
                }, function (e) {
                  return t("throw", e, n, o);
                });
              }

              o(a.arg);
            }(r, n, e, t);
          });
        }

        return t = t ? t.then(e, e) : e();
      };
    }

    function P(e, t) {
      var r = e.iterator[t.method];

      if (r === c) {
        if (t.delegate = null, "throw" === t.method) {
          if (e.iterator.return && (t.method = "return", t.arg = c, P(e, t), "throw" === t.method)) return y;
          t.method = "throw", t.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return y;
      }

      var n = g(r, e.iterator, t.arg);
      if ("throw" === n.type) return t.method = "throw", t.arg = n.arg, t.delegate = null, y;
      var o = n.arg;
      return o ? o.done ? (t[e.resultName] = o.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = c), t.delegate = null, y) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, y);
    }

    function x(e) {
      var t = {
        tryLoc: e[0]
      };
      1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
    }

    function E(e) {
      var t = e.completion || {};
      t.type = "normal", delete t.arg, e.completion = t;
    }

    function C(e) {
      this.tryEntries = [{
        tryLoc: "root"
      }], e.forEach(x, this), this.reset(!0);
    }

    function O(t) {
      if (t) {
        var e = t[o];
        if (e) return e.call(t);
        if ("function" == typeof t.next) return t;

        if (!isNaN(t.length)) {
          var r = -1,
              n = function e() {
            for (; ++r < t.length;) {
              if (u.call(t, r)) return e.value = t[r], e.done = !1, e;
            }

            return e.value = c, e.done = !0, e;
          };

          return n.next = n;
        }
      }

      return {
        next: A
      };
    }

    function A() {
      return {
        value: c,
        done: !0
      };
    }
  }(function () {
    return this || "object" == typeof self && self;
  }() || Function("return this")());
}),
    g = function () {
  return this || "object" == typeof self && self;
}() || Function("return this")(),
    hadRuntime = g.regeneratorRuntime && 0 <= Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime"),
    oldRuntime = hadRuntime && g.regeneratorRuntime;

g.regeneratorRuntime = void 0;
var runtimeModule = runtime;
if (hadRuntime) g.regeneratorRuntime = oldRuntime;else try {
  delete g.regeneratorRuntime;
} catch (e) {
  g.regeneratorRuntime = void 0;
}

var regenerator = runtimeModule,
    createSymbol = function createSymbol(e) {
  return "@@redux-saga/" + e;
},
    CANCEL = createSymbol("CANCEL_PROMISE"),
    IO = createSymbol("IO"),
    MULTICAST = createSymbol("MULTICAST"),
    undef = function undef(e) {
  return null == e;
},
    notUndef = function notUndef(e) {
  return null != e;
},
    func$1 = function func$1(e) {
  return "function" == typeof e;
},
    string$1 = function string$1(e) {
  return "string" == typeof e;
},
    array$2 = Array.isArray,
    object$2 = function object$2(e) {
  return e && !array$2(e) && "object" == typeof e;
},
    pattern = function e(t) {
  return t && (string$1(t) || symbol(t) || func$1(t) || array$2(t) && t.every(e));
},
    channel = function channel(e) {
  return e && func$1(e.take) && func$1(e.close);
},
    stringableFunc = function stringableFunc(e) {
  return func$1(e) && e.hasOwnProperty("toString");
},
    symbol = function symbol(e) {
  return Boolean(e) && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype;
},
    multicast = function multicast(e) {
  return channel(e) && e[MULTICAST];
};

function delayP(t, r) {
  var n;
  void 0 === r && (r = !0);
  var e = new Promise(function (e) {
    n = setTimeout(e, t, r);
  });
  return e[CANCEL] = function () {
    clearTimeout(n);
  }, e;
}

function check(e, t, r) {
  if (!t(e)) throw new Error(r);
}

var kThrow = function kThrow(e) {
  throw e;
},
    kReturn = function kReturn(e) {
  return {
    value: e,
    done: !0
  };
};

function makeIterator(e, t, r) {
  void 0 === t && (t = kThrow), void 0 === r && (r = "iterator");
  var n = {
    meta: {
      name: r
    },
    next: e,
    throw: t,
    return: kReturn,
    isSagaIterator: !0
  };
  return "undefined" != typeof Symbol && (n[Symbol.iterator] = function () {
    return n;
  }), n;
}

var TAKE = "TAKE",
    PUT = "PUT",
    CALL = "CALL",
    FORK = "FORK",
    makeEffect = function makeEffect(e, t) {
  var r;
  return (r = {})[IO] = !0, r.combinator = !1, r.type = e, r.payload = t, r;
};

function take(e, t) {
  if (void 0 === e && (e = "*"), "production" !== process.env.NODE_ENV && arguments.length && check(arguments[0], notUndef, "take(patternOrChannel): patternOrChannel is undefined"), pattern(e)) return makeEffect(TAKE, {
    pattern: e
  });
  if (multicast(e) && notUndef(t) && pattern(t)) return makeEffect(TAKE, {
    channel: e,
    pattern: t
  });
  if (channel(e)) return makeEffect(TAKE, {
    channel: e
  });
  if ("production" !== process.env.NODE_ENV) throw new Error("take(patternOrChannel): argument " + e + " is not valid channel or a valid pattern");
}

function put(e, t) {
  return "production" !== process.env.NODE_ENV && (1 < arguments.length ? (check(e, notUndef, "put(channel, action): argument channel is undefined"), check(e, channel, "put(channel, action): argument " + e + " is not a valid channel"), check(t, notUndef, "put(channel, action): argument action is undefined")) : check(e, notUndef, "put(action): argument action is undefined")), undef(t) && (t = e, e = void 0), makeEffect(PUT, {
    channel: e,
    action: t
  });
}

var validateFnDescriptor = function validateFnDescriptor(e, t) {
  if (check(t, notUndef, e + ": argument fn is undefined or null"), !func$1(t)) {
    var r,
        n = null;
    if (array$2(t)) n = t[0], check(r = t[1], notUndef, e + ": argument of type [context, fn] has undefined or null `fn`");else {
      if (!object$2(t)) return void check(t, func$1, e + ": argument fn is not function");
      n = t.context, check(r = t.fn, notUndef, e + ": argument of type {context, fn} has undefined or null `fn`");
    }
    n && string$1(r) ? check(n[r], func$1, e + ': context arguments has no such method - "' + r + '"') : check(r, func$1, e + ": unpacked fn argument (from [context, fn] or {context, fn}) is not a function");
  }
};

function getFnCallDescriptor(e, t) {
  var r,
      n = null;
  return func$1(e) ? r = e : (r = array$2(e) ? (n = e[0], e[1]) : (n = e.context, e.fn), n && string$1(r) && func$1(n[r]) && (r = n[r])), {
    context: n,
    fn: r,
    args: t
  };
}

var isNotDelayEffect = function isNotDelayEffect(e) {
  return e !== delay;
};

function call(e) {
  for (var t = arguments.length, r = new Array(1 < t ? t - 1 : 0), n = 1; n < t; n++) {
    r[n - 1] = arguments[n];
  }

  if ("production" !== process.env.NODE_ENV) {
    var o = "number" == typeof r[0] ? r[0] : "ms";
    check(e, isNotDelayEffect, "instead of writing `yield call(delay, " + o + ")` where delay is an effect from `redux-saga/effects` you should write `yield delay(" + o + ")`"), validateFnDescriptor("call", e);
  }

  return makeEffect(CALL, getFnCallDescriptor(e, r));
}

function fork(e) {
  "production" !== process.env.NODE_ENV && validateFnDescriptor("fork", e);

  for (var t = arguments.length, r = new Array(1 < t ? t - 1 : 0), n = 1; n < t; n++) {
    r[n - 1] = arguments[n];
  }

  return makeEffect(FORK, getFnCallDescriptor(e, r));
}

var delay = call.bind(null, delayP),
    done = function done(e) {
  return {
    done: !0,
    value: e
  };
},
    qEnd = {};

function safeName(e) {
  return channel(e) ? "channel" : stringableFunc(e) ? String(e) : func$1(e) ? e.name : String(e);
}

function fsmIterator(n, e, t) {
  var o,
      a,
      i,
      s = e;

  function r(e, t) {
    if (s === qEnd) return done(e);
    if (t && !a) throw s = qEnd, t;
    o && o(e);
    var r = t ? n[a](t) : n[s]();
    return s = r.nextState, i = r.effect, o = r.stateUpdater, a = r.errorState, s === qEnd ? done(e) : i;
  }

  return makeIterator(r, function (e) {
    return r(null, e);
  }, t);
}

function takeEvery(e, t) {
  for (var r = arguments.length, n = new Array(2 < r ? r - 2 : 0), o = 2; o < r; o++) {
    n[o - 2] = arguments[o];
  }

  var a,
      i = {
    done: !1,
    value: take(e)
  },
      s = function s(e) {
    return a = e;
  };

  return fsmIterator({
    q1: function q1() {
      return {
        nextState: "q2",
        effect: i,
        stateUpdater: s
      };
    },
    q2: function q2() {
      return {
        nextState: "q1",
        effect: (e = a, {
          done: !1,
          value: fork.apply(void 0, [t].concat(n, [e]))
        })
      };
      var e;
    }
  }, "q1", "takeEvery(" + safeName(e) + ", " + t.name + ")");
}

var validateTakeEffect = function validateTakeEffect(e, t, r) {
  check(t, notUndef, e.name + " requires a pattern or channel"), check(r, notUndef, e.name + " requires a saga parameter");
};

function takeEvery$1(e, t) {
  "production" !== process.env.NODE_ENV && validateTakeEffect(takeEvery$1, e, t);

  for (var r = arguments.length, n = new Array(2 < r ? r - 2 : 0), o = 2; o < r; o++) {
    n[o - 2] = arguments[o];
  }

  return fork.apply(void 0, [takeEvery, e, t].concat(n));
}

var _marked = regenerator.mark(root$3),
    onAddNotification = regenerator.mark(function e(t) {
  var r;
  return regenerator.wrap(function (e) {
    for (;;) {
      switch (e.prev = e.next) {
        case 0:
          return r = t.payload.id, e.next = 3, delay(5e3);

        case 3:
          return e.next = 5, put(notificationsClose({
            id: r
          }));

        case 5:
        case "end":
          return e.stop();
      }
    }
  }, e);
});

function root$3() {
  return regenerator.wrap(function (e) {
    for (;;) {
      switch (e.prev = e.next) {
        case 0:
          return e.next = 2, takeEvery$1(ADD_NOTIFICATION, onAddNotification);

        case 2:
        case "end":
          return e.stop();
      }
    }
  }, _marked);
}

exports.Accordion = Accordion, exports.AccordionHeader = AccordionHeader, exports.AccordionItem = AccordionItem, exports.Arrow = Arrow, exports.Article = Article, exports.ArticleLike = ArticleLike, exports.Button = Button, exports.ButtonsContainer = ButtonsContainer, exports.ButtonWithLoader = ButtonWithLoader, exports.CircledButton = CircledButton, exports.Checkbox = Checkbox, exports.Container = Container, exports.Col = lib_2, exports.Row = lib_4, exports.DataItem = DataItem, exports.DotNotification = DotNotification, exports.EcgChart = EcgChart, exports.FieldBase = FieldBase, exports.FieldError = FieldError, exports.FlexTableCol = FlexTableCol, exports.FlexTableRow = FlexTableRow, exports.FormWrapper = FormWrapper, exports.HeaderTitle = HeaderTitle, exports.InlineFormRow = InlineFormRow, exports.CheckboxWrapper = CheckboxWrapper, exports.RadioWrapper = RadioWrapper, exports.TextContent = TextContent, exports.InfoRow = InfoRow, exports.Input = Input, exports.Label = Label, exports.Loading = Loading, exports.Modal = Modal, exports.Notification = Notification, exports.PageWrapper = PageWrapper, exports.Pagination = Pagination, exports.Paper = Paper, exports.PaperContent = PaperContent, exports.PaperMessage = PaperMessage, exports.PaperTitle = PaperTitle, exports.PersonalInfo = PersonalInfo, exports.Radio = Radio, exports.ReportTitle = ReportTitle, exports.Search = Search, exports.SegmentedControl = SegmentedControl, exports.Select = Select, exports.SortArrow = SortArrow, exports.SortButton = SortButton, exports.StatusBar = StatusBar, exports.StatusItem = StatusItem, exports.Table = Table, exports.TargetStatus = TargetStatus, exports.Textarea = Textarea, exports.TopMenu = TopMenu, exports.TopMenuItem = TopMenuItem, exports.FormCheckbox = FormCheckbox, exports.FormInput = FormInput, exports.FormRadio = FormRadio, exports.FormSelect = FormSelect, exports.FormTextarea = FormTextarea, exports.RFFormCheckbox = RFFormCheckbox, exports.RFFormCheckboxGroup = FormCheckboxGroup, exports.RFFormInput = RFFormInput, exports.RFFormRadio = RFFormRadio, exports.RFFormRadioGroup = FormRadioGroup, exports.RFFormSelect = RFFormSelect, exports.RFFormTextarea = RFFormInput$1, exports.RFGroupError = GroupError, exports.RFStatusItem = RFStatusItem, exports.Notifications = connectData, exports.notificationsReducer = reducer, exports.notificationsSaga = root$3, exports.notificationsAdd = notificationsAdd, exports.notificationsClear = notificationsClear, exports.notificationsClose = notificationsClose;